/*
 * @license
 * Palo Alto Theme (c)
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */

// Custom redirection

if(window.location.href.includes("/apps/gbb/easybundle")){
    window.location.href = "https://betteralt.in/products/betteralt-get-3-for-1499";
}

if(window.location.href === "https://betteralt.in/collections"){
    window.location.href = "https://betteralt.in";
}

!(function (t, e, i, s) {
    "use strict";
    function o(t, e) {
        let i;
        return function () {
            if (t) {
                const s = () => t.apply(this, arguments);
                clearTimeout(i), (i = setTimeout(s, e));
            }
        };
    }
    !(function () {
        const t = { NODE_ENV: "production" };
        try {
            if (process) return (process.env = Object.assign({}, process.env)), void Object.assign(process.env, t);
        } catch (t) {}
        globalThis.process = { env: t };
    })(),
        (window.theme = window.theme || {}),
        (window.theme.sizes = { mobile: 480, small: 768, large: 1024, widescreen: 1440 }),
        (window.theme.keyboardKeys = { TAB: "Tab", ENTER: "Enter", NUMPADENTER: "NumpadEnter", ESCAPE: "Escape", SPACE: "Space", LEFTARROW: "ArrowLeft", RIGHTARROW: "ArrowRight" }),
        (window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    const n = "body",
        r = "[data-main]",
        a = "[data-site-header]",
        l = "[data-prevent-transparent-header]",
        c = "supports-transparent-header",
        h = "site-header--transparent",
        d = "is-first-section-transparent",
        u = "data-transparent",
        p = () => {
            const t = document.querySelector(n),
                e = t.querySelector(a);
            if (!e) return;
            const i = "true" === e.getAttribute(u),
                s = t.querySelector(r).children[0];
            if (!s) return;
            const o = s.querySelector(`${l}:first-of-type`);
            window.isHeaderTransparent = i && s.classList.contains(c) && !o;
            CSS.supports("(selector(:has(*)))") || (t.classList.toggle(d, window.isHeaderTransparent), e.classList.toggle(h, window.isHeaderTransparent));
        },
        m = ".section-footer--parallax",
        g = "[data-section-type]",
        f = ":scope > [data-wave]",
        y = ".wavy:not(.site-footer)",
        v = ".parallax-shadow:not(.site-footer)",
        b = "wavy",
        w = "parallax-shadow",
        S = "parallax-rounded-corners",
        E = "section-footer--parallax",
        L = "body--rounded-corners-large",
        k = "data-parallax-wavy",
        A = (t) => {
            const e = t,
                i = document.querySelectorAll(y),
                s = document.querySelectorAll(v);
            i.forEach((t) => {
                t.classList.remove(b);
                [...t.querySelectorAll(f)].map((t) => t.remove());
            }),
                s.forEach((t) => {
                    t.classList.remove(w), t.classList.remove(S), document.body.classList.remove(L);
                    [...t.querySelectorAll(f)].map((t) => t.remove());
                });
            const o = document.querySelectorAll(m);
            if (o.length > 0) {
                const t = o[0].querySelector(g);
                t.hasAttribute(k) && t.classList.add(b);
            }
            e.classList.contains(E) || document.dispatchEvent(new CustomEvent("theme:footer:unload"));
        };
    (window.Shopify = window.Shopify || {}),
        (window.Shopify.theme = window.Shopify.theme || {}),
        (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
        (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
        (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    const C = window.Shopify.theme.sections.registered,
        q = window.Shopify.theme.sections.instances,
        T = { id: "data-section-id", type: "data-section-type" };
    let P = class {
            getStack() {
                return this.callStack;
            }
            constructor(t = null, e = []) {
                (this.type = t),
                    (this.components = (function (t) {
                        if ((void 0 !== t && "object" != typeof t) || null === t) throw new TypeError("Theme Sections: The components object provided is not a valid");
                        return t;
                    })(e)),
                    (this.callStack = { onLoad: [], onUnload: [], onSelect: [], onDeselect: [], onBlockSelect: [], onBlockDeselect: [], onReorder: [] }),
                    e.forEach((t) => {
                        for (const [e, i] of Object.entries(t)) {
                            const t = this.callStack[e];
                            Array.isArray(t) && "function" == typeof i ? t.push(i) : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`), console.warn(i));
                        }
                    });
            }
        },
        x = class {
            callFunctions(t, e = null) {
                this.callStack[t].forEach((t) => {
                    const i = { id: this.id, type: this.type, container: this.container };
                    e ? t.call(i, e) : t.call(i);
                });
            }
            onLoad() {
                this.callFunctions("onLoad");
            }
            onUnload() {
                this.callFunctions("onUnload");
            }
            onSelect(t) {
                this.callFunctions("onSelect", t);
            }
            onDeselect(t) {
                this.callFunctions("onDeselect", t);
            }
            onBlockSelect(t) {
                this.callFunctions("onBlockSelect", t);
            }
            onBlockDeselect(t) {
                this.callFunctions("onBlockDeselect", t);
            }
            onReorder(t) {
                this.callFunctions("onReorder", t);
            }
            constructor(t, e) {
                (this.container = (function (t) {
                    if (!(t instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                    if (null === t.getAttribute(T.id)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + T.id + " attribute.");
                    return t;
                })(t)),
                    (this.id = t.getAttribute(T.id)),
                    (this.type = e.type),
                    (this.callStack = e.getStack());
                try {
                    this.onLoad();
                } catch (t) {
                    console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(t);
                }
            }
        };
    function I(t, e) {
        if ("string" != typeof t) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== C[t]) throw new Error('Theme Sections: A section of type "' + t + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(e) || (e = [e]);
        const i = new P(t, e);
        return (C[t] = i), C;
    }
    function H(t, e) {
        (t = O(t)),
            void 0 === e && (e = document.querySelectorAll("[" + T.type + "]")),
            (e = B(e)),
            t.forEach(function (t) {
                const i = C[t];
                void 0 !== i &&
                    (e = e.filter(function (e) {
                        return !(M(e).length > 0) && null !== e.getAttribute(T.type) && (e.getAttribute(T.type) !== t || (q.push(new x(e, i)), !1));
                    }));
            });
    }
    function F(t) {
        M(t).forEach(function (t) {
            var e = q
                .map(function (t) {
                    return t.id;
                })
                .indexOf(t.id);
            q.splice(e, 1), t.onUnload();
        });
    }
    function M(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
        if (t instanceof Element || i instanceof Element)
            B(t).forEach(function (t) {
                e = e.concat(
                    q.filter(function (e) {
                        return e.container === t;
                    })
                );
            });
        else if ("string" == typeof t || "string" == typeof i) {
            O(t).forEach(function (t) {
                e = e.concat(
                    q.filter(function (e) {
                        return e.type === t;
                    })
                );
            });
        }
        return e;
    }
    function D(t) {
        for (var e, i = 0; i < q.length; i++)
            if (q[i].id === t) {
                e = q[i];
                break;
            }
        return e;
    }
    function O(t) {
        return (
            "*" === t
                ? (t = Object.keys(C))
                : "string" == typeof t
                ? (t = [t])
                : t.constructor === x
                ? (t = [t.prototype.type])
                : Array.isArray(t) &&
                  t[0].constructor === x &&
                  (t = t.map(function (t) {
                      return t.type;
                  })),
            (t = t.map(function (t) {
                return t.toLowerCase();
            }))
        );
    }
    function B(t) {
        return (
            NodeList.prototype.isPrototypeOf(t) && t.length > 0
                ? (t = Array.prototype.slice.call(t))
                : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
                ? (t = [])
                : !Array.isArray(t) && t instanceof Element && (t = [t]),
            t
        );
    }
    window.Shopify.designMode &&
        (document.addEventListener("shopify:section:load", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + T.id + '="' + e + '"]');
            !0 === window.Shopify.visualPreviewMode && null === i && (i = t.target.querySelector(`[${T.id}]`)), null !== i && H(i.getAttribute(T.type), i);
        }),
        document.addEventListener("shopify:section:reorder", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + T.id + '="' + e + '"]');
            "object" == typeof M(i)[0] &&
                M(i).forEach(function (t) {
                    t.onReorder();
                });
        }),
        document.addEventListener("shopify:section:unload", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + T.id + '="' + e + '"]');
            "object" == typeof M(i)[0] && F(i);
        }),
        document.addEventListener("shopify:section:select", function (t) {
            var e = D(t.detail.sectionId);
            "object" == typeof e && e.onSelect(t);
        }),
        document.addEventListener("shopify:section:deselect", function (t) {
            var e = D(t.detail.sectionId);
            "object" == typeof e && e.onDeselect(t);
        }),
        document.addEventListener("shopify:block:select", function (t) {
            var e = D(t.detail.sectionId);
            "object" == typeof e && e.onBlockSelect(t);
        }),
        document.addEventListener("shopify:block:deselect", function (t) {
            var e = D(t.detail.sectionId);
            "object" == typeof e && e.onBlockDeselect(t);
        }));
    const z = '[data-parallax="card-scrolling"]',
        _ = () => {
            setTimeout(() => {
                window.Shopify.theme.sections.instances
                    .filter((t) => {
                        const e = "slider" === t.type,
                            i = "banner-image" === t.type,
                            s = t.container.matches(z);
                        return (e && s) || (i && s);
                    })
                    .forEach((t) => {
                        F(t.id), setTimeout(() => H(t.id));
                    });
            });
        };
    let $ = X();
    const R = {
            body: "body",
            main: "[data-main]",
            collectionFilters: "[data-collection-filters]",
            footer: '[data-section-type*="footer"]',
            header: "[data-header-height]",
            stickyHeader: '[data-site-header][data-position="fixed"]',
            announcementBar: "[data-announcement-bar]",
            collectionStickyBar: "[data-collection-sticky-bar]",
            logoTextLink: "[data-logo-text-link]",
        },
        V = { templateCollection: "template-collection", templateSearch: "template-search", supportsTransparentHeader: "supports-transparent-header" };
    function N() {
        var t, e;
        const i = {};
        return (
            (i.windowHeight = Math.min(window.screen.height, window.innerHeight)),
            (i.footerHeight = K(R.footer)),
            (i.headerHeight = K(R.header)),
            (i.stickyHeaderHeight = Q() ? window.stickyHeaderHeight : 0),
            (i.headerInitialHeight =
                parseInt((null === (t = document.querySelector(R.header)) || void 0 === t ? void 0 : t.dataset.height) || (null === (e = document.querySelector(R.header)) || void 0 === e ? void 0 : e.offsetHeight)) || 0),
            (i.announcementBarHeight = K(R.announcementBar)),
            (i.collectionStickyBarHeight = K(R.collectionStickyBar)),
            i
        );
    }
    function W() {
        document.addEventListener("theme:resize", j), U(), document.dispatchEvent(new CustomEvent("theme:vars"), { bubbles: !1 });
    }
    function U() {
        G();
    }
    function j() {
        G(!0);
    }
    function G(t = !1) {
        const e = document.querySelector(R.body),
            i = document.querySelector(R.collectionFilters),
            s = null !== document.querySelector(R.logoTextLink);
        let { windowHeight: o, headerHeight: n, headerInitialHeight: r, announcementBarHeight: a, footerHeight: l, collectionStickyBarHeight: c } = N();
        s &&
            (n = (function () {
                document.documentElement.style.setProperty("--header-height", "auto"), document.documentElement.style.setProperty("--header-sticky-height", "auto");
                const t = document.querySelector(R.header).offsetHeight;
                return (
                    requestAnimationFrame(() => {
                        document.documentElement.style.setProperty("--header-height", `${t}px`), document.documentElement.style.setProperty("--header-sticky-height", `${t}px`);
                    }),
                    t
                );
            })());
        const h = window.isHeaderTransparent && document.querySelector(R.main).firstElementChild.classList.contains(V.supportsTransparentHeader) ? o - a : o - r - a;
        let d = Q() ? o - window.stickyHeaderHeight : o;
        const u = e.classList.contains(V.templateCollection),
            p = e.classList.contains(V.templateSearch),
            m = (u && i) || (p && i);
        if (
            (document.documentElement.style.setProperty("--footer-height", `${l}px`),
            document.documentElement.style.setProperty("--content-full", `${h}px`),
            document.documentElement.style.setProperty("--content-min", o - n - l + "px"),
            document.documentElement.style.setProperty("--collection-sticky-bar-height", `${c}px`),
            m && (d = o),
            !t)
        )
            return void document.documentElement.style.setProperty("--full-height", `${d}px`);
        const g = X();
        g !== $ && (document.documentElement.style.setProperty("--full-height", `${d}px`), ($ = g));
    }
    function K(t) {
        const e = document.querySelector(t);
        return e ? e.clientHeight : 0;
    }
    function Q() {
        return document.querySelector(R.stickyHeader);
    }
    function X() {
        return window.matchMedia("(orientation: portrait)").matches ? "portrait" : window.matchMedia("(orientation: landscape)").matches ? "landscape" : void 0;
    }
    const Y = {
        overflowBackground: "[data-overflow-background]",
        overflowFrame: "[data-overflow-frame]",
        overflowContent: "[data-overflow-content]",
        overflowContainer: "[data-overflow-container]",
        overflowWrapper: "[data-overflow-wrapper]",
    };
    function J(t, e) {
        let i = 0;
        e.forEach((t) => {
            i = t.offsetHeight > i ? t.offsetHeight : i;
        });
        const s = t.querySelectorAll(Y.overflowBackground);
        [t, ...s].forEach((t) => {
            t.style.setProperty("min-height", `calc(${i}px + var(--header-height))`);
        });
    }
    function Z(t) {
        if (window.innerWidth < window.theme.sizes.small) {
            return void t.querySelectorAll(Y.overflowFrame).forEach((t) => {
                const e = t.querySelectorAll(Y.overflowContent);
                J(t, e);
            });
        }
        let e = 0;
        const i = t.querySelectorAll(Y.overflowFrame);
        t.querySelectorAll(Y.overflowContent).forEach((t) => {
            t.offsetHeight > e && (e = t.offsetHeight);
        });
        [...i, ...t.querySelectorAll(Y.overflowBackground)].forEach((t) => {
            t.style.setProperty("min-height", `${e}px`);
        }),
            t.style.setProperty("min-height", `${e}px`);
    }
    function tt(t) {
        const e = t.querySelectorAll(Y.overflowContainer);
        e &&
            e.forEach((t) => {
                const e = t.querySelectorAll(Y.overflowContent);
                J(t, e),
                    document.addEventListener("theme:resize", () => {
                        J(t, e);
                    });
            });
        const i = t.querySelectorAll(Y.overflowWrapper);
        i &&
            i.forEach((t) => {
                Z(t),
                    document.addEventListener("theme:resize", () => {
                        Z(t);
                    });
            });
    }
    function et() {
        document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
            window.lastWindowWidth !== window.innerWidth && (document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })), (window.lastWindowWidth = window.innerWidth));
    }
    window.lastWindowWidth = window.innerWidth;
    let it = window.pageYOffset,
        st = null,
        ot = null,
        nt = null,
        rt = null,
        at = 0;
    const lt = { quickViewVisible: "js-quick-view-visible", cartDrawerOpen: "js-drawer-open-cart" };
    function ct(e) {
        setTimeout(() => {
            at && clearTimeout(at), t.disablePageScroll(e.detail, { allowTouchMove: (t) => "TEXTAREA" === t.tagName }), document.documentElement.setAttribute("data-scroll-locked", "");
        });
    }
    function ht(t) {
        const e = t.detail;
        e ? (at = setTimeout(dt, e)) : dt();
    }
    function dt() {
        document.body.classList.contains(lt.quickViewVisible) || document.body.classList.contains(lt.cartDrawerOpen) || (t.clearQueueScrollLocks(), t.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked"));
    }
    const ut = (t, e = "", i) => {
        const s = i || document.createElement("div");
        return s.classList.add(e), s.setAttribute("data-scroll-lock-scrollable", ""), t.parentNode.insertBefore(s, t), s.appendChild(t);
    };
    function pt(t) {
        t.querySelectorAll("table").forEach((t) => {
            ut(t, "table-wrapper");
        });
    }
    const mt = { loading: "is-loading", imgIn: "img-in" },
        gt = { img: "img.is-loading", section: "[data-section-type]" };
    function ft(t) {
        t.querySelectorAll(gt.img).forEach((t) => {
            if (t.complete) {
                t.classList.remove(mt.loading), t.parentNode.classList.remove(mt.loading);
                const e = t.closest(gt.section);
                e && e.classList.add(mt.imgIn);
            }
        });
    }
    const yt = "img",
        vt = "template",
        bt = ".shopify-section",
        wt = "[data-deferred-content]",
        St = "[data-product-image]",
        Et = "srcset",
        Lt = "data-loaded",
        kt = "data-deferred-container";
    let At = class extends HTMLElement {
        connectedCallback() {
            0 != this.deferredTriggers.length
                ? this.deferredTriggers.forEach((t) => {
                      t.addEventListener(
                          "mouseenter",
                          () => {
                              this.hasAttribute(Lt) || this.loadTemplate();
                          },
                          { once: !0 }
                      );
                  })
                : this.container.addEventListener(
                      "mouseenter",
                      () => {
                          this.hasAttribute(Lt) || this.loadTemplate();
                      },
                      { once: !0 }
                  );
        }
        loadTemplate() {
            var t;
            const e = document.createElement("div"),
                i = this.querySelector(vt);
            if (!i || !(null == i || null === (t = i.content) || void 0 === t ? void 0 : t.firstElementChild)) return;
            e.appendChild(i.content.firstElementChild.cloneNode(!0));
            const s = e.querySelector(wt);
            if (!s) return;
            this.append(s), this.setAttribute(Lt, !0);
            s.querySelectorAll(yt).length > 0 && this.reloadSrcset(this);
        }
        reloadSrcset(t) {
            t &&
                t.querySelectorAll(yt).forEach((t) => {
                    if (!t.parentNode.matches(St)) {
                        const e = t.getAttribute(Et);
                        t.setAttribute(Et, ""), t.setAttribute(Et, e);
                    }
                });
        }
        constructor() {
            super(), (this.container = this), this.hasAttribute(kt) && (this.container = this.closest(this.getAttribute(kt)) || this.closest(bt)), (this.deferredTriggers = this.container.querySelectorAll(this.dataset.deferredTriggers));
        }
    };
    const Ct = "[data-has-highlight]",
        qt = "[data-highlight-holder]",
        Tt = "path",
        Pt = "sup",
        xt = ".flickity-enabled",
        It = "[data-slide].is-selected",
        Ht = "[data-sticky-text]",
        Ft = "text-count-up",
        Mt = "data-highlight-type",
        Dt = "data-is-active",
        Ot = "is-active",
        Bt = {
            "circle-hand-drawn": {
                keyframes: [
                    { strokeDashoffset: "1", opacity: "0" },
                    { opacity: "1", offset: 0.01 },
                    { strokeDashoffset: "0", opacity: "1" },
                ],
                timing: { duration: 1e3, delay: 500, iterations: 1, fill: "forwards", easing: "cubic-bezier(0.7, 0, 0.3, 1)" },
            },
            circle: {
                keyframes: [
                    { strokeDashoffset: "506", opacity: "0" },
                    { opacity: "1", offset: 0.01 },
                    { strokeDashoffset: "0", opacity: "1" },
                ],
                timing: { duration: 800, delay: 500, iterations: 1, fill: "forwards", easing: "cubic-bezier(0.6, 0, 0.4, 1)" },
            },
            highlight: {
                keyframes: [{ transform: "scaleX(0)" }, { transform: "scaleX(1)" }],
                timing: { duration: 600, delay: 700, iterations: 1, fill: "forwards", easing: "ease", pseudoElement: "::before" },
                keyframesHover: [{ transform: "scaleY(0.1)" }, { transform: "scaleY(1)" }],
            },
            "highlight-color": {
                keyframes: [
                    { backgroundSize: "200% 100%", backgroundPosition: "100% 0" },
                    { backgroundSize: "200% 100%", backgroundPosition: "0 0", offset: 0.2 },
                    { backgroundSize: "1100% 100%", backgroundPosition: "0 0" },
                ],
                timing: { duration: 2e3, delay: 700, iterations: 1, fill: "forwards", easing: "cubic-bezier(0, 0, 0.9, 0.4)" },
            },
            squiggle: { keyframes: [{ maskPosition: "100% 0" }, { maskPosition: "0 0" }], timing: { duration: 1200, delay: 700, iterations: 1, fill: "forwards", easing: "cubic-bezier(0.6, 0, 0.4, 1)" } },
            stroke: { keyframes: [{ backgroundPosition: "100% 0" }, { backgroundPosition: "0 0" }], timing: { duration: 1200, delay: 500, iterations: 1, fill: "forwards", easing: "cubic-bezier(0.25, 0.1, 0.9, 0.3)" } },
            underline: { keyframes: [{ transform: "scaleX(0)" }, { transform: "scaleX(1)" }], timing: { duration: 900, delay: 700, iterations: 1, fill: "forwards", easing: "ease", pseudoElement: "::before" } },
            "underline-hand-drawn": {
                keyframes: [
                    { strokeDashoffset: "1", opacity: "0" },
                    { opacity: "1", offset: 0.01 },
                    { strokeDashoffset: "0", opacity: "1" },
                ],
                timing: { duration: 1e3, delay: 500, iterations: 1, fill: "forwards", easing: "cubic-bezier(0.7, 0, 0.3, 1)" },
            },
        };
    let zt = class extends HTMLElement {
        connectedCallback() {
            (this.timeout = null),
                (this.controller = new AbortController()),
                this.type &&
                    this.target &&
                    ((this.animation = this.target.animate(Bt[this.type].keyframes, Bt[this.type].timing)),
                    this.animation.pause(),
                    this.bindAnimation("init"),
                    this.bindAnimation("pause"),
                    this.modifyDefaults("slider"),
                    this.animation && (this.link && this.listen(), theme.settings.animationsEnabled || (this.animation.play(), this.bindAnimation("play"))));
        }
        disconnectedCallback() {
            this.controller.abort();
        }
        attributeChangedCallback(t, e, i) {
            const s = t === Dt,
                o = null === e && s,
                n = "true" === i;
            s &&
                n &&
                (this.textCountUp
                    ? (clearTimeout(this.timeout),
                      (this.timeout = setTimeout(() => {
                          this.setAnimationDelay(0), this.animate();
                      }, 100)))
                    : this.animate()),
                o || n || this.reset();
        }
        listen() {
            this.link.addEventListener("mouseenter", (t) => this.onMouseenter(t), { signal: this.controller.signal }), this.link.addEventListener("mouseleave", (t) => this.onMouseleave(t), { signal: this.controller.signal });
        }
        animate() {
            this.animation && (this.animation.play(), this.bindAnimation("play"), (this.animation.onfinish = () => this.onFinish()));
        }
        shouldAnimate() {
            requestAnimationFrame(() => {
                let t = !0;
                Boolean(this.closest(xt)) && (t = Boolean(this.closest(It)));
                const e = this.closest(Ht);
                e && (t = Boolean(e.classList.contains(Ot))), this.setTriggerAttribute(t);
            });
        }
        setTriggerAttribute(t = !0) {
            this.setAttribute(Dt, t);
        }
        reset() {
            this.animation && (this.animation.cancel(), this.bindAnimation("cancel"), this.setAnimationDelay(Bt[this.type].timing.delay));
        }
        onMouseenter(t) {
            t.stopImmediatePropagation(), this.setAnimationDelay(0), this.modifyDefaults("mouseenter"), this.animation.reverse(), this.bindAnimation("mouseenter");
        }
        onMouseleave(t) {
            t.stopImmediatePropagation(), this.modifyDefaults("mouseleave"), this.animation.reverse(), this.bindAnimation("mouseleave");
        }
        onFinish() {
            if (this.hasAttribute(Dt)) {
                const t = "true" === this.getAttribute(Dt) ? 0 : Bt[this.type].timing.delay;
                this.setAnimationDelay(t);
            } else this.setAnimationDelay(0);
        }
        setAnimationDelay(t = 0) {
            this.animation.effect.getTiming().delay !== t && (this.animation.effect.updateTiming({ delay: t }), this.bindAnimation("delay"));
        }
        modifyDefaults(t = "mouseenter", e) {
            if ((e || (e = this.animation), "mouseenter" === t))
                return (
                    Bt[this.type].keyframesHover && e.effect.setKeyframes(Bt[this.type].keyframesHover),
                    "highlight" === this.type && e.effect.updateTiming({ duration: 350, fill: "both" }),
                    "highlight-color" === this.type && e.effect.updateTiming({ duration: 800 }),
                    void ("underline" === this.type && e.effect.updateTiming({ duration: 400 }))
                );
            if ("mouseleave" === t)
                return (
                    Bt[this.type].keyframesHover && e.effect.setKeyframes(Bt[this.type].keyframes),
                    void (("highlight" !== this.type && "highlight-color" !== this.type && "underline" !== this.type) || e.effect.updateTiming({ duration: Bt[this.type].timing.duration }))
                );
            if ("slider" === t && (theme.settings.animationsEnabled || ((Bt[this.type].timing.delay = 300), e.effect.updateTiming({ delay: Bt[this.type].timing.delay })), this.closest(xt))) {
                const t = Bt[this.type].timing.delay + 200;
                "highlight" === this.type && e.effect.updateTiming({ delay: t });
            }
        }
        bindAnimation(t = !1) {
            if (
                this.bind &&
                t &&
                ("init" === t && (this.boundAnimation = this.bind.animate(Bt[this.type].keyframes, Bt[this.type].timing)),
                "pause" === t && this.boundAnimation.pause(),
                "play" === t && this.boundAnimation.play(),
                "cancel" === t && this.boundAnimation.cancel(),
                "mouseenter" === t && (this.modifyDefaults("mouseenter", this.boundAnimation), this.boundAnimation.reverse()),
                "mouseleave" === t && (this.modifyDefaults("mouseleave", this.boundAnimation), this.boundAnimation.reverse()),
                "delay" === t)
            ) {
                const t = this.animation.effect.getTiming().delay;
                this.boundAnimation.effect.getTiming().delay !== t && this.boundAnimation.effect.updateTiming({ delay: t });
            }
        }
        constructor() {
            super(),
                (this.animation = null),
                (this.bind = null),
                (this.boundAnimation = null),
                (this.link = this.closest(Ct)),
                (this.type = this.getAttribute(Mt)),
                (this.highlightHolder = this.querySelector(qt)),
                (this.textCountUp = this.closest(Ft)),
                (this.sup = this.querySelector(Pt)),
                (this.target = this.highlightHolder),
                ("circle-hand-drawn" !== this.type && "circle" !== this.type && "underline-hand-drawn" !== this.type) || (this.target = this.querySelector(Tt)),
                ("highlight-color" !== this.type && "stroke" !== this.type) || (this.sup && (this.bind = this.sup));
        }
    };
    var _t, $t, Rt;
    (Rt = [Dt]), ($t = "observedAttributes") in (_t = zt) ? Object.defineProperty(_t, $t, { value: Rt, enumerable: !0, configurable: !0, writable: !0 }) : (_t[$t] = Rt);
    const Vt = {
            inputSearch: 'input[type="search"]',
            inputType: 'input[name="type"]',
            form: "form",
            allVisibleElements: '[role="option"]',
            ariaSelected: '[aria-selected="true"]',
            selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]',
            popularSearches: "[data-popular-searches]",
            popdownBody: "[data-popdown-body]",
            mainInputSearch: "[data-main-input-search]",
            predictiveSearchResults: "[data-predictive-search-results]",
            predictiveSearch: "predictive-search",
            searchForm: "search-form",
        },
        Nt = "is-searched",
        Wt = "template-search";
    let Ut = class extends HTMLElement {
        getQuery() {
            return this.input.value.trim();
        }
        onFocus() {
            this.currentSearchTerm = this.getQuery();
        }
        onChange() {
            this.classList.toggle(Nt, !this.isFormCleared()), (this.searchTerm = this.getQuery());
        }
        isFormCleared() {
            return 0 === this.input.value.length;
        }
        submit() {
            this.form.submit();
        }
        reset() {
            this.input.val = "";
        }
        onFormSubmit(t) {
            (this.getQuery().length && !this.querySelector(Vt.selectedLink)) || t.preventDefault();
        }
        onKeydown(t) {
            ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
        }
        onKeyup(t) {
            switch ((!this.getQuery().length && this.predictiveSearch && this.close(!0), t.preventDefault(), t.code)) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption();
            }
        }
        switchOption(t) {
            const e = "up" === t,
                i = this.classList.contains(Nt) && this.predictiveSearchResults ? this.predictiveSearchResults : this.popularSearches;
            if (!i) return;
            this.selectedElement = i.querySelector(Vt.ariaSelected);
            const s = Array.from(i.querySelectorAll(Vt.allVisibleElements)).filter((t) => null !== t.offsetParent);
            let o = 0;
            if (e && !this.selectedElement) return;
            let n = -1,
                r = 0;
            for (; -1 === n && r <= s.length; ) s[r] === this.selectedElement && (n = r), r++;
            !e && this.selectedElement ? (o = n === s.length - 1 ? 0 : n + 1) : e && (o = 0 === n ? s.length - 1 : n - 1), o !== n && ((this.activeElement = s[o]), this.handleFocusableDescendants());
        }
        selectOption() {
            const t = this.querySelector(Vt.selectedOption);
            t && t.click();
        }
        handleFocusableDescendants(t = !1) {
            const e = this.selectedElement ? this.selectedElement : this.querySelector(Vt.ariaSelected);
            var i;
            if ((e && e.setAttribute("aria-selected", !1), !this.activeElement || t))
                return (
                    (this.selectedElement = null),
                    null === (i = this.activeElement) || void 0 === i || i.setAttribute("aria-selected", !1),
                    this.input.setAttribute("aria-expanded", !1),
                    void this.input.setAttribute("aria-activedescendant", "")
                );
            this.activeElement.setAttribute("aria-selected", !0), this.input.setAttribute("aria-activedescendant", this.activeElement.id);
        }
        constructor() {
            var t;
            super(),
                (this.input = this.querySelector(Vt.inputSearch)),
                (this.form = this.querySelector(Vt.form)),
                (this.popdownBody = this.closest(Vt.popdownBody)),
                (this.popularSearches = null === (t = this.popdownBody) || void 0 === t ? void 0 : t.querySelector(Vt.popularSearches)),
                (this.predictiveSearchResults = this.querySelector(Vt.predictiveSearchResults)),
                (this.predictiveSearch = this.matches(Vt.predictiveSearch)),
                (this.searchForm = this.matches(Vt.searchForm)),
                (this.selectedElement = null),
                (this.activeElement = null),
                (this.searchTerm = ""),
                (this.currentSearchTerm = ""),
                (this.isSearchPage = document.body.classList.contains(Wt)),
                this.input.addEventListener(
                    "input",
                    o((t) => {
                        this.onChange(t);
                    }, 300).bind(this)
                ),
                this.input.addEventListener("focus", this.onFocus.bind(this)),
                this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
                this.addEventListener("keyup", this.onKeyup.bind(this)),
                this.addEventListener("keydown", this.onKeydown.bind(this)),
                this.isSearchPage && ((this.mainInputType = document.querySelector(`${Vt.mainInputSearch} ${Vt.inputType}`)), (this.inputType = this.querySelector(Vt.inputType)), (this.inputType.value = this.mainInputType.value));
        }
    };
    customElements.define("search-form", Ut);
    const jt = "predictive-search",
        Gt = "#shopify-section-api-predictive-search",
        Kt = "[data-predictive-search-results]",
        Qt = "[data-predictive-search-status]",
        Xt = "[data-predictive-search-live-region-count-value]",
        Yt = "[data-search-results-wrapper]",
        Jt = "reset",
        Zt = "data-aos-anchor",
        te = "aria-hidden",
        ee = "open",
        ie = "loading",
        se = "data-loading-text",
        oe = "results";
    customElements.define(
        "predictive-search",
        class extends Ut {
            connectedCallback() {
                this.predictiveSearchResults.addEventListener("transitionend", (t) => {
                    t.target !== this.predictiveSearchResults || this.getQuery().length || (this.classList.remove(Jt), requestAnimationFrame(() => this.clearResultsHTML()));
                });
            }
            onChange() {
                super.onChange(), this.classList.remove(Jt), this.searchTerm.length ? requestAnimationFrame(() => this.getSearchResults(this.searchTerm)) : this.classList.add(Jt);
            }
            onFocus() {
                super.onFocus(), this.currentSearchTerm.length && (this.searchTerm !== this.currentSearchTerm ? this.onChange() : "true" === this.getAttribute(oe) ? this.open() : this.getSearchResults(this.searchTerm));
            }
            getSearchResults(t) {
                const e = t.replace(" ", "-").toLowerCase(),
                    i = parseInt(window.theme.settings.suggestionsResultsLimit);
                let s = "query";
                (s += window.theme.settings.suggestArticles ? ",article" : ""),
                    (s += window.theme.settings.suggestCollections ? ",collection" : ""),
                    (s += window.theme.settings.suggestProducts ? ",product" : ""),
                    (s += window.theme.settings.suggestPages ? ",page" : ""),
                    this.setLiveRegionLoadingState(),
                    this.cachedResults[e]
                        ? this.renderSearchResults(this.cachedResults[e])
                        : fetch(`${theme.routes.predictiveSearchUrl}?q=${encodeURIComponent(t)}&resources[type]=${s}&resources[limit]=${i}&section_id=api-predictive-search`, { signal: this.abortController.signal })
                              .then((t) => {
                                  if (!t.ok) {
                                      var e = new Error(t.status);
                                      throw (this.close(), e);
                                  }
                                  return t.text();
                              })
                              .then((t) => {
                                  const i = new DOMParser().parseFromString(t, "text/html").querySelector(Gt).innerHTML;
                                  this.allPredictiveSearchInstances.forEach((t) => {
                                      t.cachedResults[e] = i;
                                  }),
                                      this.renderSearchResults(i);
                              })
                              .catch((t) => {
                                  if (20 !== (null == t ? void 0 : t.code)) throw (this.close(), t);
                              });
            }
            switchOption(t) {
                super.switchOption(t), this.statusElement && (this.statusElement.textContent = "");
            }
            setLiveRegionLoadingState() {
                (this.statusElement = this.statusElement || this.querySelector(Qt)), (this.loadingText = this.loadingText || this.getAttribute(se)), this.setLiveRegionText(this.loadingText), this.setAttribute(ie, !0);
            }
            setLiveRegionText(t) {
                this.statusElement.setAttribute(te, "false"),
                    (this.statusElement.textContent = t),
                    setTimeout(() => {
                        this.statusElement.setAttribute(te, "true");
                    }, 1e3);
            }
            renderSearchResults(t) {
                this.predictiveSearchResults.innerHTML = t;
                const e = this.predictiveSearchResults.parentElement.id,
                    i = this.predictiveSearchResults.querySelector(Yt),
                    s = i.id;
                (i.id = `${s}--${e}`), i.setAttribute(Zt, `#${i.id}`), this.setAttribute(oe, !0), this.setLiveRegionResults(), this.open();
            }
            setLiveRegionResults() {
                this.removeAttribute(ie), this.setLiveRegionText(this.querySelector(Xt).textContent);
            }
            open() {
                this.setAttribute(ee, !0);
            }
            close(t = !1) {
                this.closeResults(t);
            }
            closeResults(t = !1) {
                t && (this.reset(), this.removeAttribute(oe), this.classList.remove(Jt)), this.removeAttribute(ie), this.removeAttribute(ee);
            }
            clearResultsHTML() {
                this.predictiveSearchResults.innerHTML = "";
            }
            constructor() {
                super(), (this.abortController = new AbortController()), (this.allPredictiveSearchInstances = document.querySelectorAll(jt)), (this.predictiveSearchResults = this.querySelector(Kt)), (this.cachedResults = {});
            }
        }
    );
    let ne = class extends HTMLElement {
        constructor() {
            super(),
                document.addEventListener("DOMContentLoaded", () => {
                    document.documentElement.classList.remove("page-loading");
                });
        }
    };
    function re() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
    function ae() {
        return re() >= window.theme.sizes.small;
    }
    function le() {
        return re() < window.theme.sizes.small;
    }
    const ce = {
            aos: "[data-aos]:not(.aos-animate)",
            aosAnchor: "[data-aos-anchor]",
            animatable: "[data-aos], [data-aos-anchor]",
            watchMutations: '[id^="api-cart-items-"], [data-collection-filters], [data-collection-products], #AjaxinateLoop, [data-tab="resultsProducts"]',
            skeletonLoading: ".skeleton-loading",
            textHighlight: "text-highlight",
            counterUps: "text-count-up",
            flickitySlider: ".flickity-slider",
            slide: "[data-slide]",
            carouselMobile: ".carousel--mobile",
        },
        he = { aosAnimate: "aos-animate", isLoading: "is-loading", isSelected: ".is-selected" },
        de = {
            aos: "data-aos",
            aosAnchor: "data-aos-anchor",
            aosIntersection: "data-aos-intersection",
            aosDebounce: "data-aos-debounce",
            aosCustomInit: "data-aos-custom-init",
            aosWatchAnchors: "data-aos-watch-anchors",
            aosTrigger: "data-aos-trigger",
            aosCarouselMobile: "data-aos-carousel-mobile",
            aosCarouselDesktop: "data-aos-carousel-desktop",
        },
        ue = 0.1,
        pe = 0;
    let me = new Set();
    function ge(t) {
        t.length &&
            (t.forEach((t) => {
                const e = t.dataset.aosAnchor;
                let i;
                "" != e && (i = document.querySelector(e)), i && !me.has(t) && me.add(i);
            }),
            me.forEach((t) => {
                fe.observe(t);
            }));
    }
    const fe = new IntersectionObserver(
        (t, e) => {
            t.forEach((t) => {
                const i = t.target,
                    s = t.intersectionRatio,
                    o = t.isIntersecting;
                let n,
                    r = ue;
                i.hasAttribute(de.aosIntersection) && (r = Number(i.getAttribute(de.aosIntersection)));
                let a = pe;
                i.hasAttribute(de.aosDebounce) && (a = Number(i.getAttribute(de.aosDebounce))), o && s > r && (0 !== a ? (n && clearTimeout(n), (n = setTimeout(() => ye(i), a))) : ye(i), e.unobserve(i), me.delete(i));
            });
        },
        { root: null, rootMargin: "0px", threshold: [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.5, 0.75, 1] }
    );
    function ye(t) {
        if (!t) return;
        ve(t);
        const e = t.closest(ce.skeletonLoading);
        if (
            (e &&
                e.querySelectorAll("img").forEach((t) => {
                    t.classList.contains(he.isLoading) && t.setAttribute("loading", "eager");
                }),
            t.hasAttribute(de.aosCarouselDesktop) && ae())
        ) {
            if (t.querySelector(ce.flickitySlider)) {
                const e = t.querySelectorAll(ce.slide),
                    i = [...e].filter((t) => {
                        if (t.matches(he.isSelected)) return t;
                    }),
                    s = [...e].filter((t) => {
                        if (!t.matches(he.isSelected)) return t;
                    });
                if (i.length > 0) {
                    const t = i[i.length - 1].id;
                    i[i.length - 1].setAttribute(de.aosTrigger, `#${t}`),
                        s.forEach((e) => {
                            e.querySelectorAll(ce.animatable).forEach((e) => {
                                e.setAttribute(de.aosAnchor, `#${t}`);
                            });
                        });
                }
            }
        }
        if (t.hasAttribute(de.aosCarouselMobile) && le()) {
            const e = t.querySelector(ce.carouselMobile);
            if (e) {
                const t = [...e.children],
                    i = t[0].id;
                t.length > 1 &&
                    (t[0].setAttribute(de.aosTrigger, `#${i}`),
                    t.forEach((t) => {
                        t.querySelectorAll(ce.animatable).forEach((t) => {
                            t.setAttribute(de.aosAnchor, `#${i}`);
                        });
                    }));
            }
        }
        if (t.hasAttribute(de.aosTrigger)) {
            const e = t.getAttribute(de.aosTrigger);
            document.querySelectorAll(`[${de.aosAnchor}="${e}"]`).forEach((t) => ve(t));
        }
        let i = t.querySelectorAll(ce.aos);
        if (t.hasAttribute(de.aosWatchAnchors)) {
            i = [...i].filter((e) => {
                const i = !!e.hasAttribute(de.aosAnchor) && e.getAttribute(de.aosAnchor);
                if (i && `#${t.id}` === i) return e;
            });
        }
        i.forEach((e) => {
            e.hasAttribute(de.aosCustomInit) ? t.dispatchEvent(new CustomEvent("theme:target:animate", { bubbles: !0, detail: e })) : ve(e);
        });
    }
    function ve(t) {
        requestAnimationFrame(() => t.classList.add(he.aosAnimate)),
            (function (t) {
                const e = t.querySelectorAll(ce.textHighlight);
                e.forEach((t) => t.shouldAnimate());
            })(t),
            (function (t) {
                const e = t.querySelectorAll(ce.counterUps);
                e.forEach((t) => t.shouldAnimate());
            })(t);
    }
    function be() {
        ge(document.querySelectorAll(ce.aosAnchor)),
            (function () {
                const t = (t) => t instanceof HTMLElement;
                new MutationObserver((e) => {
                    for (const i of e) {
                        if ("childList" === !i.type) return;
                        const e = i.target,
                            s = [...i.addedNodes],
                            o = [...i.removedNodes],
                            n = e.matches(ce.watchMutations) || s.some((e) => !!t(e) && e.matches(ce.watchMutations)) || o.some((e) => !!t(e) && e.matches(ce.watchMutations)),
                            r = e.matches(ce.animatable) || s.some((e) => !!t(e) && e.matches(ce.animatable)),
                            a = null !== e.querySelector(`[${de.aosAnchor}="#${e.id}"]`);
                        (r || a || n) && ge(e.querySelectorAll(ce.aosAnchor));
                    }
                }).observe(document.body, { attributes: !1, childList: !0, subtree: !0 });
            })();
    }
    const we = (t) => {
            clearTimeout(t.countUpTimeout), t._countUpOrigInnerHTML && ((t.innerHTML = t._countUpOrigInnerHTML), (t._countUpOrigInnerHTML = void 0)), (t.style.visibility = "");
        },
        Se = (t, e = {}) => {
            const { duration: i = 1e3, delay: s = 16 } = e,
                o = i / s,
                n = t.toString().split(/(<[^>]+>|[0-9.][,.0-9]*[0-9]*)/),
                r = [];
            for (let t = 0; t < o; t++) r.push("");
            for (let t = 0; t < n.length; t++)
                if (/([0-9.][,.0-9]*[0-9]*)/.test(n[t]) && !/<[^>]+>/.test(n[t])) {
                    let e = n[t];
                    const i = [...e.matchAll(/[.,]/g)].map((t) => ({ char: t[0], i: e.length - t.index - 1 })).sort((t, e) => t.i - e.i);
                    e = e.replace(/[.,]/g, "");
                    let s = r.length - 1;
                    for (let t = o; t >= 1; t--) {
                        let n = parseInt((e / o) * t, 10);
                        (n = i.reduce((t, { char: e, i: i }) => (t.length <= i ? t : t.slice(0, -i) + e + t.slice(-i)), n.toString())), (r[s--] += n);
                    }
                } else for (let e = 0; e < o; e++) r[e] += n[t];
            return (r[r.length] = t.toString()), r;
        };
    const Ee = "data-count-up-duration",
        Le = "data-count-up-init";
    let ke = class extends HTMLElement {
        connectedCallback() {
            theme.settings.animationsEnabled || this.startCountUp();
        }
        attributeChangedCallback(t, e, i) {
            null === e && t === Le && "true" === i && this.startCountUp();
        }
        shouldAnimate() {
            requestAnimationFrame(() => this.setTriggerAttribute());
        }
        setTriggerAttribute(t = !0) {
            this.setAttribute(Le, t);
        }
        startCountUp() {
            ((t, e = {}) => {
                const { action: i = "start", duration: s = 1e3, delay: o = 16 } = e;
                if ("stop" === i) return void we(t);
                if ((we(t), !/[0-9]/.test(t.innerHTML))) return;
                const n = Se(t.innerHTML, { duration: s || t.getAttribute("data-duration"), delay: o || t.getAttribute("data-delay") });
                (t._countUpOrigInnerHTML = t.innerHTML), (t.innerHTML = n[0] || "&nbsp;"), (t.style.visibility = "visible");
                const r = function () {
                    (t.innerHTML = n.shift() || "&nbsp;"), n.length ? (clearTimeout(t.countUpTimeout), (t.countUpTimeout = setTimeout(r, o))) : (t._countUpOrigInnerHTML = void 0);
                };
                t.countUpTimeout = setTimeout(r, o);
            })(this, { duration: this.duration, delay: 0.016 * this.duration });
        }
        constructor() {
            super(), (this.container = this), (this.countUpDuration = this.getAttribute(Ee)), (this.duration = (100 / parseInt(this.countUpDuration, 10)) * 1e3);
        }
    };
    !(function (t, e, i) {
        e in t ? Object.defineProperty(t, e, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = i);
    })(ke, "observedAttributes", [Le]),
        (window.requestIdleCallback =
            window.requestIdleCallback ||
            function (t) {
                var e = Date.now();
                return setTimeout(function () {
                    t({
                        didTimeout: !1,
                        timeRemaining: function () {
                            return Math.max(0, 50 - (Date.now() - e));
                        },
                    });
                }, 1);
            }),
        (window.cancelIdleCallback =
            window.cancelIdleCallback ||
            function (t) {
                clearTimeout(t);
            }),
        window.addEventListener("resize", o(et, 50)),
        (function () {
            let t;
            window.addEventListener(
                "scroll",
                function () {
                    t && window.cancelAnimationFrame(t),
                        (t = window.requestAnimationFrame(function () {
                            !(function () {
                                const t = window.pageYOffset;
                                t > it ? ((ot = !0), (st = !1)) : t < it ? ((ot = !1), (st = !0)) : ((st = null), (ot = null)),
                                    (it = t),
                                    document.dispatchEvent(new CustomEvent("theme:scroll", { detail: { up: st, down: ot, position: t }, bubbles: !1 })),
                                    st && !nt && document.dispatchEvent(new CustomEvent("theme:scroll:up", { detail: { position: t }, bubbles: !1 })),
                                    ot && !rt && document.dispatchEvent(new CustomEvent("theme:scroll:down", { detail: { position: t }, bubbles: !1 })),
                                    (rt = ot),
                                    (nt = st);
                            })();
                        }));
                },
                { passive: !0 }
            ),
                window.addEventListener("theme:scroll:lock", ct),
                window.addEventListener("theme:scroll:unlock", ht);
        })(),
        "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
            ? ((document.documentElement.className = document.documentElement.className.replace("no-touch", "supports-touch")), (window.theme.touch = !0))
            : (window.theme.touch = !1),
        document.addEventListener(
            "load",
            (t) => {
                if ("img" == t.target.tagName.toLowerCase() && t.target.classList.contains(mt.loading)) {
                    t.target.classList.remove(mt.loading), t.target.parentNode.classList.remove(mt.loading);
                    const e = t.target.closest(gt.section);
                    e && e.classList.add(mt.imgIn);
                }
            },
            !0
        );
    const Ae = o(() => {
        p();
    }, 300);
    window.addEventListener("DOMContentLoaded", () => {
        W(), tt(document), pt(document), ft(document), window.theme.settings.animationsEnabled && be();
    }),
        document.addEventListener("shopify:section:load", (t) => {
            const e = t.target;
            window.dispatchEvent(new Event("resize"), { bubbles: !0 }), tt(e), pt(e), W(), Ae(), A(e), _(), window.theme.settings.animationsEnabled && be();
        }),
        document.addEventListener("shopify:section:reorder", (t) => {
            const e = t.target;
            Ae(), A(e), _(), window.theme.settings.animationsEnabled && be();
        }),
        document.addEventListener("shopify:section:unload", (t) => {
            const e = t.target;
            Ae(), A(e), _();
        }),
        customElements.get("text-highlight") || customElements.define("text-highlight", zt),
        customElements.get("deferred-loading") || customElements.define("deferred-loading", At),
        customElements.get("loading-overlay") || customElements.define("loading-overlay", ne),
        customElements.get("text-count-up") || customElements.define("text-count-up", ke),
        (function () {
            function t(t) {
                var e = window.innerWidth || document.documentElement.clientWidth,
                    i = window.innerHeight || document.documentElement.clientHeight,
                    s = t.getBoundingClientRect();
                return s.top >= 0 && s.bottom <= i && s.left >= 0 && s.right <= e;
            }
            function e(t) {
                var e = window.innerWidth || document.documentElement.clientWidth,
                    i = window.innerHeight || document.documentElement.clientHeight,
                    s = t.getBoundingClientRect(),
                    o = (s.left >= 0 && s.left <= e) || (s.right >= 0 && s.right <= e),
                    n = (s.top >= 0 && s.top <= i) || (s.bottom >= 0 && s.bottom <= i);
                return o && n;
            }
            window.visibilityHelper = {
                isElementTotallyVisible: t,
                isElementPartiallyVisible: e,
                inViewportPartially: function (t, i) {
                    function s() {
                        var s = e(t);
                        s != o && ((o = s), "function" == typeof i && i(s, t));
                    }
                    var o = e(t);
                    window.addEventListener("load", s), window.addEventListener("resize", s), window.addEventListener("scroll", s);
                },
                inViewportTotally: function (e, i) {
                    function s() {
                        var s = t(e);
                        s != o && ((o = s), "function" == typeof i && i(s, e));
                    }
                    var o = t(e);
                    window.addEventListener("load", s), window.addEventListener("resize", s), window.addEventListener("scroll", s);
                },
            };
        })();
    const Ce = (t, e) => {
        let i, s;
        return function o(...n) {
            const r = Date.now();
            (s = clearTimeout(s)), !i || r - i >= e ? (t.apply(null, n), (i = r)) : (s = setTimeout(o.bind(null, ...n), e - (r - i)));
        };
    };
    function qe(t) {
        (this.status = t.status || null), (this.headers = t.headers || null), (this.json = t.json || null), (this.body = t.body || null);
    }
    qe.prototype = Error.prototype;
    const Te = "[data-collapsible-single]",
        Pe = "[data-collapsible-trigger]",
        xe = "[data-collapsible-content]",
        Ie = "is-expanded",
        He = "aria-expanded",
        Fe = "aria-controls",
        Me = "data-collapsible-trigger-mobile",
        De = "data-collapsible-transition-override",
        Oe = 500,
        Be = {};
    let ze = class {
        init() {
            this.triggers.forEach((t) => {
                t.addEventListener("click", this.collapsibleToggleEvent), t.addEventListener("keyup", this.collapsibleToggleEvent);
            });
        }
        collapsibleToggle(t) {
            t.preventDefault();
            const e = t.target.matches(Pe) ? t.target : t.target.closest(Pe),
                i = e.getAttribute(Fe),
                s = document.getElementById(i),
                o = e.hasAttribute(Me),
                n = e.classList.contains(Ie),
                r = t.code === theme.keyboardKeys.SPACE,
                a = t.code === theme.keyboardKeys.ESCAPE,
                l = window.innerWidth < theme.sizes.small;
            (this.isTransitioning && !this.transitionOverride) ||
                ((!t.code || r || a) &&
                    ((!n && a) ||
                        (o && !l) ||
                        ((this.isTransitioning = !0),
                        (e.disabled = !0),
                        this.single &&
                            this.triggers.forEach((t) => {
                                const i = t.classList.contains(Ie);
                                if (e == t || !i) return;
                                const s = t.getAttribute(Fe),
                                    o = document.getElementById(s);
                                requestAnimationFrame(() => {
                                    this.closeItem(o, t);
                                });
                            }),
                        n
                            ? requestAnimationFrame(() => {
                                  this.closeItem(s, e);
                              })
                            : requestAnimationFrame(() => {
                                  this.openItem(s, e);
                              }))));
        }
        openItem(t, e) {
            let i = t.querySelector(xe).offsetHeight;
            this.setDropdownHeight(t, i, e, !0), e.classList.add(Ie), e.setAttribute(He, !0), e.dispatchEvent(new CustomEvent("theme:form:sticky", { bubbles: !0, detail: { element: "accordion" } }));
        }
        closeItem(t, e) {
            let i = t.querySelector(xe).offsetHeight;
            requestAnimationFrame(() => {
                (i = 0), this.setDropdownHeight(t, i, e, !1), e.classList.remove(Ie);
            }),
                this.setDropdownHeight(t, i, e, !1),
                e.classList.remove(Ie),
                e.setAttribute(He, !1);
        }
        setDropdownHeight(t, e, i, s) {
            (t.style.height = `${e}px`),
                t.setAttribute(He, s),
                t.classList.toggle(Ie, s),
                this.resetHeightTimer && clearTimeout(this.resetHeightTimer),
                0 == e &&
                    (this.resetHeightTimer = setTimeout(() => {
                        t.style.height = "";
                    }, Oe)),
                s
                    ? (this.resetHeightTimer = setTimeout(() => {
                          (t.style.height = "auto"), (this.isTransitioning = !1);
                      }, Oe))
                    : (this.isTransitioning = !1),
                setTimeout(() => {
                    i.disabled = !1;
                }, Oe);
        }
        onUnload() {
            this.triggers.forEach((t) => {
                t.removeEventListener("click", this.collapsibleToggleEvent), t.removeEventListener("keyup", this.collapsibleToggleEvent);
            });
        }
        constructor(t) {
            (this.container = t),
                (this.single = this.container.querySelector(Te)),
                (this.triggers = this.container.querySelectorAll(Pe)),
                (this.resetHeightTimer = 0),
                (this.isTransitioning = !1),
                (this.transitionOverride = this.container.hasAttribute(De)),
                (this.collapsibleToggleEvent = (t) => Ce(this.collapsibleToggle(t), 1250)),
                this.init();
        }
    };
    const _e = {
            onLoad() {
                Be[this.id] = new ze(this.container);
            },
            onUnload() {
                Be[this.id].onUnload();
            },
        },
        $e = "[data-quantity-holder]",
        Re = "[data-quantity-field]",
        Ve = "[data-quantity-button]",
        Ne = "[data-quantity-minus]",
        We = "[data-quantity-plus]",
        Ue = "read-only",
        je = "is-disabled";
    let Ge = class {
        init() {
            (this.quantity = this.holder.querySelector($e)),
                this.quantity &&
                    ((this.field = this.quantity.querySelector(Re)),
                    (this.buttons = this.quantity.querySelectorAll(Ve)),
                    (this.increaseButton = this.quantity.querySelector(We)),
                    (this.quantityValue = Number(this.field.value || 0)),
                    (this.cartItemID = this.field.getAttribute("data-id")),
                    (this.maxValue = Number(this.field.getAttribute("max")) > 0 ? Number(this.field.getAttribute("max")) : null),
                    (this.minValue = Number(this.field.getAttribute("min")) > 0 ? Number(this.field.getAttribute("min")) : 0),
                    (this.disableIncrease = this.disableIncrease.bind(this)),
                    (this.emptyField = !1),
                    (this.updateQuantity = this.updateQuantity.bind(this)),
                    (this.decrease = this.decrease.bind(this)),
                    (this.increase = this.increase.bind(this)),
                    this.disableIncrease(),
                    this.quantity.classList.contains(Ue) || (this.changeValueOnClick(), this.changeValueOnInput()));
        }
        changeValueOnClick() {
            this.buttons.forEach((t) => {
                t.addEventListener("click", (t) => {
                    t.preventDefault(), (this.quantityValue = Number(this.field.value || 0));
                    const e = t.target,
                        i = e.matches(Ne) || e.closest(Ne),
                        s = e.matches(We) || e.closest(We);
                    i && this.decrease(), s && this.increase(), this.updateQuantity();
                });
            });
        }
        changeValueOnInput() {
            this.field.addEventListener("input", () => {
                (this.quantityValue = this.field.value), this.updateQuantity();
            });
        }
        updateQuantity() {
            this.maxValue < this.quantityValue && null !== this.maxValue && (this.quantityValue = this.maxValue),
                this.minValue > this.quantityValue && (this.quantityValue = this.minValue),
                (this.field.value = this.quantityValue),
                this.disableIncrease(),
                document.dispatchEvent(new CustomEvent("theme:cart:update")),
                this.quantityUpdateCart && this.updateCart();
        }
        decrease() {
            this.quantityValue > this.minValue ? this.quantityValue-- : (this.quantityValue = 0);
        }
        increase() {
            this.quantityValue++;
        }
        disableIncrease() {
            this.increaseButton.classList.toggle(je, this.quantityValue >= this.maxValue && null !== this.maxValue);
        }
        updateCart() {
            if ("" === this.quantityValue) return;
            const t = new CustomEvent("theme:cart:update", { bubbles: !0, detail: { id: this.cartItemID, quantity: this.quantityValue } });
            this.holder.dispatchEvent(t);
        }
        constructor(t, e = !1) {
            (this.holder = t), (this.quantityUpdateCart = e);
        }
    };
    const Ke = {
        state: { firstFocusable: null, lastFocusable: null, trigger: null },
        trapFocus: function (t) {
            var e = Array.from(t.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])')).filter(function (t) {
                var e = t.offsetWidth,
                    i = t.offsetHeight;
                return 0 !== e && 0 !== i && "none" !== getComputedStyle(t).getPropertyValue("display");
            });
            (e = e.filter(function (t) {
                return !t.classList.contains("deferred-media__poster");
            })),
                (this.state.firstFocusable = e[0]),
                (this.state.lastFocusable = e[e.length - 1]),
                t.elementToFocus || (t.elementToFocus = this.state.firstFocusable || t.container),
                this._setupHandlers(),
                document.addEventListener("focusin", this._onFocusInHandler),
                document.addEventListener("focusout", this._onFocusOutHandler),
                t.container.setAttribute("tabindex", "-1"),
                t.elementToFocus.focus();
        },
        removeTrapFocus: function (t) {
            const e = !document.body.classList.contains("no-outline");
            t && t.container && t.container.removeAttribute("tabindex"), document.removeEventListener("focusin", this._onFocusInHandler), this.state.trigger && e && this.state.trigger.focus();
        },
        _manageFocus: function (t) {
            t.code === theme.keyboardKeys.TAB &&
                (t.target !== this.state.lastFocusable || t.shiftKey || (t.preventDefault(), this.state.firstFocusable.focus()),
                t.target === this.state.firstFocusable && t.shiftKey && (t.preventDefault(), this.state.lastFocusable.focus()));
        },
        _onFocusOut: function () {
            document.removeEventListener("keydown", this._manageFocusHandler);
        },
        _onFocusIn: function (t) {
            (t.target !== this.state.lastFocusable && t.target !== this.state.firstFocusable) || document.addEventListener("keydown", this._manageFocusHandler);
        },
        _setupHandlers: function () {
            this._onFocusInHandler || (this._onFocusInHandler = this._onFocusIn.bind(this)),
                this._onFocusOutHandler || (this._onFocusOutHandler = this._onFocusIn.bind(this)),
                this._manageFocusHandler || (this._manageFocusHandler = this._manageFocus.bind(this));
        },
    };
    const Qe = {};
    function Xe(t = {}) {
        if ((t.type || (t.type = "json"), t.url))
            return Qe[t.url]
                ? Qe[t.url]
                : (function (t, e) {
                      const i = new Promise((i, s) => {
                          "text" === e
                              ? fetch(t)
                                    .then((t) => t.text())
                                    .then((t) => {
                                        i(t);
                                    })
                                    .catch((t) => {
                                        s(t);
                                    })
                              : (function (t, e, i) {
                                    let s = document.getElementsByTagName("head")[0],
                                        o = !1,
                                        n = document.createElement("script");
                                    (n.src = t),
                                        (n.onload = n.onreadystatechange = function () {
                                            o || (this.readyState && "loaded" != this.readyState && "complete" != this.readyState) ? i() : ((o = !0), e());
                                        }),
                                        s.appendChild(n);
                                })(
                                    t,
                                    function () {
                                        i();
                                    },
                                    function () {
                                        s();
                                    }
                                );
                      });
                      return (Qe[t] = i), i;
                  })(t.url, t.type);
        if (t.json)
            return Qe[t.json]
                ? Promise.resolve(Qe[t.json])
                : window
                      .fetch(t.json)
                      .then((t) => t.json())
                      .then((e) => ((Qe[t.json] = e), e));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return Qe[e]
                ? Qe[e]
                : (function (t) {
                      const e = "".concat(t.name, t.version),
                          i = new Promise((e, i) => {
                              try {
                                  window.Shopify.loadFeatures([
                                      {
                                          name: t.name,
                                          version: t.version,
                                          onLoad: (t) => {
                                              !(function (t, e, i) {
                                                  i ? e(i) : t();
                                              })(e, i, t);
                                          },
                                      },
                                  ]);
                              } catch (t) {
                                  i(t);
                              }
                          });
                      return (Qe[e] = i), i;
                  })(t);
        }
        return Promise.reject();
    }
    (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
    const Ye = "[data-video-id]",
        Je = "loaded",
        Ze = "data-enable-sound",
        ti = "data-enable-background",
        ei = "data-enable-autoplay",
        ii = "data-enable-loop",
        si = "data-video-id",
        oi = "data-video-type";
    const ni = { videoIframe: "[data-video-id]", videoWrapper: ".video-wrapper", youtubeWrapper: "[data-youtube-wrapper]" },
        ri = "data-section-id",
        ai = "data-enable-sound",
        li = "data-check-player-visibility",
        ci = "data-video-id",
        hi = "data-video-type",
        di = "loaded",
        ui = [];
    const pi = "[data-notification-form]",
        mi = "[data-notification]",
        gi = "[data-popup-close]",
        fi = "pswp--success",
        yi = "notification-popup-visible";
    function vi(t) {
        const i = e.data(t);
        i &&
            (i.on("dragStart", (t, e) => {
                document.ontouchmove = function (t) {
                    t.preventDefault();
                };
            }),
            i.on("dragEnd", (t, e) => {
                document.ontouchmove = function (t) {
                    return !0;
                };
            }));
    }
    const bi = "html5",
        wi = "youtube",
        Si = "vimeo",
        Ei = "[data-deferred-media]",
        Li = "[data-deferred-media-button]",
        ki = "[data-product-single-media-wrapper]",
        Ai = "[data-video]",
        Ci = ".media--hidden",
        qi = "media--hidden",
        Ti = "loaded",
        Pi = "data-section-id",
        xi = "data-autoplay-video",
        Ii = "data-media-id";
    let Hi = class {
        init() {
            this.container.querySelectorAll(Ai).forEach((t) => {
                const e = t.querySelector(Li);
                e && e.addEventListener("click", this.loadContent.bind(this, t)), this.autoplayVideo && this.loadContent(t);
            });
        }
        loadContent(t) {
            if (t.querySelector(Ei).getAttribute(Ti)) return;
            const e = document.createElement("div");
            e.appendChild(t.querySelector("template").content.firstElementChild.cloneNode(!0));
            const i = t.dataset.mediaId,
                s = e.querySelector("video, iframe"),
                o = this.hostFromVideoElement(s),
                n = t.querySelector(Ei);
            n.appendChild(s),
                n.setAttribute("loaded", !0),
                (this.players[i] = {
                    mediaId: i,
                    sectionId: this.id,
                    container: t,
                    element: s,
                    host: o,
                    ready: () => {
                        this.createPlayer(i);
                    },
                });
            const r = this.players[i];
            switch (r.host) {
                case bi:
                    this.loadVideo(r, bi);
                    break;
                case Si:
                    window.isVimeoAPILoaded ? this.loadVideo(r, Si) : Xe({ url: "https://player.vimeo.com/api/player.js" }).then(() => this.loadVideo(r, Si));
                    break;
                case wi:
                    window.isYoutubeAPILoaded ? this.loadVideo(r, wi) : Xe({ url: "https://www.youtube.com/iframe_api" }).then(() => this.loadVideo(r, wi));
            }
        }
        hostFromVideoElement(t) {
            if ("VIDEO" === t.tagName) return bi;
            if ("IFRAME" === t.tagName) {
                if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(t.src)) return wi;
                if (t.src.includes("vimeo.com")) return Si;
            }
            return null;
        }
        loadVideo(t, e) {
            t.host === e && t.ready();
        }
        createPlayer(t) {
            const e = this.players[t];
            switch (e.host) {
                case bi:
                    e.element.addEventListener("play", () => {
                        e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                    }),
                        e.element.addEventListener("pause", () => {
                            e.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 });
                        }),
                        this.autoplayVideo && this.observeVideo(e, t);
                    break;
                case Si:
                    (e.player = new Vimeo.Player(e.element)),
                        e.player.play(),
                        e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 }),
                        (window.isVimeoAPILoaded = !0),
                        e.player.on("play", () => {
                            e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                        }),
                        e.player.on("pause", () => {
                            e.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 });
                        }),
                        this.autoplayVideo && this.observeVideo(e, t);
                    break;
                case wi:
                    if (e.host == wi && e.player) return;
                    YT.ready(() => {
                        const i = e.container.dataset.videoId;
                        (e.player = new YT.Player(e.element, {
                            videoId: i,
                            events: {
                                onReady: (t) => {
                                    t.target.playVideo(), e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                                },
                                onStateChange: (t) => {
                                    1 == t.data && e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 }),
                                        2 == t.data && e.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 }),
                                        0 == t.data && e.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 });
                                },
                            },
                        })),
                            (window.isYoutubeAPILoaded = !0),
                            this.autoplayVideo && this.observeVideo(e, t);
                    });
            }
            e.container.addEventListener("theme:media:visible", (t) => this.onVisible(t)), e.container.addEventListener("theme:media:hidden", (t) => this.onHidden(t)), e.container.addEventListener("xrLaunch", (t) => this.onHidden(t));
        }
        observeVideo(t) {
            new IntersectionObserver(
                (e, i) => {
                    e.forEach((e) => {
                        const i = 0 == e.intersectionRatio,
                            s = !t.element.closest(Ci);
                        i ? this.pauseVideo(t) : s && this.playVideo(t);
                    });
                },
                { rootMargin: "200px", threshold: [0, 0.25, 0.75, 1] }
            ).observe(t.element);
        }
        playVideo(t) {
            t.player && t.player.playVideo ? t.player.playVideo() : t.element && t.element.play ? t.element.play() : t.player && t.player.play && t.player.play(),
                t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
        }
        pauseVideo(t) {
            if (t.player && t.player.pauseVideo) "1" == t.player.playerInfo.playerState && t.player.pauseVideo();
            else if (t.player && t.player.pause) t.player.pause();
            else if (t.element && !t.element.paused) {
                var e;
                if ("function" == typeof t.element.pause) null === (e = t.element) || void 0 === e || e.pause();
            }
        }
        onHidden(t) {
            if (void 0 !== t.target.dataset.mediaId) {
                const e = t.target.dataset.mediaId,
                    i = this.players[e];
                this.pauseVideo(i);
            }
        }
        onVisible(t) {
            if (void 0 !== t.target.dataset.mediaId) {
                const e = t.target.dataset.mediaId,
                    i = this.players[e];
                setTimeout(() => {
                    this.playVideo(i);
                }, 50),
                    this.pauseContainerMedia(e);
            }
        }
        pauseOtherMedia(t, e) {
            const i = `[${Ii}="${t}"]`,
                s = e.querySelectorAll(`${ki}:not(${i})`);
            s.length &&
                s.forEach((t) => {
                    t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(qi);
                });
        }
        constructor(t) {
            (this.container = t),
                (this.id = this.container.getAttribute(Pi)),
                (this.autoplayVideo = "true" === this.container.getAttribute(xi)),
                (this.players = {}),
                (this.pauseContainerMedia = (t, e = this.container) => this.pauseOtherMedia(t, e)),
                this.init();
        }
    };
    function Fi(t, e, i = [], s = !1) {
        const o = new FormData(t),
            n = new URLSearchParams(o);
        if (!e) return n.toString();
        const r = new FormData(e),
            a = new URLSearchParams(r),
            l = [];
        for (const t of o.entries()) "" === t[1] && l.push(t[0]);
        for (const t of r.entries()) "" === t[1] && l.push(t[0]);
        for (let t = 0; t < l.length; t++) {
            const e = l[t];
            n.has(e) && n.delete(e), a.has(e) && a.delete(e);
        }
        for (const t of n.keys()) a.has(t) && a.delete(t);
        if (i.length > 0)
            for (let t = 0; t < i.length; t++) {
                const e = i[t];
                n.has(e) && n.delete(e), a.has(e) && a.delete(e);
            }
        return s && (a.has("type") && a.delete("type"), n.set("type", s)), `${n.toString()}&${a.toString()}`;
    }
    const Mi = "[data-custom-scrollbar]",
        Di = "[data-custom-scrollbar-items]",
        Oi = "[data-custom-scrollbar-thumb]",
        Bi = ".current";
    let zi = class {
        calculateTrack(t) {
            if (!t) return this.scrollbar.style.setProperty("--thumb-scale", 0), void this.scrollbar.style.setProperty("--thumb-position", "0px");
            const e = t.clientWidth / this.scrollbarThumb.parentElement.clientWidth,
                i = t.offsetLeft / this.scrollbarThumb.parentElement.clientWidth;
            this.scrollbar.style.setProperty("--thumb-scale", e), this.scrollbar.style.setProperty("--thumb-position", this.trackWidth * i + "px");
        }
        calculateScrollbar() {
            if (this.scrollbarItems.children.length) {
                const t = [...this.scrollbarItems.children];
                (this.trackWidth = 0),
                    t.forEach((t) => {
                        this.trackWidth += t.getBoundingClientRect().width + parseInt(window.getComputedStyle(t).marginRight);
                    }),
                    this.scrollbar.style.setProperty("--track-width", `${this.trackWidth}px`);
            }
        }
        onScrollbarChange(t) {
            t && t.detail && t.detail.element && this.container.contains(t.detail.element) && this.calculateTrack(t.detail.element);
        }
        events() {
            document.addEventListener("theme:resize:width", this.calcScrollbarEvent), document.addEventListener("theme:custom-scrollbar:change", this.onScrollbarChangeEvent);
        }
        unload() {
            document.removeEventListener("theme:resize:width", this.calcScrollbarEvent), document.removeEventListener("theme:custom-scrollbar:change", this.onScrollbarChangeEvent);
        }
        constructor(t) {
            (this.container = t),
                (this.scrollbarItems = t.querySelector(Di)),
                (this.scrollbar = t.querySelector(Mi)),
                (this.scrollbarThumb = t.querySelector(Oi)),
                (this.trackWidth = 0),
                (this.calcScrollbarEvent = () => this.calculateScrollbar()),
                (this.onScrollbarChangeEvent = (t) => this.onScrollbarChange(t)),
                this.scrollbar && this.scrollbarItems && (this.events(), this.calculateScrollbar(), this.scrollbarItems.children.length && this.calculateTrack(this.scrollbarItems.querySelector(Bi)));
        }
    };
    const _i = "[data-tooltip]",
        $i = "[data-tooltip-container]",
        Ri = "[data-tooltip-arrow]",
        Vi = "[data-aos]",
        Ni = "tooltip-default",
        Wi = "is-animating",
        Ui = "is-visible",
        ji = "is-hiding",
        Gi = "data-aos",
        Ki = "data-tooltip",
        Qi = "data-tooltip-container",
        Xi = "data-tooltip-stop-mouseenter",
        Yi = {};
    let Ji = class {
        init() {
            if (!document.querySelector($i)) {
                const t = `<div class="${this.rootClass}__inner"><div class="${this.rootClass}__arrow" data-tooltip-arrow></div><div class="${this.rootClass}__text label-typography"></div></div>`,
                    e = document.createElement("div");
                (e.className = `${this.rootClass} ${this.isAnimatingClass}`), e.setAttribute(Qi, ""), (e.innerHTML = t), document.body.appendChild(e);
            }
            this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
                this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
                this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
                document.addEventListener("theme:tooltip:close", this.removePinEvent);
            const t = document.querySelector($i);
            theme.settings.animationsEnabled &&
                this.animatedContainer &&
                ("hero" === this.animatedContainer.getAttribute(Gi)
                    ? this.animatedContainer.addEventListener("animationend", () => {
                          t.classList.remove(Wi);
                      })
                    : this.animatedContainer.addEventListener("transitionend", (e) => {
                          "transform" === e.propertyName && t.classList.remove(Wi);
                      }));
        }
        addPin(t = !1) {
            const e = document.querySelector($i),
                i = e.querySelector(Ri);
            if (e && ((t && !this.tooltip.hasAttribute(Xi)) || !t)) {
                const t = e.querySelector(`.${this.rootClass}__inner`);
                e.querySelector(`.${this.rootClass}__text`).textContent = this.label;
                const s = t.offsetWidth,
                    o = this.tooltip.getBoundingClientRect(),
                    n = o.top,
                    r = o.width,
                    a = n + o.height + window.scrollY;
                let l = o.left - s / 2 + r / 2,
                    c = "50%";
                const h = l + s - window.innerWidth;
                h > 0 && (l -= h), l < 0 && ((c = `calc(50% + ${l}px)`), (l = 0)), (i.style.left = c), (e.style.transform = `translate(${l}px, ${a}px)`), e.classList.remove(ji);
                const d = (i) => {
                    i.target === t && (("transform" !== i.propertyName && "opacity" !== i.propertyName) || requestAnimationFrame(() => (e.style.transform = "translate(0, -100%)")), e.removeEventListener("transitionend", d));
                };
                e.addEventListener("transitionend", d), e.classList.add(Ui), document.addEventListener("theme:scroll", this.removePinEvent);
            }
        }
        removePin(t, e = !1, i = !1) {
            const s = document.querySelector($i),
                o = s.classList.contains(Ui);
            s &&
                ((e && !this.tooltip.hasAttribute(Xi)) || !e) &&
                (o &&
                    (i || t.detail.hideTransition) &&
                    (s.classList.add(ji),
                    this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout),
                    (this.hideTransitionTimeout = setTimeout(() => {
                        s.classList.remove(ji);
                    }, this.transitionSpeed))),
                s.classList.remove(Ui),
                document.removeEventListener("theme:scroll", this.removePinEvent));
        }
        unload() {
            this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
                this.tooltip.removeEventListener("mouseleave", this.removePinMouseEvent),
                this.tooltip.removeEventListener("theme:tooltip:init", this.addPinEvent),
                document.removeEventListener("theme:tooltip:close", this.removePinEvent),
                document.removeEventListener("theme:scroll", this.removePinEvent);
        }
        constructor(t) {
            (this.tooltip = t),
                this.tooltip.hasAttribute(Ki) &&
                    ((this.rootClass = Ni),
                    (this.isAnimatingClass = Wi),
                    (this.label = this.tooltip.getAttribute(Ki)),
                    (this.transitionSpeed = 200),
                    (this.hideTransitionTimeout = 0),
                    (this.animatedContainer = this.tooltip.closest(Vi)),
                    (this.addPinEvent = () => this.addPin()),
                    (this.addPinMouseEvent = () => this.addPin(!0)),
                    (this.removePinEvent = (t) => Ce(this.removePin(t), 50)),
                    (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
                    this.init());
        }
    };
    const Zi = {
            onLoad() {
                Yi[this.id] = [];
                this.container.querySelectorAll(_i).forEach((t) => {
                    Yi[this.id].push(new Ji(t));
                });
            },
            onUnload() {
                Yi[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        ts = "[data-range-slider]",
        es = "[data-range-left]",
        is = "[data-range-right]",
        ss = "[data-range-line]",
        os = "[data-range-holder]",
        ns = "data-se-min",
        rs = "data-se-max",
        as = "data-se-min-value",
        ls = "data-se-max-value",
        cs = "data-se-step",
        hs = "data-range-filter-update",
        ds = "[data-field-price-min]",
        us = "[data-field-price-max]",
        ps = "is-initialized";
    function ms() {
        this.entries = [];
    }
    function gs(t, e) {
        fs(t);
        var i = (function (t, e) {
            fs(t),
                (function (t) {
                    if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
                    if (0 === t.length) throw new Error(t + " is empty.");
                    if (!t[0].hasOwnProperty("name")) throw new Error(t[0] + "does not contain name key.");
                    if ("string" != typeof t[0].name) throw new TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.");
                })(e);
            var i = [];
            return (
                e.forEach(function (e) {
                    for (var s = 0; s < t.options.length; s++) {
                        if ((t.options[s].name || t.options[s]).toLowerCase() === e.name.toLowerCase()) {
                            i[s] = e.value;
                            break;
                        }
                    }
                }),
                i
            );
        })(t, e);
        return (function (t, e) {
            fs(t),
                (function (t) {
                    if (Array.isArray(t) && "object" == typeof t[0]) throw new Error(t + "is not a valid array of options.");
                })(e);
            var i = t.variants.filter(function (t) {
                return e.every(function (e, i) {
                    return t.options[i] === e;
                });
            });
            return i[0] || null;
        })(t, i);
    }
    function fs(t) {
        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
        if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + " is empty.");
    }
    (ms.prototype.add = function (t, e, i) {
        this.entries.push({ element: t, event: e, fn: i }), t.addEventListener(e, i);
    }),
        (ms.prototype.removeAll = function () {
            this.entries = this.entries.filter(function (t) {
                return t.element.removeEventListener(t.event, t.fn), !1;
            });
        });
    var ys = '[name="id"]',
        vs = '[name="selling_plan"]',
        bs = '[name^="options"]',
        ws = '[name="quantity"]',
        Ss = '[name^="properties"]';
    const Es = { color: "ash" },
        Ls = "[data-swatch]",
        ks = "[data-product-block]",
        As = "[data-product-image-hover]",
        Cs = "[data-button-quick-view]",
        qs = "[data-grid-image]",
        Ts = "[data-grid-link]",
        Ps = "[data-swatches-more]",
        xs = "[data-section-type]",
        Is = "[data-swatches-container]",
        Hs = "[data-swatches-label]",
        Fs = "[data-swatches-button]",
        Ms = "[data-option-position]",
        Ds = "[data-slider]",
        Os = "product__media--featured-visible",
        Bs = "product__media__hover-img--visible",
        zs = "swatch__link--no-image",
        _s = "no-outline",
        $s = "is-visible",
        Rs = "selector-wrapper--large",
        Vs = "data-swatch",
        Ns = "data-swatch-handle",
        Ws = "data-swatch-label",
        Us = "data-swatch-image",
        js = "data-swatch-image-id",
        Gs = "data-swatch-variant",
        Ks = "data-variant-id",
        Qs = "data-variant-secondary-id";
    let Xs = {};
    const Ys = {};
    let Js = class {
            init() {
                this.setStyles(), this.variant && this.outer && this.handleClicks(), !this.image && this.swatchLink && this.swatchLink.classList.add(zs);
            }
            setStyles() {
                "native" == window.theme.settings.colorSwatchesType ||
                    (this.colorMatch && this.colorMatch.hex && this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`),
                    this.colorMatch && this.colorMatch.path && this.element.style.setProperty("background-image", `url(${this.colorMatch.path})`));
            }
            handleClicks() {
                this.swatchLink.addEventListener("click", (t) => {
                    const e = !document.body.classList.contains(_s),
                        i = this.swatchLink.getAttribute(Gs);
                    e || (t.preventDefault(), this.updateImagesAndLinksOnEvent(i));
                }),
                    this.swatchLink.addEventListener("keyup", (t) => {
                        const e = !document.body.classList.contains(_s),
                            i = this.swatchLink.getAttribute(Gs);
                        (t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER) ||
                            e ||
                            (t.preventDefault(), this.swatchLink.dispatchEvent(new Event("mouseenter", { bubbles: !0 })), this.updateImagesAndLinksOnEvent(i));
                    });
            }
            updateImagesAndLinksOnEvent(t) {
                this.updateLinks(), this.replaceImages(t);
            }
            updateLinks() {
                (this.linkElements = this.outer.querySelectorAll(Ts)),
                    (this.quickView = this.outer.querySelector(Cs)),
                    this.linkElements.length &&
                        this.linkElements.forEach((t) => {
                            const e = ((i = t.getAttribute("href")), (s = this.variant), /variant=/.test(i) ? i.replace(/(variant=)[^&]+/, "$1" + s) : /\?/.test(i) ? i.concat("&variant=").concat(s) : i.concat("?variant=").concat(s));
                            var i, s;
                            t.setAttribute("href", e);
                        }),
                    this.quickView && "quick_buy" === theme.settings.quickBuy && this.quickView.setAttribute(Ks, this.variant);
            }
            replaceImages(t) {
                const e = this.outer.querySelector(`[${Qs}="${t}"]`),
                    i = this.outer.querySelector(`[${Ks}="${t}"]`),
                    s = [...this.outer.querySelectorAll(qs)].find((t) => t.classList.contains(Os));
                if (i && this.imageId) {
                    if (!e || !s) return;
                    const t = () => {
                        requestAnimationFrame(() => {
                            s.classList.remove(Os),
                                i.classList.add(Os),
                                requestAnimationFrame(() => {
                                    e.classList.remove(Os);
                                });
                        }),
                            e.removeEventListener("animationend", t);
                    };
                    requestAnimationFrame(() => {
                        e.classList.add(Os);
                    }),
                        e.addEventListener("animationend", t);
                }
                "image" === theme.settings.productGridHover && (this.hoverImages = this.outer.querySelectorAll(As)),
                    this.hoverImages.length > 1 &&
                        this.hoverImages.forEach((t) => {
                            t.classList.remove(Bs), t.getAttribute(Ks) === this.variant ? t.classList.add(Bs) : this.hoverImages[0].classList.add(Bs);
                        });
            }
            constructor(t) {
                (this.element = t),
                    (this.swatchLink = this.element.nextElementSibling),
                    (this.colorString = t.getAttribute(Vs)),
                    (this.image = this.element.getAttribute(Us)),
                    (this.imageId = this.element.getAttribute(js)),
                    (this.variant = this.element.getAttribute(Gs)),
                    (this.outer = this.element.closest(ks)),
                    (this.hoverImages = []);
                const e = new (class {
                    getColor() {
                        return this.match;
                    }
                    init() {
                        return Xe({ json: theme.assets.swatches })
                            .then((t) => this.matchColors(t, this.settings.color))
                            .catch((t) => {
                                console.log("failed to load swatch colors script"), console.log(t);
                            });
                    }
                    matchColors(t, e) {
                        let i = "#E5E5E5",
                            s = null;
                        const o = theme.assets.base || "/",
                            n = e.toLowerCase().replace(/\s/g, ""),
                            r = t.colors;
                        if (r) {
                            let t = null;
                            if (
                                r.filter((e, i) => {
                                    if (Object.keys(e).toString().toLowerCase().replace(/\s/g, "") === n) return (t = i), e;
                                }).length &&
                                null !== t
                            ) {
                                const e = Object.values(r[t])[0];
                                (i = e), (e.includes(".jpg") || e.includes(".jpeg") || e.includes(".png") || e.includes(".svg")) && ((s = `${o}${e}`), (i = "#888888"));
                            }
                        }
                        return { color: this.settings.color, path: s, hex: i };
                    }
                    constructor(t = {}) {
                        (this.settings = { ...Es, ...t }), (this.match = this.init());
                    }
                })({ color: this.colorString });
                e.getColor().then((t) => {
                    (this.colorMatch = t), this.init();
                });
            }
        },
        Zs = class extends HTMLElement {
            init() {
                (this.swatchElements = this.querySelectorAll(Ls)),
                    this.swatchElements.forEach((t) => {
                        new Js(t);
                    }),
                    this.handleShowMore();
            }
            handleShowMore() {
                (this.initialHeight = this.offsetHeight), (this.expandedHeight = this.initialHeight);
                const t = this.closest(xs),
                    e = this.querySelector(Ps);
                e &&
                    (null == e ||
                        e.addEventListener("click", () => {
                            this.classList.add($s);
                        }),
                    null == t ||
                        t.addEventListener("touchstart", (t) => {
                            this.contains(t.target) || (this.classList.remove($s), this.dispatchEvent(new Event("mouseleave", { bubbles: !0 })));
                        }),
                    this.addEventListener("mouseenter", () => {
                        const t = (e) => {
                            this.expandedHeight = this.offsetHeight;
                            const i = e.target.closest(Ds);
                            this.expandedHeight > this.initialHeight && i && requestAnimationFrame(() => i.dispatchEvent(new CustomEvent("theme:slider:resize", { bubbles: !1 }))), this.removeEventListener("animationstart", t);
                        };
                        this.addEventListener("animationstart", t);
                    }),
                    this.addEventListener("mouseleave", () => {
                        const t = (e) => {
                            const i = e.target.closest(Ds);
                            this.expandedHeight > this.initialHeight && i && requestAnimationFrame(() => i.dispatchEvent(new CustomEvent("theme:slider:resize", { bubbles: !1 }))), this.removeEventListener("animationstart", t);
                        };
                        this.addEventListener("animationstart", t);
                    }));
            }
            constructor() {
                super(),
                    (this.handle = this.getAttribute(Ns)),
                    (this.label = this.getAttribute(Ws).trim().toLowerCase()),
                    (function (t) {
                        const e = `${theme.routes.root}products/${t}.js`;
                        return window
                            .fetch(e)
                            .then((t) => t.json())
                            .catch((t) => {
                                console.error(t);
                            });
                    })(this.handle).then((t) => {
                        (this.product = t), (this.colorOption = t.options.find((t) => t.name.toLowerCase() === this.label || null)), this.colorOption && ((this.swatches = this.colorOption.values), this.init());
                    });
            }
        },
        to = class {
            checkSwatchesHeight(t) {
                const e = t.querySelector(Hs),
                    i = t.querySelector(Fs),
                    s = parseInt(window.getComputedStyle(t).getPropertyValue("padding-top")),
                    o = parseInt(window.getComputedStyle(e).getPropertyValue("margin-bottom")),
                    n = parseInt(window.getComputedStyle(i).getPropertyValue("margin-bottom")),
                    r = t.closest(Ms);
                r.classList.remove(Rs), t.offsetHeight - s > e.offsetHeight + o + 2 * i.offsetHeight + 2 * n && (t.style.setProperty("--swatches-max-height", `${t.offsetHeight}px`), r.classList.add(Rs));
            }
            onUnload() {
                this.swatchesContainers.forEach((t) => {
                    document.removeEventListener("theme:resize:width", this.checkSwatchesHeightOnResize);
                });
            }
            constructor(t) {
                (this.container = t),
                    (this.swatchesContainers = this.container.querySelectorAll(Is)),
                    this.swatchesContainers.forEach((t) => {
                        (this.checkSwatchesHeightOnResize = () => this.checkSwatchesHeight(t)), this.checkSwatchesHeight(t), document.addEventListener("theme:resize:width", this.checkSwatchesHeightOnResize);
                    });
            }
        };
    const eo = (t) => {
            Xs = [];
            t.querySelectorAll(Ls).forEach((t) => {
                Xs.push(new Js(t));
            });
        },
        io = {
            onLoad() {
                eo(this.container);
            },
        },
        so = {
            onLoad() {
                Ys[this.id] = new to(this.container);
            },
            onUnload() {
                Ys[this.id].onUnload();
            },
        },
        oo = "[data-slider]",
        no = "[data-product-media-container]",
        ro = "[data-product-media-slideshow]",
        ao = "[data-product-media-slideshow-slide]",
        lo = "[data-product-slideshow-progress]",
        co = ".flickity-button",
        ho = "[data-product]",
        uo = "[data-popup-close]",
        po = "fill",
        mo = "js-quick-view-visible",
        go = {};
    let fo = class {
        productGridSlideshow() {
            const t = this.container.querySelectorAll(ro),
                i = this.container.querySelectorAll(no);
            t.length &&
                t.forEach((t) => {
                    const i = t.closest(no),
                        s = i.querySelector(lo),
                        o = t.querySelectorAll(ao).length,
                        n = 2200,
                        r = !this.sliders.length;
                    let a = new e.data(t),
                        l = 0,
                        c = ao;
                    !a.isActive &&
                        o > 1 &&
                        ((a = new e(t, {
                            draggable: r,
                            cellSelector: c,
                            contain: !0,
                            wrapAround: !0,
                            imagesLoaded: !0,
                            pageDots: !1,
                            prevNextButtons: !1,
                            adaptiveHeight: !1,
                            pauseAutoPlayOnHover: !1,
                            selectedAttraction: 0.2,
                            friction: 1,
                            on: {
                                ready: () => {
                                    this.container.style.setProperty("--autoplay-speed", "2200ms");
                                },
                                change: () => {
                                    l && clearTimeout(l),
                                        s.classList.remove(po),
                                        s.offsetWidth,
                                        requestAnimationFrame(() => {
                                            s.classList.add(po);
                                        }),
                                        (l = setTimeout(() => {
                                            s.classList.remove(po);
                                        }, n));
                                },
                                dragEnd: () => {
                                    a.playPlayer();
                                },
                            },
                        })),
                        window.theme.touch ||
                            (i.addEventListener("mouseenter", () => {
                                s.classList.add(po),
                                    l && clearTimeout(l),
                                    (l = setTimeout(() => {
                                        s.classList.remove(po);
                                    }, n)),
                                    (a.options.autoPlay = n),
                                    a.playPlayer();
                            }),
                            i.addEventListener("mouseleave", () => {
                                a.stopPlayer(), l && clearTimeout(l), s.classList.remove(po);
                            })));
                }),
                i.length &&
                    i.forEach((t) => {
                        t.addEventListener("click", (t) => {
                            t.target.matches(co) && t.preventDefault();
                        });
                    });
        }
        popupClose() {
            const t = document.querySelector(ho);
            if (t) {
                t.querySelector(uo).dispatchEvent(new Event("click"));
            }
        }
        onBlockSelect() {
            this.body.classList.contains(mo) && this.popupClose();
        }
        onDeselect() {
            this.body.classList.contains(mo) && this.popupClose();
        }
        onUnload() {
            this.body.classList.contains(mo) && this.popupClose();
        }
        constructor(t) {
            (this.container = t),
                (this.body = document.body),
                (this.sliders = this.container.querySelectorAll(oo)),
                "slideshow" !== theme.settings.productGridHover || window.theme.touch || this.productGridSlideshow(),
                new eh(this.container);
        }
    };
    const yo = {
            onLoad() {
                go[this.id] = new fo(this.container);
            },
            onBlockSelect() {
                go[this.id].onBlockSelect();
            },
            onDeselect() {
                go[this.id].onDeselect();
            },
            onUnload() {
                go[this.id].onUnload();
            },
        },
        vo = "#AjaxinateLoop",
        bo = "#AjaxinatePagination",
        wo = "[data-product-block]",
        So = "[data-promo]",
        Eo = "data-ajaxinate-id",
        Lo = "data-columns-tablet",
        ko = "data-columns-mobile",
        Ao = "is-loaded",
        Co = "loaded-item",
        qo = "collection-promo--full",
        To = "collection-promo--two-columns",
        Po = "collection-promo--grid-second",
        xo = "collection-promo--grid-third",
        Io = "collection-promo--grid-even",
        Ho = "collection-promo--one-column";
    let Fo = {},
        Mo = class {
            init() {
                this.loadMoreFix(),
                    (this.ajaxinateContainer = this.container.querySelectorAll(vo)),
                    this.ajaxinateContainer.forEach((t) => {
                        const e = `${vo}[${Eo}="${t.dataset.ajaxinateId}"]`,
                            i = `${bo}[${Eo}="${t.dataset.ajaxinateId}"]`;
                        if (t.children.length > 0) {
                            const o = new s({ container: e, pagination: i, method: "scroll" }),
                                n = t.querySelectorAll(So),
                                r = Number(t.getAttribute(Lo)),
                                a = Number(t.getAttribute(ko));
                            if (r >= 3) {
                                let e = 0;
                                if (
                                    (n.forEach((t) => {
                                        t.classList.contains(qo)
                                            ? t.classList.contains(xo)
                                                ? (e += 1)
                                                : t.classList.contains(Po)
                                                ? (e += 2)
                                                : (e += 3)
                                            : t.classList.contains(To)
                                            ? t.classList.contains(xo)
                                                ? (e += 1)
                                                : (e += 2)
                                            : (e += 1);
                                    }),
                                    e > 0)
                                ) {
                                    let i = r - (e % r);
                                    i === r && (i = 0), t.classList.add(`grid--empty-items-tablet-${i}`);
                                }
                            }
                            if (2 === a) {
                                let e = 0;
                                if (
                                    (n.forEach((t) => {
                                        (t.classList.contains(Io) || t.classList.contains(Ho)) && (e += 1);
                                    }),
                                    e > 0)
                                ) {
                                    let i = a - (e % a);
                                    i === a && (i = 0), t.classList.add(`grid--empty-items-mobile-${i}`);
                                }
                            }
                            t.classList.add(Ao), this.endlessScroll.push(o);
                        }
                    });
            }
            update(t) {
                this.ajaxinateContainer = this.container.querySelectorAll(vo);
                const e = (e) => e.settings.container === t,
                    i = this.endlessScroll.find(e);
                if (i) {
                    const t = this.endlessScroll.findIndex(e);
                    this.endlessScroll.splice(t, 1), (i.settings.method = "scroll"), i.destroy();
                }
                const o = [...this.ajaxinateContainer].find((e) => `${vo}[${Eo}="${e.dataset.ajaxinateId}"]` === t);
                if (!o) return;
                const n = `${vo}[${Eo}="${o.dataset.ajaxinateId}"]`,
                    r = `${bo}[${Eo}="${o.dataset.ajaxinateId}"]`;
                if (!(o.children.length > 0)) return;
                const a = new s({ container: n, pagination: r, method: "scroll" });
                o.classList.add(Ao), this.endlessScroll.push(a);
            }
            loadMoreFix() {
                s.prototype.loadMore = function () {
                    (this.request = new XMLHttpRequest()),
                        (this.request.onreadystatechange = function () {
                            if (!this.request.responseXML) return;
                            if (4 === !this.request.readyState || 200 === !this.request.status) return;
                            const t = this.request.responseXML.querySelector(this.settings.container),
                                e = this.request.responseXML.querySelector(this.settings.pagination);
                            t.querySelectorAll(wo).forEach((t) => t.classList.add(Co)),
                                this.containerElement.insertAdjacentHTML("beforeend", t.innerHTML),
                                null == e
                                    ? this.removePaginationElement()
                                    : ((this.paginationElement.innerHTML = e.innerHTML), this.settings.callback && "function" == typeof this.settings.callback && this.settings.callback(this.request.responseXML), this.initialize());
                        }.bind(this)),
                        this.request.open("GET", this.nextPageUrl, !0),
                        (this.request.responseType = "document"),
                        this.request.send();
                };
            }
            unload() {
                this.endlessScroll.length > 0 &&
                    (this.endlessScroll.forEach((t) => {
                        (t.settings.method = "scroll"), t.destroy();
                    }),
                    this.ajaxinateContainer.forEach((t) => t.classList.remove(Ao)));
            }
            constructor(t) {
                (this.container = t), (this.endlessScroll = []), theme.settings.enableInfinityScroll && this.init();
            }
        };
    const Do = {
            onLoad() {
                Fo = new Mo(this.container);
            },
            onUnload: function () {
                "function" == typeof Fo.unload && Fo.unload();
            },
        },
        Oo = 300,
        Bo = "[data-toggle-filters]",
        zo = "[data-close-filters]",
        _o = "[data-open-filters]",
        $o = "[data-collection-wrapper]",
        Ro = "[data-collapsible-trigger]",
        Vo = "[data-sort-toggle]",
        No = "[data-collection-sort-options]",
        Wo = "[data-input-sort]",
        Uo = "[data-collection-filters]",
        jo = "[data-collection-filters-list]",
        Go = "[data-collection-sticky-bar]",
        Ko = "[data-collection-filter]",
        Qo = "[data-collection-filter-tag]",
        Xo = "[data-collection-filter-tag-button]",
        Yo = "[data-collection-filters-form]",
        Jo = "[data-filter-reset-button]",
        Zo = "[data-filter-tag-reset-button]",
        tn = '[data-section-type="popups"]',
        en = "[data-collection-products]",
        sn = "[data-products-count]",
        on = "[data-field-price-min]",
        nn = "[data-field-price-max]",
        rn = "[data-se-min-value]",
        an = "[data-se-max-value]",
        ln = "data-se-min-value",
        cn = "data-se-max-value",
        hn = "data-se-min",
        dn = "data-se-max",
        un = "[data-tooltip]",
        pn = "[data-tooltip-container]",
        mn = "[data-show-more]",
        gn = "[data-show-more-actions]",
        fn = "[data-show-more-container]",
        yn = "[data-show-more-trigger]",
        vn = "[data-search-performed]",
        bn = "[data-search-form]",
        wn = "[data-custom-scrollbar]",
        Sn = "is-active",
        En = "is-expanded",
        Ln = "is-visible",
        kn = "is-loading",
        An = "popup--visible",
        Cn = "collection__filters--visible",
        qn = "collection__sort__option-wrapper--visible",
        Tn = "data-filter-active",
        Pn = "data-prevent-scroll-lock",
        xn = "data-filters-default-state",
        In = "tabindex",
        Hn = "aria-expanded",
        Fn = "data-current-type",
        Mn = {};
    let Dn = class {
        initFacetedFilters() {
            "tag" != this.filterMode &&
                "group" != this.filterMode &&
                this.enableFilters &&
                (this.rangeSlider = new (class {
                    init() {
                        if (((this.slider = this.container.querySelector(ts)), !this.slider)) return;
                        (this.resizeFilters = o(this.reset.bind(this), 50)),
                            (this.onMoveEvent = (t) => this.onMove(t)),
                            (this.onStopEvent = (t) => this.onStop(t)),
                            (this.onStartEvent = (t) => this.onStart(t)),
                            (this.startX = 0),
                            (this.x = 0),
                            (this.touchLeft = this.slider.querySelector(es)),
                            (this.touchRight = this.slider.querySelector(is)),
                            (this.lineSpan = this.slider.querySelector(ss)),
                            (this.min = parseFloat(this.slider.getAttribute(ns))),
                            (this.max = parseFloat(this.slider.getAttribute(rs))),
                            (this.step = 0),
                            (this.normalizeFact = 20);
                        let t = this.min;
                        this.slider.hasAttribute(as) && (t = parseFloat(this.slider.getAttribute(as)));
                        let e = this.max;
                        this.slider.hasAttribute(ls) && (e = parseFloat(this.slider.getAttribute(ls))),
                            t < this.min && (t = this.min),
                            e > this.max && (e = this.max),
                            t > e && (t = e),
                            this.slider.getAttribute(cs) && (this.step = Math.abs(parseFloat(this.slider.getAttribute(cs)))),
                            this.reset(),
                            window.addEventListener("theme:resize", this.resizeFilters),
                            (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
                            (this.selectedTouch = null),
                            (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
                            this.setMinValue(t),
                            this.setMaxValue(e),
                            this.touchLeft.addEventListener("mousedown", this.onStartEvent),
                            this.touchRight.addEventListener("mousedown", this.onStartEvent),
                            this.touchLeft.addEventListener("touchstart", this.onStartEvent, { passive: !0 }),
                            this.touchRight.addEventListener("touchstart", this.onStartEvent, { passive: !0 }),
                            this.slider.classList.add(ps);
                    }
                    reset() {
                        (this.touchLeft.style.left = "0px"),
                            (this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                            (this.lineSpan.style.marginLeft = "0px"),
                            (this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                            (this.startX = 0),
                            (this.x = 0),
                            (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
                            (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact);
                    }
                    setMinValue(t) {
                        const e = (t - this.min) / (this.max - this.min);
                        (this.touchLeft.style.left = Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px"),
                            (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                            (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                            this.slider.setAttribute(as, t);
                    }
                    setMaxValue(t) {
                        const e = (t - this.min) / (this.max - this.min);
                        (this.touchRight.style.left = Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + "px"),
                            (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                            (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                            this.slider.setAttribute(ls, t);
                    }
                    onStart(t) {
                        t.preventDefault();
                        let e = t;
                        t.touches && (e = t.touches[0]),
                            t.currentTarget === this.touchLeft ? (this.x = this.touchLeft.offsetLeft) : t.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft),
                            (this.startX = e.pageX - this.x),
                            (this.selectedTouch = t.currentTarget),
                            document.addEventListener("mousemove", this.onMoveEvent),
                            document.addEventListener("mouseup", this.onStopEvent),
                            document.addEventListener("touchmove", this.onMoveEvent, { passive: !0 }),
                            document.addEventListener("touchend", this.onStopEvent, { passive: !0 });
                    }
                    onMove(t) {
                        let e = t;
                        t.touches && (e = t.touches[0]),
                            (this.x = e.pageX - this.startX),
                            this.selectedTouch === this.touchLeft
                                ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 ? (this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10) : this.x < 0 && (this.x = 0),
                                  (this.selectedTouch.style.left = this.x + "px"))
                                : this.selectedTouch === this.touchRight &&
                                  (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 ? (this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10) : this.x > this.maxX && (this.x = this.maxX),
                                  (this.selectedTouch.style.left = this.x + "px")),
                            (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                            (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                            this.calculateValue(),
                            this.slider.getAttribute("on-change") && new Function("min, max", this.slider.getAttribute("on-change"))(this.slider.getAttribute(as), this.slider.getAttribute(ls)),
                            this.onChange(this.slider.getAttribute(as), this.slider.getAttribute(ls));
                    }
                    onStop(t) {
                        document.removeEventListener("mousemove", this.onMoveEvent),
                            document.removeEventListener("mouseup", this.onStopEvent),
                            document.removeEventListener("touchmove", this.onMoveEvent, { passive: !0 }),
                            document.removeEventListener("touchend", this.onStopEvent, { passive: !0 }),
                            (this.selectedTouch = null),
                            this.calculateValue(),
                            this.onChanged(this.slider.getAttribute(as), this.slider.getAttribute(ls));
                    }
                    onChange(t, e) {
                        const i = this.slider.closest(os);
                        if (i) {
                            const s = i.querySelector(ds),
                                o = i.querySelector(us);
                            s && o && ((s.value = parseInt(t)), (o.value = parseInt(e)));
                        }
                    }
                    onChanged(t, e) {
                        this.slider.hasAttribute(hs) && this.slider.dispatchEvent(new CustomEvent("theme:filter:range-update", { bubbles: !0 }));
                    }
                    calculateValue() {
                        const t = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
                        let e = this.lineSpan.offsetLeft / this.initialValue,
                            i = e + t;
                        if (((e = e * (this.max - this.min) + this.min), (i = i * (this.max - this.min) + this.min), 0 !== this.step)) {
                            let t = Math.floor(e / this.step);
                            (e = this.step * t), (t = Math.floor(i / this.step)), (i = this.step * t);
                        }
                        this.selectedTouch === this.touchLeft && this.slider.setAttribute(as, e), this.selectedTouch === this.touchRight && this.slider.setAttribute(ls, i);
                    }
                    unload() {
                        document.removeEventListener("theme:filters:init", this.initListener), window.removeEventListener("theme:resize", this.resizeFilters);
                    }
                    constructor(t) {
                        (this.container = t), this.init(), (this.initListener = () => this.init()), document.addEventListener("theme:filters:init", this.initListener);
                    }
                })(this.container));
        }
        initTooltips() {
            var t, e;
            ((this.tooltips = this.container.querySelectorAll(un)), window.innerWidth < theme.sizes.small) && (this.tooltips = null === (e = this.productGrid) || void 0 === e ? void 0 : e.querySelectorAll(un));
            null === (t = this.tooltips) ||
                void 0 === t ||
                t.forEach((t) => {
                    new Ji(t);
                }),
                this.handleVisibleTooltips();
        }
        handleVisibleTooltips() {
            if (this.tooltips.length > 0) {
                const t = document.querySelector(pn);
                t.classList.contains(Ln) && t.classList.remove(Ln);
            }
        }
        updateRange() {
            const t = this.filtersForm.querySelector(rn),
                e = this.filtersForm.querySelector(an),
                i = this.filtersForm.querySelector(on),
                s = this.filtersForm.querySelector(nn);
            if (t.hasAttribute(ln) && e.hasAttribute(cn)) {
                const o = parseFloat(i.placeholder, 10),
                    n = parseFloat(s.placeholder, 10),
                    r = parseFloat(t.getAttribute(ln), 10),
                    a = parseFloat(e.getAttribute(cn), 10);
                (o === r && n === a) || ((i.value = parseInt(r)), (s.value = parseInt(a)), this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })));
            }
        }
        onSubmitHandler(t) {
            t.preventDefault();
            const e = new FormData(this.filtersForm),
                i = new URLSearchParams(e),
                s = [];
            let o = "";
            this.isSearchPage && ((this.searchForm = this.container.querySelector(bn)), (this.currentType = this.container.getAttribute(Fn)));
            const n = this.filtersForm.querySelector(rn),
                r = this.filtersForm.querySelector(an),
                a = this.filtersForm.querySelector(on),
                l = this.filtersForm.querySelector(nn);
            if (n && r && a && l && n.hasAttribute(hn) && r.hasAttribute(dn)) {
                const t = parseFloat(n.getAttribute(hn), 10),
                    e = parseFloat(r.getAttribute(dn), 10),
                    o = a.value ? parseFloat(a.value, 10) : t,
                    c = l.value ? parseFloat(l.value, 10) : e;
                o <= t && c >= e && (s.push("filter.v.price.gte"), s.push("filter.v.price.lte"), i.delete("filter.v.price.gte"), i.delete("filter.v.price.lte"));
            }
            if (((o = i.toString()), this.isSearchPage)) {
                o = Fi(this.searchForm, this.filtersForm, s);
                let t = "";
                "all" === this.currentType && (t = "&type=product"), o.indexOf("&type=product") > -1 && (t = ""), (o += t);
            }
            this.renderSection(o, t);
        }
        onHistoryChange(t) {
            var e;
            if (!this.filters) return;
            let i = (null === (e = t.state) || void 0 === e ? void 0 : e.searchParams) || "";
            if (this.isSearchPage) {
                t.state || (i = window.location.search);
                if (!(i.indexOf("type=product") > -1)) return;
            }
            this.renderSection(i, null, !1);
        }
        renderSection(t, e, i = !0) {
            this.startLoading();
            const s = `${window.location.pathname}?section_id=${this.sectionId}&${t}`,
                o = (t) => t.url === s;
            this.filterData.some(o) ? this.renderSectionFromCache(o, e) : this.renderSectionFromFetch(s, e), i && this.updateURLHash(t);
        }
        renderSectionFromFetch(t) {
            fetch(t)
                .then((t) => t.text())
                .then((e) => {
                    const i = e;
                    (this.filterData = [...this.filterData, { html: i, url: t }]),
                        (this.inputSort = this.container.querySelectorAll(Wo)),
                        this.renderFilters(i),
                        this.bindFilterButtonsEvents(),
                        this.hideFiltersOnMobile(),
                        this.renderProductGrid(i),
                        this.updateProductsCount(i),
                        this.finishLoading(),
                        this.mobileFiltersScrollLock(),
                        this.handleSearchPageActiveTab();
                });
        }
        renderSectionFromCache(t, e) {
            const i = this.filterData.find(t).html;
            this.renderFilters(i, e), this.hideFiltersOnMobile(), this.renderProductGrid(i), this.updateProductsCount(i), this.finishLoading(), this.mobileFiltersScrollLock(), this.handleSearchPageActiveTab();
        }
        handleSearchPageActiveTab() {
            this.isSearchPage && ((this.scrollable = this.container.querySelector(wn)), this.scrollable && !this.customScrollbar && (this.customScrollbar = new zi(this.container)));
        }
        renderProductGrid(t) {
            const e = new DOMParser().parseFromString(t, "text/html").querySelector(en);
            e && ((this.productGrid.innerHTML = e.innerHTML), this.initProductGridEvents(theme.settings.enableInfinityScroll), this.filterShowMore());
        }
        updateProductsCount(t) {
            const e = new DOMParser().parseFromString(t, "text/html").querySelector(sn);
            e && (this.productsCount.innerHTML = e.innerHTML);
        }
        renderFilters(t) {
            const e = new DOMParser().parseFromString(t, "text/html").querySelector(Uo);
            e &&
                ((this.filters.innerHTML = e.innerHTML),
                (this.filtersForm = document.querySelector(Yo)),
                this.bindFilterButtonsEvents(),
                this.bindToggleButtonsEvents(),
                eo(this.container),
                (this.collapsible = new ze(this.container)),
                document.dispatchEvent(new CustomEvent("theme:filters:init", { bubbles: !0 })));
        }
        updateURLHash(t) {
            history.pushState({ searchParams: t }, "", `${window.location.pathname}${t && "?".concat(t)}`);
        }
        bindFilterButtonsEvents() {
            this.inputSort.length > 0 &&
                this.inputSort.forEach((t) => {
                    t.addEventListener("change", this.updateCollectionFormSortEvent);
                }),
                this.filtersForm && (this.filtersForm.addEventListener("input", this.debouncedSubmitEvent.bind(this)), this.filtersForm.addEventListener("theme:filter:range-update", this.updateRangeEvent)),
                this.collectionSortOptions && this.collectionSortOptions.addEventListener("keyup", this.onTabHandlerEvent),
                "tag" != this.filterMode &&
                    "group" != this.filterMode &&
                    this.enableFilters &&
                    this.container.querySelectorAll(Jo).forEach((t) => {
                        t.addEventListener("click", this.onFilterResetClick, { once: !0 });
                    });
        }
        onFilterResetClick(t) {
            t.preventDefault(), this.renderSection(new URL(t.currentTarget.href).searchParams.toString());
        }
        bindToggleButtonsEvents() {
            var t;
            this.container.querySelectorAll(Bo).forEach((t) => {
                t.addEventListener("click", this.onFilterToggleClick);
            }),
                this.container.querySelectorAll(zo).forEach((t) => {
                    t.addEventListener("click", this.hideFiltersDrawer);
                }),
                this.container.querySelectorAll(_o).forEach((t) => {
                    t.addEventListener("click", this.showFiltersDrawer);
                }),
                null === (t = this.container.querySelector($o)) || void 0 === t || t.addEventListener("keyup", this.onKeyUpHandler);
        }
        onTabHandler(t) {
            if (t.code === theme.keyboardKeys.SPACE || t.code === theme.keyboardKeys.ENTER || t.code === theme.keyboardKeys.NUMPADENTER) {
                const e = t.target.previousElementSibling.value;
                this.filtersForm.querySelectorAll(Wo).forEach((t) => {
                    t.checked && (t.checked = !1), t.value === e && (t.checked = !0);
                }),
                    this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })),
                    t.target.dispatchEvent(new Event("click", { bubbles: !0 }));
            }
        }
        onKeyUpHandler(t) {
            t.code === theme.keyboardKeys.ESCAPE && this.hideFiltersDrawer();
        }
        onFilterToggleClick(t) {
            t.preventDefault(), U();
            this.filters.classList.contains(Cn) ? this.hideFiltersDrawer() : this.showFiltersDrawer();
        }
        sortDropdownToggle() {
            this.collectionSortOptions && this.collectionSortOptions.classList.toggle(qn);
        }
        bodyClick(t) {
            if (!this.collectionSortOptions) return;
            const e = this.sortToggle.contains(t.target);
            this.collectionSortOptions.classList.contains(qn) && !e && this.sortDropdownToggle();
        }
        updateCollectionFormSort(t) {
            const e = t.target,
                i = e.value,
                s = e.closest(No);
            this.container.querySelectorAll(Wo).forEach((t) => {
                t.value === i && (t.checked = !0);
            }),
                null !== s && this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 }));
        }
        showFiltersDrawer() {
            (this.a11y.state.trigger = document.querySelector(Bo)), this.a11y.trapFocus({ container: this.filters }), this.mobileFiltersScrollLock();
        }
        mobileFiltersScrollLock() {
            if (window.innerWidth < theme.sizes.small) {
                const t = document.querySelector(jo);
                this.filters.classList.contains(Cn) || this.filters.classList.add(Cn), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: t }));
            }
        }
        hideFiltersOnMobile() {
            const t = this.container.querySelectorAll(`${Ro}:not(${yn})`);
            window.innerWidth < theme.sizes.small &&
                requestAnimationFrame(() => {
                    t.forEach((t) => {
                        const e = "true" === t.getAttribute(Tn);
                        t.classList.contains(En) && !e && t.dispatchEvent(new Event("click"));
                    });
                });
        }
        showFiltersOnDesktop() {
            const t = this.container.querySelectorAll(`${Ro}:not(${yn})`),
                e = this.container.getAttribute(xn),
                i = "first-open" === e,
                s = "open" === e,
                o = "closed" === e,
                n = this.enableSorting ? 1 : 0;
            t.forEach((t, e) => {
                const r = t.classList.contains(En),
                    a = "true" === t.getAttribute(Tn),
                    l = a && !r && s;
                (a && !l) || (((o && r) || (i && !r && e === n) || (i && r && e !== n) || (s && !r) || l) && t.dispatchEvent(new Event("click")));
            });
        }
        hideFiltersDrawer() {
            let t = this.filters.classList.contains(Cn),
                e = this.container.classList.contains(kn);
            t && (this.filters.classList.remove(Cn), this.a11y.removeTrapFocus()), e || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: Oo }));
        }
        filtersResizeEvents() {
            window.innerWidth >= theme.sizes.small ? (this.showFiltersOnDesktop(), this.hideFiltersDrawer()) : this.hideFiltersOnMobile();
        }
        filterShowMore() {
            (this.showMore = this.container.querySelectorAll(mn)),
                0 !== this.showMore.length &&
                    this.showMore.forEach((t) => {
                        const e = t.querySelector(Ro),
                            i = t.querySelector(gn);
                        if (!i) return;
                        const s = i.querySelector(yn),
                            o = i.querySelector(fn),
                            n = o.querySelectorAll(window.theme.focusable);
                        "true" === o.getAttribute(Hn) ||
                            n.forEach((t) => {
                                t.setAttribute(In, "-1");
                            }),
                            s.addEventListener("keyup", (t) => {
                                (t.code !== theme.keyboardKeys.SPACE && t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER) || this.updateShowMoreFocusableElements(t, n);
                            }),
                            s.addEventListener("click", (t) => {
                                this.updateShowMoreFocusableElements(t, n);
                            }),
                            e.addEventListener("keyup", (t) => {
                                (t.code !== theme.keyboardKeys.SPACE && t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER) || this.updateCollapsedContainerFocusableElements(e, s, n);
                            }),
                            e.addEventListener("click", () => {
                                this.updateCollapsedContainerFocusableElements(e, s, n);
                            });
                    });
        }
        updateCollapsedContainerFocusableElements(t, e, i) {
            requestAnimationFrame(() => {
                const s = "true" === t.getAttribute(Hn),
                    o = "true" === e.getAttribute(Hn);
                i.forEach((t) => {
                    !s && o && t.setAttribute(In, "-1"), s && o && t.removeAttribute(In);
                });
            });
        }
        updateShowMoreFocusableElements(t, e) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    const i = "true" === t.target.getAttribute(Hn);
                    e.forEach((t, e) => {
                        if (i) return t.removeAttribute(In), void (0 === e && t.focus());
                        t.setAttribute(In, "-1");
                    });
                });
            });
        }
        initTagFilters() {
            ("tag" != this.filterMode && "group" != this.filterMode) || !this.enableFilters || ((this.tags = this.container.dataset.tags.split("+").filter((t) => t)), this.bindFilterTagButtonsEvents(), this.bindSortChangeEvent());
        }
        renderTagFiltersProducts(t) {
            this.startLoading(),
                "object" == typeof this.endlessCollection && this.endlessCollection.unload(),
                fetch(t)
                    .then((t) => t.text())
                    .then((e) => {
                        const i = e,
                            s = new DOMParser().parseFromString(i, "text/html"),
                            o = s.querySelector(en).innerHTML,
                            n = s.querySelector(Uo).innerHTML;
                        (this.productGrid.innerHTML = o),
                            (this.filters.innerHTML = n),
                            (this.inputSort = this.container.querySelectorAll(Wo)),
                            (this.filtersForm = document.querySelector(Yo)),
                            (this.filterData = [...this.filterData, { html: i, url: t }]),
                            (this.alreadyClicked = !1),
                            this.bindFilterTagButtonsEvents(),
                            this.bindFilterButtonsEvents(),
                            this.bindSortChangeEvent(),
                            this.bindToggleButtonsEvents(),
                            this.initProductGridEvents(theme.settings.enableInfinityScroll),
                            this.updateProductsCount(i),
                            this.mobileFiltersScrollLock(),
                            this.hideFiltersOnMobile(),
                            eo(this.container),
                            (this.collapsible = new ze(this.container)),
                            this.filterShowMore(),
                            history.replaceState && window.history.pushState({ path: t }, "", t);
                    })
                    .catch((t) => {
                        this.finishLoading(), console.log(`Error: ${t}`);
                    });
        }
        bindFilterTagButtonsEvents() {
            this.container.querySelectorAll(Xo).forEach((t) => {
                t.addEventListener("click", this.onFilterTagButtonClick.bind(this));
            }),
                this.container.querySelectorAll(Zo).forEach((t) => {
                    t.addEventListener("click", this.onFilterTagClearClick);
                }),
                this.container.querySelectorAll(Jo).forEach((t) => {
                    t.addEventListener("click", this.onFilterTagResetClick);
                });
        }
        bindSortChangeEvent() {
            this.container.querySelectorAll(Wo).forEach((t) => {
                t.addEventListener("input", this.debouncedSortEvent.bind(this));
            });
        }
        onFilterTagButtonClick(t) {
            if ((t.preventDefault(), this.alreadyClicked)) return;
            this.alreadyClicked = !0;
            const e = t.currentTarget,
                i = e.dataset.tag;
            if (e.parentNode.classList.contains(Sn)) {
                let t = this.tags.indexOf(i);
                e.parentNode.classList.remove(Sn), t > -1 && this.tags.splice(t, 1);
            } else e.parentNode.classList.add(Sn), this.tags.push(i);
            let s = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
            this.container.querySelector(Ko).classList.remove(En), this.container.querySelector(Ko).setAttribute(Hn, !1), this.container.setAttribute("data-tags", "[" + this.tags + "]"), this.renderTagFiltersProducts(s);
        }
        onFilterTagClearClick(t) {
            if ((t.preventDefault(), this.alreadyClicked)) return;
            this.alreadyClicked = !0;
            const e = t.currentTarget.dataset.tag,
                i = this.tags.indexOf(e);
            i > -1 && this.tags.splice(i, 1);
            const s = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
            this.container.setAttribute("data-tags", "[" + this.tags + "]"), this.renderTagFiltersProducts(s);
        }
        onSortChange() {
            let t = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
            this.renderTagFiltersProducts(t);
        }
        getSortValue() {
            let t = "";
            return (
                this.inputSort.forEach((e) => {
                    e.checked && (t = e.value);
                }),
                t
            );
        }
        onFilterTagResetClick(t) {
            if ((null == t || t.preventDefault(), this.alreadyClicked)) return;
            (this.alreadyClicked = !0),
                this.container.querySelectorAll(Qo).forEach((t) => {
                    t.classList.remove(Sn);
                }),
                this.container.querySelectorAll(Ko).forEach((t) => {
                    t.classList.remove(En), t.setAttribute(Hn, !1);
                }),
                (this.tags = []),
                this.container.setAttribute("data-tags", "");
            let e = this.collectionHandle + "/?sort_by=" + this.getSortValue();
            this.renderTagFiltersProducts(e);
        }
        getProductsOffsetTop() {
            return this.productGrid.getBoundingClientRect().top - document.body.getBoundingClientRect().top - this.filtersStickyBar.offsetHeight;
        }
        getStickyBarOffsetTop() {
            return this.filtersStickyBar.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
        }
        initProductGridEvents(t) {
            if (t) return this.initInfinityScroll(), void this.initProductGridEvents(!1);
            (this.productGridEvents = new fo(this.container)),
                this.initTooltips(),
                setTimeout(() => {
                    this.finishLoading();
                }, 1.5 * Oo);
        }
        initInfinityScroll() {
            if (this.isSearchPage) {
                if (!this.enableFilters) return;
                document.dispatchEvent(new CustomEvent("theme:tab:ajaxinate", { bubbles: !0, detail: "product" }));
            } else
                "object" == typeof this.endlessCollection && this.endlessCollection.unload(),
                    (this.endlessCollection = new Mo(this.container)),
                    0 !== this.endlessCollection.endlessScroll.length && (this.endlessCollection.endlessScroll[0].settings.callback = () => this.initProductGridEvents(!1));
        }
        startLoading() {
            this.container.classList.add(kn), window.innerWidth >= theme.sizes.small && document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
            let t = this.getProductsOffsetTop();
            window.scrollTo({ top: t, left: 0, behavior: "smooth" });
        }
        finishLoading() {
            const t = document.querySelectorAll(`${tn} .${An}`),
                e = t.length > 0;
            if ((this.container.classList.remove(kn), e)) {
                let e = 0;
                [...t].forEach((t) => {
                    t.hasAttribute(Pn) && (e += 1);
                }),
                    e === t.length && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: Oo }));
            } else window.innerWidth >= theme.sizes.small && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: Oo }));
        }
        onDeselect() {
            this.productGridEvents && this.productGridEvents.onDeselect();
        }
        onUnload() {
            "object" == typeof this.endlessCollection && this.endlessCollection.unload(),
                this.productGridEvents && this.productGridEvents.onUnload(),
                this.collapsible && this.collapsible.onUnload(),
                this.rangeSlider && this.rangeSlider.unload(),
                this.filters && document.removeEventListener("theme:resize:width", this.resizeEvent),
                document.removeEventListener("click", this.bodyClickEvent),
                this.groupTagFilters.length > 0 && this.onFilterTagResetClick(),
                this.finishLoading();
        }
        constructor(t) {
            var e;
            (this.container = t),
                (this.sectionId = t.dataset.sectionId),
                (this.enableFilters = "true" === t.dataset.enableFilters),
                (this.enableSorting = "true" === t.dataset.enableSorting),
                (this.filterMode = t.dataset.filterMode),
                (this.collectionHandle = this.container.dataset.collection),
                (this.isSearchPage = null != t.closest(vn)),
                (this.productGrid = this.container.querySelector(en)),
                (this.productsCount = this.container.querySelector(sn)),
                (this.groupTagFilters = this.container.querySelectorAll(Ko)),
                (this.filters = this.container.querySelector(Uo)),
                (this.filterTriggers = this.container.querySelectorAll(Ro)),
                (this.filtersStickyBar = this.container.querySelector(Go)),
                (this.filtersForm = this.container.querySelector(Yo)),
                (this.inputSort = this.container.querySelectorAll(Wo)),
                (this.sortToggle = this.container.querySelector(Vo)),
                (this.collectionSortOptions = this.container.querySelector(No)),
                (this.a11y = Ke),
                (this.filterData = []),
                (this.rangeSlider = null),
                (this.sortDropdownEvent = () => this.sortDropdownToggle()),
                (this.onTabHandlerEvent = (t) => this.onTabHandler(t)),
                (this.updateCollectionFormSortEvent = (t) => this.updateCollectionFormSort(t)),
                (this.bodyClickEvent = (t) => this.bodyClick(t)),
                (this.onFilterResetClick = this.onFilterResetClick.bind(this)),
                (this.onFilterTagResetClick = this.onFilterTagResetClick.bind(this)),
                (this.onFilterTagClearClick = this.onFilterTagClearClick.bind(this)),
                (this.onFilterToggleClick = this.onFilterToggleClick.bind(this)),
                (this.onKeyUpHandler = this.onKeyUpHandler.bind(this)),
                (this.updateRangeEvent = this.updateRange.bind(this)),
                (this.debouncedSubmitEvent = o((t) => {
                    this.onSubmitHandler(t);
                }, 500)),
                (this.debouncedSortEvent = o((t) => {
                    this.onSortChange(t);
                }, 500)),
                (this.productGridEvents = {}),
                this.filters &&
                    ((this.hideFiltersDrawer = this.hideFiltersDrawer.bind(this)),
                    (this.showFiltersDrawer = this.showFiltersDrawer.bind(this)),
                    (this.resizeEvent = o(() => {
                        this.filtersResizeEvents();
                    }, 500)),
                    this.filtersResizeEvents(),
                    document.addEventListener("theme:resize:width", this.resizeEvent)),
                this.initTagFilters(),
                this.initFacetedFilters(),
                this.bindToggleButtonsEvents(),
                this.bindFilterButtonsEvents(),
                this.initProductGridEvents(theme.settings.enableInfinityScroll),
                eo(this.container),
                (this.collapsible = new ze(this.container)),
                U(),
                window.addEventListener("popstate", this.onHistoryChange.bind(this)),
                null === (e = this.sortToggle) || void 0 === e || e.addEventListener("click", this.sortDropdownEvent),
                document.addEventListener("click", this.bodyClickEvent),
                this.filterShowMore();
        }
    };
    const On = {
            onLoad() {
                Mn[this.id] = new Dn(this.container);
            },
            onDeselect() {
                Mn[this.id].onDeselect();
            },
            onUnload() {
                Mn[this.id].onUnload();
            },
        },
        Bn = "[data-aos]",
        zn = "[data-aos-anchor]",
        _n = "[data-tabs-link]",
        $n = "[data-tab]",
        Rn = "[data-tab-ref]",
        Vn = "[data-custom-scrollbar]",
        Nn = "[data-custom-scrollbar-holder]",
        Wn = "[data-slider]",
        Un = "[data-tabs-contents]",
        jn = "[data-search-form]",
        Gn = "[data-all-types-container]",
        Kn = "[data-collection-filters-form]",
        Qn = "[data-current-page]",
        Xn = "[data-tooltip]",
        Yn = "[data-collection-products]",
        Jn = "#AjaxinateLoop",
        Zn = "current",
        tr = "hide",
        er = "alt",
        ir = "aos-animate",
        sr = "is-loaded",
        or = "data-tabs-link",
        nr = "data-tab",
        rr = "data-tab-ref",
        ar = "data-start-index",
        lr = "data-search-performed",
        cr = "data-type",
        hr = "data-current-type",
        dr = "data-all-types",
        ur = "data-current-page",
        pr = "data-ajaxinate-id",
        mr = {};
    let gr = class {
        assignSearchPageArguments() {
            this.isSearchPage &&
                ((this.searchForm = this.container.querySelector(jn)),
                (this.searchFormData = new FormData(this.searchForm)),
                (this.searchTerm = encodeURIComponent(this.searchFormData.get("q"))),
                (this.currentType = this.container.getAttribute(hr)),
                (this.sectionId = this.container.dataset.sectionId),
                (this.searchForAllTypes = "true" === this.container.getAttribute(dr)),
                (this.fetchURL = ""),
                (this.searchParams = ""),
                (this.cachedResults = {}),
                this.handleTabsHistory(),
                this.infiniteScrollListener(),
                this.initInfinityScroll(this.currentType));
        }
        init() {
            const t = this.container.querySelectorAll(_n),
                e = this.container.querySelector(`[${or}="${this.container.hasAttribute(ar) ? this.container.getAttribute(ar) : 0}"]`),
                i = this.container.querySelector(`[${nr}="${this.container.hasAttribute(ar) ? this.container.getAttribute(ar) : 0}"]`);
            null == i || i.classList.add(Zn),
                null == e || e.classList.add(Zn),
                this.checkVisibleTabsLinks(),
                t.forEach((t) => {
                    this.handleTabsNavListeners(t);
                });
        }
        handleTabsHistory() {
            window.addEventListener("popstate", this.onHistoryChange.bind(this)),
                (this.openTabFromHistoryEvent = (t) => this.openTabFromHistory(t)),
                this.tabsLink.forEach((t) => {
                    t.addEventListener("theme:tab:open-from-history", this.openTabFromHistoryEvent);
                });
        }
        handleTabsNavListeners(t) {
            const e = t.getAttribute(or),
                i = this.container.querySelector(`[${nr}="${e}"]`);
            i &&
                (t.addEventListener("click", (e) => {
                    this.isSearchPage && this.handleURLSearchParams(e, !0), this.tabChange(t, i);
                }),
                t.addEventListener("keyup", (e) => {
                    (e.code !== theme.keyboardKeys.SPACE && e.code !== theme.keyboardKeys.ENTER && e.code !== theme.keyboardKeys.NUMPADENTER) || (this.isSearchPage && this.handleURLSearchParams(e, !0), this.tabChange(t, i));
                }));
        }
        openTabFromHistory(t) {
            const e = t.target,
                i = this.container.querySelector(t.detail.element).getAttribute(or),
                s = this.container.querySelector(`[${nr}="${i}"]`);
            s && (this.handleURLSearchParams(t, !1), this.tabChange(e, s));
        }
        handleURLSearchParams(t, e = !0) {
            const i = t.target.matches(_n) ? t.target : t.target.closest(_n),
                s = i.getAttribute(cr),
                o = i.getAttribute(or),
                n = this.container.querySelector(`[${nr}="${o}"]`).querySelector(Qn),
                r = document.querySelector(Kn);
            let a = n ? `&page=${n.getAttribute(ur)}` : "";
            if (((this.searchParams = Fi(this.searchForm, r, [], s)), "product" === s)) {
                const t = this.searchParams.replace("&type=product", "");
                this.searchParams = `${t}&type=product`;
            } else this.searchParams = `q=${this.searchTerm}&type=${s}`;
            theme.settings.enableInfinityScroll || "" === a || (this.searchParams += a),
                (this.fetchURL = `${theme.routes.searchUrl}?${this.searchParams}&section_id=${this.sectionId}`),
                e && history.pushState({ searchParams: this.searchParams }, "", `${window.location.pathname}${this.searchParams && "?".concat(this.searchParams)}`);
        }
        tabChangeFetchContent(t, e) {
            const i = t.getAttribute(cr),
                s = t.getAttribute(or),
                o = this.container.querySelector(`[${nr}="${s}"]`),
                n = this.currentType === i;
            if (this.cachedResults[s] || n)
                return (
                    "product" !== i || this.searchFilters || (this.searchFilters = new Dn(this.container)),
                    void requestAnimationFrame(() => {
                        this.handleActiveTabClasses(t, e), this.scrollToCurrentTabLink(t), this.triggerTabAnimations(e), this.checkVisibleTabsLinks(), this.updateAjaxify(e, i);
                    })
                );
            fetch(this.fetchURL)
                .then((t) => {
                    if (!t.ok) {
                        throw new Error(t.status);
                    }
                    return t.text();
                })
                .then((n) => {
                    const r = new DOMParser().parseFromString(n, "text/html").querySelector(`[${nr}="${s}"]`).innerHTML;
                    var a;
                    this.searchForAllTypes && (null === (a = this.container.querySelector(Gn)) || void 0 === a || a.remove());
                    (this.cachedResults[s] = r),
                        (o.innerHTML = r),
                        "product" !== i || this.searchFilters || (this.searchFilters = new Dn(this.container)),
                        requestAnimationFrame(() => {
                            this.handleActiveTabClasses(t, e), this.scrollToCurrentTabLink(t), this.triggerTabAnimations(e), this.checkVisibleTabsLinks(), this.initInfinityScroll(i);
                        });
                })
                .catch((t) => {
                    throw t;
                });
        }
        onHistoryChange(t) {
            var e;
            const i = (null === (e = t.state) || void 0 === e ? void 0 : e.searchParams) || window.location.search,
                s = i.indexOf("type=product") > -1,
                o = i.indexOf("type=article") > -1,
                n = i.indexOf("type=page") > -1,
                r = s || o || n,
                a = this.container.querySelector(`${_n}[${cr}="product"]`),
                l = this.container.querySelector(`${_n}[${cr}="article"]`),
                c = this.container.querySelector(`${_n}[${cr}="page"]`);
            r
                ? (s && (null == a || a.dispatchEvent(new CustomEvent("theme:tab:open-from-history", { bubbles: !0, detail: { element: `[${cr}="product"]` } }))),
                  o && (null == l || l.dispatchEvent(new CustomEvent("theme:tab:open-from-history", { bubbles: !0, detail: { element: `[${cr}="article"]` } }))),
                  n && (null == c || c.dispatchEvent(new CustomEvent("theme:tab:open-from-history", { bubbles: !0, detail: { element: `[${cr}="page"]` } }))))
                : (window.location = i);
        }
        initCustomScrollbar() {
            this.scrollable && !this.customScrollbar && (this.customScrollbar = new zi(this.container));
        }
        infiniteScrollListener() {
            theme.settings.enableInfinityScroll && ((this.ajaxifyFromFiltersEvent = (t) => this.ajaxifyFromFilters(t)), document.addEventListener("theme:tab:ajaxinate", this.ajaxifyFromFiltersEvent));
        }
        ajaxifyFromFilters(t) {
            this.initInfinityScroll(t.detail);
        }
        initInfinityScroll(t) {
            if (!theme.settings.enableInfinityScroll) return;
            if (0 === this.container.querySelectorAll(Jn).length) return;
            const e = this.container.querySelector(`${$n}.${Zn}`),
                i = null == e ? void 0 : e.querySelector(Jn),
                s = null == i ? void 0 : i.classList.contains(sr);
            e ? (!i && this.endlessCollection && this.updateAjaxinateInstancesSettings(t), i && !s && this.initAjaxyfy(t)) : this.initAjaxyfy(t);
        }
        updateAjaxinateInstancesSettings(t) {
            setTimeout(() => {
                if (0 === this.endlessCollection.endlessScroll.length) return;
                [...this.endlessCollection.endlessScroll].forEach((t) => {
                    const e = t.containerElement,
                        i = [...this.tab].find((t) => t.classList.contains(Zn));
                    !(null !== e.closest(`${$n}.${Zn}`)) && i && (t.settings.method = "click");
                });
                const e = () => this.initProductGridEvents();
                if ("product" === t || "all" === t) {
                    const t = (t) => t.settings.container.indexOf("resultsProducts") > -1 || t.settings.container.indexOf("allTypes") > -1,
                        i = [...this.endlessCollection.endlessScroll].find(t);
                    if (!i) return;
                    i.settings.callback = e;
                }
            });
        }
        initAjaxyfy(t) {
            if ("object" != typeof this.endlessCollection) return (this.endlessCollection = new Mo(this.container)), void this.updateAjaxinateInstancesSettings(t);
            this.endlessCollection.endlessScroll.length > 0 && (this.endlessCollection.unload(), (this.endlessCollection = new Mo(this.container)), this.updateAjaxinateInstancesSettings(t));
        }
        updateAjaxify(t, e) {
            var i;
            if (0 === (null === (i = this.endlessCollection) || void 0 === i ? void 0 : i.endlessScroll.length)) return;
            const s = t.querySelector(Jn),
                o = `${Jn}[${pr}="${null == s ? void 0 : s.dataset.ajaxinateId}"]`;
            s && (this.endlessCollection.update(o), this.updateAjaxinateInstancesSettings(e));
        }
        initProductGridEvents() {
            (this.productGridEvents = new fo(this.container)), this.initTooltips();
        }
        initTooltips() {
            var t, e;
            ((this.tooltips = this.container.querySelectorAll(Xn)), (this.productGrid = this.container.querySelector(Yn)), window.innerWidth < theme.sizes.small) &&
                (this.tooltips = null === (e = this.productGrid) || void 0 === e ? void 0 : e.querySelectorAll(Xn));
            null === (t = this.tooltips) ||
                void 0 === t ||
                t.forEach((t) => {
                    new Ji(t);
                });
        }
        tabChange(t, e) {
            t.classList.contains(Zn) ||
                (this.isSearchPage ? this.tabChangeFetchContent(t, e) : (this.handleActiveTabClasses(t, e), this.scrollToCurrentTabLink(t), this.triggerTabAnimations(e), this.handleTabSliders(e), this.checkVisibleTabsLinks()));
        }
        handleActiveTabClasses(t, e) {
            var i;
            const s = this.container.querySelector(`${$n}.${Zn}`),
                o = this.container.querySelector(`${_n}.${Zn}`);
            null == s || s.classList.remove(Zn),
                null == o || o.classList.remove(Zn),
                t.classList.add(Zn),
                e.classList.add(Zn),
                t.classList.contains(tr) && e.classList.add(tr),
                null === (i = this.tabRef) ||
                    void 0 === i ||
                    i.forEach((t) => {
                        const i = t.classList.contains(Zn),
                            s = t.getAttribute(rr) === e.getAttribute(nr);
                        t.classList.toggle(Zn, !i && s);
                    });
        }
        scrollToCurrentTabLink(t) {
            const e = t.closest(Nn) ? t.closest(Nn) : t.parentElement,
                i = parseInt(window.getComputedStyle(e).getPropertyValue("padding-left"));
            e.scrollTo({ top: 0, left: t.offsetLeft - e.offsetWidth / 2 + t.offsetWidth / 2 + i, behavior: "smooth" }), t.dispatchEvent(new CustomEvent("theme:custom-scrollbar:change", { bubbles: !0, detail: { element: t } }));
        }
        triggerTabAnimations(t) {
            if ("false" == theme.settings.animationsEnabled) return;
            document.dispatchEvent(new CustomEvent("theme:scroll"));
            const e = this.tabsContents.querySelector(`[${nr}="resultsProducts"]`);
            if (e && e.classList.contains(Zn)) {
                ge(this.tabsContents.querySelectorAll(zn));
            } else
                this.tabsContents.querySelectorAll(Bn).forEach((t) => {
                    t.classList.remove(ir);
                }),
                    this.animateElementsTimer && clearTimeout(this.animateElementsTimer),
                    (this.animateElementsTimer = setTimeout(() => {
                        t.querySelectorAll(Bn).forEach((t) => {
                            t.classList.add(ir);
                        });
                    }, 150));
        }
        handleInactiveTabsAnimations() {
            this.tab.forEach((t) => {
                t.classList.contains(Zn) ||
                    t.querySelectorAll(Bn).forEach((t) => {
                        requestAnimationFrame(() => t.classList.remove(ir));
                    });
            });
        }
        handleTabSliders(t) {
            const e = t.querySelector(Wn);
            e && e.dispatchEvent(new CustomEvent("theme:tab:change", { bubbles: !1 }));
        }
        checkVisibleTabsLinks() {
            const t = this.container.querySelectorAll(_n),
                e = this.container.querySelectorAll(`${_n}.${tr}`);
            t.length - e.length < 2 ? this.container.classList.add(er) : this.container.classList.remove(er);
        }
        onBlockSelect(t) {
            const e = t.target;
            e && (e.dispatchEvent(new Event("click")), e.parentNode.scrollTo({ top: 0, left: e.offsetLeft - e.clientWidth, behavior: "smooth" }));
        }
        onUnload() {
            this.customScrollbar && this.customScrollbar.unload(),
                this.isSearchPage && theme.settings.enableInfinityScroll && document.removeEventListener("theme:tab:ajaxinate", this.ajaxifyFromFiltersEvent),
                document.removeEventListener("theme:scroll", this.inactiveTabsAnimationsCallback);
        }
        constructor(t) {
            (this.container = t),
                (this.tabsContents = t.querySelector(Un)),
                (this.animateElementsTimer = null),
                (this.isSearchPage = null != t.closest(`[${lr}="true"]`)),
                this.container &&
                    ((this.scrollable = this.container.querySelector(Vn)),
                    (this.tabRef = this.container.querySelectorAll(Rn)),
                    (this.tabsLink = this.container.querySelectorAll(_n)),
                    (this.tab = this.container.querySelectorAll($n)),
                    this.assignSearchPageArguments(),
                    this.init(),
                    this.initCustomScrollbar(),
                    this.isSearchPage || this.initTooltips(),
                    (this.inactiveTabsAnimationsCallback = o(() => this.handleInactiveTabsAnimations(), 200)),
                    document.addEventListener("theme:scroll", this.inactiveTabsAnimationsCallback),
                    this.container.addEventListener("mouseenter", () => {
                        this.handleInactiveTabsAnimations();
                    }));
        }
    };
    const fr = {
            onLoad() {
                mr[this.id] = new gr(this.container);
            },
            onBlockSelect(t) {
                mr[this.id].onBlockSelect(t);
            },
            onUnload() {
                mr[this.id].onUnload();
            },
        },
        yr = "[data-drawer]",
        vr = "[data-drawer-toggle]",
        br = "[data-scroll]",
        wr = "[data-quick-view-item]",
        Sr = "is-open",
        Er = "js-drawer-open",
        Lr = "js-drawer-open--size",
        kr = "cv-h",
        Ar = "site-header",
        Cr = "product-single",
        qr = "aria-expanded",
        Tr = "aria-controls";
    let Pr = {},
        xr = class {
            initListeners() {
                this.drawerToggleButtons.forEach((t) => {
                    t.addEventListener("click", this.drawerToggleEvent);
                }),
                    this.drawers.forEach((t) => {
                        t.addEventListener("keyup", this.keyPressCloseEvent), (this.collapsible = new ze(t)), (this.tabs = new gr(t));
                    }),
                    document.addEventListener("click", this.drawerCloseEvent),
                    document.addEventListener("theme:drawer:closing", this.drawerCloseEvent);
            }
            toggle(t) {
                t.preventDefault();
                const e = document.querySelector(`#${t.target.getAttribute(Tr)}`);
                if (!e) return;
                e.classList.contains(Sr) ? this.close() : this.open(t);
            }
            open(t) {
                const e = t.target,
                    i = document.querySelector(`#${t.target.getAttribute(Tr)}`);
                if (!i) return;
                const s = i.querySelector(br) || i;
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: s })),
                    document.dispatchEvent(new CustomEvent("theme:drawer:open"), { bubbles: !0 }),
                    this.body.classList.add(Er),
                    this.container.classList.contains(Cr) && this.body.classList.add(Lr),
                    i.classList.add(Sr),
                    i.classList.remove(kr),
                    e.setAttribute(qr, !0),
                    setTimeout(() => {
                        (this.a11y.state.trigger = e), this.a11y.trapFocus({ container: i });
                    });
            }
            close() {
                if (!this.body.classList.contains(Er)) return;
                const t = document.querySelector(`${yr}.${Sr}`);
                this.drawerToggleButtons.forEach((t) => {
                    t.setAttribute(qr, !1);
                }),
                    this.a11y.removeTrapFocus({ container: t }),
                    t.classList.remove(Sr);
                const e = (i) => {
                    i.target === t &&
                        (requestAnimationFrame(() => {
                            t.classList.add(kr), document.dispatchEvent(new CustomEvent("theme:drawer:close"), { bubbles: !0 }), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                        }),
                        t.removeEventListener("transitionend", e));
                };
                t.addEventListener("transitionend", e), this.body.classList.remove(Er), this.body.classList.remove(Lr);
            }
            onUnload() {
                this.close(),
                    this.drawerToggleButtons.forEach((t) => {
                        t.removeEventListener("click", this.drawerToggleEvent);
                    }),
                    this.drawers.forEach((t) => {
                        t.removeEventListener("keyup", this.keyPressCloseEvent);
                    }),
                    document.removeEventListener("click", this.drawerCloseEvent),
                    document.removeEventListener("theme:drawer:closing", this.drawerCloseEvent),
                    this.collapsible && this.collapsible.onUnload(),
                    this.tabs && this.tabs.onUnload();
            }
            constructor(t) {
                (this.container = t),
                    (this.body = document.body),
                    (this.drawers = this.container.querySelectorAll(yr)),
                    (this.drawerToggleButtons = this.container.querySelectorAll(vr)),
                    (this.a11y = Ke),
                    (this.drawerToggleEvent = Ce((t) => {
                        this.toggle(t);
                    }, 150)),
                    (this.keyPressCloseEvent = Ce((t) => {
                        t.code === theme.keyboardKeys.ESCAPE && this.close(t);
                    }, 150)),
                    (this.drawerCloseEvent = (t) => {
                        const e = document.querySelector(`${yr}.${Sr}`);
                        let i = !1;
                        if (!e) return;
                        "click" === t.type && (i = t.target.matches(vr));
                        const s = !!e && e.contains(t.target),
                            o = e.closest(wr),
                            n = !!o && o.contains(t.target);
                        i || s || n || this.close();
                    }),
                    this.initListeners();
            }
        };
    const Ir = {
            onLoad() {
                this.container.classList.contains(Ar) && (this.container = this.container.parentNode), (Pr[this.id] = new xr(this.container));
            },
            onUnload() {
                Pr[this.id].onUnload();
            },
        },
        Hr = (t, e = !1, i = "block") => {
            t && (e ? t.style.removeProperty("display") : (t.style.display = i));
        },
        Fr = (t) => {
            t && (t.style.display = "none");
        },
        Mr = (t) => {
            const { stickyHeaderHeight: e } = N();
            window.scrollTo({ top: t + Math.round(window.scrollY) - e, left: 0, behavior: "smooth" });
        },
        Dr = "[data-store-availability-list]",
        Or = { close: ".js-modal-close", open: ".js-modal-open-store-availability-modal", openClass: "modal--is-active", openBodyClass: "modal--is-visible", closeModalOnClick: !1, scrollIntoView: !1 };
    const Br = "body",
        zr = "[data-store-availability-modal]",
        _r = "[data-store-availability-modal-open]",
        $r = "[data-store-availability-modal-close]",
        Rr = "[data-store-availability-modal-product__title]",
        Vr = "store-availabilities-modal--active";
    const Nr = "[data-product-form]",
        Wr = "[data-option-position]",
        Ur = '[name^="options"], [data-popout-option]',
        jr = "sold-out",
        Gr = "unavailable",
        Kr = "data-option-position",
        Qr = "data-value";
    const Xr = 1,
        Yr = "data-notification-popup",
        Jr = { history: !1, focus: !1, mainClass: "pswp--notification pswp--not-close-btn", closeOnVerticalDrag: !1 };
    let Zr = class {
        init() {
            const t = [{ html: this.notificationPopupHtml }];
            (this.a11y.state.trigger = this.button), new Oc(t, Jr, Xr);
        }
        constructor(t) {
            (this.button = t), (this.a11y = Ke), (this.notificationPopupHtml = this.button.getAttribute(Yr)), "" !== this.notificationPopupHtml.trim() && this.init();
        }
    };
    const ta = "[data-product]",
        ea = "[data-product-form]",
        ia = "[data-add-to-cart]",
        sa = "[data-add-to-cart-text]",
        oa = "[data-buy-it-now]",
        na = "[data-compare-price]",
        ra = "[data-form-wrapper]",
        aa = "[data-site-header]",
        la = "[data-product-select]",
        ca = "_preorder",
        ha = "[data-price-wrapper]",
        da = "[data-price-off]",
        ua = "[data-price-off-type]",
        pa = "[data-price-off-amount]",
        ma = "[data-product-slide]",
        ga = "[data-product-image]",
        fa = "[data-product-single-media-slider]",
        ya = "[data-product-json]",
        va = "[data-product-price]",
        ba = "[data-product-unit-price]",
        wa = "[data-product-base]",
        Sa = "[data-product-unit]",
        Ea = "[data-subscription-watch-price]",
        La = "[data-subscription-selectors]",
        ka = "[data-toggles-group]",
        Aa = "data-group-toggle",
        Ca = "[data-plan-description]",
        qa = "[data-remaining-count]",
        Ta = "[data-remaining-wrapper]",
        Pa = "[data-product-remaining-json]",
        xa = "[data-store-availability-container]",
        Ia = "[data-upsell-btn]",
        Ha = ".shopify-section",
        Fa = "[data-quick-view-item]",
        Ma = "[data-notification-button-text]",
        Da = "[data-swatches-container]",
        Oa = "[data-swatches-more]",
        Ba = "[data-option-position]",
        za = ".shopify-payment-button__button",
        _a = '[role="button"], [type="submit"], form',
        $a = "[disabled]",
        Ra = "hidden",
        Va = "variant--soldout",
        Na = "variant--unavailabe",
        Wa = "product__price--sale",
        Ua = "product__price--hidden",
        ja = "count-is-low",
        Ga = "count-is-in",
        Ka = "count-is-out",
        Qa = "count-is-unavailable",
        Xa = "selector-wrapper--visible",
        Ya = "data-image-id",
        Ja = "data-tall-layout",
        Za = "data-enable-history-state",
        tl = "data-notification-popup",
        el = "data-swatch-variant",
        il = "disabled";
    let sl = {},
        ol = class {
            init() {
                let t = null;
                const e = this.container.querySelector(ya);
                e && (t = e.innerHTML),
                    t
                        ? ((this.productJSON = JSON.parse(t)),
                          this.linkForm(),
                          (this.sellout = new (class {
                              init() {
                                  this.update();
                              }
                              update() {
                                  this.getCurrentState(),
                                      this.optionElements.forEach((t) => {
                                          const e = t.value || t.getAttribute(Qr),
                                              i = t.closest(Wr);
                                          if (!i) return;
                                          const s = i.getAttribute(Kr),
                                              o = parseInt(s, 10) - 1;
                                          let n = [...this.selections];
                                          n[o] = e;
                                          const r = this.productJSON.variants.find((t) => {
                                              let e = !0;
                                              for (let i = 0; i < n.length; i++) t.options[i] !== n[i] && (e = !1);
                                              return e;
                                          });
                                          t.parentElement.classList.remove(jr, Gr), void 0 === r ? t.parentElement.classList.add(Gr) : !1 === (null == r ? void 0 : r.available) && t.parentElement.classList.add(jr);
                                      });
                              }
                              getCurrentState() {
                                  for (var t of ((this.formData = new FormData(this.form)), (this.selections = []), this.formData.entries())) t[0].includes("options[") && this.selections.push(t[1]);
                              }
                              constructor(t, e) {
                                  (this.container = t),
                                      (this.productJSON = e),
                                      (this.form = this.container.querySelector(Nr)),
                                      (this.formData = new FormData(this.form)),
                                      (this.optionElements = this.container.querySelectorAll(Ur)),
                                      this.productJSON && this.form && this.init();
                              }
                          })(this.container, this.productJSON)))
                        : console.error("Missing product JSON");
            }
            observeContainer() {
                (this.mutationObserver = new MutationObserver((t) => {
                    for (const i of t) {
                        var e;
                        if ("childList" === i.type && i.target.closest(oa))
                            if ((this.updateButtonsHeight(), !i.target.querySelector($a))) null === (e = this.mutationObserver) || void 0 === e || e.disconnect(), (this.mutationObserver = null);
                    }
                })),
                    this.mutationObserver.observe(this.container, { childList: !0, subtree: !0 });
            }
            updateButtonsHeight() {
                (this.shopifyPaymentButton = this.container.querySelector(za)),
                    (this.paymentButton = this.buyItNow.querySelectorAll(`${_a}`)),
                    this.shopifyPaymentButton &&
                        (this.shopifyPaymentButton.hasAttribute(il) ||
                            (this.shopifyPaymentButton.setAttribute("style", "min-height: auto !important;"),
                            this.addToCartButton.setAttribute("style", "min-height: auto;"),
                            this.paymentButton.forEach((t) => t.setAttribute("style", "min-height: auto !important;")),
                            requestAnimationFrame(() => {
                                (this.compareHeights = []),
                                    this.paymentButton.forEach((t) => this.compareHeights.push(t.offsetHeight)),
                                    this.compareHeights.push(this.shopifyPaymentButton.offsetHeight),
                                    this.compareHeights.push(this.addToCartButton.offsetHeight),
                                    o(this.setButtonsStyles(), 400);
                            })));
            }
            setButtonsStyles() {
                0 !== this.compareHeights.length &&
                    ((this.maxHeight = Math.max(...this.compareHeights)),
                    requestAnimationFrame(() => {
                        this.addToCartButton.setAttribute("style", `min-height: ${this.maxHeight}px;`),
                            this.shopifyPaymentButton.setAttribute("style", `min-height: ${this.maxHeight}px !important; height: auto !important;`),
                            this.paymentButton.forEach((t) => t.setAttribute("style", `min-height: ${this.maxHeight}px !important; height: auto !important;`));
                    }));
            }
            linkForm() {
                this.productForm = new (class {
                    destroy() {
                        this._listeners.removeAll();
                    }
                    options() {
                        return this._serializeInputValues(this.optionInputs, function (t) {
                            return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                        });
                    }
                    variant() {
                        const t = this.options();
                        return t.length ? gs(this.product, t) : this.product.variants[0];
                    }
                    plan(t) {
                        let e = { allocation: null, group: null, detail: null };
                        const i = new FormData(this.form).get("selling_plan");
                        return (
                            i &&
                                t &&
                                (e.allocation = t.selling_plan_allocations.find(function (t) {
                                    return t.selling_plan_id.toString() === i.toString();
                                })),
                            e.allocation &&
                                (e.group = this.product.selling_plan_groups.find(function (t) {
                                    return t.id.toString() === e.allocation.selling_plan_group_id.toString();
                                })),
                            e.group &&
                                (e.detail = e.group.selling_plans.find(function (t) {
                                    return t.id.toString() === i.toString();
                                })),
                            e && e.allocation && e.detail && e.allocation ? e : null
                        );
                    }
                    properties() {
                        return this._serializeInputValues(this.propertyInputs, function (t) {
                            return (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                        });
                    }
                    quantity() {
                        return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
                    }
                    getFormState() {
                        const t = this.variant();
                        return { options: this.options(), variant: t, properties: this.properties(), quantity: this.quantity(), plan: this.plan(t) };
                    }
                    _setIdInputValue(t) {
                        t && t.id ? (this.variantElement.value = t.id.toString()) : (this.variantElement.value = ""), this.variantElement.dispatchEvent(new Event("change"));
                    }
                    _onSubmit(t, e) {
                        (e.dataset = this.getFormState()), t.onFormSubmit && t.onFormSubmit(e);
                    }
                    _onOptionChange(t) {
                        this._setIdInputValue(t.dataset.variant);
                    }
                    _onFormEvent(t) {
                        return void 0 === t
                            ? Function.prototype.bind()
                            : function (e) {
                                  (e.dataset = this.getFormState()), this._setIdInputValue(e.dataset.variant), t(e);
                              }.bind(this);
                    }
                    _initInputs(t, e) {
                        return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(
                            function (t) {
                                return this._listeners.add(t, "change", this._onFormEvent(e)), t;
                            }.bind(this)
                        );
                    }
                    _serializeInputValues(t, e) {
                        return t.reduce(function (t, i) {
                            return (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) && t.push(e({ name: i.name, value: i.value })), t;
                        }, []);
                    }
                    _validateProductObject(t) {
                        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
                        if (void 0 === t.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                        return t;
                    }
                    constructor(t, e, i) {
                        (this.element = t),
                            (this.form = "FORM" == this.element.tagName ? this.element : this.element.querySelector("form")),
                            (this.product = this._validateProductObject(e)),
                            (this.variantElement = this.element.querySelector(ys)),
                            (i = i || {}),
                            (this._listeners = new ms()),
                            this._listeners.add(this.element, "submit", this._onSubmit.bind(this, i)),
                            (this.optionInputs = this._initInputs(bs, i.onOptionChange)),
                            (this.planInputs = this._initInputs(vs, i.onPlanChange)),
                            (this.quantityInputs = this._initInputs(ws, i.onQuantityChange)),
                            (this.propertyInputs = this._initInputs(Ss, i.onPropertyChange));
                    }
                })(this.productForm, this.productJSON, { onOptionChange: this.onOptionChange.bind(this), onPlanChange: this.onPlanChange.bind(this) });
                const t = this.productForm.getFormState();
                if ((this.pushState(t, !0), this.subsToggleListeners(), this.swatchesContainer)) {
                    this.observeSwatch(t);
                    const e = this.swatchesContainer.closest(Ba),
                        i = e.querySelector(Oa);
                    null == i ||
                        i.addEventListener("click", (t) => {
                            t.preventDefault(), e.classList.contains(Xa) ? e.classList.remove(Xa) : e.classList.add(Xa);
                        });
                }
            }
            onOptionChange(t) {
                this.pushState(t.dataset), this.updateProductImage(t);
            }
            onPlanChange(t) {
                this.subPrices && this.pushState(t.dataset);
            }
            pushState(t, e = !1) {
                var i;
                (this.productState = this.setProductState(t)),
                    this.updateAddToCartState(t),
                    this.updateProductPrices(t),
                    this.updateSaleText(t),
                    this.updateSubscriptionText(t),
                    this.fireHookEvent(t),
                    this.updateRemaining(t),
                    null === (i = this.sellout) || void 0 === i || i.update(t),
                    this.enableHistoryState && !e && this.updateHistoryState(t),
                    this.storeAvailability && (t.variant ? this.storeAvailability.updateContent(t.variant.id, this.productForm.product.title) : this.storeAvailability.clearContent());
            }
            updateAddToCartState(t) {
                const e = t.variant,
                    i = this.container.querySelectorAll(ha),
                    s = this.container.querySelectorAll(ia),
                    o = this.container.querySelectorAll(sa),
                    n = this.container.querySelectorAll(ra),
                    r = this.container.querySelector(oa);
                let a = theme.strings.add_to_cart;
                this.productJSON.tags.includes(ca) && (a = theme.strings.preorder),
                    null == i ||
                        i.forEach((t) => {
                            t.classList.toggle(Ua, !e);
                        }),
                    null == s ||
                        s.forEach((t) => {
                            var i;
                            if (t.matches(Ia)) return;
                            if (((t.disabled = !0), null == r || r.classList.add(Ra), !e)) return;
                            if (((t.disabled = !1), e.available && (null == r || r.classList.remove(Ra)), !t.hasAttribute(tl))) return;
                            const s = t.id.replace("AddToCart", "NotificationForm"),
                                o = this.sessionStorage.getItem("notification_form_id");
                            let n = !1,
                                a = e.id,
                                l = e.title;
                            if (o) {
                                const t = o.substring(0, o.lastIndexOf("--")),
                                    e = o.split("--").slice(-1)[0];
                                (n = s === t),
                                    n &&
                                        ((this.latestVariantId = a),
                                        (this.latestVariantTitle = l),
                                        (a = Number(e)),
                                        this.productJSON.variants.forEach((t) => {
                                            t.id === a && (l = t.title);
                                        }));
                            }
                            let c = t.getAttribute(tl);
                            const h = null === (i = new DOMParser().parseFromString(c, "text/html").querySelector(Ma)) || void 0 === i ? void 0 : i.innerHTML;
                            if ("" != this.latestVariantId && "" != this.latestVariantTitle) {
                                var d;
                                (c = c.replaceAll(this.latestVariantId, a)), (c = c.replaceAll(`<p class='product__notification__subtitle'>${this.latestVariantTitle}</p>`, `<p class='product__notification__subtitle'>${l}</p>`));
                                const t = null === (d = new DOMParser().parseFromString(c, "text/html").querySelector(Ma)) || void 0 === d ? void 0 : d.innerHTML;
                                c = c.replace(t, h);
                            }
                            t.setAttribute(tl, c), n && (this.scrollToForm(this.product.closest(Ha)), new Zr(t)), (this.latestVariantId = a), (this.latestVariantTitle = l);
                        }),
                    null == o ||
                        o.forEach((t) => {
                            if (e) {
                                if (e.available) t.innerHTML = `${a}  | <s style="color:#bbb; font-size: 11px;">₹${e.compare_at_price/100}</s>  ₹${e.price/100}`;
                                else if (((t.innerHTML = theme.strings.sold_out), t.parentNode.hasAttribute(tl))) {
                                    if (t.closest(Fa)) return;
                                    t.innerHTML = `${theme.strings.sold_out} - ${theme.strings.newsletter_product_availability}`;
                                }
                            } else t.innerHTML = theme.strings.unavailable;
                        }),
                    null == n ||
                        n.forEach((t) => {
                            if (!e) return t.classList.add(Na), void t.classList.remove(Va);
                            const i = t.querySelector(la);
                            if ((i && (i.value = e.id), !e.available)) return t.classList.add(Va), void t.classList.remove(Na);
                            t.classList.remove(Va, Na);
                        });
            }
            updateHistoryState(t) {
                const e = t.variant,
                    i = t.plan,
                    s = window.location.href;
                if (e && s.includes("/product")) {
                    const t = new window.URL(s),
                        o = t.searchParams;
                    o.set("variant", e.id), i && i.detail && i.detail.id && this.productState.hasPlan ? o.set("selling_plan", i.detail.id) : o.delete("selling_plan"), (t.search = o.toString());
                    const n = t.toString();
                    window.history.replaceState({ path: n }, "", n);
                }
            }
            updateRemaining(t) {
                const e = t.variant,
                    i = [Ga, Ka, Qa, ja];
                if (e && this.remainingWrapper && this.remainingJSON) {
                    const t = this.remainingJSON[e.id];
                    ("out" === t || t < 1) && (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(Ka)),
                        ("in" === t || t >= this.remainingMaxInt) && (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(Ga)),
                        ("low" === t || (t > 0 && t < this.remainingMaxInt)) && (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(ja), this.remainingCount && (this.remainingCount.innerHTML = t));
                } else !e && this.remainingWrapper && (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(Qa));
            }
            getBaseUnit(t) {
                return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit;
            }
            subsToggleListeners() {
                this.container.querySelectorAll(ka).forEach((t) => {
                    t.addEventListener(
                        "change",
                        function (t) {
                            const e = t.target.value.toString(),
                                i = this.container.querySelector(`[${Aa}="${e}"]`),
                                s = this.container.querySelectorAll(`[${Aa}]`);
                            if (i) {
                                i.classList.remove(Ra);
                                const t = i.querySelector('[name="selling_plan"]');
                                (t.checked = !0), t.dispatchEvent(new Event("change"));
                            }
                            s.forEach((t) => {
                                if (t !== i) {
                                    t.classList.add(Ra);
                                    t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                                        (t.checked = !1), t.dispatchEvent(new Event("change"));
                                    });
                                }
                            });
                        }.bind(this)
                    );
                });
            }
            updateSaleText(t) {
                this.productState.planSale ? this.updateSaleTextSubscription(t) : this.productState.onSale ? this.updateSaleTextStandard(t) : this.priceOffWrap && this.priceOffWrap.classList.add(Ra);
            }
            updateSaleTextStandard(t) {
                if (!this.priceOffType) return;
                this.priceOffType.innerHTML = window.theme.strings.sale_badge_text || "sale";
                const e = t.variant;
                if (window.theme.settings.savingBadgeType && "percentage" === window.theme.settings.savingBadgeType) {
                    const t = (e.compare_at_price - e.price) / e.compare_at_price,
                        i = Math.floor(100 * t);
                    this.priceOffAmount.innerHTML = `${i}%`;
                } else {
                    const t = e.compare_at_price - e.price;
                    this.priceOffAmount.innerHTML = i.formatMoney(t, theme.moneyFormat);
                }
                this.priceOffWrap.classList.remove(Ra);
            }
            updateSaleTextSubscription(t) {
                const e = t.variant,
                    s = this.productForm.product.selling_plan_groups.find((t) => t.id === e.selling_plan_allocations[0].selling_plan_group_id),
                    o = t.plan ? t.plan.detail.price_adjustments[0] : s.selling_plans[0].price_adjustments[0],
                    n = o.value || 0,
                    r = "percentage" === o.value_type ? `${n}%` : i.formatMoney(e.price - n, theme.moneyFormat);
                (this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton"), (this.priceOffAmount.innerHTML = r), this.priceOffWrap.classList.remove(Ra);
            }
            updateSubscriptionText(t) {
                t.plan && this.planDecription && null !== t.plan.detail.description
                    ? ((this.planDecription.innerHTML = t.plan.detail.description), this.planDecription.classList.remove(Ra))
                    : this.planDecription && this.planDecription.classList.add(Ra);
            }
            updateProductPrices(t) {
                const e = t.variant,
                    s = t.plan;
                this.container.querySelectorAll(ha).forEach((t) => {
                    const o = t.querySelector(na),
                        n = t.querySelector(va);
                    let r = "",
                        a = "";
                    if ((this.productState.available && ((r = e.compare_at_price), (a = e.price)), this.productState.hasPlan)) {
                        a = s ? s.allocation.price : e.selling_plan_allocations[0].per_delivery_price;
                    }
                    if (this.productState.planSale) {
                        const t = s ? s.allocation.price : e.selling_plan_allocations[0].per_delivery_price;
                        (r = s ? s.allocation.compare_at_price : e.selling_plan_allocations[0].compare_at_price), (a = t);
                    }
                    o &&
                        (this.productState.onSale || this.productState.planSale ? (o.classList.remove(Ra), n.classList.add(Wa)) : (o.classList.add(Ra), n.classList.remove(Wa)),
                        (o.innerHTML = theme.settings.currency_code_enable ? i.formatMoney(r, theme.moneyWithCurrencyFormat) : i.formatMoney(r, theme.moneyFormat))),
                        (n.innerHTML = 0 === a ? window.theme.strings.free : theme.settings.currency_code_enable ? i.formatMoney(a, theme.moneyWithCurrencyFormat) : i.formatMoney(a, theme.moneyFormat));
                }),
                    this.hasUnitPricing && this.updateProductUnits(t);
            }
            updateProductUnits(t) {
                const e = t.variant,
                    s = t.plan;
                let o = null;
                if (
                    (e && e.unit_price && (o = e.unit_price),
                    s && (null == s ? void 0 : s.allocation) && (null == s ? void 0 : s.allocation.unit_price) && (o = s.allocation.unit_price),
                    !s && e.selling_plan_allocations && e.selling_plan_allocations.length > 0)
                ) {
                    o = e.selling_plan_allocations[0].unit_price;
                }
                if (o) {
                    const t = this.getBaseUnit(e),
                        s = 0 === o ? window.theme.strings.free : i.formatMoney(o, theme.moneyFormat);
                    (this.container.querySelector(ba).innerHTML = s), (this.container.querySelector(wa).innerHTML = t), Hr(this.container.querySelector(Sa));
                } else Fr(this.container.querySelector(Sa));
            }
            fireHookEvent(t) {
                const e = t.variant;
                this.container.dispatchEvent(new CustomEvent("theme:variant:change", { detail: { variant: e }, bubbles: !0 }));
            }
            setProductState(t) {
                const e = t.variant,
                    i = t.plan,
                    s = { available: !0, soldOut: !1, onSale: !1, showUnitPrice: !1, requiresPlan: !1, hasPlan: !1, planPerDelivery: !1, planSale: !1 };
                if (e) {
                    const t = e.requires_selling_plan || !1;
                    e.available || (s.soldOut = !0),
                        e.compare_at_price > e.price && (s.onSale = !0),
                        e.unit_price && (s.showUnitPrice = !0),
                        this.product && this.product.requires_selling_plan && (s.requiresPlan = !0),
                        i && this.subPrices && ((s.hasPlan = !0), i.allocation.per_delivery_price !== i.allocation.price && (s.planPerDelivery = !0), e.price > i.allocation.price && (s.planSale = !0)),
                        !i && t && ((s.hasPlan = !0), e.selling_plan_allocations[0].per_delivery_price !== e.selling_plan_allocations[0].price && (s.planPerDelivery = !0), e.price > e.selling_plan_allocations[0].price && (s.planSale = !0));
                } else s.available = !1;
                return s;
            }
            updateProductImage(t) {
                const i = t.dataset.variant;
                if (!i || !(null == i ? void 0 : i.featured_media)) return;
                const s = this.container.querySelector(`${ga}[${Ya}="${i.featured_media.id}"]`),
                    o = null == s ? void 0 : s.closest(ma);
                if (o) {
                    const t = parseInt([...o.parentElement.children].indexOf(o)),
                        n = this.container.querySelector(fa),
                        r = e.data(n);
                    if (r && r.isActive) {
                        const t = n.querySelector(`[data-id="${i.featured_media.id}"]`);
                        if (t) {
                            const e = parseInt([...t.parentNode.children].indexOf(t));
                            r.select(e);
                        }
                        return;
                    }
                    if (this.tallLayout) {
                        const e = s.getBoundingClientRect().top;
                        if (0 === t && e + window.scrollY > window.pageYOffset) return;
                        document.dispatchEvent(new CustomEvent("theme:tooltip:close", { bubbles: !1, detail: { hideTransition: !1 } })), Mr(e);
                    }
                }
            }
            observeSwatch(t) {
                const e = this.swatchesContainer.querySelector(`[${el}*="${t.variant.id}"]`);
                this.swatchesContainer.closest(Ba).classList.remove(Xa),
                    new IntersectionObserver(
                        (t, e) => {
                            t.forEach((t) => {
                                0 == t.intersectionRatio && this.swatchesContainer.closest(Ba).classList.add(Xa);
                            });
                        },
                        { root: this.container, threshold: [0.95, 1] }
                    ).observe(e);
            }
            scrollToForm(t) {
                var e;
                const i = null === (e = document.querySelector(aa)) || void 0 === e ? void 0 : e.dataset.height;
                visibilityHelper.isElementPartiallyVisible(t) ||
                    visibilityHelper.isElementTotallyVisible(t) ||
                    setTimeout(() => {
                        const e = t.getBoundingClientRect().top - i;
                        window.scrollTo({ top: e, left: 0, behavior: "smooth" });
                    }, 400);
            }
            onUnload() {
                this.productForm && this.productForm.destroy(), this.hasPaymentButton && window.removeEventListener("theme:resize:width", this.onResizeCallback);
            }
            constructor(t) {
                if (
                    ((this.container = t),
                    (this.product = this.container.querySelector(ta)),
                    (this.productForm = this.container.querySelector(ea)),
                    (this.tallLayout = "true" === this.container.getAttribute(Ja)),
                    (this.addToCartButton = this.container.querySelector(ia)),
                    (this.buyItNow = this.container.querySelector(oa)),
                    (this.hasPaymentButton = null !== this.buyItNow),
                    !this.product || !this.productForm)
                ) {
                    return void new Ge(this.container).init();
                }
                (this.storeAvailabilityContainer = this.container.querySelector(xa)),
                    (this.enableHistoryState = "true" === this.container.getAttribute(Za)),
                    (this.hasUnitPricing = this.container.querySelector(Sa)),
                    (this.subSelectors = this.container.querySelector(La)),
                    (this.subPrices = this.container.querySelector(Ea)),
                    (this.priceOffWrap = this.container.querySelector(da)),
                    (this.priceOffAmount = this.container.querySelector(pa)),
                    (this.priceOffType = this.container.querySelector(ua)),
                    (this.planDecription = this.container.querySelector(Ca)),
                    (this.swatchesContainer = this.container.querySelector(Da)),
                    (this.latestVariantId = ""),
                    (this.latestVariantTitle = ""),
                    (this.sellout = null),
                    (this.sessionStorage = window.sessionStorage),
                    (this.remainingWrapper = this.container.querySelector(Ta)),
                    this.remainingWrapper &&
                        ((this.remainingMaxInt = parseInt(this.remainingWrapper.dataset.remainingMax, 10)),
                        (this.remainingCount = this.container.querySelector(qa)),
                        (this.remainingJSONWrapper = this.container.querySelector(Pa)),
                        (this.remainingJSON = null),
                        this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML && (this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML))),
                    this.storeAvailabilityContainer &&
                        (this.storeAvailability = new (class {
                            updateContent(t, e) {
                                this._fetchStoreAvailabilities(t, e);
                            }
                            clearContent() {
                                this.container.innerHTML = "";
                            }
                            _initModal() {
                                return new (class {
                                    init() {
                                        this.openElement.addEventListener("click", this.open.bind(this)), this.modal.querySelector(this.config.close).addEventListener("click", this.closeModal.bind(this));
                                    }
                                    open(t) {
                                        let e = !1;
                                        if ((t ? t.preventDefault() : (e = !0), this.modalIsOpen && !e)) return void this.closeModal();
                                        this.modal.classList.add(this.config.openClass),
                                            this.nodes.parents.forEach((t) => {
                                                t.classList.add(this.config.openBodyClass);
                                            }),
                                            (this.modalIsOpen = !0);
                                        const i = document.querySelector(Dr);
                                        document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: i })),
                                            this.config.scrollIntoView && this.scrollIntoView(),
                                            this.bindEvents(),
                                            this.a11y.trapFocus({ container: this.modal });
                                    }
                                    closeModal() {
                                        if (this.modalIsOpen) {
                                            document.activeElement.blur(), this.modal.classList.remove(this.config.openClass);
                                            var t = this;
                                            this.nodes.parents.forEach(function (e) {
                                                e.classList.remove(t.config.openBodyClass);
                                            }),
                                                (this.modalIsOpen = !1),
                                                this.openElement.focus(),
                                                this.unbindEvents(),
                                                this.a11y.removeTrapFocus({ container: this.modal }),
                                                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 400 }));
                                        }
                                    }
                                    bindEvents() {
                                        (this.keyupHandler = this.keyupHandler.bind(this)),
                                            (this.clickHandler = this.clickHandler.bind(this)),
                                            document.body.addEventListener("keyup", this.keyupHandler),
                                            document.body.addEventListener("click", this.clickHandler);
                                    }
                                    unbindEvents() {
                                        document.body.removeEventListener("keyup", this.keyupHandler), document.body.removeEventListener("click", this.clickHandler);
                                    }
                                    keyupHandler(t) {
                                        t.code === theme.keyboardKeys.ESCAPE && this.closeModal();
                                    }
                                    clickHandler(t) {
                                        !this.config.closeModalOnClick || this.modal.contains(t.target) || t.target.matches(this.config.open) || this.closeModal();
                                    }
                                    scrollIntoView() {
                                        this.focusOnOpen.scrollIntoView({ behavior: "smooth" });
                                    }
                                    constructor(t, e) {
                                        if (((this.modal = document.getElementById(t)), !this.modal)) return !1;
                                        (this.nodes = { parents: [document.querySelector("html"), document.body] }),
                                            (this.config = Object.assign(Or, e)),
                                            (this.modalIsOpen = !1),
                                            (this.focusOnOpen = this.config.focusOnOpen ? document.getElementById(this.config.focusOnOpen) : this.modal),
                                            (this.openElement = document.querySelector(this.config.open)),
                                            (this.a11y = Ke),
                                            this.init();
                                    }
                                })("StoreAvailabilityModal", { close: $r, open: _r, closeModalOnClick: !0, openClass: Vr, scrollIntoView: !1 });
                            }
                            _fetchStoreAvailabilities(t, e) {
                                const i = "/variants/" + t + "/?section_id=store-availability";
                                this.clearContent();
                                const s = this;
                                fetch(i)
                                    .then(function (t) {
                                        return t.text();
                                    })
                                    .then(function (t) {
                                        const i = document.querySelector(Br);
                                        let o = i.querySelector(zr);
                                        o && o.remove(),
                                            (s.container.innerHTML = t),
                                            (s.container.innerHTML = s.container.firstElementChild.innerHTML),
                                            "" !== s.container.firstElementChild.innerHTML.trim()
                                                ? s.container.querySelector(_r) && ((s.modal = s._initModal()), s._updateProductTitle(e), (o = s.container.querySelector(zr)), o && i.appendChild(o))
                                                : s.clearContent();
                                    });
                            }
                            _updateProductTitle(t) {
                                this.container.querySelector(Rr).textContent = t;
                            }
                            constructor(t) {
                                this.container = t;
                            }
                        })(this.storeAvailabilityContainer));
                new Ge(this.container).init(),
                    this.init(),
                    this.hasPaymentButton && ((this.mutationObserver = null), (this.onResizeCallback = () => this.updateButtonsHeight()), this.observeContainer(), window.addEventListener("theme:resize:width", this.onResizeCallback));
            }
        };
    const nl = {
            onLoad() {
                sl[this.id] = new ol(this.container);
            },
            onUnload() {
                sl[this.id].onUnload();
            },
        },
        rl = "form",
        al = "[data-popout]",
        ll = "[data-popout-list]",
        cl = "[data-popout-toggle]",
        hl = "[data-popout-input]",
        dl = "[data-popout-option]",
        ul = "[data-popout-text]",
        pl = "[aria-current]",
        ml = "[data-product-image]",
        gl = "[data-product-grid-item]",
        fl = "select-popout__list--visible",
        yl = "select-popout--alt",
        vl = "--current",
        bl = "is-visible",
        wl = "aria-current",
        Sl = "aria-expanded",
        El = "data-value",
        Ll = "data-popout-prevent",
        kl = "data-quantity-field",
        Al = "data-quick-view-item",
        Cl = "data-popout-initialized";
    let ql = {},
        Tl = class {
            unload() {
                this.popoutOptions.length &&
                    this.popoutOptions.forEach((t) => {
                        t.removeEventListener("theme:popout:click", this.popupOptionsClickEvent), t.removeEventListener("click", this._connectOptionsDispatchEvent);
                    }),
                    this.popoutToggle.removeEventListener("click", this.popupToggleClickEvent),
                    this.popoutToggle.removeEventListener("focusout", this.popupToggleFocusoutEvent),
                    this.popoutList.removeEventListener("focusout", this.popupListFocusoutEvent),
                    this.popout.removeEventListener("keyup", this.popoutKeyupEvent),
                    document.removeEventListener("theme:cart:update", this.updatePopout),
                    document.body.removeEventListener("click", this.bodyClick);
            }
            popupToggleClick(t) {
                const e = "true" === t.currentTarget.getAttribute(Sl);
                if (this.popoutList.closest(gl)) {
                    const t = this.popoutList.closest(gl).querySelector(ml);
                    t && t.classList.toggle(bl, !e);
                }
                t.currentTarget.setAttribute(Sl, !e), this.popoutList.classList.toggle(fl);
            }
            popupToggleFocusout(t) {
                if (!t.relatedTarget) return;
                const e = this.popout.contains(t.relatedTarget),
                    i = t.relatedTarget.hasAttribute(Al);
                e || i || this._hideList();
            }
            popupListFocusout(t) {
                const e = t.currentTarget.contains(t.relatedTarget);
                this.popoutList.classList.contains(fl) && !e && this._hideList();
            }
            popupOptionsClick(t) {
                if ("#" === t.target.closest(dl).attributes.href.value) {
                    t.preventDefault();
                    let e = "";
                    if ((t.currentTarget.getAttribute(El) && (e = t.currentTarget.getAttribute(El)), (this.popoutInput.value = e), this.popoutPrevent)) {
                        this.popoutInput.dispatchEvent(new Event("change")), !t.detail.preventTrigger && this.popoutInput.hasAttribute(kl) && this.popoutInput.dispatchEvent(new Event("input"));
                        const i = this.popoutList.querySelector(`[class*="${vl}"]`);
                        let s = vl;
                        if (i && i.classList.length)
                            for (const t of i.classList)
                                if (t.includes(vl)) {
                                    s = t;
                                    break;
                                }
                        const o = this.popoutList.querySelector(`.${s}`);
                        o && (o.classList.remove(`${s}`), t.currentTarget.parentElement.classList.add(`${s}`));
                        const n = this.popoutList.querySelector(pl);
                        n && (n.removeAttribute(wl), t.currentTarget.setAttribute(wl, "true")), "" !== e && (this.popoutText.textContent = e), this.popupToggleFocusout(t), this.popupListFocusout(t);
                    } else this._submitForm(e);
                }
            }
            updatePopout() {
                const t = this.popoutList.querySelector(`[${El}="${this.popoutInput.value}"]`);
                t ? (t.dispatchEvent(new CustomEvent("theme:popout:click", { cancelable: !0, bubbles: !0, detail: { preventTrigger: !0 } })), t.parentElement.nextSibling || this.popout.classList.add(yl)) : this.popout.classList.add(yl);
            }
            popoutKeyup(t) {
                t.code === theme.keyboardKeys.ESCAPE && (this._hideList(), this.popoutToggle.focus());
            }
            bodyClick(t) {
                const e = this.popout.contains(t.target);
                this.popoutList.classList.contains(fl) && !e && this._hideList();
            }
            _connectToggle() {
                this.popout.setAttribute(Cl, ""), this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
            }
            _connectOptions() {
                this.popoutOptions.length &&
                    this.popoutOptions.forEach((t) => {
                        t.addEventListener("theme:popout:click", this.popupOptionsClickEvent), t.addEventListener("click", this._connectOptionsDispatchEvent);
                    });
            }
            _connectOptionsDispatch(t) {
                const e = new CustomEvent("theme:popout:click", { cancelable: !0, bubbles: !0, detail: { preventTrigger: !1 } });
                t.target.dispatchEvent(e) || t.preventDefault();
            }
            _onFocusOut() {
                this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent),
                    this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent),
                    this.popout.addEventListener("keyup", this.popoutKeyupEvent),
                    document.body.addEventListener("click", this.bodyClick);
            }
            _submitForm() {
                const t = this.popout.closest(rl);
                t && t.submit();
            }
            _hideList() {
                this.popoutList.classList.remove(fl), this.popoutToggle.setAttribute(Sl, !1);
            }
            constructor(t) {
                (this.popout = t),
                    (this.popoutList = this.popout.querySelector(ll)),
                    (this.popoutToggle = this.popout.querySelector(cl)),
                    (this.popoutText = this.popout.querySelector(ul)),
                    (this.popoutInput = this.popout.querySelector(hl)),
                    (this.popoutOptions = this.popout.querySelectorAll(dl)),
                    (this.popoutPrevent = "true" === this.popout.getAttribute(Ll)),
                    (this.popupToggleFocusoutEvent = (t) => this.popupToggleFocusout(t)),
                    (this.popupListFocusoutEvent = (t) => this.popupListFocusout(t)),
                    (this.popupToggleClickEvent = (t) => this.popupToggleClick(t)),
                    (this.popoutKeyupEvent = (t) => this.popoutKeyup(t)),
                    (this.popupOptionsClickEvent = (t) => this.popupOptionsClick(t)),
                    (this._connectOptionsDispatchEvent = (t) => this._connectOptionsDispatch(t)),
                    (this.bodyClick = this.bodyClick.bind(this)),
                    (this.updatePopout = this.updatePopout.bind(this)),
                    this._connectOptions(),
                    this._connectToggle(),
                    this._onFocusOut(),
                    this.popoutInput && this.popoutInput.hasAttribute(kl) && document.addEventListener("theme:cart:update", this.updatePopout);
            }
        };
    const Pl = {
            onLoad() {
                ql[this.id] = [];
                this.container.querySelectorAll(al).forEach((t) => {
                    t.hasAttribute(Cl) || ql[this.id].push(new Tl(t));
                });
            },
            onUnload() {
                ql[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        xl = "[data-add-to-cart]",
        Il = "[data-deferred-media]",
        Hl = "[data-deferred-media-button]",
        Fl = "[data-popup-close]",
        Ml = "[data-popout]",
        Dl = "[data-quick-view-inner]",
        Ol = "[data-quick-view-item-holder]",
        Bl = "[data-product]",
        zl = "[data-product-form]",
        _l = "[data-product-single-media-slider]",
        $l = "[data-product-single-media-wrapper]",
        Rl = "[data-model]",
        Vl = "[data-product-json]",
        Nl = "[data-quick-view-foot-inner]",
        Wl = "[data-shop-the-look-thumb]",
        Ul = "[data-tooltip]",
        jl = "[data-drawer-toggle]",
        Gl = "has-media-active",
        Kl = "is-active",
        Ql = "is-loading",
        Xl = "media--hidden",
        Yl = "no-outline",
        Jl = "notification-popup-visible",
        Zl = "popup-quick-view--animate-in",
        tc = "popup-quick-view--animate-out",
        ec = "popup-quick-view--animated",
        ic = "popup-quick-view",
        sc = "js-quick-view-visible",
        oc = "js-quick-view-from-cart",
        nc = "js-drawer-open",
        rc = "id",
        ac = "data-media-id",
        lc = "data-section-id",
        cc = "loaded",
        hc = "tabindex",
        dc = "data-quick-view-onboarding",
        uc = "data-hotspot",
        pc = "data-hotspot-ref",
        mc = "AddToCartForm--",
        gc = "AddToCart--";
    const fc = 400,
        yc = ".pswp",
        vc = ".pswp__custom-close",
        bc = "iframe, video",
        wc = ".pswp__custom-iframe",
        Sc = ".pswp__thumbs",
        Ec = ".pswp__button, .pswp__caption-close",
        Lc = "is-current",
        kc = "pswp--custom-loader",
        Ac = "pswp--custom-opening",
        Cc = "pswp__loader",
        qc = "pswp--open",
        Tc = "pswp__button--close",
        Pc = "pswp--notification",
        xc = "popup-quick-view",
        Ic = "js-drawer-open-cart",
        Hc = "popup-quick-view--animate-out",
        Fc = "data-pswp-option-classes",
        Mc = "data-video-type",
        Dc = `<div class="${Cc}"><div class="loader loader--image"><div class="loader__image"></div></div></div>`;
    let Oc = class {
        init() {
            document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                this.pswpElement.classList.add(Ac),
                this.initLoader(),
                Xe({ url: window.theme.assets.photoswipe })
                    .then(() => this.loadPopup())
                    .catch((t) => console.error(t));
        }
        initLoader() {
            if (this.pswpElement.classList.contains(kc) && "" !== this.options && this.options.mainClass) {
                this.pswpElement.setAttribute(Fc, this.options.mainClass);
                let t = document.createElement("div");
                (t.innerHTML = Dc), (t = t.firstChild), this.pswpElement.appendChild(t);
            } else this.pswpElement.setAttribute(Fc, "");
        }
        loadPopup() {
            const t = window.themePhotoswipe.PhotoSwipe.default,
                e = window.themePhotoswipe.PhotoSwipeUI.default;
            this.pswpElement.classList.remove(Ac),
                (this.popup = new t(this.pswpElement, e, this.items, this.options)),
                this.popup.listen("afterInit", this.dispatchPopupInitEventCallback),
                this.popup.listen("imageLoadComplete", this.setCurrentThumbCallback),
                this.popup.listen("imageLoadComplete", this.loadingStateCallback),
                this.popup.listen("beforeChange", this.setCurrentThumbCallback),
                this.popup.listen("close", this.onCloseCallback),
                this.popup.init(),
                this.initPopupCallback();
        }
        loadingState(t) {
            t === this.options.index && this.pswpElement.classList.contains(kc) && this.pswpElement.classList.remove(kc);
        }
        initPopupCallback() {
            this.isVideo && this.hideUnusedButtons(),
                this.initVideo(),
                this.thumbsActions(),
                this.a11y.trapFocus({ container: this.pswpElement }),
                this.pswpElement.classList.contains(xc) &&
                    new (class {
                        initTooltips() {
                            (this.tooltips = this.pswpElement.querySelectorAll(Ul)),
                                this.tooltips.forEach((t) => {
                                    new Ji(t);
                                });
                        }
                        initPopouts() {
                            var t;
                            (this.popoutElements = this.pswpElement.querySelectorAll(Ml)),
                                (this.popouts = {}),
                                null === (t = this.popoutElements) ||
                                    void 0 === t ||
                                    t.forEach((t, e) => {
                                        this.popouts[e] = new Tl(t);
                                    });
                        }
                        handleDraggable(t, e) {
                            t && ((t.options.draggable = Boolean(e)), t.updateDraggable());
                        }
                        initItems(t, e) {
                            this.addFormSuffix(t), this.initProductSlider(t, e), this.initProductVideo(t), this.initProductModel(t), this.initShopifyXrLaunch(t), eo(t), this.pswpElement.querySelectorAll(jl).length && new xr(t), pt(t);
                            const i = new ol(t.parentNode);
                            this.productForms.push(i), Shopify.PaymentButton && Shopify.PaymentButton.init(), t.classList.remove(Ql);
                        }
                        init() {
                            document.addEventListener("submit", this.prevent3dModelSubmitEvent),
                                this.popupCloseButtons.forEach((t) => {
                                    t.addEventListener("keyup", (t) => {
                                        (t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER && t.code !== theme.keyboardKeys.SPACE) || this.closePopup(t);
                                    }),
                                        t.addEventListener("click", (t) => {
                                            this.closePopup(t);
                                        });
                                }),
                                this.pswpElement.addEventListener("click", this.outerCloseEvent),
                                document.dispatchEvent(new CustomEvent("theme:popup:open", { bubbles: !0 })),
                                this.popup.listen("preventDragEvent", (t, e, i) => {
                                    i.prevent = !1;
                                }),
                                this.pswpElement.addEventListener("mousedown", () => {
                                    this.popup.framework.unbind(window, "pointermove pointerup pointercancel", this.popup);
                                }),
                                this.popup.listen("initialZoomInEnd", () => {
                                    document.body.classList.add(sc), this.a11y.trapFocus({ container: this.quickViewInner });
                                }),
                                this.pswpElement.addEventListener("animationend", this.closeOnAnimationEndEvent),
                                this.popup.listen("destroy", () => {
                                    this.flkty.length > 0 &&
                                        requestAnimationFrame(() => {
                                            this.flkty.forEach((t) => t.pausePlayer());
                                        }),
                                        document.body.classList.remove(sc),
                                        document.removeEventListener("keyup", this.closeOnEscapeEvent),
                                        document.addEventListener("keyup", this.closeOnEscapeEvent),
                                        this.pswpElement.removeEventListener("click", this.outerCloseEvent),
                                        this.pswpElement.removeEventListener("animationend", this.closeOnAnimationEndEvent),
                                        document.removeEventListener("submit", this.prevent3dModelSubmitEvent),
                                        this.deferredMedias.forEach((t) => {
                                            t.removeAttribute(cc);
                                            const e = t.closest($l);
                                            e.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), e.classList.add(Xl);
                                        });
                                }),
                                document.addEventListener("keyup", this.closeOnEscapeEvent),
                                document.addEventListener("theme:cart:added", () => {
                                    this.pswpElement.classList.contains(ic) && this.pswpElement.classList.add(tc);
                                }),
                                this.animateInQuickview(),
                                this.initShopTheLookListeners();
                        }
                        initShopTheLookListeners() {
                            var t;
                            null === (t = this.buttonsShopTheLookThumb) ||
                                void 0 === t ||
                                t.forEach((t) => {
                                    t.addEventListener("click", (t) => {
                                        t.preventDefault();
                                        const e = t.target.matches(Wl) ? t.target : t.target.closest(Wl),
                                            i = this.pswpElement.querySelector(`[${uc}="${e.getAttribute(pc)}"]`);
                                        !e.classList.contains(Kl) &&
                                            i &&
                                            (this.flkty.length > 0 &&
                                                requestAnimationFrame(() => {
                                                    this.flkty.forEach((t) => {
                                                        t.resize();
                                                        const e = this.quickViewInner.querySelectorAll($l);
                                                        e.length &&
                                                            e.forEach((t) => {
                                                                t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(Xl);
                                                            });
                                                    });
                                                }),
                                            i.classList.add(Kl),
                                            this.quickViewItemHolders.forEach((t) => {
                                                t !== i && t.classList.remove(Kl);
                                            }));
                                    });
                                });
                        }
                        prevent3dModelSubmit(t) {
                            t.submitter.closest(Il) && t.submitter.closest(zl) && t.preventDefault();
                        }
                        closeQuickviewOnMobile() {
                            window.innerWidth < window.theme.sizes.large && document.body.classList.contains(sc) && this.popup.close();
                        }
                        animateInQuickview() {
                            this.pswpElement.classList.add(Zl),
                                this.quickViewFoot.addEventListener("animationend", (t) => {
                                    this.handleAnimatedState(t);
                                }),
                                this.pswpElement.addEventListener("animationend", (t) => {
                                    this.handleAnimatedState(t, !0);
                                });
                        }
                        handleAnimatedState(t, e = !1) {
                            if ("quickViewAnimateInUp" == t.animationName) {
                                if (e && window.innerWidth >= window.theme.sizes.small) return;
                                this.pswpElement.classList.add(ec), this.pswpElement.classList.remove(Zl), document.body.classList.remove(oc), ft(this.pswpElement);
                            }
                        }
                        closePopup(t) {
                            null == t || t.preventDefault(),
                                document.body.classList.contains(nc) && document.dispatchEvent(new CustomEvent("theme:drawer:closing", { bubbles: !0 })),
                                this.pswpElement.classList.add(tc),
                                this.swatchesContainer.onUnload();
                        }
                        closeOnAnimationEnd(t) {
                            ("quickViewAnimateOutRight" != t.animationName && "quickViewAnimateOutDown" != t.animationName) ||
                                (this.popup.template.classList.remove(tc, ec), this.popup.close(), this.productForms.length > 0 && this.productForms.forEach((t) => t.onUnload()));
                        }
                        closeOnEscape(t) {
                            const e = document.body.classList.contains(sc),
                                i = document.body.classList.contains(Jl);
                            t.code === theme.keyboardKeys.ESCAPE && e && !i && this.closePopup(t);
                        }
                        initProductSlider(t, i) {
                            const s = t.querySelector(_l),
                                o = t.querySelectorAll($l);
                            if (o.length > 1) {
                                const n = new e(s, {
                                    wrapAround: !0,
                                    cellAlign: "left",
                                    pageDots: !1,
                                    prevNextButtons: !0,
                                    adaptiveHeight: !1,
                                    pauseAutoPlayOnHover: !1,
                                    selectedAttraction: 0.2,
                                    friction: 1,
                                    autoPlay: !1,
                                    on: {
                                        ready: () => {
                                            s.setAttribute(hc, "-1"),
                                                requestAnimationFrame(() => {
                                                    n.resize();
                                                });
                                        },
                                        settle: () => {
                                            const e = n.selectedElement,
                                                i = e.getAttribute(ac);
                                            e.setAttribute(hc, "0"),
                                                n.cells.forEach((t) => {
                                                    t.element !== e && t.element.setAttribute(hc, "-1");
                                                }),
                                                this.switchMedia(t, i);
                                        },
                                    },
                                });
                                this.flkty.push(n),
                                    o.length &&
                                        o.forEach((t) => {
                                            t.addEventListener("theme:media:play", () => {
                                                this.handleDraggable(this.flkty[i], !1), t.closest(_l).classList.add(Gl);
                                            }),
                                                t.addEventListener("theme:media:pause", () => {
                                                    this.handleDraggable(this.flkty[i], !0), t.closest(_l).classList.remove(Gl);
                                                });
                                        }),
                                    vi(s);
                            }
                        }
                        switchMedia(t, e) {
                            const i = this.quickViewInner.querySelectorAll($l),
                                s = t.querySelector(`${$l}[${ac}="${e}"]`),
                                o = !document.body.classList.contains(Yl);
                            i.length &&
                                i.forEach((t) => {
                                    t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(Xl);
                                }),
                                o && s.focus(),
                                s.closest(_l).classList.remove(Gl),
                                s.classList.remove(Xl),
                                s.dispatchEvent(new CustomEvent("theme:media:visible"), { bubbles: !0 });
                            const n = s.querySelector(Il);
                            n && "true" !== n.getAttribute(cc) && s.querySelector(Hl).dispatchEvent(new Event("click"));
                        }
                        initProductVideo(t) {
                            const e = new Hi(t);
                            this.videos.push(e);
                        }
                        initProductModel(t) {
                            const e = t.getAttribute(lc),
                                i = t.querySelectorAll(Rl);
                            i.length &&
                                i.forEach((t) => {
                                    theme.ProductModel.init(t, e);
                                });
                        }
                        initShopifyXrLaunch(t) {
                            document.addEventListener("shopify_xr_launch", () => {
                                t.querySelector(`${Rl}:not(.${Xl})`).dispatchEvent(new CustomEvent("xrLaunch"));
                            });
                        }
                        addFormSuffix(t) {
                            const e = `${t.getAttribute(lc)}-${JSON.parse(t.querySelector(Vl).innerHTML).handle}`,
                                i = t.querySelector(zl),
                                s = t.querySelector(xl);
                            i.setAttribute(rc, mc + e), s.setAttribute(rc, gc + e);
                        }
                        constructor(t, e) {
                            (this.popup = t),
                                (this.pswpElement = e),
                                (this.quickViewFoot = this.pswpElement.querySelector(Nl)),
                                (this.quickViewInner = this.pswpElement.querySelector(Dl)),
                                (this.product = this.pswpElement.querySelectorAll(Bl)),
                                (this.flkty = []),
                                (this.videos = []),
                                (this.productForms = []),
                                (this.deferredMedias = this.pswpElement.querySelectorAll(Il)),
                                (this.buttonsShopTheLookThumb = this.pswpElement.querySelectorAll(Wl)),
                                (this.quickViewItemHolders = this.pswpElement.querySelectorAll(Ol)),
                                (this.popupCloseButtons = this.quickViewInner.querySelectorAll(Fl)),
                                (this.a11y = Ke),
                                (this.prevent3dModelSubmitEvent = (t) => this.prevent3dModelSubmit(t)),
                                (this.closeOnAnimationEndEvent = (t) => this.closeOnAnimationEnd(t)),
                                (this.closeOnEscapeEvent = (t) => this.closeOnEscape(t)),
                                (this.outerCloseEvent = (t) => {
                                    if (!this.quickViewInner.contains(t.target)) {
                                        const e = this.quickViewInner.nextElementSibling;
                                        if (e && e.contains(t.target)) return;
                                        this.closePopup(t);
                                    }
                                }),
                                this.product.forEach((t, e) => {
                                    t.hasAttribute(dc) || this.initItems(t, e);
                                }),
                                this.init(),
                                this.initTooltips(),
                                this.initPopouts(),
                                (this.swatchesContainer = new to(this.pswpElement));
                        }
                    })(this.popup, this.pswpElement),
                this.pswpElement.classList.contains(Pc) &&
                    new (class {
                        init() {
                            this.popup.listen("preventDragEvent", (t, e, i) => {
                                i.prevent = !1;
                            });
                            const t = -1 !== window.location.search.indexOf("?customer_posted=true");
                            this.notificationForm = this.pswpElement.querySelector(pi);
                            const e = this.pswpElement.querySelector(gi);
                            document.body.classList.add(yi),
                                this.pswpElement.addEventListener("mousedown", () => {
                                    this.popup.framework.unbind(window, "pointermove pointerup pointercancel", this.popup);
                                }),
                                t && this.pswpElement.classList.add(fi),
                                this.notificationForm.addEventListener("submit", (t) => this.notificationSubmitEvent(t)),
                                this.pswpElement.addEventListener("click", this.outerCloseEvent),
                                e.addEventListener("click", () => {
                                    this.popup.close();
                                }),
                                this.popup.listen("destroy", () => {
                                    this.notificationRemoveStorage(), this.pswpElement.removeEventListener("click", this.outerCloseEvent), document.body.classList.remove(yi);
                                });
                        }
                        notificationSubmitEvent(t) {
                            this.notificationStopSubmit && (t.preventDefault(), this.notificationRemoveStorage(), this.notificationWriteStorage(), (this.notificationStopSubmit = !1), this.notificationForm.submit());
                        }
                        notificationWriteStorage() {
                            void 0 !== this.sessionStorage && this.sessionStorage.setItem("notification_form_id", this.notificationForm.id);
                        }
                        notificationRemoveStorage() {
                            this.sessionStorage.removeItem("notification_form_id");
                        }
                        constructor(t, e) {
                            (this.popup = t), (this.pswpElement = e), (this.notificationForm = null), (this.notificationStopSubmit = !0), (this.sessionStorage = window.sessionStorage);
                            const i = this.pswpElement.querySelector(mi);
                            (this.outerCloseEvent = (t) => {
                                i.contains(t.target) || this.popup.close();
                            }),
                                this.init();
                        }
                    })(this.popup, this.pswpElement),
                (this.closePopup = () => {
                    this.pswpElement.classList.contains(xc) ? this.pswpElement.classList.add(Hc) : this.popup.close();
                }),
                this.closeBtn && this.closeBtn.addEventListener("click", this.closePopup),
                document.addEventListener("theme:cart:added", this.closePopup);
        }
        dispatchPopupInitEvent() {
            this.triggerBtn && this.triggerBtn.dispatchEvent(new CustomEvent("theme:popup:init", { bubbles: !0 }));
        }
        initVideo() {
            const t = this.pswpElement.querySelector(wc);
            if (t) {
                const e = t.getAttribute(Mc);
                (this.isVideo = !0),
                    "youtube" == e
                        ? new (class {
                              init() {
                                  window.isYoutubeAPILoaded ? this.loadYoutubePlayer() : Xe({ url: "https://www.youtube.com/iframe_api" }).then(() => this.loadYoutubePlayer());
                              }
                              loadYoutubePlayer() {
                                  const t = {
                                      height: "720",
                                      width: "1280",
                                      playerVars: this.videoOptionsVars,
                                      events: {
                                          onReady: (t) => {
                                              const e = t.target.getIframe().id;
                                              "true" === document.querySelector(`#${e}`).getAttribute(ai) ? t.target.unMute() : t.target.mute(),
                                                  t.target.playVideo(),
                                                  this.checkPlayerVisibilityFlag &&
                                                      (this.checkPlayerVisibility(e),
                                                      window.addEventListener(
                                                          "scroll",
                                                          Ce(() => {
                                                              this.checkPlayerVisibility(e);
                                                          }, 150)
                                                      ));
                                          },
                                          onStateChange: (t) => {
                                              0 == t.data && t.target.playVideo(), 1 == t.data && t.target.getIframe().parentElement.classList.add(di);
                                          },
                                      },
                                  };
                                  (t.videoId = this.videoID),
                                      this.videoID.length &&
                                          YT.ready(() => {
                                              ui[this.playerID] = new YT.Player(this.playerID, t);
                                          }),
                                      (window.isYoutubeAPILoaded = !0);
                              }
                              checkPlayerVisibility(t) {
                                  let e;
                                  if ("string" == typeof t) e = t;
                                  else {
                                      if (null == t.data) return;
                                      e = t.data.id;
                                  }
                                  const i = document.getElementById(e + "-container");
                                  if (!i) return;
                                  const s = ui[e],
                                      o = i.getBoundingClientRect();
                                  let n = visibilityHelper.isElementPartiallyVisible(i) || visibilityHelper.isElementTotallyVisible(i);
                                  o.top < 0 && i.clientHeight + o.top >= 0 && (n = !0), n && s && "function" == typeof s.playVideo ? s.playVideo() : !n && s && "function" == typeof s.pauseVideo && s.pauseVideo();
                              }
                              onUnload() {
                                  const t = "youtube-" + this.container.getAttribute(ri);
                                  ui[t] && ui[t].destroy();
                              }
                              constructor(t) {
                                  (this.container = t),
                                      (this.player = this.container.querySelector(ni.videoIframe)),
                                      this.player &&
                                          ((this.videoOptionsVars = {}),
                                          (this.videoID = this.player.getAttribute(ci)),
                                          (this.videoType = this.player.getAttribute(hi)),
                                          "youtube" == this.videoType &&
                                              ((this.checkPlayerVisibilityFlag = "true" === this.player.getAttribute(li)),
                                              (this.playerID = this.player.querySelector(ni.youtubeWrapper) ? this.player.querySelector(ni.youtubeWrapper).id : this.player.id),
                                              this.player.hasAttribute(ni.dataHideOptions) &&
                                                  (this.videoOptionsVars = { cc_load_policy: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, autohide: 0, controls: 0, branding: 0, showinfo: 0, rel: 0, fs: 0, wmode: "opaque" }),
                                              this.init(),
                                              this.container.addEventListener(
                                                  "touchstart",
                                                  function (t) {
                                                      if (t.target.matches(ni.videoWrapper) || t.target.closest(ni.videoWrapper)) {
                                                          const e = t.target.querySelector(ni.videoIframe).id;
                                                          ui[e].playVideo();
                                                      }
                                                  },
                                                  { passive: !0 }
                                              )));
                              }
                          })(t.parentElement)
                        : "vimeo" == e &&
                          new (class {
                              init() {
                                  this.loadVimeoPlayer();
                              }
                              loadVimeoPlayer() {
                                  const t = "https://vimeo.com/" + this.videoID;
                                  let e = "";
                                  const i = this.player,
                                      s = { url: t, background: this.enableBackground, muted: this.disableSound, autoplay: this.enableAutoplay, loop: this.enableLoop };
                                  for (let t in s) e += encodeURIComponent(t) + "=" + encodeURIComponent(s[t]) + "&";
                                  fetch(`https://vimeo.com/api/oembed.json?${e}`)
                                      .then((t) => t.json())
                                      .then(function (t) {
                                          (i.innerHTML = t.html),
                                              setTimeout(function () {
                                                  i.parentElement.classList.add(Je);
                                              }, 1e3);
                                      })
                                      .catch(function () {
                                          console.log("error");
                                      });
                              }
                              constructor(t) {
                                  (this.container = t),
                                      (this.player = this.container.querySelector(Ye)),
                                      this.player &&
                                          ((this.videoID = this.player.getAttribute(si)),
                                          (this.videoType = this.player.getAttribute(oi)),
                                          (this.enableBackground = "true" === this.player.getAttribute(ti)),
                                          (this.disableSound = "false" === this.player.getAttribute(Ze)),
                                          (this.enableAutoplay = "false" !== this.player.getAttribute(ei)),
                                          (this.enableLoop = "false" !== this.player.getAttribute(ii)),
                                          "vimeo" == this.videoType && this.init());
                              }
                          })(t.parentElement);
            }
        }
        thumbsActions() {
            this.popupThumbsContainer &&
                this.popupThumbsContainer.firstChild &&
                (this.popupThumbsContainer.addEventListener("wheel", (t) => this.stopDisabledScroll(t)),
                this.popupThumbsContainer.addEventListener("mousewheel", (t) => this.stopDisabledScroll(t)),
                this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t) => this.stopDisabledScroll(t)),
                (this.popupThumbs = this.pswpElement.querySelectorAll(`${Sc} > *`)),
                this.popupThumbs.forEach((t, e) => {
                    t.addEventListener("click", (i) => {
                        i.preventDefault(), t.parentElement.querySelector(`.${Lc}`).classList.remove(Lc), t.classList.add(Lc), this.popup.goTo(e);
                    });
                }));
        }
        hideUnusedButtons() {
            this.pswpElement.querySelectorAll(Ec).forEach((t) => {
                t.classList.contains(Tc) || (t.style.display = "none");
            });
        }
        stopDisabledScroll(t) {
            t.stopPropagation();
        }
        onClose() {
            const t = this.pswpElement.querySelector(bc);
            if ((t && t.parentNode.removeChild(t), this.popupThumbsContainer && this.popupThumbsContainer.firstChild))
                for (; this.popupThumbsContainer.firstChild; ) this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild);
            this.pswpElement.setAttribute(Fc, "");
            const e = this.pswpElement.querySelector(`.${Cc}`);
            e && this.pswpElement.removeChild(e),
                document.body.classList.contains(Ic) || this.a11y.removeTrapFocus(),
                document.removeEventListener("theme:cart:added", this.closePopup),
                setTimeout(() => {
                    const t = this.recentlyOpenedPopupsCount(),
                        e = document.body.classList.contains(Ic);
                    0 !== t || e || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                }, fc);
        }
        recentlyOpenedPopupsCount() {
            let t = 0;
            return (
                this.pswpElements.forEach((e) => {
                    e.classList.contains(qc) && (t += 1);
                }),
                t
            );
        }
        setCurrentThumb() {
            if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild) return;
            const t = this.pswpElement.querySelector(`${Sc} > .${Lc}`);
            if ((t && t.classList.remove(Lc), !this.popupThumbs)) return;
            const e = this.popupThumbs[this.popup.getCurrentIndex()];
            e.classList.add(Lc), this.scrollThumbs(e);
        }
        scrollThumbs(t) {
            const e = this.popupThumbsContainer.scrollLeft + this.popupThumbsContainer.offsetWidth,
                i = t.offsetLeft;
            if (e <= i + t.offsetWidth || e > i) {
                const e = parseInt(window.getComputedStyle(t).marginLeft);
                this.popupThumbsContainer.scrollTo({ top: 0, left: i - e, behavior: "smooth" });
            }
        }
        constructor(t, e = "", i = 0, s = null) {
            (this.items = t),
                (this.triggerBtn = s),
                (this.pswpElements = document.querySelectorAll(yc)),
                (this.pswpElement = this.pswpElements[i]),
                (this.popup = null),
                (this.popupThumbs = null),
                (this.popupThumbsContainer = this.pswpElement.querySelector(Sc)),
                (this.closeBtn = this.pswpElement.querySelector(vc));
            (this.options = "" !== e ? e : { history: !1, focus: !1, mainClass: "" }),
                (this.onCloseCallback = () => this.onClose()),
                (this.dispatchPopupInitEventCallback = () => this.dispatchPopupInitEvent()),
                (this.setCurrentThumbCallback = () => this.setCurrentThumb()),
                (this.loadingStateCallback = (t) => this.loadingState(t)),
                (this.a11y = Ke),
                this.init();
        }
    };
    const Bc = 0,
        zc = "[data-button-quick-view]",
        _c = "[data-quick-view-items-template]",
        $c = "[data-cart-drawer]",
        Rc = "[data-shop-the-look-quick-view-button]",
        Vc = "[data-shop-the-look-thumb]",
        Nc = "[data-quick-view-item-holder]",
        Wc = "is-loading",
        Uc = "is-active",
        jc = "js-quick-view-from-cart",
        Gc = "popup-quick-view pswp--not-close-btn",
        Kc = "popup-quick-view popup-quick-view--shop-the-look pswp--not-close-btn",
        Qc = "data-handle",
        Xc = "data-variant-id",
        Yc = "data-shop-the-look-quick-view",
        Jc = "data-hotspot",
        Zc = "data-initialized",
        th = { history: !1, focus: !1, mainClass: Gc, showHideOpacity: !1, closeOnVerticalDrag: !1, closeOnScroll: !1, modal: !1, escKey: !1 };
    let eh = class {
        popupInit(t) {
            var e, i;
            const s = this.loadPhotoswipe.pswpElement.querySelector(`[${Jc}="${t.getAttribute(Jc)}"]`),
                o = this.loadPhotoswipe.pswpElement.querySelectorAll(Nc);
            s.classList.add(Uc),
                o.forEach((t) => {
                    t !== s && t.classList.remove(Uc);
                }),
                this.toggleQuickViewButtonsLoadingClasses(!0),
                this.toggleQuickViewThumbsLoadingClasses(!0);
            const n = (t) => {
                "quickViewAnimateInUp" === t.animationName &&
                    requestAnimationFrame(() => {
                        this.toggleQuickViewThumbsLoadingClasses(!1);
                    }),
                    "quickViewAnimateOutDown" === t.animationName && this.loadPhotoswipe.pswpElement.removeEventListener("animationend", n);
            };
            this.loadPhotoswipe.pswpElement.addEventListener("animationend", n),
                null === (e = this.loadPhotoswipe) ||
                    void 0 === e ||
                    null === (i = e.popup) ||
                    void 0 === i ||
                    i.listen("destroy", () => {
                        this.toggleQuickViewButtonsLoadingClasses(!1), this.toggleQuickViewThumbsLoadingClasses(!1);
                    });
        }
        toggleQuickViewButtonsLoadingClasses(t = !0) {
            var e, i;
            t
                ? null === (i = this.buttonsQuickView) ||
                  void 0 === i ||
                  i.forEach((t) => {
                      t.classList.add(Wc);
                  })
                : null === (e = this.buttonsQuickView) ||
                  void 0 === e ||
                  e.forEach((t) => {
                      t.classList.remove(Wc);
                  });
        }
        toggleQuickViewThumbsLoadingClasses(t = !0) {
            var e, i, s;
            ((this.buttonsShopTheLookThumb = null === (e = this.loadPhotoswipe) || void 0 === e ? void 0 : e.pswpElement.querySelectorAll(Vc)), t)
                ? null === (s = this.buttonsShopTheLookThumb) ||
                  void 0 === s ||
                  s.forEach((t) => {
                      t.classList.add(Wc);
                  })
                : null === (i = this.buttonsShopTheLookThumb) ||
                  void 0 === i ||
                  i.forEach((t) => {
                      t.classList.remove(Wc);
                  });
        }
        initPhotoswipe(t) {
            t.preventDefault();
            const e = t.target.matches(zc) ? t.target : t.target.closest(zc),
                i = window.innerWidth < theme.sizes.small;
            let s = "",
                o = !1;
            if (e.hasAttribute(Yc)) {
                if (!i) return;
                o = !0;
            }
            (th.mainClass = Gc), e.classList.add(Wc), e.closest($c) && document.body.classList.add(jc), (this.a11y.state.trigger = e), e.hasAttribute(Xc) && (s = `&variant=${e.getAttribute(Xc)}`);
            const n = `${theme.routes.root}products/${e.getAttribute(Qc)}?section_id=api-quickview${s}`;
            if (o) {
                (th.mainClass = Kc),
                    this.buttonsQuickView.forEach((t) => {
                        t.classList.add(Wc);
                    });
                const t = new XMLSerializer(),
                    i = this.container.querySelector(_c).content.firstElementChild.cloneNode(!0),
                    s = t.serializeToString(i);
                this.loadPhotoswipeWithTemplate(s, e);
            } else this.loadPhotoswipeFromFetch(n, e);
        }
        loadPhotoswipeWithTemplate(t, e) {
            const i = [{ html: t }];
            this.loadPhotoswipe = new Oc(i, th, Bc, e);
        }
        loadPhotoswipeFromFetch(t, e) {
            fetch(t)
                .then((t) => t.text())
                .then((t) => {
                    const i = [{ html: t }];
                    this.loadPhotoswipe = new Oc(i, th, Bc, e);
                })
                .catch((t) => console.log("error: ", t));
        }
        constructor(t) {
            var e, i;
            (this.container = t),
                (this.a11y = Ke),
                (this.buttonsQuickView = this.container.querySelectorAll(zc)),
                (this.buttonsShopTheLookQuickView = this.container.querySelectorAll(Rc)),
                (this.popupInitCallback = (t) => this.popupInit(t)),
                null === (e = this.buttonsQuickView) ||
                    void 0 === e ||
                    e.forEach((t) => {
                        t.hasAttribute(Zc) ||
                            (t.addEventListener("click", (t) => this.initPhotoswipe(t)),
                            t.addEventListener("theme:popup:init", () => {
                                t.classList.remove(Wc), t.hasAttribute(Yc) && this.popupInitCallback(t);
                            }),
                            t.setAttribute(Zc, ""));
                    }),
                null === (i = this.buttonsShopTheLookQuickView) ||
                    void 0 === i ||
                    i.forEach((t) => {
                        t.addEventListener("click", () => {
                            var t;
                            null === (t = this.buttonsQuickView[0]) || void 0 === t || t.dispatchEvent(new Event("click"));
                        });
                    });
        }
    };
    const ih = { cartDrawerEnabled: "drawer" === window.theme.settings.cartType, timers: { addProductTimeout: 1e3 }, animations: { data: "data-aos", method: "fade-up" } },
        sh = {
            outerSection: "[data-section-id]",
            aos: "[data-aos]",
            additionalCheckoutButtons: "[data-additional-checkout-button]",
            apiContent: "[data-api-content]",
            apiLineItems: "[data-api-line-items]",
            apiUpsellItems: "[data-api-upsell-items]",
            apiCartPrice: "[data-api-cart-price]",
            buttonAddToCart: "[data-add-to-cart]",
            upsellButtonByHandle: "[data-handle]",
            cartCloseError: "[data-cart-error-close]",
            cartDrawer: "[data-cart-drawer]",
            cartDrawerTemplate: "[data-cart-drawer-template]",
            cartDrawerToggle: "[data-cart-drawer-toggle]",
            cartDrawerBody: "[data-cart-drawer-body]",
            cartErrors: "[data-cart-errors]",
            cartForm: "[data-cart-form]",
            cartTermsCheckbox: "[data-cart-acceptance-checkbox]",
            cartCheckoutButtonWrapper: "[data-cart-checkout-buttons]",
            cartCheckoutButton: "[data-cart-checkout-button]",
            cartItemRemove: "[data-item-remove]",
            cartItemsQty: "[data-cart-items-qty]",
            cartTotal: "[data-cart-total]",
            cartTotalPrice: "[data-cart-total-price]",
            cartMessage: "[data-cart-message]",
            cartMessageDefault: "[data-message-default]",
            cartPage: "[data-cart-page]",
            cartProgress: "[data-cart-message-progress]",
            emptyMessage: "[data-empty-message]",
            buttonHolder: "[data-foot-holder]",
            item: "[data-cart-item]",
            itemsHolder: "[data-items-holder]",
            itemsWrapper: "[data-items-wrapper]",
            formCloseError: "[data-close-error]",
            formErrorsContainer: "[data-cart-errors-container]",
            upsellHolder: "[data-upsell-holder]",
            errorMessage: "[data-error-message]",
            termsErrorMessage: "[data-terms-error-message]",
            pairProductsHolder: "[data-pair-products-holder]",
            pairProducts: "[data-pair-products]",
            priceHolder: "[data-cart-price-holder]",
            leftToSpend: "[data-left-to-spend]",
            quickBuyForm: "[data-quickbuy-form]",
            qtyInput: "[data-quantity-field]",
            productMediaContainer: "[data-product-media-container]",
            formWrapper: "[data-form-wrapper]",
            productForm: "[data-product-form], [data-product-form-upsell]",
            popupQuickView: ".popup-quick-view",
            popupClose: "[data-popup-close]",
            error: "[data-error]",
            quickViewOnboarding: "[data-quick-view-onboarding]",
            flickityEnabled: ".flickity-enabled",
        },
        oh = "hidden",
        nh = "is-hidden",
        rh = "js-drawer-open-cart",
        ah = "is-open",
        lh = "is-visible",
        ch = "is-expanded",
        hh = "is-loading",
        dh = "is-disabled",
        uh = "is-success",
        ph = "cart__toggle--has-items",
        mh = "variant--soldout",
        gh = "is-removed",
        fh = "aos-animate",
        yh = "is-updated",
        vh = "no-outline",
        bh = "product-grid-item__image--error",
        wh = "cv-h",
        Sh = "data-limit",
        Eh = "data-cart-message",
        Lh = "data-cart-total",
        kh = "aria-expanded",
        Ah = "disabled",
        Ch = "value",
        qh = "data-id",
        Th = "data-item",
        Ph = "data-item-index",
        xh = "data-item-title",
        Ih = "data-atc-trigger",
        Hh = "data-notification-popup",
        Fh = "data-recipient-errors";
    let Mh = {},
        Dh = class {
            init() {
                var t;
                (this.cartToggleButtons = document.querySelectorAll(sh.cartDrawerToggle)),
                    (this.cartPage = document.querySelector(sh.cartPage)),
                    (this.cartDrawer = document.querySelector(sh.cartDrawer)),
                    (this.cart = this.cartDrawer || this.cartPage),
                    (this.cartCount = this.getCartItemCount()),
                    this.assignArguments(),
                    (this.recipientErrors = "true" === (null === (t = this.form) || void 0 === t ? void 0 : t.getAttribute(Fh))),
                    (this.flktyUpsell = null),
                    (this.form = null),
                    (this.collapsible = null),
                    (this.a11y = Ke),
                    (this.build = this.build.bind(this)),
                    (this.addToCart = this.addToCart.bind(this)),
                    (this.updateCart = this.updateCart.bind(this)),
                    (this.openCartDrawer = this.openCartDrawer.bind(this)),
                    (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
                    (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
                    (this.formSubmitHandler = Ce(this.formSubmitHandler.bind(this), 50)),
                    (this.closeCartError = () => {
                        this.cartErrorHolder.classList.remove(ch);
                    }),
                    (this.cartDrawerCloseEvent = null),
                    (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
                    (this.isCartPage = Boolean(this.cart && null === this.cartDrawer)),
                    (this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this)),
                    (this.totalItems = 0),
                    (this.isCartDrawerOpen = !1),
                    (this.isCartDrawerLoaded = !1),
                    (this.cartDiscounts = 0),
                    (this.cartDrawerEnabled = ih.cartDrawerEnabled),
                    (this.cartUpdateFailed = !1),
                    this.cartEvents(),
                    this.cartAddEvent(),
                    this.cartDrawerToggleEvents(),
                    this.initQuantity(),
                    this.buttonHolder && (this.collapsible = new ze(this.buttonHolder)),
                    this.isCartPage && this.renderPairProducts(),
                    document.addEventListener("theme:popup:open", this.closeCartDrawer);
            }
            assignArguments() {
                var t;
                (this.outerSection = null === (t = this.cart) || void 0 === t ? void 0 : t.closest(sh.outerSection)),
                    (this.cartDrawerBody = document.querySelector(sh.cartDrawerBody)),
                    (this.emptyMessage = document.querySelector(sh.emptyMessage)),
                    (this.buttonHolder = document.querySelector(sh.buttonHolder)),
                    (this.itemsHolder = document.querySelector(sh.itemsHolder)),
                    (this.cartItemsQty = document.querySelector(sh.cartItemsQty)),
                    (this.itemsWrapper = document.querySelector(sh.itemsWrapper)),
                    (this.items = document.querySelectorAll(sh.item)),
                    (this.cartTotal = document.querySelector(sh.cartTotal)),
                    (this.cartTotalPrice = document.querySelector(sh.cartTotalPrice)),
                    (this.cartMessage = document.querySelectorAll(sh.cartMessage)),
                    (this.cartOriginalTotal = document.querySelector(sh.cartOriginalTotal)),
                    (this.cartErrorHolder = document.querySelector(sh.cartErrors)),
                    (this.cartCloseErrorMessage = document.querySelector(sh.cartCloseError)),
                    (this.pairProductsHolder = document.querySelector(sh.pairProductsHolder)),
                    (this.pairProducts = document.querySelector(sh.pairProducts)),
                    (this.priceHolder = document.querySelector(sh.priceHolder)),
                    (this.upsellHolders = document.querySelectorAll(sh.upsellHolder)),
                    (this.cartTermsCheckbox = document.querySelector(sh.cartTermsCheckbox)),
                    (this.cartCheckoutButtonWrapper = document.querySelector(sh.cartCheckoutButtonWrapper)),
                    (this.cartCheckoutButton = document.querySelector(sh.cartCheckoutButton)),
                    (this.cartForm = document.querySelector(sh.cartForm)),
                    (this.cartItemCount = 0),
                    (this.subtotal = window.theme.subtotal),
                    (this.button = null);
                const { headerInitialHeight: e, announcementBarHeight: i } = N();
                (this.headerInitialHeight = e),
                    (this.announcementBarHeight = i),
                    this.cartMessage.length > 0 && (this.cartFreeLimitShipping = 100 * Number(this.cartMessage[0].getAttribute(Sh)) * window.Shopify.currency.rate),
                    this.updateProgress();
            }
            initQuantity() {
                var t;
                (this.items = document.querySelectorAll(sh.item)),
                    null === (t = this.items) ||
                        void 0 === t ||
                        t.forEach((t) => {
                            new Ge(t, !0).init(), this.cartUpdateEvent(t);
                        });
            }
            cartUpdateEvent(t) {
                t.addEventListener("theme:cart:update", (e) => {
                    this.updateCart({ id: e.detail.id, quantity: e.detail.quantity }, t);
                });
            }
            cartEvents() {
                const t = document.querySelectorAll(sh.cartItemRemove);
                (this.totalItems = t.length),
                    null == t ||
                        t.forEach((t) => {
                            const e = t.closest(sh.item);
                            t.addEventListener("click", (i) => {
                                i.preventDefault(), t.classList.contains(dh) || this.updateCart({ id: e.getAttribute(qh), quantity: 0 }, e);
                            });
                        }),
                    this.cartCloseErrorMessage && (this.cartCloseErrorMessage.removeEventListener("click", this.closeCartError), this.cartCloseErrorMessage.addEventListener("click", this.closeCartError)),
                    this.cartTermsCheckbox &&
                        (this.cartTermsCheckbox.removeEventListener("change", this.formSubmitHandler),
                        this.cartCheckoutButtonWrapper.removeEventListener("click", this.formSubmitHandler),
                        this.cartForm.removeEventListener("submit", this.formSubmitHandler),
                        this.cartTermsCheckbox.addEventListener("change", this.formSubmitHandler),
                        this.cartCheckoutButtonWrapper.addEventListener("click", this.formSubmitHandler),
                        this.cartForm.addEventListener("submit", this.formSubmitHandler));
            }
            cartAddEvent() {
                document.addEventListener("click", (t) => {
                    const e = t.target,
                        i = null == e ? void 0 : e.matches(sh.buttonAddToCart),
                        s = null == e ? void 0 : e.closest(sh.buttonAddToCart);
                    if (i || s) {
                        var o, n, r;
                        t.preventDefault(),
                            (this.button = i ? e : s),
                            (this.form = e.closest("form")),
                            (this.recipientErrors = "true" === (null === (o = this.form) || void 0 === o ? void 0 : o.getAttribute(Fh))),
                            (this.formWrapper = this.button.closest(sh.formWrapper));
                        const a = null === (n = this.formWrapper) || void 0 === n ? void 0 : n.classList.contains(mh),
                            l = this.button.hasAttribute(Ah),
                            c = this.button.closest(sh.quickViewOnboarding),
                            h = this.button.hasAttribute(Ih),
                            d = this.button.hasAttribute(Hh),
                            u = null === (r = this.form) || void 0 === r ? void 0 : r.querySelector('[type="file"]');
                        if (l || u || c) return;
                        if (a && d) return void new Zr(this.button);
                        h && (this.a11y.state.trigger = this.button);
                        const p = new FormData(this.form);
                        this.addToCart(p), document.dispatchEvent(new CustomEvent("theme:cart:add", { bubbles: !0, detail: { selector: e } }));
                    }
                });
            }
            getCart() {
                if (this.cartDrawer && !this.isCartDrawerLoaded) {
                    const t = !1;
                    this.renderCartDrawer(t);
                }
                fetch(theme.routes.cart_url + "?section_id=api-cart-items")
                    .then(this.handleErrors)
                    .then((t) => t.text())
                    .then((t) => {
                        const e = document.createElement("div");
                        e.innerHTML = t;
                        const i = e.querySelector(sh.apiContent);
                        this.build(i);
                    })
                    .catch((t) => console.log(t));
            }
            addToCart(t) {

                if (t instanceof FormData) {
                    t.set('properties[add_to_cart_timestamp]', new Date().toISOString());
                }

                this.cartDrawerEnabled && this.button && (this.button.classList.add(hh), this.button.setAttribute(Ah, !0)),
                    fetch(theme.routes.cart_add_url, { method: "POST", headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" }, body: t })
                        .then((t) => t.json())
                        .then((t) => {
                            if (((this.button.disabled = !0), this.addLoadingClass(), t.status)) return this.addToCartError(t), this.removeLoadingClass(), void this.scrollToCartTop();
                            this.hideAddToCartErrorMessage(), this.cartDrawerEnabled ? this.getCart() : (window.location = theme.routes.cart_url);
                        })
                        .catch((t) => console.log(t));
            }
            updateCart(t = {}, e = null) {
                let i = t.quantity;
                null !== e && (i ? e.classList.add(hh) : e.classList.add(gh)), this.disableCartButtons(), this.addLoadingClass();
                const s = this.cart.querySelector(`[${Th}="${t.id}"]`) || e,
                    o = (null == s ? void 0 : s.hasAttribute(Ph)) ? parseInt(s.getAttribute(Ph)) : 0,
                    n = (null == s ? void 0 : s.hasAttribute(xh)) ? s.getAttribute(xh) : null;
                if (0 === o) return;
                const r = { line: o, quantity: i };
                if (s.dataset.fbtmst == 1 && i == 0)
                {
                  fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => {
                      const updates = {};
                  
                      // Step 2: Find items with the _FBT property
                      cart.items.forEach(item => {
                        const fbtValue = item.properties && item.properties._FBT;
                        if (fbtValue === s.dataset.fbt) {
                          updates[item.key] = 0; // Step 3: Set quantity to 0 to remove
                        }
                      });
                  
                      // If there are items to remove
                      if (Object.keys(updates).length > 0) {
                        // Step 4: Send update.js request
                        fetch('/cart/update.js', {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json'
                          },
                          body: JSON.stringify({ updates })
                        })
                        /* .then(response => response.json())
                        .then(updatedCart => {
                          console.log('Cart updated:', updatedCart);
                          // Optional: Refresh cart UI or redirect
                        })
                        .catch(error => console.error('Update failed:', error));*/


                        .then((t) => {
                          if (400 === t.status) {
                              const e = new Error(t.status);
                              throw (this.cartDrawerEnabled ? this.getCart() : (window.location = theme.routes.cart_url), e);
                          }
                          return t.text();
                      })
                      .then((t) => {
                          if (JSON.parse(t).errors)
                              return (this.cartUpdateFailed = !0), this.updateErrorText(n), this.toggleErrorMessage(), this.resetLineItem(e), this.enableCartButtons(), this.removeLoadingClass(), void this.scrollToCartTop();
                          this.getCart();
                      })
                      .catch((t) => {
                          console.log(t), this.enableCartButtons(), this.removeLoadingClass();
                      });
                        
                        
                      }
                    })
                    .catch(error => console.error('Cart fetch failed:', error));






                  
                }
                else {
                  fetch(theme.routes.cart_change_url, { method: "post", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(r) })
                      .then((t) => {
                          if (400 === t.status) {
                              const e = new Error(t.status);
                              throw (this.cartDrawerEnabled ? this.getCart() : (window.location = theme.routes.cart_url), e);
                          }
                          return t.text();
                      })
                      .then((t) => {
                          if (JSON.parse(t).errors)
                              return (this.cartUpdateFailed = !0), this.updateErrorText(n), this.toggleErrorMessage(), this.resetLineItem(e), this.enableCartButtons(), this.removeLoadingClass(), void this.scrollToCartTop();
                          this.getCart();
                      })
                      .catch((t) => {
                          console.log(t), this.enableCartButtons(), this.removeLoadingClass();
                      });
                }
            }
            resetLineItem(t) {
                const e = t.querySelector(sh.qtyInput),
                    i = e.getAttribute("value");
                (e.value = i), t.classList.remove(hh);
            }
            disableCartButtons() {
                const t = this.cart.querySelectorAll("input"),
                    e = this.cart.querySelectorAll(`button, ${sh.cartItemRemove}`);
                t.length &&
                    t.forEach((t) => {
                        t.classList.add(dh), t.blur(), (t.disabled = !0);
                    }),
                    e.length &&
                        e.forEach((t) => {
                            t.setAttribute(Ah, !0);
                        });
            }
            enableCartButtons() {
                const t = this.cart.querySelectorAll("input"),
                    e = this.cart.querySelectorAll(`button, ${sh.cartItemRemove}`);
                t.length &&
                    t.forEach((t) => {
                        t.classList.remove(dh), (t.disabled = !1);
                    }),
                    e.length &&
                        e.forEach((t) => {
                            t.removeAttribute(Ah);
                        });
            }
            updateErrorText(t) {
                this.cartErrorHolder.querySelector(sh.errorMessage).innerText = t;
            }
            toggleErrorMessage() {
                if (this.cartErrorHolder) {
                    if ((this.cartErrorHolder.classList.toggle(ch, this.cartUpdateFailed), this.cartUpdateFailed)) {
                        const t = this.cartErrorHolder.querySelector(sh.cartCloseError);
                        this.focusOnErrorMessage(this.cartErrorHolder, t);
                    }
                    this.cartUpdateFailed = !1;
                }
            }
            handleErrors(t) {
                return t.ok
                    ? t
                    : t.json().then(function (e) {
                          throw new qe({ status: t.statusText, headers: t.headers, json: e });
                      });
            }
            addToCartError(t) {
                const e = this.button.closest(sh.quickBuyForm),
                    i = this.button.closest(sh.upsellHolder),
                    s = !document.body.classList.contains(vh);
                let o = (this.button.closest(sh.productForm) ? this.button.closest(sh.productForm) : this.button.closest(sh.upsellHolder)).querySelector(sh.formErrorsContainer);
                i && (o = i.querySelector(sh.formErrorsContainer)),
                    this.cartDrawerEnabled && this.button && null !== this.button.closest(sh.cartDrawer) && !this.button.closest(sh.cartDrawer) && this.closeCartDrawer(),
                    this.button.classList.remove(hh),
                    this.button.removeAttribute(Ah);
                const n = e ? "" : `\n      <button type="button" class="errors__button-close" data-close-error>\n        ${theme.icons.close}\n      </button>\n    `;
                let r = `${t.message}: ${t.description}`;
                if (
                    (t.message === t.description && (r = t.message),
                    this.recipientErrors &&
                        t.description &&
                        "object" == typeof t.description &&
                        (r = Object.entries(t.description)
                            .map(([t, e]) => `${e}`)
                            .join("<br>")),
                    (o.innerHTML = `\n      <div class="errors" data-error autofocus>\n        ${r}\n        ${n}\n      </div>\n    `),
                    e)
                ) {
                    const t = o.closest(sh.productMediaContainer);
                    t.classList.add(bh),
                        o.querySelector(sh.error).addEventListener("animationend", () => {
                            t.classList.remove(bh), (o.innerHTML = ""), s || document.activeElement.blur();
                        });
                } else
                    o.classList.add(lh),
                        o.addEventListener("transitionend", () => {
                            this.resizeSliders(o);
                        }),
                        this.handleCloseErrorMessages(o);
            }
            handleCloseErrorMessages(t) {
                const e = t.querySelector(sh.formCloseError);
                null == e ||
                    e.addEventListener("click", (e) => {
                        const i = e.target;
                        (i.matches(sh.formCloseError) || i.closest(sh.formCloseError)) &&
                            (e.preventDefault(),
                            t.classList.remove(lh),
                            t.querySelector(sh.error).addEventListener("transitionend", () => {
                                (t.innerHTML = ""), this.resizeSliders(i);
                            }));
                    }),
                    this.focusOnErrorMessage(t, e);
            }
            focusOnErrorMessage(t, e) {
                !document.body.classList.contains(vh) &&
                    t.addEventListener("transitionend", () => {
                        requestAnimationFrame(() => (null == e ? void 0 : e.focus({ focusVisible: !0 })));
                    });
            }
            hideAddToCartErrorMessage() {
                const t = this.button.closest(sh.upsellHolder) ? this.button.closest(sh.upsellHolder) : this.button.closest(sh.productForm),
                    e = null == t ? void 0 : t.querySelector(sh.formErrorsContainer);
                null == e || e.classList.remove(lh);
            }
            resizeSliders(t) {
                const i = t.closest(sh.flickityEnabled);
                if (!i) return;
                const s = e.data(i);
                requestAnimationFrame(() => s.resize());
            }
            renderCartDrawer(t = !0) {
                const e = document.querySelector(sh.cartDrawerTemplate);
                e &&
                    ((this.cartDrawer.innerHTML = e.innerHTML),
                    this.assignArguments(),
                    this.initQuantity(),
                    this.cartEvents(),
                    this.buttonHolder && (this.collapsible = new ze(this.buttonHolder)),
                    (this.cartDrawerToggle = this.cartDrawer.querySelector(sh.cartDrawerToggle)),
                    this.cartDrawerToggle.addEventListener("click", this.cartDrawerToggleClickEvent),
                    (this.isCartDrawerLoaded = !0),
                    this.renderPairProducts(),
                    document.dispatchEvent(new CustomEvent("theme:cart:loaded", { bubbles: !0 })),
                    t && this.openCartDrawer());
            }
            openCartDrawer() {
                this.isCartDrawerOpen ||
                    (this.isCartDrawerLoaded
                        ? (document.dispatchEvent(new CustomEvent("theme:cart:open", { bubbles: !0 })),
                          document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.cartDrawer })),
                          document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.cartDrawerBody })),
                          this.scrollToCartTop(),
                          document.body.classList.add(rh),
                          this.cartDrawer.classList.add(ah),
                          this.cartDrawer.classList.remove(wh),
                          requestAnimationFrame(() => this.animateCartItems("in")),
                          this.cartToggleButtons.forEach((t) => {
                              t.setAttribute(kh, !0);
                          }),
                          this.a11y.trapFocus({ container: this.cartDrawer }),
                          this.observeAdditionalCheckoutButtons(),
                          (this.isCartDrawerOpen = !0))
                        : this.renderCartDrawer());
            }
            animateCartItems(t = "in") {
                const e = this.cart.querySelectorAll(sh.aos);
                "in" === t && e.forEach((t) => requestAnimationFrame(() => t.classList.add(fh))), "out" === t && e.forEach((t) => t.classList.remove(fh));
            }
            closeCartDrawer() {
                if (!this.isCartDrawerOpen) return;
                document.dispatchEvent(new CustomEvent("theme:cart:close", { bubbles: !0 })),
                    this.cartErrorHolder.classList.remove(ch),
                    this.a11y.removeTrapFocus(),
                    this.cartToggleButtons.forEach((t) => {
                        t.setAttribute(kh, !1);
                    }),
                    document.body.classList.remove(rh),
                    this.cartDrawer.classList.remove(ah),
                    this.itemsHolder.classList.remove(yh);
                const t = (e) => {
                    e.target === this.cartDrawer && (this.animateCartItems("out"), this.cartDrawer.removeEventListener("transitionend", t));
                };
                this.cartDrawer.addEventListener("transitionend", t);
                !document.body.classList.contains(vh) ||
                    requestAnimationFrame(() => {
                        document.activeElement.blur();
                    });
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 400 })), (this.isCartDrawerOpen = !1);
            }
            toggleCartDrawer() {
                this.isCartDrawerOpen ? this.closeCartDrawer() : this.openCartDrawer();
            }
            cartDrawerToggleEvents() {
                this.cartDrawer &&
                    (this.cartDrawer.addEventListener("keyup", (t) => {
                        t.code === theme.keyboardKeys.ESCAPE && this.closeCartDrawer();
                    }),
                    (this.cartDrawerToggleClickEvent = (t) => {
                        t.preventDefault();
                        const e = t.target;
                        "false" === e.getAttribute(kh) && (this.a11y.state.trigger = e), this.toggleCartDrawer();
                    }),
                    (this.cartDrawerCloseEvent = (t) => {
                        const e = t.target.matches(sh.cartDrawerToggle),
                            i = document.querySelector(sh.cartDrawer).contains(t.target),
                            s = t.target.closest(sh.popupQuickView);
                        e || i || s || this.closeCartDrawer();
                    }),
                    this.cartToggleButtons.forEach((t) => {
                        t.addEventListener("click", this.cartDrawerToggleClickEvent);
                    }),
                    document.addEventListener("mousedown", this.cartDrawerCloseEvent));
            }
            toggleClassesOnContainers() {
                const t = this;
                this.emptyMessage.classList.toggle(oh, t.hasItemsInCart()),
                    this.buttonHolder.classList.toggle(oh, !t.hasItemsInCart()),
                    this.itemsHolder.classList.toggle(oh, !t.hasItemsInCart()),
                    this.cartItemsQty.classList.toggle(oh, !t.hasItemsInCart());
            }
            build(t) {
                const e = t.querySelector(sh.apiLineItems),
                        s = t.querySelector(sh.apiUpsellItems),
                        o = Boolean(null === e && null === s),
                        n = t.querySelector(sh.apiCartPrice),
                        r = t.querySelector(sh.cartTotal);

                this.priceHolder && n && (this.priceHolder.innerHTML = n.innerHTML);
                this.animateCartItems("out");

                o
                    ? ((this.itemsHolder.innerHTML = ""),
                    this.pairProductsHolder && (this.pairProductsHolder.innerHTML = ""))
                    : ((this.itemsHolder.innerHTML = e.innerHTML),
                    this.pairProductsHolder && (this.pairProductsHolder.innerHTML = s.innerHTML),
                    this.renderPairProducts());

                this.newTotalItems = e && e.querySelectorAll(sh.item).length ? e.querySelectorAll(sh.item).length : 0;
                this.subtotal = r && r.hasAttribute(Lh) ? parseInt(r.getAttribute(Lh)) : 0;
                this.cartCount = this.getCartItemCount();
                this.cartMessage.length > 0 && this.updateProgress();

                this.cartToggleButtons.forEach((t) => {
                    t.classList.remove(ph);
                    this.newTotalItems > 0 && t.classList.add(ph);
                });

                this.toggleErrorMessage();
                this.updateItemsQuantity(this.cartCount);
                this.cartTotalPrice.innerHTML =
                    0 === this.subtotal ? window.theme.strings.free : i.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat);

                if (this.totalItems !== this.newTotalItems) {
                    this.totalItems = this.newTotalItems;
                    this.toggleClassesOnContainers();
                }

                (this.isCartDrawerOpen || this.isCartPage) && this.itemsHolder.classList.add(yh);

                this.cartEvents();
                this.initQuantity();
                this.enableCartButtons();
                this.resetButtonClasses();
                this.removeLoadingClass();

                document.dispatchEvent(new CustomEvent("theme:cart:added", { bubbles: !0 }));

                if (this.cartDrawer && !window.location.pathname.includes("/collections/499-store")) {
                    this.openCartDrawer();
                }else{
                    let customConfirmTag1 = document.querySelector(".added-to-cart-confirm-custom1");
                    customConfirmTag1.style.display="inline-block"
                    setTimeout(() => {
                        customConfirmTag1.style.display="none";
                        this.openCartDrawer();
                    }, 1000);
                }

                requestAnimationFrame(() => this.animateCartItems("in"));
                }

            getCartItemCount() {
                return this.cart ? Array.from(this.cart.querySelectorAll(sh.qtyInput)).reduce((t, e) => t + parseInt(e.value), 0) : 0;
            }
            hasItemsInCart() {
                return this.totalItems > 0;
            }
            freeShippingMessageHandle(t) {
                this.cartMessage.length > 0 &&
                    document.querySelectorAll(sh.cartMessage).forEach((e) => {
                        const i = e.hasAttribute(Eh) && "true" === e.getAttribute(Eh) && 0 !== t,
                            s = e.querySelector(sh.cartMessageDefault);
                        e.classList.toggle(uh, t >= this.cartFreeLimitShipping && i), e.classList.toggle(nh, 0 === t), s.classList.toggle(nh, t >= this.cartFreeLimitShipping);
                    });
            }
            updateProgress() {
                const t = (this.subtotal / this.cartFreeLimitShipping) * 100,
                    e = theme.settings.currency_code_enable ? i.formatMoney(this.cartFreeLimitShipping - this.subtotal, theme.moneyWithCurrencyFormat) : i.formatMoney(this.cartFreeLimitShipping - this.subtotal, theme.moneyFormat);
                this.cartMessage.length > 0 &&
                    document.querySelectorAll(sh.cartMessage).forEach((i) => {
                        const s = i.querySelectorAll(sh.cartProgress),
                            o = i.querySelector(sh.leftToSpend);
                        o && (o.innerHTML = e.replace(".00", "").replace(",00", "")),
                            s.length &&
                                s.forEach((e, i) => {
                                    e.classList.toggle(nh, this.subtotal / this.cartFreeLimitShipping >= 1), e.style.setProperty("--progress-width", `${t}%`), 0 === i && e.setAttribute(Ch, t);
                                }),
                            this.freeShippingMessageHandle(this.subtotal);
                    });
            }
            renderPairProducts() {
                if (
                    ((this.flktyUpsell = null),
                    (this.pairProductsHolder = document.querySelector(sh.pairProductsHolder)),
                    (this.pairProducts = document.querySelector(sh.pairProducts)),
                    (this.upsellHolders = document.querySelectorAll(sh.upsellHolder)),
                    null === this.pairProductsHolder || void 0 === this.pairProductsHolder)
                )
                    return;
                const t = this;
                this.upsellHolders.length > 1
                    ? (this.flktyUpsell = new e(this.pairProducts, {
                          wrapAround: !0,
                          pageDots: !0,
                          adaptiveHeight: !0,
                          prevNextButtons: !1,
                          on: {
                              ready: function () {
                                  new eh(t.cart), this.reloadCells(), requestAnimationFrame(() => this.resize());
                              },
                          },
                      }))
                    : new eh(this.cart);
            }
            updateItemsQuantity(t) {
                let e = theme.strings.cart_items_one,
                    i = theme.strings.cart_items_many;
                (e = e.split("}}")[1]), (i = i.split("}}")[1]), this.cartItemsQty && (this.cartItemsQty.textContent = 1 === t ? `${t} ${e}` : `${t} ${i}`);
            }
            observeAdditionalCheckoutButtons() {
                const t = this.cart.querySelector(sh.additionalCheckoutButtons);
                if (t) {
                    const e = new MutationObserver(() => {
                        this.a11y.removeTrapFocus(), this.a11y.trapFocus({ container: this.cart }), e.disconnect();
                    });
                    e.observe(t, { subtree: !0, childList: !0 });
                }
            }
            formSubmitHandler() {
                const t = document.querySelector(sh.cartTermsCheckbox).checked,
                    e = document.querySelector(sh.termsErrorMessage);
                if (t) e.classList.remove(ch), this.cartCheckoutButton.removeAttribute(Ah);
                else {
                    if (document.querySelector(sh.termsErrorMessage).length > 0) return;
                    (e.innerText = theme.strings.cart_acceptance_error), this.cartCheckoutButton.setAttribute(Ah, !0), e.classList.add(ch);
                }
            }
            resetButtonClasses() {
                const t = document.querySelectorAll(sh.buttonAddToCart);
                t &&
                    t.forEach((t) => {
                        t.classList.contains(hh) &&
                            (t.classList.remove(hh),
                            t.classList.add(uh),
                            setTimeout(() => {
                                t.removeAttribute(Ah), t.classList.remove(uh);
                            }, ih.timers.addProductTimeout));
                    });
            }
            addLoadingClass() {
                this.cartDrawer ? this.cartDrawer.classList.add(hh) : this.itemsWrapper && this.itemsWrapper.classList.add(hh);
            }
            removeLoadingClass() {
                this.cartDrawer ? this.cartDrawer.classList.remove(hh) : this.itemsWrapper && this.itemsWrapper.classList.remove(hh);
            }
            scrollToCartTop() {
                var t;
                this.cartDrawer
                    ? this.cartDrawerBody.scrollTo({ top: 0, left: 0, behavior: "instant" })
                    : window.scrollTo({ top: (null === (t = this.outerSection) || void 0 === t ? void 0 : t.offsetTop) - this.headerInitialHeight - this.announcementBarHeight, left: 0, behavior: "smooth" });
            }
            unload() {
                this.cartDrawerToggle && this.cartDrawerToggle.removeEventListener("click", this.cartDrawerToggleClickEvent),
                    this.cartToggleButtons.forEach((t) => {
                        t.removeEventListener("click", this.cartDrawerToggleClickEvent);
                    }),
                    document.removeEventListener("mousedown", this.cartDrawerCloseEvent),
                    null !== this.collapsible && this.collapsible.onUnload();
            }
            constructor() {
                "/password" !== window.location.pathname && this.init();
            }
        };
    I("cart-template", {
        onLoad() {
            Mh[this.id] = new Dh();
        },
        onUnload() {
            "function" == typeof Mh[this.id].unload && Mh[this.id].unload();
        },
    });
    const Oh = "is-visible",
        Bh = document.querySelector("[data-scroll-top-button]");
    Bh &&
        (Bh.addEventListener("click", () => {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }),
        document.addEventListener(
            "scroll",
            Ce(() => {
                Bh.classList.toggle(Oh, window.pageYOffset > window.innerHeight);
            }, 150)
        ));
    const zh = "details",
        _h = "[data-popdown-body]",
        $h = "[data-popdown-close]",
        Rh = "[data-popdown-toggle]",
        Vh = "[data-search-form-inner]",
        Nh = "[data-popular-searches-link]",
        Wh = "[data-site-header]",
        Uh = "[data-nav]",
        jh = "[data-nav-items-compress]",
        Gh = "[data-nav-icons]",
        Kh = "[data-mobile-menu]",
        Qh = "predictive-search",
        Xh = "search-form",
        Yh = "data-popdown-in-header",
        Jh = "data-popdown-in-page",
        Zh = "data-search-performed",
        td = "aria-activedescendant",
        ed = "aria-expanded",
        id = "open",
        sd = "role",
        od = "search-opened",
        nd = "site-header--menu-opened",
        rd = "site-header--compress",
        ad = "is-open";
    let ld = class extends HTMLElement {
        connectedCallback() {
            this.isPopdownInHeader &&
                (this.searchFormInner.addEventListener("transitionend", this.popdownTransitionCallbackEvent),
                this.details.addEventListener("keyup", (t) => "ESCAPE" === t.code.toUpperCase() && this.close()),
                this.details.addEventListener("toggle", this.detailsToggleCallbackEvent),
                this.popdownClose.addEventListener("click", (t) => this.close(t)),
                this.popdownToggle.addEventListener("click", (t) => this.onPopdownToggleClick(t)),
                this.popdownToggle.setAttribute(sd, "button")),
                this.isPopdownInPage &&
                    (this.popdownClose.addEventListener("click", () => this.triggerPopdownClose()),
                    this.searchFormWrapper.addEventListener("focusout", () => this.onFocusOut()),
                    this.searchFormWrapper.input.addEventListener("click", (t) => this.triggerPopdownOpen(t))),
                this.popularSearchesLink.forEach((t) => {
                    t.addEventListener("click", (t) => {
                        t.preventDefault();
                        const e = t.target.textContent;
                        (this.searchFormWrapper.input.value = e), this.searchFormWrapper.submit();
                    });
                });
        }
        onPopdownToggleClick(t) {
            const e = navigator.userAgent.includes("Chrome"),
                i = /iPhone|iPad|iPod/i.test(navigator.userAgent);
            e && !i && t.target.closest(zh).setAttribute(id, ""), t.target.closest(zh).hasAttribute(id) && (t.preventDefault(), this.close());
        }
        detailsToggleCallback(t) {
            t.target.hasAttribute(id) && this.open();
        }
        popdownTransitionCallback(t) {
            t.target === this.searchFormInner && (this.details.classList.contains(ad) ? "transform" === t.propertyName && this.a11y.trapFocus({ container: this.searchFormInner }) : this.onClose());
        }
        onBodyClick(t) {
            var e;
            const i = this.contains(t.target);
            (null === (e = this.header) || void 0 === e ? void 0 : e.classList.contains(nd)) || i || i || this.close();
        }
        onFocusOut() {
            this.predictiveSearch &&
                requestAnimationFrame(() => {
                    this.searchFormWrapper.contains(document.activeElement) || this.searchFormWrapper.close();
                });
        }
        triggerPopdownOpen(t) {
            const e = this.closest(`[${Zh}="false"]`);
            let i = matchMedia("(pointer:coarse)").matches;
            const s = window.innerWidth < theme.sizes.small,
                o = i || s,
                n = null != e;
            if ((s && window.Shopify.designMode && (i = !0), this.nav && this.mobileMenu && (o || n))) {
                t.preventDefault();
                const e = this.header.classList.contains(rd);
                let s = this.mobileMenu.querySelector(Rh);
                i || (s = e ? this.nav.querySelector(`${jh} ${Rh}`) : this.nav.querySelector(`${Gh} ${Rh}`)),
                    setTimeout(() => {
                        null == s || s.dispatchEvent(new Event("click", { bubbles: !0 }));
                    }, 300);
            }
        }
        open() {
            (this.onBodyClickEvent = (t) => this.onBodyClick(t)),
                this.searchFormWrapper.input.setAttribute(ed, !0),
                document.body.classList.add(od),
                document.body.addEventListener("click", this.onBodyClickEvent),
                document.addEventListener("theme:resize", this.ensureClosingOnResizeEvent),
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                requestAnimationFrame(() => {
                    this.details.classList.add(ad);
                });
        }
        close(t) {
            (t && t.target === this.popdownClose && "" !== this.searchFormWrapper.input.getAttribute(td)) ||
                (this.a11y.removeTrapFocus(), this.details.classList.remove(ad), this.predictiveSearch && this.searchFormWrapper.close(), this.searchFormWrapper.handleFocusableDescendants(!0));
        }
        triggerPopdownClose() {
            this.predictiveSearch && this.searchFormWrapper.close(), this.searchFormWrapper.popularSearches && requestAnimationFrame(() => document.activeElement.blur());
        }
        onClose() {
            this.details.removeAttribute(id),
                document.dispatchEvent(new CustomEvent("theme:search:close", { bubbles: !0 })),
                document.body.classList.remove(od),
                document.body.removeEventListener("click", this.onBodyClickEvent),
                document.removeEventListener("theme:resize", this.ensureClosingOnResizeEvent),
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
        }
        ensureClosingOnResize() {
            null === this.offsetParent && this.onClose();
        }
        constructor() {
            var t, e, i;
            super(),
                (this.isPopdownInHeader = this.hasAttribute(Yh)),
                (this.isPopdownInPage = this.hasAttribute(Jh)),
                (this.popdownBody = this.querySelector(_h)),
                (this.popdownClose = this.querySelector($h)),
                (this.searchFormInner = this.querySelector(Vh)),
                (this.popularSearchesLink = this.querySelectorAll(Nh)),
                (this.searchFormWrapper = this.querySelector(Xh) ? this.querySelector(Xh) : this.querySelector(Qh)),
                (this.predictiveSearch = this.searchFormWrapper.matches(Qh)),
                (this.header = document.querySelector(Wh)),
                (this.headerSection = null === (t = this.header) || void 0 === t ? void 0 : t.parentNode),
                (this.nav = null === (e = this.header) || void 0 === e ? void 0 : e.querySelector(Uh)),
                (this.mobileMenu = null === (i = this.headerSection) || void 0 === i ? void 0 : i.querySelector(Kh)),
                (this.a11y = Ke),
                (this.ensureClosingOnResizeEvent = () => this.ensureClosingOnResize()),
                (this.popdownTransitionCallbackEvent = (t) => this.popdownTransitionCallback(t)),
                (this.detailsToggleCallbackEvent = (t) => this.detailsToggleCallback(t)),
                this.isPopdownInHeader && ((this.details = this.querySelector(zh)), (this.popdownToggle = this.querySelector(Rh)));
        }
    };
    customElements.define("search-popdown", ld),
        (Shopify.Products = (function () {
            const t = { howManyToShow: 4, howManyToStoreInMemory: 10, wrapperId: "recently-viewed-products", section: null, onComplete: null };
            let e = [],
                i = null,
                s = null;
            const o = new Date(),
                n = new Date();
            n.setTime(o.getTime() + 7776e6);
            const r = {
                    configuration: { expires: n.toGMTString(), path: "/", domain: window.location.hostname, sameSite: "none", secure: !0 },
                    name: "shopify_recently_viewed",
                    write: function (t) {
                        const e = t.join(" ");
                        document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
                    },
                    read: function () {
                        let t = [],
                            e = null;
                        return (
                            -1 !== document.cookie.indexOf("; ") &&
                                document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
                                (e = document.cookie
                                    .split("; ")
                                    .find((t) => t.startsWith(this.name))
                                    .split("=")[1]),
                            null !== e && (t = e.split(" ")),
                            t
                        );
                    },
                    destroy: function () {
                        document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
                    },
                    remove: function (t) {
                        const e = this.read(),
                            i = e.indexOf(t);
                        -1 !== i && (e.splice(i, 1), this.write(e));
                    },
                },
                a = (e, i, o, n) => {
                    i.length && e < t.howManyToShow
                        ? fetch(`${window.theme.routes.root}products/${i[0]}?section_id=api-product-grid-item`)
                              .then((t) => t.text())
                              .then((t) => {
                                  const s = 150 * e,
                                      l = o.id ? `#${o.id}` : "",
                                      c = document.createElement("div");
                                  let h = t;
                                  if (h.includes("data-unpublished")) return r.remove(i[0]), i.shift(), void a(e, i, o, n);
                                  (h = h.includes("||itemAosDelay||") ? h.replaceAll("||itemAosDelay||", s) : h),
                                      (h = h.includes("||itemAosAnchor||") ? h.replaceAll("||itemAosAnchor||", l) : h),
                                      (c.innerHTML = h),
                                      (o.innerHTML += c.querySelector("[data-api-content]").innerHTML),
                                      i.shift(),
                                      e++,
                                      a(e, i, o, n);
                              })
                              .catch(() => {
                                  r.remove(i[0]), i.shift(), a(e, i, o, n);
                              })
                        : ((e, i) => {
                              Hr(e, !0);
                              const o = r.read().length;
                              if (Shopify.recentlyViewed && s && o && o < s && e.children.length) {
                                  let t = [],
                                      i = [],
                                      s = 0;
                                  for (const e in Shopify.recentlyViewed) {
                                      s += 1;
                                      const o = Shopify.recentlyViewed[e].split(" "),
                                          n = parseInt(e.split("_")[1]);
                                      (t = [...t, ...o]), (r.read().length === n || (s === Object.keys(Shopify.recentlyViewed).length && !i.length)) && (i = [...i, ...o]);
                                  }
                                  for (let s = 0; s < e.children.length; s++) {
                                      const o = e.children[s];
                                      t.length && o.classList.remove(...t), i.length && o.classList.add(...i);
                                  }
                              }
                              if (t.onComplete)
                                  try {
                                      t.onComplete(e, i);
                                  } catch (t) {
                                      console.log(t);
                                  }
                          })(o, n);
                };
            return {
                showRecentlyViewed: function (o) {
                    const n = o || {};
                    Object.assign(t, n), (e = r.read()), (i = document.querySelector(`#${t.wrapperId}`)), (s = t.howManyToShow), (t.howManyToShow = Math.min(e.length, t.howManyToShow)), t.howManyToShow && i && a(0, e, i, t.section);
                },
                getConfig: function () {
                    return t;
                },
                clearList: function () {
                    r.destroy();
                },
                recordRecentlyViewed: function (e) {
                    const i = e || {};
                    Object.assign(t, i);
                    let s = r.read();
                    if (-1 !== window.location.pathname.indexOf("/products/")) {
                        let e = decodeURIComponent(window.location.pathname)
                            .match(
                                /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
                            )[0]
                            .split("/products/")[1];
                        t.handle && (e = t.handle);
                        const i = s.indexOf(e);
                        -1 === i ? (s.unshift(e), (s = s.splice(0, t.howManyToStoreInMemory))) : (s.splice(i, 1), s.unshift(e)), r.write(s);
                    }
                },
                hasProducts: r.read().length > 0,
            };
        })()),
        (theme.ProductModel = (function () {
            let t = {},
                e = {},
                i = {};
            const s = {
                    productMediaWrapper: "[data-product-single-media-wrapper]",
                    mediaGroup: "[data-product-single-media-group]",
                    productXr: "[data-shopify-xr]",
                    mediaId: "data-media-id",
                    model3d: "data-shopify-model3d-id",
                    modelViewer: "model-viewer",
                    modelJson: "#ModelJson-",
                    deferredMedia: "[data-deferred-media]",
                    deferredMediaButton: "[data-deferred-media-button]",
                },
                o = { isLoading: "is-loading", mediaHidden: "media--hidden" };
            function n(t, n) {
                if (t.querySelector(s.deferredMedia).getAttribute("loaded")) return;
                t.classList.add(o.isLoading);
                const l = document.createElement("div");
                l.appendChild(t.querySelector("template").content.firstElementChild.cloneNode(!0));
                const c = l.querySelector("model-viewer"),
                    h = t.querySelector(s.deferredMedia);
                h.appendChild(c), h.setAttribute("loaded", !0);
                const d = t.dataset.mediaId,
                    u = c.dataset.modelId,
                    p = t.closest(s.mediaGroup).parentElement.querySelector(s.productXr);
                (i[n] = { element: p, defaultId: u }),
                    (e[d] = { modelId: u, mediaId: d, sectionId: n, container: t, element: c }),
                    window.ShopifyXR
                        ? a()
                        : window.Shopify.loadFeatures([
                              { name: "shopify-xr", version: "1.0", onLoad: r },
                              { name: "model-viewer-ui", version: "1.0", onLoad: a },
                          ]);
            }
            function r(e) {
                if (e) console.warn(e);
                else if (window.ShopifyXR) {
                    for (const e in t)
                        if (t.hasOwnProperty(e)) {
                            const i = t[e];
                            if (i.loaded) continue;
                            const o = document.querySelector(`${s.modelJson}${e}`);
                            o && (window.ShopifyXR.addModels(JSON.parse(o.innerHTML)), (i.loaded = !0));
                        }
                    window.ShopifyXR.setupXRElements();
                } else
                    document.addEventListener("shopify_xr_initialized", function () {
                        r();
                    });
            }
            function a(t) {
                if (t) console.warn(t);
                else
                    for (const t in e)
                        if (e.hasOwnProperty(t)) {
                            const i = e[t];
                            i.modelViewerUi || ((i.modelViewerUi = new Shopify.ModelViewerUI(i.element)), l(i));
                        }
            }
            function l(t) {
                const e = i[t.sectionId];
                t.container.addEventListener("theme:media:visible", function () {
                    e.element.setAttribute(s.model3d, t.modelId), window.theme.touch || (t.modelViewerUi.play(), t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 }));
                }),
                    t.container.addEventListener("theme:media:hidden", function () {
                        t.modelViewerUi.pause();
                    }),
                    t.container.addEventListener("xrLaunch", function () {
                        t.modelViewerUi.pause();
                    }),
                    t.element.addEventListener("load", () => {
                        e.element.setAttribute(s.model3d, t.modelId), t.container.classList.remove(o.isLoading), t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                    }),
                    t.element.addEventListener("shopify_model_viewer_ui_toggle_play", function () {
                        c(t.mediaId),
                            setTimeout(() => {
                                t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
                            }, 50);
                    }),
                    t.element.addEventListener("shopify_model_viewer_ui_toggle_pause", function () {
                        t.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 });
                    }),
                    c(t.mediaId);
            }
            function c(t) {
                const e = `[${s.mediaId}="${t}"]`,
                    i = document.querySelectorAll(`${s.productMediaWrapper}:not(${e})`);
                i.length &&
                    i.forEach((t) => {
                        t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(o.mediaHidden);
                    });
            }
            return {
                init: function (e, i) {
                    t[i] = { loaded: !1 };
                    const o = e.querySelector(s.deferredMediaButton);
                    o && o.addEventListener("click", n.bind(this, e, i));
                },
                loadContent: n,
                removeSectionModels: function (i) {
                    for (const t in e)
                        if (e.hasOwnProperty(t)) {
                            e[t].sectionId === i && delete e[t];
                        }
                    delete t[i], delete theme.mediaInstances[i];
                },
            };
        })()),
        I("collection-template", On);
    const cd = ".template-customers-addresses",
        hd = "[data-form]",
        dd = "[data-form-new]",
        ud = "[data-button-new]",
        pd = "[data-button-edit]",
        md = "[data-button-delete]",
        gd = "[data-button-cancel]",
        fd = "data-form-edit",
        yd = "AddressCountryNew",
        vd = "AddressProvinceNew",
        bd = "AddressProvinceContainerNew",
        wd = "[data-country-option]",
        Sd = "AddressCountry",
        Ed = "AddressProvince",
        Ld = "AddressProvinceContainer",
        kd = 'input[type="text"]:not(.optional)',
        Ad = "data-form-id",
        Cd = "is-hidden",
        qd = "validation--showup";
    const Td = document.querySelector(cd);
    Td &&
        new (class {
            init() {
                if (this.addressNewForm) {
                    const t = this.section,
                        e = this.addressNewForm;
                    this.customerAddresses();
                    const i = t.querySelectorAll(ud);
                    i.length &&
                        i.forEach((t) => {
                            t.addEventListener("click", function (i) {
                                i.preventDefault(), t.classList.add(Cd), e.classList.remove(Cd);
                            });
                        });
                    const s = t.querySelectorAll(pd);
                    s.length &&
                        s.forEach((e) => {
                            e.addEventListener("click", function (e) {
                                e.preventDefault();
                                const i = this.getAttribute(Ad);
                                t.querySelector(`[${fd}="${i}"]`).classList.toggle(Cd);
                            });
                        });
                    const o = t.querySelectorAll(md);
                    o.length &&
                        o.forEach((t) => {
                            t.addEventListener("click", function (t) {
                                t.preventDefault();
                                const e = this.getAttribute(Ad);
                                confirm(theme.strings.delete_confirm) && Shopify.postLink("/account/addresses/" + e, { parameters: { _method: "delete" } });
                            });
                        });
                    const n = t.querySelectorAll(gd);
                    n.length &&
                        n.forEach((t) => {
                            t.addEventListener("click", function (t) {
                                t.preventDefault(), this.closest(hd).classList.add(Cd), document.querySelector(ud).classList.remove(Cd);
                            });
                        });
                }
            }
            customerAddresses() {
                Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(yd, vd, { hideElement: bd }),
                    this.section.querySelectorAll(wd).forEach((t) => {
                        const e = t.getAttribute(Ad),
                            i = `${Sd}_${e}`,
                            s = `${Ed}_${e}`,
                            o = `${Ld}_${e}`;
                        new Shopify.CountryProvinceSelector(i, s, { hideElement: o });
                    });
            }
            validate() {
                this.accountForms.forEach((t) => {
                    const e = t.querySelector("form"),
                        i = e.querySelectorAll(kd);
                    e.addEventListener("submit", (t) => {
                        let e = !1;
                        i.forEach((t) => {
                            t.value ? t.nextElementSibling.classList.remove(qd) : (t.nextElementSibling.classList.add(qd), (e = !0));
                        }),
                            e && t.preventDefault();
                    });
                });
            }
            constructor(t) {
                (this.section = t), (this.addressNewForm = this.section.querySelector(dd)), (this.accountForms = this.section.querySelectorAll(hd)), this.init(), this.validate();
            }
        })(Td);
    const Pd = "[data-account-form]",
        xd = "[data-show-reset]",
        Id = "[data-hide-reset]",
        Hd = "[data-recover-password]",
        Fd = "[data-login-form]",
        Md = "[data-recover-success]",
        Dd = "[data-recover-success-text]",
        Od = "#recover",
        Bd = "is-hidden";
    const zd = document.querySelector(Pd);
    zd &&
        new (class {
            init() {
                window.location.hash == Od ? this.showRecoverPasswordForm() : this.hideRecoverPasswordForm(),
                    this.success && this.successText.classList.remove(Bd),
                    this.showButton.addEventListener(
                        "click",
                        (t) => {
                            t.preventDefault(), this.showRecoverPasswordForm();
                        },
                        !1
                    ),
                    this.hideButton.addEventListener(
                        "click",
                        (t) => {
                            t.preventDefault(), this.hideRecoverPasswordForm();
                        },
                        !1
                    );
            }
            showRecoverPasswordForm() {
                return this.recover.classList.remove(Bd), this.login.classList.add(Bd), (window.location.hash = Od), !1;
            }
            hideRecoverPasswordForm() {
                return this.login.classList.remove(Bd), this.recover.classList.add(Bd), (window.location.hash = ""), !1;
            }
            constructor(t) {
                (this.form = t),
                    (this.showButton = t.querySelector(xd)),
                    (this.hideButton = t.querySelector(Id)),
                    (this.recover = t.querySelector(Hd)),
                    (this.login = t.querySelector(Fd)),
                    (this.success = t.querySelector(Md)),
                    (this.successText = t.querySelector(Dd)),
                    this.init();
            }
        })(zd),
        I("search-template", [On, fr]);
    const _d = "[data-ticker-scale]",
        $d = "[data-ticker-text]",
        Rd = "data-clone",
        Vd = "data-marquee-speed",
        Nd = "ticker--animated",
        Wd = "ticker--unloaded",
        Ud = "ticker__comparitor",
        jd = 1.63,
        Gd = 100;
    const Kd = "[data-parallax]",
        Qd = ".shopify-section",
        Xd = "[data-main]",
        Yd = "is-disabled",
        Jd = "main-content",
        Zd = "shopify-section",
        tu = "section-footer--visible",
        eu = "card-scrolling-hidden",
        iu = "sticky-top-zero",
        su = "data-parallax",
        ou = "data-parallax-intensity",
        nu = "data-parallax-static",
        ru = "data-parallax-single",
        au = "data-parallax-disable-on-mobile",
        lu = "data-parallax-rounded-corners",
        cu = "data-parallax-rounded-corners-large",
        hu = {};
    let du = class {
        assignFooterArguments() {
            this.animations.includes("footer") &&
                ((this.shopifySection = this.container.closest(Qd)),
                (this.footerPrevSectionOffset = 0),
                this.container.hasAttribute(lu) && ((this.footerPrevSectionOffset = 8), this.container.hasAttribute(cu) && (this.footerPrevSectionOffset = 34)),
                (this.prevSection = this.container.parentNode.previousElementSibling),
                !this.prevSection || this.prevSection.classList.contains(Zd) || this.prevSection.classList.contains(Jd) || (this.prevSection = this.main),
                requestAnimationFrame(() => {
                    (this.containerHeight = this.container.offsetHeight), (this.footerOffset = 0.15 * this.containerHeight), (this.cachedPosition = this.footerOffset), (this.cachedPercentage = 0);
                }));
        }
        assignCardScrollingArguments() {
            if (!this.animations.includes("card-scrolling")) return;
            let { stickyHeaderHeight: t } = N();
            if (
                ((this.headerHeight = t || 0),
                (this.shopifySection = this.container.closest(Qd)),
                (this.nextSection = this.shopifySection.nextElementSibling),
                (this.cardScrollingStickyTop = this.headerHeight || 0),
                (this.cardScrollingMarginTop = this.nextSection ? parseInt(window.getComputedStyle(this.nextSection).getPropertyValue("margin-top")) : 0),
                (this.after = !1),
                (this.prevSection = this.shopifySection.previousElementSibling),
                this.prevSection)
            ) {
                const t = this.firstSection.id,
                    e = this.prevSection.matches(`#${t}`),
                    i = this.prevSection.offsetHeight;
                this.shopifySection.classList.toggle(iu, e && i <= 2 * this.headerHeight);
            }
            this.opacityValue = (t) => (t ? (Boolean(t <= 0) ? 0 : Boolean(t > 0 && t <= 100) ? Number(t / 100).toFixed(4) : Boolean(t > 100) ? 1 : void 0) : 0);
        }
        init() {
            this.updateParallax(), document.addEventListener("theme:scroll", this.scrollEvent), document.addEventListener("theme:resize", this.resizeEvent);
        }
        updateParallax() {
            this.container.classList.contains(Yd) ||
                (this.disableOnMobile && le()) ||
                ((this.scrollTop = Math.round(window.scrollY)),
                (this.scrollBottom = this.scrollTop + this.viewportHeight),
                (this.elementOffsetTopPoint = Math.round(this.container.getBoundingClientRect().top + this.scrollTop)),
                window.Shopify.designMode && (this.assignCardScrollingArguments(), (this.containerHeight = this.container.offsetHeight)),
                (this.elementOffsetBottomPoint = this.elementOffsetTopPoint + this.containerHeight),
                (this.isBottomOfElementPassed = this.elementOffsetBottomPoint < this.scrollTop),
                (this.isTopOfElementReached = this.elementOffsetTopPoint < this.scrollBottom),
                (this.isInView = this.isTopOfElementReached && !this.isBottomOfElementPassed),
                this.adjustCalculations(),
                this.toggleVisibility(),
                this.isInView &&
                    ((this.scrollProgress = this.scrollBottom - this.elementOffsetTopPoint),
                    (this.percentage = (100 * (this.scrollProgress - this.containerHeight / 2)) / this.viewportHeight),
                    (this.percentageFull = Number(this.scrollProgress / this.containerHeight).toFixed(2)),
                    (this.percentageVisible = Number((100 * this.scrollProgress) / (this.viewportHeight + this.containerHeight)).toFixed(2)),
                    this.animations.includes("circle") && this.animateCircleText(),
                    (this.animations.includes("horizontal") || this.animations.includes("vertical") || this.animations.includes("diagonal")) && this.animateOverlappingImages(),
                    (this.animations.includes("offset-ltr") || this.animations.includes("offset-rtl")) && this.offsetX(),
                    this.animations.includes("card-scrolling") && this.cardScrollingEffect(),
                    this.animations.includes("zoom-on-scroll") && this.zoomInOut(),
                    this.animations.includes("footer") && this.animateFooter()));
        }
        adjustCalculations() {
            var t;
            (this.animations.includes("card-scrolling") &&
                ((this.currentSectionTop = this.shopifySection.getBoundingClientRect().top),
                this.nextSection
                    ? ((this.nextSectionTop = this.nextSection.getBoundingClientRect().top), (this.offsetTop = this.nextSectionTop - this.containerHeight - this.cardScrollingMarginTop))
                    : ((this.nextSectionTop = this.currentSectionTop + this.containerHeight), (this.offsetTop = this.currentSectionTop)),
                (this.distance = Math.floor(this.currentSectionTop - this.headerHeight)),
                (this.after = Boolean(Math.round(this.nextSectionTop - this.headerHeight - this.cardScrollingMarginTop + 0.1 * this.viewportHeight) < 0)),
                (this.isInView = this.isTopOfElementReached && !this.after)),
            this.animations.includes("footer")) &&
                ((this.elementOffsetTopPoint = Math.round((null === (t = this.prevSection) || void 0 === t ? void 0 : t.getBoundingClientRect().bottom) - this.footerPrevSectionOffset + this.scrollTop)),
                (this.elementOffsetBottomPoint = this.elementOffsetTopPoint + this.containerHeight),
                (this.isBottomOfElementPassed = this.elementOffsetBottomPoint < this.scrollTop),
                (this.isTopOfElementReached = this.elementOffsetTopPoint < this.scrollBottom),
                (this.isInView = this.isTopOfElementReached && !this.isBottomOfElementPassed),
                (this.isApproaching = Math.round(this.elementOffsetTopPoint - this.viewportHeight / 2) < this.scrollBottom));
        }
        toggleVisibility() {
            this.animations.includes("card-scrolling") && this.shopifySection.classList.toggle(eu, this.after),
                this.animations.includes("footer") && (Boolean(this.isApproaching || this.isInView) ? this.shopifySection.classList.add(tu) : this.shopifySection.classList.remove(tu));
        }
        cardScrollingEffect() {
            const t = (this.offsetTop / this.containerHeight) * -100;
            this.container.style.setProperty("--card-scrolling-overlay", this.opacityValue(t));
        }
        zoomInOut() {
            if (this.animations.includes("card-scrolling") && this.nextSection) {
                const t = this.nextSectionTop - this.headerHeight - this.cardScrollingMarginTop - this.containerHeight,
                    e = Math.round(t + this.scrollTop),
                    i = this.scrollBottom - e;
                this.percentageVisible = Number((100 * i) / (this.viewportHeight + this.containerHeight + this.cardScrollingMarginTop)).toFixed(2);
            }
            const t = (0.2 * this.percentageVisible) / 100;
            let e = Number(1 + t).toFixed(4);
            (e = e > 1 ? e : 1), this.container.style.setProperty("--scale", e);
        }
        offsetX() {
            const t = this.container.hasAttribute(nu),
                e = this.container.getAttribute(ou) || 100;
            let i = this.animations.includes("offset-ltr") ? e : 0;
            t && (i = e / 2);
            const s = this.animations.includes("offset-ltr") ? 1 : -1,
                o = (e * this.percentageVisible) / 100 - i,
                n = Number(o * s).toFixed(2);
            this.container.style.setProperty("--offsetX", `${n}%`);
        }
        updateHeight() {
            if (this.animations.includes("card-scrolling")) {
                let { stickyHeaderHeight: t } = N();
                if (
                    ((this.headerHeight = t || 0),
                    (this.cardScrollingStickyTop = this.headerHeight || 0),
                    (this.cardScrollingMarginTop = this.nextSection ? parseInt(window.getComputedStyle(this.nextSection).getPropertyValue("margin-top")) : 0),
                    (this.containerHeight = this.container.offsetHeight),
                    (this.prevSection = this.shopifySection.previousElementSibling),
                    this.prevSection)
                ) {
                    const t = this.firstSection.id,
                        e = this.prevSection.matches(`#${t}`),
                        i = this.prevSection.offsetHeight;
                    this.shopifySection.classList.toggle(iu, e && i <= 2 * this.headerHeight);
                }
            }
            const t = matchMedia("(min-width: 1024px)").matches;
            (this.orientation !== X() || t) && ((this.viewportHeight = Math.round(Math.max(document.documentElement.clientHeight, window.innerHeight || 0))), (this.containerHeight = this.container.offsetHeight), (this.orientation = X()));
        }
        animateCircleText() {
            const t = ((70 * this.percentage) / 100) * -1;
            this.percentage > 0 && this.container.style.setProperty("--rotate", `${35 + t}deg`);
        }
        animateOverlappingImages() {
            const t = 0.25 * this.container.getAttribute(ou),
                e = t / 2,
                i = this.container.hasAttribute(ru),
                s = (t * this.percentage) / 100;
            let o = 0,
                n = 0,
                r = 0,
                a = 0;
            (this.animations.includes("horizontal") || this.animations.includes("diagonal")) && ((o = -1 * e + s), (r = e - s)),
                (this.animations.includes("vertical") || this.animations.includes("diagonal")) && ((n = e - s), (a = -1 * e + s)),
                this.container.style.setProperty("--transformX-primary", `${o}%`),
                this.container.style.setProperty("--transformY-primary", `${n}%`),
                i || (this.container.style.setProperty("--transformX-secondary", `${r}%`), this.container.style.setProperty("--transformY-secondary", `${a}%`));
        }
        animateFooter() {
            const t = this.footerOffset * this.percentageFull,
                e = Number((t / this.footerOffset) * 100).toFixed(2),
                i = new WebKitCSSMatrix(window.getComputedStyle(this.container).transform),
                s = Number(i.m42).toFixed(2);
            let o = Number(this.footerOffset - t).toFixed(2);
            this.percentageFull >= 1 && (o = 0), s !== o && this.cachedPercentage !== e && (this.container.style.setProperty("--transformY", `${o}`), (this.cachedPercentage = e), (this.cachedPosition = o));
        }
        unload() {
            document.removeEventListener("theme:scroll", this.scrollEvent), document.removeEventListener("theme:resize", this.resizeEvent);
        }
        constructor(t) {
            (this.container = t),
                (this.percentage = 0),
                (this.percentageFull = 0),
                (this.animation = this.container.getAttribute(su)),
                (this.animations = this.animation.split(",")),
                (this.disableOnMobile = this.container.hasAttribute(au)),
                (this.viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)),
                (this.containerHeight = this.container.offsetHeight),
                (this.main = document.querySelector(Xd)),
                (this.firstSection = this.main.children[0]),
                (this.orientation = X()),
                (this.scrollEvent = () => this.updateParallax()),
                (this.resizeEvent = () => this.updateHeight()),
                this.assignFooterArguments(),
                this.assignCardScrollingArguments(),
                requestAnimationFrame(() => this.init());
        }
    };
    const uu = {
            onLoad() {
                hu[this.id] = [];
                this.container.querySelectorAll(Kd).forEach((t) => {
                    hu[this.id].push(new du(t));
                });
            },
            onUnload() {
                hu[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        pu = "[data-announcement]",
        mu = "[data-announcement-slide]",
        gu = "[data-ticker-frame]",
        fu = "[data-slide]",
        yu = "[data-slider]",
        vu = "[data-static]",
        bu = "[data-ticker-scale]",
        wu = "[data-ticker-text]",
        Su = "[data-parallax]",
        Eu = "text-highlight",
        Lu = "data-slide",
        ku = "data-slider-speed",
        Au = "data-slider-arrows",
        Cu = "data-stop",
        qu = "style",
        Tu = "data-target-referrer",
        Pu = "clip-path",
        xu = "desktop",
        Iu = "mobile",
        Hu = "ticker--animated",
        Fu = "is-disabled",
        Mu = "clipPath",
        Du = {};
    const Ou = {
        onLoad() {
            Du[this.id] = [];
            const t = this.container.querySelector(pu);
            t &&
                Du[this.id].push(
                    new (class {
                        init() {
                            this.removeAnnouncement(),
                                this.slider && (this.initSlider(), document.addEventListener("theme:resize:width", this.initSlider.bind(this))),
                                this.static && (this.initTickers(), this.tickerAnimationPause()),
                                this.slider || this.static || (this.initTickers(!0), this.tickerAnimationPause()),
                                this.updateSVGClipPathIDs();
                        }
                        removeAnnouncement() {
                            for (let t = 0; t < this.slides.length; t++) {
                                const e = this.slides[t];
                                e.hasAttribute(Tu) && (-1 !== this.locationPath.indexOf(e.getAttribute(Tu)) || window.Shopify.designMode || e.parentNode.removeChild(e));
                            }
                        }
                        checkSlidesClasses(t, e) {
                            if (0 !== t.length) {
                                const i = e.querySelectorAll(`${fu}.${Iu}`),
                                    s = e.querySelectorAll(`${fu}.${xu}`);
                                t.length === i.length ? e.parentNode.classList.add(Iu) : t.length === s.length && e.parentNode.classList.add(xu);
                            }
                        }
                        initSlider() {
                            const t = this.slider.querySelectorAll(fu),
                                i = this.slider.hasAttribute(Au);
                            if ((this.checkSlidesClasses(t, this.barHolder), t)) {
                                let t = `${fu}`;
                                (t = window.innerWidth < theme.sizes.small ? `${fu}:not(.${xu})` : `${fu}:not(.${Iu})`),
                                    null != this.flkty && this.flkty.destroy(),
                                    (this.flkty = new e(this.slider, {
                                        cellSelector: t,
                                        pageDots: !1,
                                        prevNextButtons: i,
                                        wrapAround: !0,
                                        autoPlay: parseInt(this.slider.getAttribute(ku), 10),
                                        on: {
                                            ready: () => {
                                                setTimeout(() => {
                                                    this.slider.dispatchEvent(new CustomEvent("slider-is-loaded", { bubbles: !0, detail: { slider: this } }));
                                                }, 10);
                                            },
                                            change: (t) => {
                                                this.flkty.cells.forEach((e, i) => {
                                                    e.element.querySelectorAll(Eu).forEach((e) => {
                                                        e.setTriggerAttribute(Boolean(i === t));
                                                    });
                                                });
                                            },
                                        },
                                    })),
                                    this.flkty.reposition();
                            }
                            this.slider.addEventListener("slider-is-loaded", () => {
                                this.initTickers(), this.updateSVGClipPathIDs();
                            });
                        }
                        initTickers(t = !1) {
                            this.barHolder.querySelectorAll(gu).forEach((e) => {
                                const i = new (class {
                                    listen() {
                                        document.addEventListener("theme:resize:width", this.resizeEvent), this.checkWidth();
                                    }
                                    checkWidth() {
                                        const t = 2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", "");
                                        if (this.frame.clientWidth - t < this.comparitor.clientWidth || this.stopClone) {
                                            if (1 === this.scale.childElementCount) {
                                                if ((this.text.classList.add(Nd), (this.clone = this.text.cloneNode(!0)), this.clone.setAttribute(Rd, ""), this.scale.appendChild(this.clone), this.stopClone))
                                                    for (let t = 0; t < 10; t++) {
                                                        const t = this.text.cloneNode(!0);
                                                        t.setAttribute(Rd, ""), this.scale.appendChild(t);
                                                    }
                                                let t = this.frame.getAttribute(Vd);
                                                null === t && (t = 100);
                                                const e = jd * (100 / parseInt(t, 10)),
                                                    i = (this.text.clientWidth / Gd) * e;
                                                this.scale.style.setProperty("--animation-time", `${i}s`);
                                            }
                                        } else {
                                            this.text.classList.add(Nd);
                                            let t = this.scale.querySelector(`[${Rd}]`);
                                            t && this.scale.removeChild(t), this.text.classList.remove(Nd);
                                        }
                                    }
                                    unload() {
                                        document.removeEventListener("theme:resize:width", this.resizeEvent);
                                    }
                                    constructor(t, e = !1) {
                                        (this.frame = t),
                                            (this.stopClone = e),
                                            (this.scale = this.frame.querySelector(_d)),
                                            (this.text = this.frame.querySelector($d)),
                                            (this.comparitor = this.text.cloneNode(!0)),
                                            this.comparitor.classList.add(Ud),
                                            this.frame.appendChild(this.comparitor),
                                            this.scale.classList.remove(Wd),
                                            (this.resizeEvent = o(() => this.checkWidth(), 100)),
                                            this.listen();
                                    }
                                })(e, t);
                                this.tickers.push(i);
                                const s = e.querySelectorAll(fu);
                                this.checkSlidesClasses(s, this.barHolder);
                            });
                        }
                        toggleTicker(t, e) {
                            const i = t.target.closest(bu),
                                s = document.querySelector(`[${Lu}="${t.detail.blockId}"]`);
                            e &&
                                s &&
                                (i.setAttribute(Cu, ""),
                                i.querySelectorAll(wu).forEach((t) => {
                                    t.classList.remove(Hu), (t.style.transform = `translate3d(${-(s.offsetLeft - parseInt(getComputedStyle(s).marginLeft, 10))}px, 0, 0)`);
                                })),
                                !e &&
                                    s &&
                                    (i.querySelectorAll(wu).forEach((t) => {
                                        t.classList.add(Hu), t.removeAttribute(qu);
                                    }),
                                    i.removeAttribute(Cu),
                                    this.static && document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })));
                        }
                        tickerAnimationPause() {
                            let t = 0,
                                e = !1;
                            const i = this.barHolder.querySelector(mu);
                            i.addEventListener("mouseenter", () => {
                                (e = !0),
                                    (t = setTimeout(() => {
                                        e &&
                                            i.querySelectorAll(wu).forEach((t) => {
                                                t.style.animationPlayState = "paused";
                                            }),
                                            clearTimeout(t);
                                    }, 500));
                            }),
                                i.addEventListener("mouseleave", () => {
                                    (e = !1),
                                        i.querySelectorAll(wu).forEach((t) => {
                                            t.style.animationPlayState = "running";
                                        });
                                });
                        }
                        updateSVGClipPathIDs() {
                            this.barHolder.querySelectorAll(fu).forEach((t, e) => {
                                const i = t.querySelector(Mu);
                                if (i) {
                                    const s = `${i.id}_${e}`;
                                    i.id = s;
                                    const o = t.querySelector(`g[${Pu}]`);
                                    o && o.setAttribute(Pu, `url(#${s})`);
                                }
                            });
                        }
                        onBlockSelect(t) {
                            const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
                            this.slider && null !== this.flkty && (this.flkty.select(e), this.flkty.pausePlayer()),
                                this.slider || this.toggleTicker(t, !0),
                                this.parallax && (this.parallax.style.setProperty("--offsetX", "0%"), this.parallax.classList.add(Fu));
                        }
                        onBlockDeselect(t) {
                            this.slider && null !== this.flkty && this.flkty.unpausePlayer(),
                                this.slider || this.toggleTicker(t, !1),
                                this.parallax && (this.parallax.classList.remove(Fu), document.dispatchEvent(new CustomEvent("theme:scroll")));
                        }
                        onUnload() {
                            document.removeEventListener("theme:resize:width", this.initSlider.bind(this)),
                                this.tickers.length > 0 &&
                                    this.tickers.forEach((t) => {
                                        t.unload();
                                    });
                        }
                        constructor(t) {
                            (this.barHolder = t),
                                (this.locationPath = location.href),
                                (this.slides = this.barHolder.querySelectorAll(fu)),
                                (this.slider = this.barHolder.querySelector(yu)),
                                (this.static = this.barHolder.querySelector(vu)),
                                (this.parallax = this.barHolder.querySelector(Su)),
                                (this.tickers = []),
                                (this.flkty = null),
                                this.init();
                        }
                    })(t)
                );
        },
        onBlockSelect(t) {
            Du[this.id].length &&
                Du[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
        },
        onBlockDeselect(t) {
            Du[this.id].length &&
                Du[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockDeselect(t);
                });
        },
        onUnload() {
            Du[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload();
            });
        },
    };
    I("announcement-bar", Ou), I("marquee", [Ou, uu]);
    const Bu = "[data-hover-disclosure]",
        zu = "[data-site-header]",
        _u = "[data-top-link]",
        $u = "[data-header-background]",
        Ru = "[data-nav-item]",
        Vu = "is-visible",
        Nu = "grandparent",
        Wu = "site-header--menu-opened",
        Uu = "has-scrolled",
        ju = "site-header--hovered",
        Gu = "search-opened",
        Ku = "megamenu-opened",
        Qu = "data-hover-disclosure-toggle",
        Xu = "aria-haspopup",
        Yu = "aria-expanded",
        Ju = "aria-controls";
    let Zu = {};
    const tp = {
            onLoad() {
                Zu[this.id] = [];
                this.container.querySelectorAll(Bu).forEach((t) => {
                    Zu[this.id].push(
                        new (class {
                            setBackgroundHeight() {
                                (this.hasScrolled = this.body.classList.contains(Uu)),
                                    (this.headerHeight = this.hasScrolled ? window.stickyHeaderHeight : this.header.offsetHeight),
                                    this.grandparent ? ((this.dropdown.style.height = "auto"), (this.dropdownHeight = this.dropdown.offsetHeight + this.headerHeight)) : (this.dropdownHeight = this.headerHeight),
                                    this.background.style.setProperty("--header-background-height", `${this.dropdownHeight}px`),
                                    window.innerWidth < theme.sizes.small && this.hideDisclosure();
                            }
                            showDisclosure() {
                                this.setBackgroundHeight(),
                                    document.addEventListener("theme:resize", this.setBackgroundHeightEvent),
                                    this.trigger.setAttribute(Yu, !0),
                                    this.trigger.classList.add(Vu),
                                    this.header.classList.add(Wu),
                                    this.trigger.classList.contains(Nu) && (this.body.classList.add(Ku), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.header }))),
                                    this.updateHeaderHover();
                            }
                            hideDisclosure() {
                                this.background.style.removeProperty("--header-background-height"),
                                    document.removeEventListener("theme:resize", this.setBackgroundHeightEvent),
                                    this.trigger.classList.remove(Vu),
                                    this.trigger.setAttribute(Yu, !1),
                                    this.header.classList.remove(Wu),
                                    this.body.classList.remove(Ku),
                                    this.body.classList.contains(Gu) || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 1 }));
                            }
                            updateHeaderHover() {
                                requestAnimationFrame(() => {
                                    const t = this.header.matches(":hover"),
                                        e = this.header.classList.contains(ju);
                                    t && !e && this.header.classList.add(ju);
                                });
                            }
                            handleTablets() {
                                this.trigger.addEventListener("touchstart", (t) => {
                                    if (!this.trigger.classList.contains(Vu)) {
                                        t.preventDefault();
                                        const e = this.header.querySelectorAll(`.${Vu}${Ru}`);
                                        if (e.length > 0)
                                            return void e.forEach((t) => {
                                                if (t !== this.trigger) {
                                                    t.dispatchEvent(new Event("mouseleave", { bubbles: !0 }));
                                                    const e = () => {
                                                        requestAnimationFrame(() => {
                                                            this.showDisclosure();
                                                        }),
                                                            t.removeEventListener("transitionend", e);
                                                    };
                                                    t.addEventListener("transitionend", e);
                                                }
                                            });
                                        this.showDisclosure();
                                    }
                                });
                            }
                            connectHoverToggle() {
                                this.trigger.addEventListener("mouseenter", () => this.showDisclosure()),
                                    this.link.addEventListener("focus", () => this.showDisclosure()),
                                    this.trigger.addEventListener("mouseleave", () => this.hideDisclosure()),
                                    this.trigger.addEventListener("focusout", (t) => {
                                        this.trigger.contains(t.relatedTarget) || this.hideDisclosure();
                                    }),
                                    this.disclosure.addEventListener("keyup", (t) => {
                                        t.code === theme.keyboardKeys.ESCAPE && this.hideDisclosure();
                                    });
                            }
                            onBlockSelect(t) {
                                this.disclosure.contains(t.target) && this.showDisclosure(t);
                            }
                            onBlockDeselect(t) {
                                this.disclosure.contains(t.target) && this.hideDisclosure();
                            }
                            constructor(t) {
                                (this.disclosure = t),
                                    (this.body = document.body),
                                    (this.header = t.closest(zu)),
                                    (this.key = this.disclosure.id),
                                    (this.trigger = document.querySelector(`[${Qu}='${this.key}']`)),
                                    (this.link = this.trigger.querySelector(_u)),
                                    (this.grandparent = this.trigger.classList.contains(Nu)),
                                    (this.background = document.querySelector($u)),
                                    this.trigger.setAttribute(Xu, !0),
                                    this.trigger.setAttribute(Yu, !1),
                                    this.trigger.setAttribute(Ju, this.key),
                                    (this.dropdown = this.trigger.querySelector(Bu)),
                                    (this.setBackgroundHeightEvent = () => this.setBackgroundHeight()),
                                    this.connectHoverToggle(),
                                    this.handleTablets();
                            }
                        })(t)
                    );
                });
            },
            onBlockSelect(t) {
                Zu[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                Zu[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
        },
        ep = "[data-site-header]",
        ip = "[data-announcement-wrapper]",
        sp = "[data-collection-filters]",
        op = "[data-logo-text-link]",
        np = "[data-collapsible-trigger]",
        rp = "#nav-drawer",
        ap = "[data-drawer]",
        lp = "[data-drawer-toggle]",
        cp = "[data-popdown-toggle]",
        hp = "[data-mobile-menu]",
        dp = "[data-nav]",
        up = "[data-nav-icons]",
        pp = "[data-nav-item]",
        mp = "[data-nav-link-mobile]",
        gp = "[data-nav-search-open]",
        fp = "[data-wrapper]",
        yp = "[data-header-background]",
        vp = "[data-cart-page]",
        bp = "[data-takes-space]",
        wp = {
            jsDrawerOpenAll: ["js-drawer-open", "js-drawer-open-cart", "js-quick-view-visible", "js-quick-view-from-cart"],
            headerTransparent: "site-header--transparent",
            headerHovered: "site-header--hovered",
            headerMenuOpened: "site-header--menu-opened",
            hasScrolled: "has-scrolled",
            hasStickyHeader: "has-sticky-header",
            hideHeader: "hide-header",
            headerCompress: "site-header--compress",
            isVisible: "is-visible",
            isOpen: "is-open",
            searchOpened: "search-opened",
            noOutline: "no-outline",
            cloneClass: "js__header__clone",
        },
        Sp = "data-nav-alignment",
        Ep = "data-header-sticky",
        Lp = {};
    const kp = {
        onLoad() {
            Lp[this.id] = new (class {
                updateHeaderHover() {
                    requestAnimationFrame(() => {
                        const t = this.header.matches(":hover"),
                            e = this.header.classList.contains(wp.headerHovered);
                        t && !e && this.header.classList.add(wp.headerHovered);
                    });
                }
                handleTouchstart(t) {
                    const e = this.header.contains(t.target),
                        i = this.header.querySelector(`.${wp.isVisible}${pp}`);
                    !e && i && i.dispatchEvent(new Event("mouseleave", { bubbles: !0 }));
                }
                handleTextLinkLogos() {
                    if (null === this.logoTextLink) return;
                    const t = this.header.offsetHeight;
                    document.documentElement.style.setProperty("--header-height", `${t}px`), document.documentElement.style.setProperty("--header-sticky-height", `${t}px`);
                }
                initStickyHeader() {
                    if (
                        ((this.headerSticky = this.header.hasAttribute(Ep)),
                        CSS.supports("(selector(:has(*)))") || document.body.classList.toggle(wp.hasStickyHeader, this.headerSticky),
                        (this.hasScrolled = !1),
                        (this.hasCollectionFilters = document.querySelector(sp)),
                        (this.position = this.header.dataset.position),
                        "fixed" === this.position && !this.hasCollectionFilters)
                    )
                        return this.headerState(), void document.addEventListener("theme:scroll", this.headerStateEvent);
                    document.body.classList.remove(wp.hasScrolled), window.isHeaderTransparent && this.header.classList.add(wp.headerTransparent);
                }
                headerState(t) {
                    const e = parseInt(this.header.dataset.height || this.header.offsetHeight),
                        i = document.querySelector(ip),
                        s = e + (i ? i.offsetHeight : 0),
                        o = window.pageYOffset || document.documentElement.scrollTop,
                        n = t && t.detail && t.detail.up;
                    (this.hasScrolled = o > s), document.body.classList.toggle(wp.hasScrolled, this.hasScrolled);
                    const r = o < s + window.stickyHeaderHeight && n;
                    if ((document.body.classList.toggle(wp.hideHeader, r), window.isHeaderTransparent)) {
                        const t = !this.hasScrolled || r;
                        this.header.classList.toggle(wp.headerTransparent, t);
                    }
                    if (this.header.classList.contains(wp.headerHovered)) {
                        const t = this.hasScrolled ? window.stickyHeaderHeight : e;
                        this.background.style.setProperty("--header-background-height", `${t}px`);
                        const i = this.header.querySelector(`.${wp.isVisible}${pp}`);
                        i && i.dispatchEvent(new Event("mouseenter", { bubbles: !0 }));
                    }
                }
                handleBackgroundEvents() {
                    this.headerWrapper.addEventListener("mouseenter", this.updateBackgroundHeightEvent),
                        this.headerWrapper.addEventListener("mouseleave", this.updateBackgroundHeightEvent),
                        this.header.addEventListener("focusout", this.updateBackgroundHeightEvent),
                        document.addEventListener("theme:cart:close", this.updateBackgroundHeightEvent),
                        document.addEventListener("theme:search:close", this.updateBackgroundHeightEvent);
                }
                updateBackgroundHeight(t) {
                    const e = matchMedia("(pointer:fine)").matches,
                        i = !document.body.classList.contains(wp.noOutline),
                        s = e && !i;
                    if (!t) return;
                    let o = wp.jsDrawerOpenAll.some((t) => document.body.classList.contains(t));
                    ("mouseenter" === t.type || o) &&
                        ((this.headerHeight = this.hasScrolled ? window.stickyHeaderHeight : this.header.offsetHeight),
                        this.header.classList.add(wp.headerHovered),
                        this.header.classList.contains(wp.headerMenuOpened) || this.background.style.setProperty("--header-background-height", `${this.headerHeight}px`)),
                        "mouseenter" !== t.type &&
                            requestAnimationFrame(() => {
                                if (((o = wp.jsDrawerOpenAll.some((t) => document.body.classList.contains(t))), o)) return;
                                if ("focusout" === t.type && !e) return;
                                if ("theme:search:close" === t.type && !s) return;
                                if (this.hasScrolled) return;
                                const n = null === document.activeElement.closest(ep),
                                    r = document.body.classList.contains(wp.searchOpened),
                                    a = this.header.classList.contains(wp.headerMenuOpened);
                                r || a || (("focusout" !== t.type || n) && (this.header.classList.remove(wp.headerHovered), this.background.style.setProperty("--header-background-height", "0px"), i || document.activeElement.blur()));
                            });
                }
                listenWidth() {
                    document.addEventListener("theme:resize", this.checkWidthEvent), this.checkWidth();
                }
                checkWidth() {
                    window.innerWidth < this.minWidth ? this.header.classList.add(wp.headerCompress) : this.header.classList.remove(wp.headerCompress);
                }
                getMinWidth() {
                    const t = this.headerWrapper.currentStyle || window.getComputedStyle(this.headerWrapper),
                        e = 2 * parseInt(t.paddingLeft),
                        i = this.header.cloneNode(!0);
                    i.classList.add(wp.cloneClass), document.body.appendChild(i);
                    const s = i.querySelectorAll(bp),
                        o = (function (t, e) {
                            let i = [];
                            t.forEach((t) => {
                                i.push(t.clientWidth);
                            });
                            let [s, o, n] = i;
                            if ("left" === e) {
                                const t = s;
                                (s = o), (o = t);
                            }
                            return "right" !== e && (s > n ? (n = s) : (s = n)), s + o + n;
                        })(s, this.header.getAttribute(Sp));
                    return document.body.removeChild(i), o + 20 * s.length + e;
                }
                initMobileNav() {
                    var t;
                    if (
                        ((this.mobileMenu = this.headerSection.querySelector(hp)),
                        (this.navDrawer = this.headerSection.querySelector(rp)),
                        (this.drawerToggle = this.navDrawer.querySelector(lp)),
                        (this.navSearchOpen = this.navDrawer.querySelectorAll(gp)),
                        null === (t = this.navSearchOpen) ||
                            void 0 === t ||
                            t.forEach((t) => {
                                t.addEventListener("click", (t) => {
                                    t.preventDefault();
                                    const e = this.drawerToggle.closest(`${ap}.${wp.isOpen}`),
                                        i = matchMedia("(pointer:coarse)").matches ? this.mobileMenu.querySelector(cp) : this.nav.querySelector(cp);
                                    this.drawerToggle.dispatchEvent(new Event("click", { bubbles: !0 }));
                                    const s = (t) => {
                                        t.target === e && (requestAnimationFrame(() => i.dispatchEvent(new Event("click", { bubbles: !0 }))), e.removeEventListener("transitionend", s));
                                    };
                                    e.addEventListener("transitionend", s);
                                });
                            }),
                        "link" === theme.settings.mobileMenuBehaviour)
                    )
                        return;
                    const e = this.headerSection.querySelectorAll(mp);
                    e.length &&
                        e.forEach((t) => {
                            t.addEventListener("click", (e) => {
                                const i = t.parentNode.querySelectorAll(np).length,
                                    s = t.nextElementSibling;
                                i && (e.preventDefault(), s.dispatchEvent(new Event("click"), { bubbles: !0 }));
                            });
                        });
                }
                onUnload() {
                    document.documentElement.style.removeProperty("--header-height"),
                        document.documentElement.style.removeProperty("--header-sticky-height"),
                        this.initStickyHeader(),
                        document.body.classList.remove(...wp.jsDrawerOpenAll),
                        document.removeEventListener("theme:scroll", this.headerStateEvent),
                        document.removeEventListener("theme:resize", this.checkWidthEvent),
                        document.removeEventListener("theme:cart:close", this.updateBackgroundHeightEvent),
                        document.removeEventListener("theme:search:close", this.updateBackgroundHeightEvent),
                        document.body.removeEventListener("touchstart", this.handleTouchstartEvent),
                        document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                        "function" == typeof window.cart.unload && window.cart.unload();
                }
                constructor(t) {
                    (this.container = t),
                        (this.background = document.querySelector(yp)),
                        (this.header = t),
                        (this.headerSection = t.parentNode),
                        (this.headerWrapper = t.querySelector(fp)),
                        (this.logoTextLink = t.querySelector(op)),
                        (this.nav = t.querySelector(dp)),
                        (this.navIcons = t.querySelector(up)),
                        (this.headerStateEvent = (t) => this.headerState(t)),
                        (this.handleTouchstartEvent = (t) => this.handleTouchstart(t)),
                        (this.updateBackgroundHeightEvent = (t) => this.updateBackgroundHeight(t)),
                        p(),
                        (this.minWidth = this.getMinWidth()),
                        (this.checkWidthEvent = () => this.checkWidth()),
                        this.listenWidth(),
                        this.initMobileNav(),
                        this.handleTextLinkLogos(),
                        this.initStickyHeader(),
                        this.handleBackgroundEvents(),
                        document.querySelector(vp) || (window.cart = new Dh()),
                        document.body.addEventListener("touchstart", this.handleTouchstartEvent, { passive: !0 }),
                        this.updateHeaderHover();
                }
            })(this.container);
        },
        onUnload() {
            Lp[this.id].onUnload();
        },
    };
    I("header", [kp, tp, Ir]);
    const Ap = "[data-collapsible-trigger]",
        Cp = "is-expanded";
    I("accordions", [
        {
            onBlockSelect(t) {
                const e = t.target.querySelector(Ap);
                requestAnimationFrame(() => {
                    e.classList.contains(Cp) || e.dispatchEvent(new Event("click"));
                });
            },
        },
        _e,
    ]);
    const qp = "[data-share-button]",
        Tp = "[data-share-button-tooltip]",
        Pp = "is-visible",
        xp = "is-hiding",
        Ip = {};
    const Hp = {
        onLoad() {
            Ip[this.id] = new (class {
                init() {
                    this.button &&
                        this.button.addEventListener("click", () => {
                            let t = window.location.href;
                            this.button.dataset.shareLink && (t = this.button.dataset.shareLink),
                                this.tooltip.classList.contains(Pp) ||
                                    navigator.clipboard.writeText(t).then(() => {
                                        this.tooltip.classList.add(Pp),
                                            setTimeout(() => {
                                                this.tooltip.classList.add(xp),
                                                    this.tooltip.classList.remove(Pp),
                                                    this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout),
                                                    (this.hideTransitionTimeout = setTimeout(() => {
                                                        this.tooltip.classList.remove(xp);
                                                    }, this.transitionSpeed));
                                            }, 1500);
                                    });
                        });
                }
                constructor(t) {
                    (this.container = t), (this.button = this.container.querySelector(qp)), (this.tooltip = this.container.querySelector(Tp)), (this.transitionSpeed = 200), (this.hideTransitionTimeout = 0), this.init();
                }
            })(this.container);
        },
    };
    I("article", [Hp]);
    const Fp = "[data-video-play]",
        Mp = "data-video-play";
    const Dp = {
            onLoad() {
                new (class {
                    init() {
                        this.videoPlay.length &&
                            this.videoPlay.forEach((t) => {
                                t.addEventListener("click", (e) => {
                                    if (t.hasAttribute(Mp) && "" !== t.getAttribute(Mp).trim()) {
                                        e.preventDefault();
                                        const i = [{ html: t.getAttribute(Mp) }],
                                            s = { mainClass: "pswp--video" };
                                        (this.a11y.state.trigger = t), new Oc(i, s);
                                    }
                                });
                            });
                    }
                    constructor(t) {
                        (this.container = t), (this.videoPlay = this.container.querySelectorAll(Fp)), (this.a11y = Ke), this.init();
                    }
                })(this.container);
            },
        },
        Op = "[data-banner-image]",
        Bp = ".lazy-image",
        zp = '[data-parallax="zoom-on-scroll"],[data-parallax="card-scrolling"],[data-parallax="zoom-on-scroll,card-scrolling"]',
        _p = "banner--no-cached-images",
        $p = "banner--img-loaded",
        Rp = "img-in",
        Vp = {};
    I("banner-image", [
        {
            onLoad() {
                Vp[this.id] = new (class {
                    init() {
                        this.handleImageAnimation(!0), this.container.matches(zp) && (this.parallax = new du(this.container));
                    }
                    handleImageAnimation(t = !1) {
                        if (!t) return this.container.classList.remove(_p), void this.container.classList.remove($p);
                        const e = this.container.querySelector(Op).querySelectorAll(Bp),
                            i = this.container.classList.contains(Rp);
                        if (e.length && !i) {
                            this.container.classList.add(_p);
                            const t = (i) => {
                                requestAnimationFrame(() => this.container.classList.add($p)), e[0].removeEventListener("transitionend", t);
                            };
                            e[0].addEventListener("transitionend", t);
                        }
                    }
                    onReorder() {
                        this.handleImageAnimation(!1);
                    }
                    onUnload() {
                        this.handleImageAnimation(!1), this.parallax && (this.parallax.unload(), (this.parallax = null));
                    }
                    constructor(t) {
                        (this.container = t.container), (this.parallax = null), this.init();
                    }
                })(this);
            },
            onReorder(t) {
                Vp[this.id].onReorder(t);
            },
            onUnload(t) {
                Vp[this.id].onUnload(t);
            },
        },
        Dp,
    ]);
    const Np = "[data-scroll-spy]",
        Wp = "is-selected",
        Up = "is-full-height",
        jp = "data-scroll-spy",
        Gp = "data-scroll-spy-prevent",
        Kp = "data-scroll-spy-mobile",
        Qp = "data-scroll-spy-desktop",
        Xp = {};
    const Yp = {
            onLoad() {
                Xp[this.id] = [];
                this.container.querySelectorAll(Np).forEach((t) => {
                    const e = this.container.querySelector(t.getAttribute(jp));
                    Xp[this.id].push(
                        new (class {
                            init() {
                                this.onScroll(), document.addEventListener("theme:scroll", this.scrollCallback), document.addEventListener("theme:resize:width", this.scrollCallback);
                            }
                            isEligible() {
                                return !this.container.hasAttribute(Gp) && ((le() && this.anchor.hasAttribute(Kp)) || (ae() && this.anchor.hasAttribute(Qp)) || (!this.anchor.hasAttribute(Qp) && !this.anchor.hasAttribute(Kp)));
                            }
                            onScroll() {
                                if (!this.isEligible()) return;
                                (this.top = this.element.getBoundingClientRect().top), (this.bottom = this.element.getBoundingClientRect().bottom);
                                const t = Math.round(window.innerHeight),
                                    e = Math.round(window.scrollY),
                                    i = e + t,
                                    s = Math.round(this.top + e),
                                    o = this.element.offsetHeight;
                                if (!(s < i) || s + o < e) return;
                                this.anchor.parentNode.offsetHeight <= o ? this.container.style.setProperty("--sticky-position", window.innerHeight / 2 - o / 2 + "px") : this.container.classList.add(Up),
                                    (this.anchorTop = this.anchor.getBoundingClientRect().top),
                                    (this.anchorBottom = this.anchor.getBoundingClientRect().bottom);
                                const n = this.top < this.anchorTop,
                                    r = this.bottom < this.anchorBottom;
                                n &&
                                    !r &&
                                    (this.anchors.forEach((t) => {
                                        t.matches(this.anchorSelector) || t.classList.remove(Wp);
                                    }),
                                    this.anchor.classList.add(Wp));
                            }
                            onUnload() {
                                document.removeEventListener("theme:scroll", this.scrollCallback), document.removeEventListener("theme:resize:width", this.scrollCallback);
                            }
                            constructor(t, e) {
                                (this.container = t),
                                    (this.element = e),
                                    this.element &&
                                        ((this.anchorSelector = `[${jp}="#${this.element.id}"]`),
                                        (this.anchor = this.container.querySelector(this.anchorSelector)),
                                        (this.anchors = this.container.querySelectorAll(`[${jp}]`)),
                                        this.anchor && ((this.scrollCallback = () => this.onScroll()), this.init()));
                            }
                        })(this.container, e)
                    );
                });
            },
            onUnload() {
                Xp[this.id].forEach((t) => {
                    "function" == typeof t.onUnload && t.onUnload();
                });
            },
        },
        Jp = "[data-banner]",
        Zp = "[data-slider-content]",
        tm = "[data-slider-media]",
        em = "a, button",
        im = "data-index",
        sm = "tabindex",
        om = "data-slider-single-image",
        nm = "data-scroll-spy-prevent",
        rm = "is-selected",
        am = "row",
        lm = "columns";
    let cm = {};
    I("banner-with-text-columns", [
        {
            onLoad() {
                cm[this.id] = new (class {
                    listen() {
                        document.addEventListener("theme:resize:width", this.onResizeCallback),
                            this.links.forEach((t) => {
                                t.addEventListener("focus", () => {
                                    const e = Number(t.closest(Jp).getAttribute(im));
                                    window.innerWidth >= theme.sizes.small && this.sync(e);
                                });
                            }),
                            this.banners.forEach((t) => {
                                t.addEventListener("mouseenter", () => {
                                    const e = Number(t.getAttribute(im));
                                    window.innerWidth >= theme.sizes.small && !window.theme.touch && this.sync(e);
                                }),
                                    t.addEventListener("pointerup", () => {
                                        const e = Number(t.getAttribute(im));
                                        window.innerWidth >= theme.sizes.small && window.theme.touch && this.sync(e);
                                    });
                            });
                    }
                    handleColumnsLayout() {
                        if (this.sliderContent.children.length <= 1) return;
                        let t = window.innerWidth < window.theme.sizes.small;
                        this.sliderMedia.children.length > 1 &&
                            ((this.flktyMedia = new e(this.sliderMedia, {
                                draggable: !1,
                                wrapAround: !1,
                                fade: !0,
                                prevNextButtons: !1,
                                adaptiveHeight: !1,
                                pageDots: !1,
                                setGallerySize: !1,
                                on: {
                                    change: (t) => {
                                        this.handleGroupItemsNavigation(t, this.flktyContent);
                                    },
                                },
                            })),
                            vi(this.sliderMedia)),
                            (this.flktyContent = new e(this.sliderContent, {
                                draggable: t,
                                prevNextButtons: !1,
                                pageDots: !0,
                                cellAlign: "left",
                                adaptiveHeight: !1,
                                imagesLoaded: !0,
                                on: {
                                    ready: () => {
                                        this.listen(), this.slidesTabIndex();
                                    },
                                    change: (t) => {
                                        window.innerWidth < theme.sizes.small && !this.singleImageEnabled && this.flktyMedia.select(t), this.slidesTabIndex(), this.handleGroupItemsNavigation(t, this.flktyMedia);
                                    },
                                },
                            })),
                            vi(this.sliderContent);
                    }
                    handleRowLayout() {
                        if (this.sliderMedia.children.length <= 1 || le()) return this.updateState(0), void this.listen();
                        this.initMediaSlider();
                    }
                    initMediaSlider() {
                        (this.flktyMedia = new e(this.sliderMedia, {
                            draggable: !0,
                            wrapAround: !1,
                            fade: !0,
                            prevNextButtons: !1,
                            adaptiveHeight: !1,
                            pageDots: !1,
                            setGallerySize: !1,
                            on: {
                                ready: () => {
                                    this.updateState(0), this.listen();
                                },
                                change: (t) => {
                                    this.updateState(t);
                                },
                            },
                        })),
                            vi(this.sliderMedia);
                    }
                    handleGroupItemsNavigation(t, e = null) {
                        null !== e &&
                            requestAnimationFrame(() => {
                                t !== e.selectedIndex && e.select(t);
                            });
                    }
                    slidesTabIndex() {
                        this.sliderContent &&
                            e.data(this.sliderContent).cells.forEach((t) => {
                                let e = "-1";
                                t.element.classList.contains(rm) && (e = "0"),
                                    t.element.querySelectorAll(em).forEach((t) => {
                                        t.setAttribute(sm, e);
                                    });
                            });
                    }
                    sync(t = 0) {
                        this.appearance === lm ? this.flktyContent.selectCell(t) : this.updateState(t), this.flktyMedia && this.flktyMedia.selectCell(t);
                    }
                    updateState(t = 0) {
                        this.banners.forEach((e) => {
                            const i = Number(e.getAttribute(im));
                            e.classList.toggle(rm, i === t);
                        });
                    }
                    handleSlidersOnResize() {
                        if (this.appearance === am) {
                            if (le() && this.flktyMedia) return this.flktyMedia.destroy(), void (this.flktyMedia = null);
                            if (ae() && !this.flktyMedia) return void this.initMediaSlider();
                        }
                        this.flktyContent && (this.flktyContent.resize(), this.toggleDraggable()), this.flktyMedia && this.flktyMedia.resize();
                    }
                    toggleDraggable() {
                        (this.flktyContent.options.draggable = window.innerWidth < window.theme.sizes.small), this.flktyContent.updateDraggable();
                    }
                    onBlockSelect(t) {
                        const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
                        if ((this.sync(e), this.appearance === am)) {
                            const t = this.sliderMedia.children[e],
                                i = Math.round(t.getBoundingClientRect().top);
                            this.container.setAttribute(nm, ""), setTimeout(() => Mr(i), 400), setTimeout(() => this.container.removeAttribute(nm), 1e3);
                        }
                    }
                    onUnload() {
                        document.removeEventListener("theme:resize:width", this.onResizeCallback);
                    }
                    constructor(t) {
                        var e;
                        (this.container = t.container),
                            (this.sliderContent = this.container.querySelector(Zp)),
                            (this.singleImageEnabled = null === (e = this.sliderContent) || void 0 === e ? void 0 : e.hasAttribute(om)),
                            (this.banners = this.container.querySelectorAll(Jp)),
                            (this.links = this.container.querySelectorAll("a")),
                            (this.sliderMedia = this.container.querySelector(tm)),
                            (this.flktyContent = null),
                            (this.flktyMedia = null),
                            (this.onResizeCallback = () => this.handleSlidersOnResize()),
                            (this.appearance = this.container.dataset.appearance),
                            this.appearance === lm ? this.handleColumnsLayout() : this.handleRowLayout();
                    }
                })(this);
            },
            onBlockSelect(t) {
                cm[this.id].onBlockSelect(t);
            },
        },
        Yp,
    ]),
        I("blog-posts", Do);
    const hm = "[data-slider]",
        dm = "[data-slider-item]",
        um = "[data-media-container]",
        pm = "a, button",
        mm = ".flickity-button",
        gm = "carousel--inactive",
        fm = "carousel--resize",
        ym = "tabindex",
        vm = {};
    const bm = {
        onLoad() {
            vm[this.id] = new (class {
                initSlider() {
                    this.slider.classList.remove(gm),
                        (this.flkty = new e(this.slider, {
                            pageDots: !1,
                            cellAlign: "left",
                            groupCells: !0,
                            contain: !0,
                            on: {
                                ready: () => {
                                    this.setSliderArrowsPosition(this.slider),
                                        setTimeout(() => {
                                            this.changeTabIndex(), this.flkty.resize();
                                        }, 0);
                                },
                                change: () => {
                                    this.changeTabIndex();
                                },
                            },
                        })),
                        (e.prototype._createResizeClass = function () {
                            this.element.classList.add(fm);
                        }),
                        e.createMethods.push("_createResizeClass");
                    const t = e.prototype.resize;
                    e.prototype.resize = function () {
                        this.element.classList.remove(fm), t.call(this), this.element.classList.add(fm);
                    };
                }
                destroySlider() {
                    this.slider.classList.add(gm), null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
                }
                checkSlidesSize() {
                    const t = this.container.querySelector(dm).currentStyle || window.getComputedStyle(this.container.querySelector(dm));
                    this.gutter = parseInt(t.marginRight);
                    const e = this.slider.offsetWidth < this.getItemsWidth();
                    window.innerWidth >= theme.sizes.small && e ? this.initSlider() : this.destroySlider();
                }
                changeTabIndex() {
                    const t = this.flkty.selectedIndex;
                    this.flkty.slides.forEach((e, i) => {
                        e.cells.forEach((e) => {
                            e.element.querySelectorAll(pm).forEach((e) => {
                                e.setAttribute(ym, t === i ? "0" : "-1");
                            });
                        });
                    });
                }
                getItemsWidth() {
                    let t = 0;
                    const e = this.slider.querySelectorAll(dm);
                    return (
                        e.length &&
                            e.forEach((e) => {
                                t += e.offsetWidth + this.gutter;
                            }),
                        t
                    );
                }
                listen() {
                    this.slider && (this.checkSlidesSize(), document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize));
                }
                setSliderArrowsPosition(t) {
                    const e = t.querySelectorAll(mm),
                        i = t.querySelector(um);
                    e.length &&
                        i &&
                        e.forEach((t) => {
                            t.style.top = i.offsetHeight / 2 + "px";
                        });
                }
                onBlockSelect(t) {
                    if (null !== this.flkty) {
                        const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
                            i = parseInt(this.flkty.slides[0].cells.length),
                            s = Math.floor(e / i);
                        this.flkty.select(s);
                    } else {
                        const e = this.slider.currentStyle || window.getComputedStyle(this.slider),
                            i = parseInt(e.paddingLeft),
                            s = t.target.offsetLeft - i;
                        this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
                    }
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize);
                }
                constructor(t) {
                    (this.container = t.container), (this.slider = this.container.querySelector(hm)), (this.flkty = null), (this.gutter = 0), (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()), this.listen();
                }
            })(this);
        },
        onUnload(t) {
            vm[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            vm[this.id].onBlockSelect(t);
        },
    };
    I("columns-with-image", [bm, Dp]);
    const wm = "[data-form-message-close]",
        Sm = "[data-form-message]",
        Em = "hide-down",
        Lm = "notification-visible";
    let km = {};
    I("contact-form", {
        onLoad() {
            km[this.id] = new (class {
                hidePopups() {
                    document.body.classList.add(Lm);
                }
                showPopups() {
                    document.body.classList.remove(Lm);
                }
                closeFormMessage() {
                    this.closeButton.addEventListener("click", this.closeMessage.bind(this));
                }
                closeMessage(t) {
                    t.preventDefault(), this.messageWrapper.classList.add(Em), this.showPopups();
                }
                autoHideMessage() {
                    setTimeout(() => {
                        this.messageWrapper.classList.add(Em), this.showPopups();
                    }, 1e4);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.closeButton = this.container.querySelector(wm)),
                        (this.messageWrapper = this.container.querySelector(Sm)),
                        this.messageWrapper && (this.hidePopups(), this.closeFormMessage(), this.autoHideMessage());
                }
            })(this);
        },
    });
    const Am = "time",
        Cm = "[data-days]",
        qm = "[data-hours]",
        Tm = "[data-minutes]",
        Pm = "[data-seconds]",
        xm = "[data-section-type]",
        Im = ".shopify-section",
        Hm = "[data-aos]",
        Fm = "countdown-timer--show-message",
        Mm = "hide-countdown",
        Dm = "aos-animate",
        Om = "countdown",
        Bm = "data-expiration-behavior",
        zm = "data-leading-zero",
        _m = "hide",
        $m = "show-message";
    let Rm = class extends HTMLElement {
        connectedCallback() {
            this.init();
        }
        disconnectedCallback() {
            this.stopTimer();
        }
        init() {
            isNaN(this.endDate) || this.endDate <= Date.now() ? this.onComplete() : (this.section.classList.contains(Om) && this.onLoad(!0), (this.interval = setInterval(this.update, 1e3)));
        }
        stopTimer() {
            clearInterval(this.interval);
        }
        convertTime(t) {
            const e = this.formatDigits(parseInt(t / this.daysInMs, 10));
            t -= e * this.daysInMs;
            const i = this.formatDigits(parseInt(t / this.hoursInMs, 10));
            t -= i * this.hoursInMs;
            const s = this.formatDigits(parseInt(t / this.minutesInMs, 10));
            t -= s * this.minutesInMs;
            return { days: e, hours: i, minutes: s, seconds: this.formatDigits(parseInt(t / this.secondsInMs, 10)) };
        }
        formatDigits(t) {
            return t < 10 && this.leadingZero && (t = "0" + t), t;
        }
        render(t) {
            (this.days.textContent = t.days), (this.hours.textContent = t.hours), (this.minutes.textContent = t.minutes), (this.seconds.textContent = t.seconds);
        }
        onComplete() {
            this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 }), this.shouldHideOnComplete && this.shopifySection.classList.add(Mm), this.shouldShowMessage && this.classList.add(Fm);
        }
        triggerAnimations() {
            "false" != theme.settings.animations &&
                this.section.querySelectorAll(Hm).forEach((t) => {
                    this.isAnimated && t.classList.add(Dm);
                });
        }
        removeAnimations() {
            this.section.querySelectorAll(Hm).forEach((t) => {
                requestAnimationFrame(() => {
                    t.classList.contains(Dm) && (t.classList.remove(Dm), (this.isAnimated = !0));
                });
            });
        }
        onLoad(t) {
            t ? this.removeAnimations() : ((this.isLoading = !1), this.triggerAnimations());
        }
        update() {
            const t = Date.now(),
                e = this.endDate - t;
            if (e <= 0) return this.stopTimer(), void this.onComplete();
            const i = this.convertTime(e);
            this.render(i), this.isLoading && this.onLoad(!1);
        }
        constructor() {
            super(),
                (this.section = this.closest(xm)),
                (this.shopifySection = this.closest(Im)),
                (this.expirationBehavior = this.getAttribute(Bm)),
                (this.leadingZero = this.hasAttribute(zm)),
                (this.time = this.querySelector(Am)),
                (this.endDate = Date.parse(this.time.dateTime)),
                (this.days = this.querySelector(Cm)),
                (this.hours = this.querySelector(qm)),
                (this.minutes = this.querySelector(Tm)),
                (this.seconds = this.querySelector(Pm)),
                (this.daysInMs = 864e5),
                (this.hoursInMs = this.daysInMs / 24),
                (this.minutesInMs = this.hoursInMs / 60),
                (this.secondsInMs = this.minutesInMs / 60),
                (this.isLoading = !0),
                (this.shouldHideOnComplete = this.expirationBehavior === _m),
                (this.shouldShowMessage = this.expirationBehavior === $m),
                (this.isAnimated = !1),
                (this.update = this.update.bind(this));
        }
    };
    I("countdown", [Dp, uu]), customElements.get("countdown-timer") || customElements.define("countdown-timer", Rm);
    const Vm = "[data-video-id]",
        Nm = "[data-video-player]",
        Wm = "[data-video-template]",
        Um = "[data-video-autoplay]",
        jm = "[data-video-wrapper]",
        Gm = "[data-video-bg-play]",
        Km = "is-loading",
        Qm = "is-paused",
        Xm = {};
    const Ym = {
        onLoad() {
            Xm[this.id] = [];
            this.container.querySelectorAll(jm).forEach((t) => {
                Xm[this.id].push(
                    new (class {
                        init() {
                            this.videoId &&
                                (new IntersectionObserver(
                                    (t, e) => {
                                        t.forEach((t) => {
                                            if (t.isIntersecting) {
                                                const i = this.videoTemplate.innerHTML;
                                                (this.videoPlayer.innerHTML = i),
                                                    (this.video = this.container.querySelector(Um)),
                                                    this.videoPlayer.classList.remove(Km),
                                                    this.container.classList.add(Qm),
                                                    this.listen(),
                                                    e.unobserve(t.target);
                                            }
                                        });
                                    },
                                    { root: null, rootMargin: "300px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
                                ).observe(this.videoPlayer),
                                this.videoPlayButton.addEventListener("click", (t) => {
                                    var e;
                                    t.preventDefault(), null === (e = this.video) || void 0 === e || e.play();
                                }));
                        }
                        listen() {
                            this.video.addEventListener("play", () => {
                                this.container.classList.remove(Qm);
                            }),
                                this.container.addEventListener(
                                    "touchstart",
                                    () => {
                                        this.video.play();
                                    },
                                    { passive: !0 }
                                );
                        }
                        constructor(t) {
                            (this.container = t),
                                (this.videoId = this.container.querySelector(Vm)),
                                (this.videoPlayer = this.container.querySelector(Nm)),
                                (this.videoTemplate = this.container.querySelector(Wm)),
                                (this.videoPlayButton = this.container.querySelector(Gm)),
                                this.init();
                        }
                    })(t)
                );
            });
        },
    };
    let Jm = class {
        write() {
            ((-1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find((t) => t.startsWith(this.name))) || -1 === document.cookie.indexOf("; ")) &&
                (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
        }
        read() {
            if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((t) => t.startsWith(this.name))) {
                return document.cookie
                    .split("; ")
                    .find((t) => t.startsWith(this.name))
                    .split("=")[1];
            }
            return !1;
        }
        destroy() {
            document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
                (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
        }
        constructor(t, e) {
            (this.configuration = { expires: null, path: "/", domain: window.location.hostname, sameSite: "none", secure: !0 }), (this.name = t), (this.value = e);
        }
    };
    const Zm = "[data-newsletter-form]",
        tg = "[data-popup]",
        eg = "has-success",
        ig = "has-error",
        sg = "newsletter_form_id",
        og = {};
    const ng = {
            onLoad() {
                og[this.id] = [];
                this.container.querySelectorAll(Zm).forEach((t) => {
                    og[this.id].push(
                        new (class {
                            init() {
                                this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage();
                            }
                            newsletterSubmitEvent(t) {
                                this.stopSubmit && (t.preventDefault(), this.removeStorage(), this.writeStorage(), (this.stopSubmit = !1), this.newsletter.submit());
                            }
                            checkForChallengePage() {
                                this.isChallengePage = window.location.pathname === theme.routes.root + "challenge";
                            }
                            writeStorage() {
                                void 0 !== this.sessionStorage && this.sessionStorage.setItem(sg, this.newsletter.id);
                            }
                            readStorage() {
                                this.formID = this.sessionStorage.getItem(sg);
                            }
                            removeStorage() {
                                this.sessionStorage.removeItem(sg);
                            }
                            showMessage() {
                                if ((this.readStorage(), this.newsletter.id === this.formID)) {
                                    const t = document.getElementById(this.formID),
                                        e = -1 !== window.location.search.indexOf("?customer_posted=true"),
                                        i = -1 !== window.location.search.indexOf("accepts_marketing");
                                    e
                                        ? (t.classList.remove(ig), t.classList.add(eg), this.popup && ((this.cookie = new Jm(this.popup.dataset.cookieName, "user_has_closed")), this.cookie.write()))
                                        : i && (t.classList.remove(eg), t.classList.add(ig)),
                                        (e || i) && this.scrollToForm(t);
                                }
                            }
                            scrollToForm(t) {
                                const e = t.getBoundingClientRect();
                                visibilityHelper.isElementPartiallyVisible(t) ||
                                    visibilityHelper.isElementTotallyVisible(t) ||
                                    setTimeout(() => {
                                        window.scrollTo({ top: e.top, left: 0, behavior: "smooth" });
                                    }, 400);
                            }
                            onUnload() {
                                this.newsletter.removeEventListener("submit", this.newsletterSubmit);
                            }
                            constructor(t) {
                                (this.newsletter = t),
                                    (this.sessionStorage = window.sessionStorage),
                                    (this.popup = this.newsletter.closest(tg)),
                                    (this.stopSubmit = !0),
                                    (this.isChallengePage = !1),
                                    (this.formID = null),
                                    (this.formIdSuccess = null),
                                    this.checkForChallengePage(),
                                    (this.newsletterSubmit = (t) => this.newsletterSubmitEvent(t)),
                                    this.isChallengePage || this.init();
                            }
                        })(t)
                    );
                });
            },
            onUnload() {
                og[this.id].forEach((t) => {
                    "function" == typeof t.onUnload && t.onUnload();
                });
            },
        },
        rg = "[data-product]",
        ag = "[data-slider]",
        lg = "[data-slide]",
        cg = "[data-product-media-container]",
        hg = ".flickity-button",
        dg = "a, button",
        ug = "tabindex",
        pg = {};
    const mg = {
        onLoad() {
            pg[this.id] = new (class {
                checkSlider() {
                    window.innerWidth >= theme.sizes.small
                        ? this.productSlider.forEach((t) => {
                              this.initProductSlider(t);
                          })
                        : this.productSlider.forEach((t) => {
                              this.destroyProductSlider(t);
                          });
                }
                initProductSlider(t) {
                    const i = t.querySelectorAll(lg).length,
                        s = t.dataset.slider;
                    i > 1 &&
                        (void 0 !== this.flkty[s] && this.flkty[s].isActive
                            ? this.setSliderArrowsPosition(t)
                            : (this.flkty[s] = new e(t, {
                                  prevNextButtons: !0,
                                  adaptiveHeight: !0,
                                  pageDots: !0,
                                  wrapAround: !0,
                                  on: {
                                      ready: () => {
                                          this.setSliderArrowsPosition(t);
                                      },
                                      change: (t) => {
                                          this.flkty[s].cells.forEach((e, i) => {
                                              e.element.querySelectorAll(dg).forEach((e) => {
                                                  e.setAttribute(ug, i === t ? "0" : "-1");
                                              });
                                          });
                                      },
                                  },
                              })));
                }
                destroyProductSlider(t) {
                    const e = t.dataset.slider;
                    "object" == typeof this.flkty[e] && this.flkty[e].destroy();
                }
                setSliderArrowsPosition(t) {
                    const e = t.querySelectorAll(hg),
                        i = t.querySelector(cg);
                    e.length &&
                        i &&
                        e.forEach((t) => {
                            t.style.top = i.offsetHeight / 2 + "px";
                        });
                }
                resizeSlider(t) {
                    const i = t.target,
                        s = e.data(i) || null;
                    s && s.resize();
                }
                listen() {
                    this.checkSlider(),
                        document.addEventListener("theme:resize:width", this.checkSliderOnResize),
                        this.productSlider.forEach((t) => {
                            t.addEventListener("theme:slider:resize", this.resizeSliderEvent);
                        });
                }
                onUnload() {
                    if (this.flkty) for (const t in this.flkty) this.flkty.hasOwnProperty(t) && this.flkty[t].destroy();
                    document.removeEventListener("theme:resize:width", this.checkSliderOnResize),
                        this.productSlider.forEach((t) => {
                            t.removeEventListener("theme:slider:resize", this.resizeSliderEvent);
                        });
                }
                constructor(t) {
                    (this.container = t),
                        (this.product = this.container.querySelectorAll(rg)),
                        (this.productSlider = this.container.querySelectorAll(ag)),
                        (this.checkSliderOnResize = () => this.checkSlider()),
                        (this.resizeSliderEvent = (t) => this.resizeSlider(t)),
                        (this.flkty = []),
                        (this.videoObj = []),
                        (this.quickViewObj = []),
                        this.listen();
                }
            })(this.container);
        },
        onUnload(t) {
            pg[this.id].onUnload(t);
        },
    };
    I("custom-content", [mg, ng, Dp, Zi, Ym, yo]);
    const gg = "[data-slider]",
        fg = "[data-slide]",
        yg = "[data-product-media-container]",
        vg = "a, button",
        bg = ".flickity-button",
        wg = "[data-promo]",
        Sg = "[data-product-block]",
        Eg = "carousel",
        Lg = "carousel--inactive",
        kg = "is-last-slide-visible",
        Ag = "featured-collection",
        Cg = "collection-promo--full",
        qg = "collection-promo--two-columns",
        Tg = "data-slider-id",
        Pg = "data-slider-show-image",
        xg = "tabindex",
        Ig = {};
    let Hg = class {
        initSlider(t) {
            const i = t.getAttribute(Tg);
            t.classList.remove(Lg),
                void 0 !== this.flkty[i] && this.flkty[i].isActive
                    ? this.setSliderArrowsPosition(t)
                    : ((this.flkty[i] = new e(t, {
                          pageDots: !1,
                          cellSelector: fg,
                          cellAlign: "left",
                          groupCells: !0,
                          contain: !0,
                          wrapAround: !1,
                          adaptiveHeight: !1,
                          on: {
                              ready: () => {
                                  this.setSliderArrowsPosition(t),
                                      setTimeout(() => {
                                          this.changeTabIndex(t);
                                      }, 0);
                              },
                              change: () => {
                                  this.changeTabIndex(t);
                              },
                          },
                      })),
                      this.handleLastSlideOverlayOnTablet(t));
        }
        destroySlider(t) {
            const e = t.getAttribute(Tg);
            t.classList.contains(Eg) && t.classList.add(Lg), "object" == typeof this.flkty[e] && this.flkty[e].destroy();
        }
        resetSlider(t) {
            const e = t.target,
                i = e.getAttribute(Tg);
            "object" == typeof this.flkty[i] ? this.flkty[i].select(0, !1, !0) : e.scrollTo({ left: 0, behavior: "instant" });
        }
        resizeSlider(t) {
            const i = t.target,
                s = e.data(i) || null;
            s && s.resize();
        }
        checkSlidesSize() {
            this.sliders.length &&
                this.sliders.forEach((t) => {
                    const e = this.columns,
                        i = window.innerWidth >= theme.sizes.large,
                        s = window.innerWidth >= theme.sizes.small && window.innerWidth < theme.sizes.large;
                    let o = t.querySelectorAll(fg).length;
                    const n = t.querySelectorAll(wg);
                    n.length &&
                        i &&
                        n.forEach((t) => {
                            t.classList.contains(Cg) ? (o += e - 1) : t.classList.contains(qg) && (o += 1);
                        }),
                        t.hasAttribute(Pg) && (o += 1),
                        (i && o > e) || (s && o > 2) ? (this.initSlider(t), this.getTallestProductGridItem(t)) : this.destroySlider(t);
                });
        }
        changeTabIndex(t) {
            const e = t.getAttribute(Tg),
                i = this.flkty[e].selectedIndex;
            this.flkty[e].slides.forEach((t, e) => {
                t.cells.forEach((t) => {
                    t.element.querySelectorAll(vg).forEach((t) => {
                        t.setAttribute(xg, i === e ? "0" : "-1");
                    });
                });
            });
        }
        setSliderArrowsPosition(t) {
            const e = t.querySelectorAll(bg),
                i = t.querySelector(yg);
            e.length &&
                i &&
                e.forEach((t) => {
                    t.style.top = i.offsetHeight / 2 + "px";
                });
        }
        handleLastSlideOverlayOnTablet(t) {
            const e = t.getAttribute(Tg);
            this.flkty[e].on("select", () => {
                if (!(window.innerWidth >= theme.sizes.small && window.innerWidth < theme.sizes.large)) return;
                const i = this.flkty[e].selectedIndex,
                    s = this.flkty[e].slides.length - 1 === i;
                t.parentNode.classList.toggle(kg, s);
            });
        }
        getTallestProductGridItem(t) {
            if (t.querySelectorAll(wg).length) {
                const e = t.querySelectorAll(Sg),
                    i = Math.max(...Array.from(e).map((t) => t.offsetHeight));
                t.style.setProperty("--carousel-promo-height", `${i}px`);
            }
        }
        handleLastSlideOverlayOnMobile() {
            this.sliders.forEach((t) => {
                t.addEventListener("scroll", (e) => {
                    if (!(window.innerWidth < theme.sizes.small)) return;
                    const i = e.target.offsetWidth,
                        s = Array.from(t.children).pop().getBoundingClientRect().left + 80 < i;
                    t.parentNode.classList.toggle(kg, s);
                });
            });
        }
        listen() {
            this.sliders.length &&
                (this.checkSlidesSize(),
                document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize),
                this.sliders.forEach((t) => {
                    t.addEventListener("theme:tab:change", this.resetSliderEvent), t.addEventListener("theme:slider:resize", this.resizeSliderEvent);
                }));
        }
        onBlockSelect(t) {
            const i = t.target.closest(gg),
                s = e.data(i) || null;
            if (!i) return;
            let o = t.target.parentNode,
                n = t.target;
            if ((this.container.classList.contains(Ag) && ((o = o.parentNode), (n = n.parentNode)), null !== s && s.isActive)) {
                const t = parseInt([...o.children].indexOf(n)),
                    e = parseInt(s.slides[0].cells.length),
                    i = Math.floor(t / e);
                s.select(i);
            } else {
                const t = i.currentStyle || window.getComputedStyle(i),
                    e = parseInt(t.paddingLeft),
                    s = n.offsetLeft - e;
                i.scrollTo({ top: 0, left: s, behavior: "smooth" });
            }
        }
        onUnload() {
            if (this.flkty) for (const t in this.flkty) this.flkty.hasOwnProperty(t) && this.flkty[t].destroy();
            document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize),
                this.sliders.length &&
                    this.sliders.forEach((t) => {
                        t.removeEventListener("theme:tab:change", this.resetSliderEvent), t.removeEventListener("theme:slider:resize", this.resizeSliderEvent);
                    });
        }
        constructor(t) {
            (this.container = t),
                (this.columns = parseInt(this.container.dataset.columns)),
                (this.sliders = this.container.querySelectorAll(gg)),
                (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
                (this.resetSliderEvent = (t) => this.resetSlider(t)),
                (this.resizeSliderEvent = (t) => this.resizeSlider(t)),
                (this.flkty = []),
                this.listen(),
                this.handleLastSlideOverlayOnMobile();
        }
    };
    const Fg = {
        onLoad() {
            Ig[this.id] = [];
            this.container.querySelectorAll(gg).forEach((t) => {
                Ig[this.id].push(new Hg(this.container));
            });
        },
        onUnload() {
            Ig[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload();
            });
        },
        onBlockSelect(t) {
            Ig[this.id].forEach((e) => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
            });
        },
    };
    I("featured-collection", [yo, Zi, Fg]), I("featured-video", [Dp, Ym]);
    const Mg = "[data-shop-pay-wrapper]",
        Dg = "shop-login-button",
        Og = "shop-follow-button",
        Bg = "follow-on-shop-button",
        zg = "heart-icon",
        _g = "shop-logo",
        $g = {};
    const Rg = {
            onLoad() {
                $g[this.id] = new (class {
                    init() {
                        if (!this.shopLoginButton || !this.shopPayWrapper) return;
                        const t = this.shopPayWrapper.dataset.bg || "transparent",
                            e = this.shopPayWrapper.dataset.text || "#fff",
                            i = this.shopPayWrapper.dataset.hover || "#fff";
                        (this.mainButtonStyles = `\n      :host {\n        --bg-color: ${t};\n        --text-color: ${e};\n        --hover-color: ${i};\n      }\n\n      .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--text-color);\n        transition: border 0.3s ease;\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n\n      .button {\n        background: transparent;\n        color: var(--text-color);\n      }\n\n      .following-text {\n        color: var(--text-color);\n      }\n\n      .button--following:focus-visible,\n      .button--following:hover {\n        background: var(--bg-color);\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n    `),
                            (this.svgIconsStyles = `\n      :host {\n        color: ${e};\n      }\n    `),
                            customElements.whenDefined(Dg).then((t) => {
                                requestAnimationFrame(() => {
                                    const t = this.shopLoginButton.shadowRoot,
                                        e = null == t ? void 0 : t.querySelector(Og),
                                        i = null == e ? void 0 : e.shadowRoot,
                                        s = null == i ? void 0 : i.querySelector(Bg),
                                        o = null == s ? void 0 : s.shadowRoot;
                                    o && this.overwriteStyles(o.host.shadowRoot, this.mainButtonStyles);
                                    const n = o.querySelector(zg),
                                        r = null == n ? void 0 : n.shadowRoot,
                                        a = o.querySelector(_g),
                                        l = null == a ? void 0 : a.shadowRoot;
                                    r && this.overwriteStyles(r.host.shadowRoot, this.svgIconsStyles), l && this.overwriteStyles(l.host.shadowRoot, this.svgIconsStyles);
                                });
                            });
                    }
                    overwriteStyles(t, e) {
                        let i = document.createElement("style");
                        (i.innerHTML = e), t.appendChild(i);
                    }
                    constructor(t) {
                        (this.container = t), (this.shopPayWrapper = document.querySelector(Mg)), (this.shopLoginButton = document.querySelector(Dg)), this.init();
                    }
                })(this.container);
            },
        },
        Vg = ":scope > [data-wave]",
        Ng = "[data-main]",
        Wg = "[data-collapsible-trigger-mobile]",
        Ug = '[data-parallax="footer"]',
        jg = "is-expanded",
        Gg = "wavy",
        Kg = "parallax-shadow",
        Qg = "parallax-rounded-corners",
        Xg = "main-content--parallax",
        Yg = "section-footer--parallax",
        Jg = "section-footer--visible",
        Zg = "main-content",
        tf = "shopify-section",
        ef = "body--rounded-corners-large",
        sf = "--bg",
        of = "--footer-bg",
        nf = "data-parallax",
        rf = "data-parallax-wavy",
        af = "data-parallax-rounded-corners",
        lf = "data-parallax-rounded-corners-large",
        cf = "data-parallax-disable-on-safari",
        hf = {};
    I("footer", [
        Pl,
        ng,
        _e,
        {
            onLoad() {
                hf[this.id] = new (class {
                    init() {
                        const t = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && this.container.hasAttribute(cf),
                            e = this.isViewportSmaller() || window.innerWidth < theme.sizes.small || t,
                            i = document.body;
                        i.classList.remove(ef);
                        const s = getComputedStyle(this.container).getPropertyValue(sf);
                        this.parentContainer.style.setProperty("--footer-parallax-height", "auto");
                        let o = this.parentContainer.previousElementSibling;
                        if (o) {
                            if ((o.classList.contains(tf) || o.classList.contains(Zg) || (o = this.main), this.wavyEnabled && !e)) {
                                [...o.querySelectorAll(Vg)].map((t) => t.remove());
                                const t = this.container.querySelector(Vg);
                                o.append(t.cloneNode(!0)), o.classList.add(Gg), this.container.classList.remove(Gg);
                            } else this.container.hasAttribute(af) && !this.wavyEnabled ? (o.classList.toggle(Qg, !e), o.classList.toggle(Kg, !e), this.container.hasAttribute(lf) && i.classList.toggle(ef, !e)) : e || o.classList.add(Kg);
                            o.style.setProperty(of, s);
                        }
                        e ||
                            (this.main.classList.add(Xg),
                            this.parentContainer.classList.add(Yg),
                            this.parentContainer.style.setProperty("--footer-parallax-height", `${this.container.clientHeight}px`),
                            (this.footerParallax = new du(this.container)));
                    }
                    resize() {
                        this.parentContainer.style.setProperty("--footer-parallax-height", "auto"),
                            (this.isViewportSmaller() || window.innerWidth < theme.sizes.small || !this.footerParallax) && this.onUnload(!0),
                            this.parentContainer.style.setProperty("--footer-parallax-height", `${this.container.clientHeight}px`);
                    }
                    isViewportSmaller() {
                        const t = Math.round(Math.max(document.documentElement.clientHeight, window.innerHeight || 0)),
                            e = this.container.clientHeight;
                        let i = 0;
                        return this.wavyEnabled && (i = 50), t < e + i;
                    }
                    onBlockSelect(t) {
                        const e = t.target.querySelector(Wg);
                        requestAnimationFrame(() => {
                            e && !e.classList.contains(jg) && e.dispatchEvent(new Event("click"));
                        });
                    }
                    onBlockDeselect(t) {
                        const e = t.target.querySelector(Wg);
                        requestAnimationFrame(() => {
                            e && e.classList.contains(jg) && e.dispatchEvent(new Event("click"));
                        });
                    }
                    onUnload(t = !1) {
                        document.removeEventListener("theme:resize", this.resizeEvent),
                            document.removeEventListener("theme:footer:unload", this.unloadEvent),
                            this.footerParallax && (this.footerParallax.unload(), t && A(this.parentContainer)),
                            (this.footerParallax || t) &&
                                setTimeout(() => {
                                    const t = Shopify.theme.sections.instances,
                                        e = document.querySelectorAll(Ug),
                                        i = t.filter((t) => t.container === e[0]);
                                    this.main.classList.remove(Xg), this.parentContainer.classList.remove(Yg), this.parentContainer.classList.remove(Jg), i[0] && i[0].onLoad();
                                });
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.main = document.querySelector(Ng)),
                            (this.footerParallax = null),
                            (this.wavyEnabled = this.container.hasAttribute(rf)),
                            (this.parentContainer = this.container.parentNode),
                            (this.resizeEvent = () => this.resize()),
                            (this.unloadEvent = () => this.onUnload()),
                            requestIdleCallback(() => {
                                this.container.hasAttribute(nf) &&
                                    !this.main.classList.contains(Xg) &&
                                    (this.init(), document.addEventListener("theme:resize", this.resizeEvent), document.addEventListener("theme:footer:unload", this.unloadEvent));
                            });
                    }
                })(this);
            },
            onBlockSelect(t) {
                hf[this.id].onBlockSelect(t);
            },
            onBlockDeselect(t) {
                hf[this.id].onBlockDeselect(t);
            },
            onReorder() {
                hf[this.id].onUnload();
            },
            onUnload() {
                hf[this.id].onUnload();
            },
        },
        Rg,
    ]);
    const df = "[data-slider]";
    let uf = {};
    I("icons-row", {
        onLoad() {
            uf[this.id] = new (class {
                onBlockSelect(t) {
                    const e = this.slider.currentStyle || window.getComputedStyle(this.slider),
                        i = parseInt(e.paddingLeft),
                        s = t.target.offsetLeft - i;
                    this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
                }
                constructor(t) {
                    (this.container = t.container), (this.slider = this.container.querySelector(df));
                }
            })(this);
        },
        onBlockSelect(t) {
            uf[this.id].onBlockSelect(t);
        },
    });
    const pf = "[data-accordion-item]",
        mf = "[data-accordion-button]",
        gf = "is-active",
        ff = "to-animate",
        yf = "is-animating",
        vf = {};
    I("image-accordions", {
        onLoad() {
            vf[this.id] = new (class {
                init() {
                    this.triggerLoadingAnimation(),
                        this.imageAccordionsItems.forEach((t) => {
                            t.addEventListener("mouseenter", this.accordionExpandEvent.bind(this, t));
                        }),
                        this.buttons.forEach((t) => {
                            t.addEventListener("focusin", this.accordionFocusEvent.bind(this, t));
                        });
                }
                triggerLoadingAnimation() {
                    if ("false" == theme.settings.animationsEnabled || le()) return;
                    const t = (e) => {
                            "expandAccordion" === e.animationName &&
                                (this.accordionExpand(this.imageAccordionsItems[0]), this.container.classList.remove(ff), this.container.classList.remove(yf), this.container.removeEventListener("animationend", t));
                        },
                        e = (t) => {
                            requestAnimationFrame(() => {
                                t.target === this.container && (this.container.classList.add(yf), this.container.removeEventListener("transitionend", e));
                            });
                        };
                    this.container.addEventListener("transitionend", e, { signal: this.controller.signal }), this.container.addEventListener("animationend", t, { signal: this.controller.signal });
                }
                accordionExpand(t) {
                    t.classList.contains(gf) ||
                        (this.imageAccordionsItems.forEach((t) => {
                            t.classList.remove(gf);
                        }),
                        t.classList.add(gf));
                }
                accordionFocus(t) {
                    t.closest(pf).dispatchEvent(new Event("mouseenter"));
                }
                onBlockSelect(t) {
                    const e = t.target;
                    e && (this.controller.abort(), this.container.classList.remove(ff, yf), this.accordionExpand(e), le() && e.parentNode.scrollTo({ top: 0, left: e.offsetLeft, behavior: "smooth" }));
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.controller = new AbortController()),
                        (this.imageAccordionsItems = this.container.querySelectorAll(pf)),
                        (this.buttons = this.container.querySelectorAll(mf)),
                        (this.accordionExpandEvent = (t) => this.accordionExpand(t)),
                        (this.accordionFocusEvent = (t) => this.accordionFocus(t)),
                        this.init();
                }
            })(this);
        },
        onBlockSelect(t) {
            vf[this.id].onBlockSelect(t);
        },
    }),
        I("image-with-text", Dp),
        I("list-collections", Fg);
    const bf = {},
        wf = "[data-slider-gallery]",
        Sf = "[data-slider-info]",
        Ef = "[data-slide-item]";
    I("locations", {
        onLoad() {
            bf[this.id] = new (class {
                initSlider() {
                    const t = this.container.querySelectorAll(Ef).length;
                    let i = e.data(this.slider) || null,
                        s = e.data(this.sliderNav) || null;
                    t <= 1 ||
                        ((i = new e(this.slider, { fade: !0, wrapAround: !0, adaptiveHeight: !0, prevNextButtons: !1, pageDots: !1 })),
                        vi(this.slider),
                        (s = new e(this.sliderNav, { fade: !0, wrapAround: !0, imagesLoaded: !0, asNavFor: this.slider, prevNextButtons: !0, pageDots: !1 })),
                        s.on("change", () => {
                            i.selectCell(s.selectedIndex);
                        }),
                        i.on("change", () => {
                            s.selectCell(i.selectedIndex);
                        }));
                }
                onBlockSelect(t) {
                    const i = e.data(this.slider) || null,
                        s = e.data(this.sliderNav) || null,
                        o = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    null !== i && i.select(o), null !== s && s.select(o);
                }
                constructor(t) {
                    (this.container = t.container), (this.slider = this.container.querySelector(wf)), (this.sliderNav = this.container.querySelector(Sf)), this.initSlider();
                }
            })(this);
        },
        onBlockSelect(t) {
            bf[this.id].onBlockSelect(t);
        },
    });
    const Lf = {},
        kf = "[data-slider]",
        Af = "[data-slide-item]",
        Cf = "[data-pointer]",
        qf = "[data-product-media-container]",
        Tf = "[data-quick-view-item-holder]",
        Pf = ".flickity-button",
        xf = "a, button",
        If = "[data-tooltip]",
        Hf = "data-pointer",
        Ff = "data-hotspot",
        Mf = "tabindex",
        Df = "product-grid-item__image--hovered",
        Of = "pointer--selected",
        Bf = "is-selected",
        zf = "is-active",
        _f = "pswp--open";
    const $f = {
        onLoad() {
            Lf[this.id] = new (class {
                listen() {
                    this.slider && (this.checkSlidesSize(), document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize), this.slider.addEventListener("theme:slider:resize", this.resizeSliderEvent)),
                        this.pointers.length > 0 &&
                            this.pointers.forEach((t) => {
                                t.addEventListener("click", this.pointersInit), t.addEventListener("mouseover", this.pointersOver), t.addEventListener("mouseleave", this.pointersOut);
                            });
                }
                checkSlidesSize() {
                    const t = window.innerWidth >= theme.sizes.small;
                    this.initTooltips(), t ? (this.slides.length > 2 ? this.initSlider() : (this.destroySlider(), this.slidesTabIndex())) : !t && this.slides.length > 1 ? this.initSlider() : this.destroySlider();
                }
                initTooltips() {
                    (this.tooltips = this.container.querySelectorAll(If)),
                        this.tooltips.forEach((t) => {
                            new Ji(t);
                        });
                }
                initSlider() {
                    null !== this.flkty
                        ? this.setSliderArrowsPosition()
                        : (this.flkty = new e(this.slider, {
                              prevNextButtons: !0,
                              wrapAround: !0,
                              adaptiveHeight: !1,
                              cellAlign: "left",
                              groupCells: !1,
                              contain: !0,
                              on: {
                                  ready: () => {
                                      this.slidesTabIndex(), this.setSliderArrowsPosition(), this.dotPointers();
                                  },
                                  change: () => {
                                      this.slidesTabIndex(), this.dotPointers();
                                  },
                              },
                          }));
                }
                setSliderArrowsPosition() {
                    if (!(window.innerWidth >= theme.sizes.small)) return;
                    const t = this.slider.querySelectorAll(Pf),
                        e = this.slider.querySelector(qf);
                    t.length &&
                        e &&
                        t.forEach((t) => {
                            t.style.top = e.offsetHeight / 2 + "px";
                        });
                }
                slidesTabIndex() {
                    this.slides.length < 3
                        ? this.slider.querySelectorAll(xf).forEach((t) => {
                              t.setAttribute(Mf, "0");
                          })
                        : e.data(this.slider).cells.forEach((t) => {
                              let e = "-1";
                              t.element.classList.contains(Bf) && (e = "0"),
                                  t.element.querySelectorAll(xf).forEach((t) => {
                                      t.setAttribute(Mf, e);
                                  });
                          });
                }
                destroySlider() {
                    "object" == typeof this.flkty && null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
                }
                resizeSlider(t) {
                    const i = t.target,
                        s = e.data(i) || null;
                    s && s.resize();
                }
                dotPointers(t) {
                    if (0 === this.pointers.length) return;
                    if (
                        (this.pointers.forEach((t) => {
                            t.classList.remove(Of);
                        }),
                        t)
                    ) {
                        var e;
                        const i = t.target.getAttribute(Hf);
                        return void (null === (e = this.flkty) || void 0 === e || e.select(i));
                    }
                    const i = null == this.flkty ? 0 : this.flkty.selectedIndex;
                    i >= 0 && this.pointers[i].classList.add(Of);
                }
                dotPointerIn(t) {
                    const e = t.target.getAttribute(Hf),
                        i = this.slides[e].querySelector(qf),
                        s = matchMedia("(pointer:coarse)").matches;
                    window.innerWidth < theme.sizes.small || s || this.observeImage(i),
                        this.pointers.forEach((t) => {
                            t.style.setProperty("--look-animation", "none");
                        });
                }
                dotPointerOut(t) {
                    const e = t.target.getAttribute(Hf),
                        i = this.slides[e].querySelector(qf);
                    i.classList.remove(Df),
                        i.dispatchEvent(new Event("mouseleave")),
                        this.observer && this.observer.disconnect(),
                        this.pointers.forEach((t) => {
                            t.style.removeProperty("--look-animation");
                        });
                }
                observeImage(t) {
                    (this.observer = new IntersectionObserver(
                        (t, e) => {
                            t.forEach((t) => {
                                const e = t.target;
                                0 == t.intersectionRatio || (e.dispatchEvent(new Event("mouseenter")), e.classList.add(Df));
                            });
                        },
                        { root: this.slider, threshold: [0.95, 1] }
                    )),
                        this.observer.observe(t);
                }
                triggerClick(t) {
                    requestAnimationFrame(() => t.dispatchEvent(new Event("click")));
                }
                destroyQuickViewPopup() {
                    var t, e;
                    const i = null === (t = this.quickViewPopup) || void 0 === t || null === (e = t.loadPhotoswipe) || void 0 === e ? void 0 : e.pswpElement;
                    i && i.classList.contains(_f) && this.quickViewPopup.loadPhotoswipe.popup.close();
                }
                onBlockSelect(t) {
                    this.debouncedBlockSelectCallback(t);
                }
                debouncedBlockSelect(t) {
                    var e, i;
                    const s = null === (e = this.quickViewPopup) || void 0 === e || null === (i = e.loadPhotoswipe) || void 0 === i ? void 0 : i.pswpElement;
                    s
                        ? setTimeout(() => {
                              if (s.classList.contains(_f)) {
                                  const e = this.quickViewPopup.loadPhotoswipe.pswpElement.querySelector(`[${Ff}="${t.target.getAttribute(Ff)}"]`),
                                      i = this.quickViewPopup.loadPhotoswipe.pswpElement.querySelectorAll(Tf);
                                  e.classList.add(zf),
                                      i.forEach((t) => {
                                          t !== e && t.classList.remove(zf);
                                      });
                              } else this.triggerClick(t.target);
                          })
                        : setTimeout(() => this.triggerClick(t.target), 400);
                }
                onUnload() {
                    this.destroyQuickViewPopup(), document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize), this.slider && this.slider.removeEventListener("theme:slider:resize", this.resizeSliderEvent);
                }
                onDeselect() {
                    this.destroyQuickViewPopup();
                }
                constructor(t) {
                    (this.container = t),
                        (this.slider = this.container.querySelector(kf)),
                        (this.slides = this.container.querySelectorAll(Af)),
                        (this.pointers = this.container.querySelectorAll(Cf)),
                        (this.flkty = null),
                        (this.observer = null),
                        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
                        (this.resizeSliderEvent = (t) => this.resizeSlider(t)),
                        (this.pointersInit = (t) => this.dotPointers(t)),
                        (this.pointersOver = (t) => this.dotPointerIn(t)),
                        (this.pointersOut = (t) => this.dotPointerOut(t)),
                        (this.debouncedBlockSelectCallback = o((t) => this.debouncedBlockSelect(t), 500)),
                        (this.quickViewPopup = new eh(this.container)),
                        this.listen();
                }
            })(this.container);
        },
        onUnload() {
            Lf[this.id].onUnload();
        },
        onBlockSelect(t) {
            Lf[this.id].onBlockSelect(t);
        },
        onDeselect() {
            Lf[this.id].onDeselect();
        },
    };
    I("look", [$f]);
    const Rf = "[data-grid]";
    I("mosaic", {
        onBlockSelect(t) {
            const e = t.target.closest(Rf),
                i = e.currentStyle || window.getComputedStyle(e),
                s = parseInt(i.paddingLeft),
                o = t.target.offsetLeft - s;
            e.scrollTo({ top: 0, left: o, behavior: "smooth" });
        },
    }),
        I("newsletter", ng),
        I("overlapping-images", [Dp, uu]);
    const Vf = "[data-toggle-admin]",
        Nf = "[data-toggle-newsletter]",
        Wf = "[data-form-admin]",
        Uf = "[data-form-newsletter]";
    let jf = {};
    I("password-template", {
        onLoad() {
            jf[this.id] = new (class {
                init() {
                    this.toggleAdmin.addEventListener("click", (t) => {
                        t.preventDefault(), this.showPasswordForm();
                    }),
                        this.toggleNewsletter.addEventListener("click", (t) => {
                            t.preventDefault(), this.hidePasswordForm();
                        }),
                        "#login" == window.location.hash || this.adminErrors ? this.showPasswordForm() : this.hidePasswordForm();
                }
                showPasswordForm() {
                    Hr(this.adminForm), Fr(this.newsletterForm), (window.location.hash = "#login");
                }
                hidePasswordForm() {
                    Hr(this.newsletterForm), Fr(this.adminForm), (window.location.hash = "");
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.toggleAdmin = this.container.querySelector(Vf)),
                        (this.toggleNewsletter = this.container.querySelector(Nf)),
                        (this.adminForm = this.container.querySelector(Wf)),
                        (this.newsletterForm = this.container.querySelector(Uf)),
                        (this.adminErrors = this.adminForm.querySelector(".errors")),
                        (this.newsletterErrors = this.newsletterForm.querySelector(".errors")),
                        this.init();
                }
            })(this);
        },
    });
    const Gf = "[data-large-promo]",
        Kf = "[data-large-promo-inner]",
        Qf = "[data-tracking-consent]",
        Xf = "[data-tracking-consent-inner]",
        Yf = "[data-confirm-cookies]",
        Jf = "[data-popup-bar]",
        Zf = "[data-popup-bar-holder]",
        ty = "[data-popup-bar-toggle]",
        ey = "[data-popup-body]",
        iy = "[data-popup-close]",
        sy = "[data-popup-underlay]",
        oy = "[data-newsletter-form]",
        ny = "data-target-referrer",
        ry = "data-prevent-scroll-lock",
        ay = "has-success",
        ly = "has-error",
        cy = "selected",
        hy = "has-block-selected",
        dy = "popup--expanded",
        uy = "popup--visible",
        py = "mobile",
        my = "desktop",
        gy = "popup--bar",
        fy = "popup-bar-is-visible";
    let yy = {},
        vy = 0,
        by = 0,
        wy = [],
        Sy = class {
            always() {
                this.showPopup();
            }
            delayed(t = 10) {
                setTimeout(() => {
                    this.showPopup();
                }, 1e3 * t);
            }
            bottom() {
                document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
            }
            idle() {
                if (!(!0 === this.checkPopupTarget())) return;
                let t = 0;
                const e = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                    i = ["load", "resize", "scroll"],
                    s = () => {
                        (t = setTimeout(() => {
                            (t = 0), this.showPopup();
                        }, 6e4)),
                            e.forEach((t) => {
                                document.addEventListener(t, o);
                            }),
                            i.forEach((t) => {
                                window.addEventListener(t, o);
                            });
                    },
                    o = () => {
                        t && clearTimeout(t),
                            e.forEach((t) => {
                                document.removeEventListener(t, o);
                            }),
                            i.forEach((t) => {
                                window.removeEventListener(t, o);
                            }),
                            s();
                    };
                s();
            }
            showPopup() {
                const t = { id: this.popup.id, body: this.popupBody };
                wy.push(t);
                if (!0 === this.checkPopupTarget()) {
                    if (((by += 1), this.popup.classList.add(uy), this.popup.classList.contains(gy) && document.body.classList.add(fy), this.a11y.trapFocus({ container: this.popupBody }), this.popup.hasAttribute(ry))) return !1;
                    this.scrollLock();
                }
            }
            checkPopupTarget() {
                const t = this.popup.parentNode.classList.contains(py),
                    e = this.popup.parentNode.classList.contains(my);
                return !((t && window.innerWidth >= theme.sizes.small) || (e && window.innerWidth < theme.sizes.small));
            }
            scrollLock() {
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.popupBody }));
            }
            showPopupOnScroll() {
                window.scrollY + window.innerHeight >= document.body.clientHeight && (this.showPopup(), document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent));
            }
            onUnload() {
                document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent);
            }
            constructor(t, e) {
                if (
                    ((this.popupContainer = t),
                    (this.popup = e),
                    (this.popupBody = e.querySelector(ey)),
                    (this.delay = t.dataset.popupDelay),
                    (this.isSubmitted = -1 !== window.location.href.indexOf("accepts_marketing") || -1 !== window.location.href.indexOf("customer_posted=true")),
                    (this.a11y = Ke),
                    (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
                    ("always" === this.delay || this.isSubmitted) && this.always(),
                    this.delay && this.delay.includes("delayed") && !this.isSubmitted)
                ) {
                    const t = this.delay.includes("_") ? parseInt(this.delay.split("_")[1]) : 10;
                    this.delayed(t);
                }
                "bottom" !== this.delay || this.isSubmitted || this.bottom(), "idle" !== this.delay || this.isSubmitted || this.idle();
            }
        },
        Ey = class {
            constructor(t) {
                if (((this.popupContainer = t), (this.locationPath = location.href), !this.popupContainer.hasAttribute(ny))) return !1;
                -1 !== this.locationPath.indexOf(this.popupContainer.getAttribute(ny)) || window.Shopify.designMode || this.popupContainer.parentNode.removeChild(this.popupContainer);
            }
        };
    I("popups", [
        {
            onLoad() {
                (yy[this.id] = []), window.Shopify.designMode && (by = 0);
                const t = this.container.querySelectorAll(Gf);
                t.length &&
                    t.forEach((t) => {
                        yy[this.id].push(
                            new (class {
                                init() {
                                    (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                                        (window.Shopify.designMode ? this.showPopup() : new Sy(this.popupContainer, this.popup),
                                        this.form &&
                                            setTimeout(() => {
                                                this.form.classList.contains(ay) && (this.showPopupIfNoCookie(), (by -= 1));
                                            }),
                                        this.initClosers());
                                }
                                checkPopupTarget() {
                                    const t = this.popup.parentNode.classList.contains(py),
                                        e = this.popup.parentNode.classList.contains(my);
                                    return !((t && window.innerWidth >= theme.sizes.small) || (e && window.innerWidth < theme.sizes.small));
                                }
                                showPopupIfNoCookie() {
                                    this.showPopup();
                                }
                                initClosers() {
                                    this.close.addEventListener("click", this.closePopup.bind(this)),
                                        this.underlay.addEventListener("click", this.closePopup.bind(this)),
                                        this.popupContainer.addEventListener("keyup", (t) => {
                                            t.code === theme.keyboardKeys.ESCAPE && this.closePopup(t);
                                        });
                                }
                                closePopup(t) {
                                    t.preventDefault(), this.hidePopup(), this.cookie.write();
                                }
                                scrollLock() {
                                    this.resetScrollUnlock(), this.a11y.trapFocus({ container: this.popupBody }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.popupBody }));
                                }
                                scrollUnlock() {
                                    this.resetScrollUnlock(),
                                        (vy = setTimeout(() => {
                                            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                                        }, 300));
                                }
                                resetScrollUnlock() {
                                    vy && clearTimeout(vy);
                                }
                                showPopup() {
                                    const t = !0 === this.checkPopupTarget(),
                                        e = { id: this.popupId, body: this.popup };
                                    wy.push(e), t && ((by += 1), this.popup.classList.add(uy), this.scrollLock());
                                }
                                hidePopup() {
                                    this.popup.classList.remove(uy);
                                    const t = wy.findIndex((t) => t.id === this.popupId);
                                    if (((by -= 1), wy.splice(t, 1), 1 == by && document.body.classList.contains(fy))) this.scrollUnlock();
                                    else if (by < 1) this.scrollUnlock(), this.a11y.removeTrapFocus();
                                    else if (wy.length > 0) {
                                        const t = wy[wy.length - 1].body;
                                        this.a11y.trapFocus({ container: t });
                                    }
                                }
                                onBlockSelect(t) {
                                    this.popupContainer.contains(t.target) && !this.popup.classList.contains(uy) && (this.popup.classList.add(cy), this.popupContainer.classList.add(hy), this.showPopup());
                                }
                                onBlockDeselect(t) {
                                    this.popupContainer.contains(t.target) && (this.popup.classList.remove(cy), this.popupContainer.classList.remove(hy), this.hidePopup());
                                }
                                onUnload() {
                                    this.scrollUnlock();
                                }
                                onDeselect() {
                                    this.popup.classList.remove(cy), this.popupContainer.classList.remove(hy), this.hidePopup();
                                }
                                constructor(t) {
                                    (this.popupContainer = t),
                                        (this.popup = this.popupContainer.querySelector(Kf)),
                                        (this.popupBody = this.popup.querySelector(ey)),
                                        (this.popupId = this.popup.id),
                                        (this.close = this.popup.querySelector(iy)),
                                        (this.underlay = this.popup.querySelector(sy)),
                                        (this.form = this.popup.querySelector(oy)),
                                        (this.cookie = new Jm(this.popupContainer.dataset.cookieName, "user_has_closed")),
                                        (this.isTargeted = new Ey(this.popupContainer)),
                                        (this.a11y = Ke),
                                        this.init();
                                }
                            })(t)
                        );
                    });
                const e = this.container.querySelectorAll(Jf);
                e.length &&
                    e.forEach((t) => {
                        yy[this.id].push(
                            new (class {
                                init() {
                                    (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                                        (window.Shopify.designMode ? this.showPopup() : new Sy(this.popupContainer, this.popup),
                                        this.initPopupToggleButton(),
                                        this.initClosers(),
                                        this.form &&
                                            setTimeout(() => {
                                                this.form.classList.contains(ay) && this.showPopupIfNoCookie(), this.form.classList.contains(ly) && this.toggle.dispatchEvent(new Event("click"));
                                            }));
                                }
                                checkPopupTarget() {
                                    const t = this.popup.parentNode.classList.contains(py),
                                        e = this.popup.parentNode.classList.contains(my);
                                    return !((t && window.innerWidth >= theme.sizes.small) || (e && window.innerWidth < theme.sizes.small));
                                }
                                showPopupIfNoCookie() {
                                    this.showPopup(), this.toggle.dispatchEvent(new Event("click"));
                                }
                                initPopupToggleButton() {
                                    this.toggle.addEventListener("click", (t) => {
                                        t.preventDefault(), this.popup.classList.toggle(dy), this.popup.classList.contains(dy) ? this.scrollLock() : this.scrollUnlock();
                                    });
                                }
                                showPopup() {
                                    const t = { id: this.popupId, body: this.popup };
                                    wy.push(t), this.a11y.trapFocus({ container: this.popupBody }), !0 === this.checkPopupTarget() && ((by += 1), document.body.classList.add(fy), this.popup.classList.add(uy));
                                }
                                hidePopup() {
                                    this.popup.classList.remove(uy), document.body.classList.remove(fy);
                                    const t = wy.findIndex((t) => t.id === this.popupId);
                                    if ((wy.splice(t, 1), by >= 1 && (by -= 1), by < 1)) this.scrollUnlock(), this.a11y.removeTrapFocus();
                                    else if (wy.length > 0) {
                                        const t = wy[wy.length - 1].body;
                                        this.a11y.trapFocus({ container: t });
                                    }
                                }
                                initClosers() {
                                    this.close.addEventListener("click", this.closePopup.bind(this)),
                                        this.underlay.addEventListener("click", () => this.toggle.dispatchEvent(new Event("click"))),
                                        this.popupContainer.addEventListener("keyup", (t) => {
                                            t.code === theme.keyboardKeys.ESCAPE && (this.popup.classList.remove(dy), this.scrollUnlock());
                                        });
                                }
                                closePopup(t) {
                                    t.preventDefault(), this.cookie.write(), this.hidePopup();
                                }
                                scrollLock() {
                                    document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.popupBody }));
                                }
                                scrollUnlock() {
                                    this.resetScrollUnlock(),
                                        (vy = setTimeout(() => {
                                            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                                        }, 300));
                                }
                                resetScrollUnlock() {
                                    vy && clearTimeout(vy);
                                }
                                onBlockSelect(t) {
                                    this.popupContainer.contains(t.target) &&
                                        !this.popup.classList.contains(uy) &&
                                        (this.showPopup(), this.popup.classList.add(dy), this.popup.classList.add(cy), this.popup.parentNode.classList.add(hy), this.resetScrollUnlock(), this.scrollLock());
                                }
                                onBlockDeselect(t) {
                                    this.popupContainer.contains(t.target) && (this.popup.classList.remove(dy), this.popup.classList.remove(cy), this.popup.parentNode.classList.remove(hy), this.hidePopup());
                                }
                                onUnload() {
                                    this.scrollUnlock();
                                }
                                onDeselect() {
                                    this.popup.classList.remove(dy), this.popup.classList.remove(cy), this.popup.parentNode.classList.remove(hy), this.hidePopup();
                                }
                                constructor(t) {
                                    (this.popupContainer = t),
                                        (this.popup = this.popupContainer.querySelector(Zf)),
                                        (this.popupBody = this.popup.querySelector(ey)),
                                        (this.popupId = this.popup.id),
                                        (this.close = this.popup.querySelector(iy)),
                                        (this.underlay = this.popup.querySelector(sy)),
                                        (this.toggle = this.popup.querySelector(ty)),
                                        (this.cookie = new Jm(this.popupContainer.dataset.cookieName, "user_has_closed")),
                                        (this.form = this.popup.querySelector(oy)),
                                        (this.isTargeted = new Ey(this.popupContainer)),
                                        (this.a11y = Ke),
                                        this.init();
                                }
                            })(t)
                        );
                    });
                const i = this.container.querySelectorAll(Qf);
                i.length &&
                    i.forEach((t) => {
                        yy[this.id].push(
                            new (class {
                                init() {
                                    this.enableTracking && this.showPopup(), this.clickEvents();
                                }
                                clickEvents() {
                                    this.close.addEventListener("click", (t) => {
                                        t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!1, () => this.hidePopup());
                                    }),
                                        this.acceptButton.addEventListener("click", (t) => {
                                            t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!0, () => this.hidePopup());
                                        }),
                                        document.addEventListener("trackingConsentAccepted", () => {
                                            console.log("trackingConsentAccepted event fired");
                                        });
                                }
                                showPopup() {
                                    const t = { id: this.popupId, body: this.popup };
                                    wy.push(t), this.popup.classList.add(uy), this.a11y.trapFocus({ container: this.popup });
                                }
                                hidePopup() {
                                    this.popup.classList.remove(uy);
                                    const t = wy.findIndex((t) => t.id === this.popupId);
                                    if ((wy.splice(t, 1), by < 1)) this.a11y.removeTrapFocus();
                                    else if (wy.length > 0) {
                                        const t = wy[wy.length - 1].body;
                                        this.a11y.trapFocus({ container: t });
                                    }
                                }
                                onBlockSelect(t) {
                                    this.popupContainer.contains(t.target) && this.enableTracking && !this.popup.classList.contains(uy) && (this.showPopup(), this.popup.classList.add(cy), this.popup.parentNode.classList.add(hy));
                                }
                                onBlockDeselect(t) {
                                    this.popupContainer.contains(t.target) && (this.popup.classList.remove(cy), this.popupContainer.classList.remove(hy), this.hidePopup());
                                }
                                onDeselect() {
                                    this.popup.classList.remove(cy), this.popupContainer.classList.remove(hy), this.hidePopup();
                                }
                                constructor(t) {
                                    (this.popupContainer = t),
                                        (this.popup = this.popupContainer.querySelector(Xf)),
                                        (this.popupId = this.popup.id),
                                        (this.close = this.popup.querySelector(iy)),
                                        (this.acceptButton = this.popup.querySelector(Yf)),
                                        (this.enable = "true" === this.popupContainer.dataset.enable),
                                        (this.a11y = Ke),
                                        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (t) => {
                                            if (t) throw t;
                                            const e = window.Shopify.customerPrivacy.userCanBeTracked(),
                                                i = window.Shopify.customerPrivacy.getTrackingConsent();
                                            (this.enableTracking = !e && "no_interaction" === i && this.enable), window.Shopify.designMode && (this.enableTracking = !0), this.init();
                                        });
                                }
                            })(t)
                        );
                    });
            },
            onDeselect() {
                yy[this.id].forEach((t) => {
                    "function" == typeof t.onDeselect && t.onDeselect();
                });
            },
            onBlockSelect(t) {
                yy[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                yy[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
            onUnload(t) {
                yy[this.id].forEach((e) => {
                    "function" == typeof e.onUnload && e.onUnload(t);
                });
            },
        },
        ng,
    ]);
    const Ly = "[data-press-items]",
        ky = "[data-logo-slider]",
        Ay = "[data-logo-slide]",
        Cy = "a, button",
        qy = "data-logo-index",
        Ty = "tabindex";
    let Py = {};
    const xy = {
        onLoad() {
            Py[this.id] = new (class {
                checkSlides() {
                    const t = this.container.offsetWidth,
                        i = this.container.querySelectorAll(Ay),
                        s = e.data(this.sliderNav) || null;
                    null !== s &&
                        ((s.options.draggable = !1),
                        (s.options.wrapAround = !1),
                        (s.options.contain = !0),
                        this.getSlidesWidth() > t && i.length > 2 && ((s.options.draggable = !0), (s.options.wrapAround = !0), (s.options.contain = !1)),
                        s.resize(),
                        s.updateDraggable());
                }
                getSlidesWidth() {
                    const t = this.container.querySelectorAll(Ay);
                    let e = 0;
                    return (
                        t.length &&
                            t.forEach((t) => {
                                e += t.offsetWidth;
                            }),
                        e
                    );
                }
                initSlider() {
                    let t = e.data(this.slider) || null,
                        i = e.data(this.sliderNav) || null;
                    const s = parseInt(this.container.dataset.duration),
                        o = "true" === this.container.dataset.autoplay && s;
                    (t = new e(this.slider, { fade: !0, wrapAround: !0, adaptiveHeight: !1, prevNextButtons: !1, pageDots: !1, autoPlay: o })),
                        (i = new e(this.sliderNav, {
                            draggable: !1,
                            wrapAround: !1,
                            contain: !0,
                            imagesLoaded: !0,
                            asNavFor: this.slider,
                            prevNextButtons: !1,
                            adaptiveHeight: !1,
                            pageDots: !1,
                            on: {
                                ready: () => {
                                    this.container.querySelectorAll(Ay).forEach((e) => {
                                        e.addEventListener("keyup", (i) => {
                                            if (i.code === theme.keyboardKeys.ENTER || i.code === theme.keyboardKeys.NUMPADENTER || i.code === theme.keyboardKeys.SPACE) {
                                                const i = Number(e.getAttribute(qy));
                                                t.selectCell(i);
                                            }
                                        });
                                    });
                                },
                            },
                        })),
                        vi(this.slider),
                        vi(this.sliderNav),
                        i.on("change", (e) => {
                            t.selectCell(e);
                        }),
                        t.on("change", (e) => {
                            i.selectCell(e),
                                t.cells.forEach((t, i) => {
                                    t.element.querySelectorAll(Cy).forEach((t) => {
                                        t.setAttribute(Ty, i === e ? "0" : "-1");
                                    });
                                });
                        });
                }
                resizeSlider() {
                    const t = e.data(this.slider);
                    t && t.resize();
                }
                onBlockSelect(t) {
                    const i = e.data(this.slider) || null,
                        s = e.data(this.sliderNav) || null,
                        o = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    null !== i && (i.select(o), i.pausePlayer()), null !== s && s.select(o);
                }
                onBlockDeselect() {
                    const t = e.data(this.slider) || null;
                    "true" === this.container.dataset.autoplay && null !== t && t.playPlayer();
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.sliderResizeEvent);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.slider = this.container.querySelector(Ly)),
                        (this.sliderNav = this.container.querySelector(ky)),
                        (this.sliderResizeEvent = () => this.checkSlides()),
                        this.initSlider(),
                        this.checkSlides(),
                        window.addEventListener("load", this.resizeSlider.bind(this)),
                        document.addEventListener("theme:resize:width", this.sliderResizeEvent);
                }
            })(this);
        },
        onUnload(t) {
            Py[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            Py[this.id].onBlockSelect(t);
        },
        onBlockDeselect() {
            Py[this.id].onBlockDeselect();
        },
    };
    I("press", xy);
    const Iy = "[data-product-single-media-slider]",
        Hy = "[data-product-info]",
        Fy = "[data-header-sticky]",
        My = "[data-header-height]",
        Dy = "is-sticky",
        Oy = "data-sticky-enabled";
    window.theme.variables = { productPageSticky: !1 };
    const By = {};
    const zy = {
            onLoad() {
                By[this.id] = new (class {
                    init() {
                        this.stickyEnabled && (this.stickyScrollCheck(), document.addEventListener("theme:resize", this.resizeEvent)), this.initSticky();
                    }
                    initSticky() {
                        theme.variables.productPageSticky &&
                            ((this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition())),
                            this.productInfo.addEventListener("theme:form:sticky", (t) => {
                                this.removeAnimationFrame(), (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(t)));
                            }),
                            document.addEventListener("theme:scroll", this.scrollEvent));
                    }
                    scrollEvents(t) {
                        null !== t.detail && ((this.scrollTop = t.detail.position), (this.scrollDirectionDown = t.detail.down)),
                            this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition()));
                    }
                    resizeEvents() {
                        this.stickyScrollCheck(), document.removeEventListener("theme:scroll", this.scrollEvent), this.initSticky();
                    }
                    stickyScrollCheck() {
                        const t = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) >= window.theme.sizes.large,
                            e = this.container.querySelector(Hy);
                        if (e)
                            if (t) {
                                const t = this.container.querySelector(Hy),
                                    i = this.container.querySelector(Iy);
                                if (!t || !i) return;
                                t.offsetHeight < i.offsetHeight ? ((theme.variables.productPageSticky = !0), e.classList.add(Dy)) : ((theme.variables.productPageSticky = !1), e.classList.remove(Dy));
                            } else (theme.variables.productPageSticky = !1), e.classList.remove(Dy);
                    }
                    calculateStickyPosition(t = null) {
                        const e = Boolean(t && t.detail),
                            i = Boolean(e && t.detail.element && "accordion" === t.detail.element),
                            s = this.productInfo.offsetHeight,
                            o = window.innerHeight - s - this.defaultTopBottomSpacings,
                            n = Math.abs(this.scrollTop - this.scrollLastPosition);
                        this.scrollDirectionDown ? (this.stickyScrollTop -= n) : (this.stickyScrollTop += n),
                            this.stickyFormLoad &&
                                (document.querySelector(Fy) && document.querySelector(My)
                                    ? (this.stickyDefaultTop = parseInt(document.querySelector(My).getBoundingClientRect().height))
                                    : (this.stickyDefaultTop = this.defaultTopBottomSpacings),
                                (this.stickyScrollTop = this.stickyDefaultTop)),
                            (this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, o), this.stickyDefaultTop));
                        const r = this.stickyScrollTop - this.currentPoint;
                        (this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + 0.5 * r),
                            this.productInfo.style.setProperty("--sticky-top", `${this.currentPoint}px`),
                            (this.scrollLastPosition = this.scrollTop),
                            (this.stickyFormLoad = !1),
                            (i && this.onChangeCounter <= 10) || (i && this.stickyFormLastHeight !== s) || (this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky)
                                ? (i && (this.onChangeCounter += 1), i && this.stickyFormLastHeight !== s && (this.onChangeCounter = 11), (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(t))))
                                : this.requestAnimationSticky && this.removeAnimationFrame(),
                            (this.stickyFormLastHeight = s);
                    }
                    removeAnimationFrame() {
                        this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), (this.requestAnimationSticky = null), (this.onChangeCounter = 0));
                    }
                    onUnload() {
                        this.stickyEnabled && document.removeEventListener("theme:resize", this.resizeEvent), theme.variables.productPageSticky && document.removeEventListener("theme:scroll", this.scrollEvent);
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.stickyEnabled = "true" === this.container.getAttribute(Oy)),
                            (this.productInfo = this.container.querySelector(Hy)),
                            (this.stickyScrollTop = 0),
                            (this.scrollLastPosition = 0),
                            (this.stickyDefaultTop = 0),
                            (this.currentPoint = 0),
                            (this.defaultTopBottomSpacings = 30),
                            (this.scrollTop = window.scrollY),
                            (this.scrollDirectionDown = !0),
                            (this.requestAnimationSticky = null),
                            (this.stickyFormLoad = !0),
                            (this.stickyFormLastHeight = null),
                            (this.onChangeCounter = 0),
                            (this.scrollEvent = (t) => this.scrollEvents(t)),
                            (this.resizeEvent = (t) => this.resizeEvents(t)),
                            this.init();
                    }
                })(this);
            },
            onUnload() {
                By[this.id].onUnload();
            },
        },
        _y = "[data-product-single-media-group]",
        $y = "[data-product-single-media-slider]",
        Ry = "[data-zoom-wrapper]",
        Vy = "pswp-zoom-gallery",
        Ny = "pswp-zoom-gallery--single",
        Wy = "is-moving",
        Uy = "data-image-width",
        jy = "data-image-height";
    const Gy = "[data-complementary-products]",
        Ky = "[data-button-quick-view]",
        Qy = "data-url";
    let Xy = class extends HTMLElement {
        connectedCallback() {
            new IntersectionObserver(
                ((t, e) => {
                    t[0].isIntersecting &&
                        (e.unobserve(this),
                        this.hasAttribute(Qy) &&
                            "" !== this.getAttribute(Qy) &&
                            fetch(this.getAttribute(Qy))
                                .then((t) => t.text())
                                .then((t) => {
                                    const e = document.createElement("div");
                                    e.innerHTML = t;
                                    const i = e.querySelector(Gy);
                                    i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML), e.querySelector(Ky) && new eh(this);
                                })
                                .catch((t) => {
                                    console.error(t);
                                }));
                }).bind(this),
                { rootMargin: "0px 0px 400px 0px" }
            ).observe(this);
        }
        constructor() {
            super();
        }
    };
    const Yy = "[data-recipient-checkbox]",
        Jy = "[data-recipient-email]",
        Zy = "[data-recipient-name]",
        tv = "[data-recipient-message]",
        ev = "[data-recipient-send-on]",
        iv = "[data-recipient-control]",
        sv = "[data-recipient-offset]",
        ov = "[data-product-form]",
        nv = "[data-cart-drawer]",
        rv = "js-quick-view-visible";
    let av = class extends HTMLElement {
        connectedCallback() {
            this.recipientCheckbox && (this.disableInputFields(), this.recipientCheckbox.addEventListener("change", this.onChangeEvent), document.addEventListener("theme:cart:added", this.onCartAddedEvent));
        }
        onChange(t) {
            if (!t.target.checked) return this.clearInputFields(), void this.disableInputFields();
            this.enableInputFields();
        }
        onCartAdded() {
            const t = this.closest(ov).offsetTop,
                e = document.body.classList.contains(rv);
            if (!(!0 === this.recipientCheckbox.checked)) return;
            e || window.scrollTo({ top: t, left: 0, behavior: "smooth" });
            const i = (t) => {
                t.target === this.cartDrawer &&
                    (requestAnimationFrame(() => {
                        (this.recipientCheckbox.checked = !1), this.recipientCheckbox.dispatchEvent(new Event("change"));
                    }),
                    this.cartDrawer.removeEventListener("transitionend", i));
            };
            this.cartDrawer.addEventListener("transitionend", i);
        }
        inputFields() {
            return [this.recipientEmail, this.recipientName, this.recipientMessage, this.recipientSendOn];
        }
        disableableFields() {
            return [...this.inputFields(), this.recipientOffset];
        }
        clearInputFields() {
            this.inputFields().forEach((t) => (t.value = ""));
        }
        enableInputFields() {
            this.disableableFields().forEach((t) => (t.disabled = !1));
        }
        disableInputFields() {
            this.disableableFields().forEach((t) => (t.disabled = !0));
        }
        disconnectedCallback() {
            this.recipientCheckbox.removeEventListener("change", this.onChangeEvent), document.removeEventListener("theme:cart:added", this.onCartAddedEvent);
        }
        constructor() {
            super(),
                (this.recipientCheckbox = this.querySelector(Yy)),
                (this.recipientControl = this.querySelector(iv)),
                (this.recipientControl.disabled = !0),
                (this.recipientEmail = this.querySelector(Jy)),
                (this.recipientName = this.querySelector(Zy)),
                (this.recipientMessage = this.querySelector(tv)),
                (this.recipientSendOn = this.querySelector(ev)),
                (this.recipientOffset = this.querySelector(sv)),
                this.recipientOffset && (this.recipientOffset.value = new Date().getTimezoneOffset()),
                (this.cartDrawer = document.querySelector(nv)),
                (this.onChangeEvent = (t) => this.onChange(t)),
                (this.onCartAddedEvent = () => this.onCartAdded());
        }
    };
    const lv = "[data-product-single-media-slider]",
        cv = "[data-thumbnail-id]",
        hv = "[data-product-single-media-thumbs]",
        dv = "[data-product-single-media-wrapper]",
        uv = "[data-model]",
        pv = ".product-single__thumbnail-link",
        mv = "[data-deferred-media]",
        gv = "[data-deferred-media-button]",
        fv = "[data-product-rating]",
        yv = "#shopify-product-reviews",
        vv = "a, button",
        bv = "[data-upsell-holder]",
        wv = "[data-upsell-slider]",
        Sv = "[data-slider]",
        Ev = "[data-product-json]",
        Lv = "featured-product",
        kv = "featured-product--onboarding",
        Av = "has-media-active",
        Cv = "is-selected",
        qv = "media--hidden",
        Tv = "no-outline",
        Pv = "is-moving",
        xv = "data-media-id",
        Iv = "data-section-id",
        Hv = "data-thumbnail-id",
        Fv = "data-tall-layout",
        Mv = "loaded",
        Dv = "tabindex",
        Ov = {};
    const Bv = {
        onLoad() {
            Ov[this.id] = new (class {
                productSlider() {
                    this.checkSlider(), document.addEventListener("theme:resize:width", this.checkSliderOnResize);
                }
                checkSlider() {
                    !this.tallLayout || window.innerWidth < theme.sizes.large ? this.initProductSlider() : this.destroyProductSlider();
                }
                resizeFlickityNav() {
                    null !== this.flktyNav && this.flktyNav.resize();
                }
                initProductSlider() {
                    const t = this.container.querySelector(lv),
                        i = this.container.querySelector(hv),
                        s = this.container.querySelectorAll(dv);
                    if (
                        s.length > 1 &&
                        ((this.flkty = new e(t, {
                            wrapAround: !0,
                            pageDots: !1,
                            adaptiveHeight: !0,
                            on: {
                                ready: () => {
                                    t.setAttribute(Dv, "-1"),
                                        s.forEach((t) => {
                                            if (!t.classList.contains(Cv)) {
                                                const e = t.querySelectorAll(vv);
                                                e.length &&
                                                    e.forEach((t) => {
                                                        t.setAttribute(Dv, "-1");
                                                    });
                                            }
                                        });
                                },
                                dragStart: () => {
                                    t.classList.add(Pv);
                                },
                                dragMove: () => {
                                    this.isFlickityDragging = !0;
                                },
                                staticClick: () => {
                                    this.isFlickityDragging = !1;
                                },
                                settle: (e) => {
                                    const i = this.flkty.selectedElement.getAttribute(xv);
                                    this.flkty.cells.forEach((t, i) => {
                                        const s = t.element.querySelectorAll(vv);
                                        s.length &&
                                            s.forEach((t) => {
                                                t.setAttribute(Dv, i === e ? "0" : "-1");
                                            });
                                    }),
                                        this.switchMedia(i),
                                        t.classList.remove(Pv);
                                },
                            },
                        })),
                        s.length &&
                            s.forEach((t) => {
                                t.addEventListener("theme:media:play", () => {
                                    (this.flkty.options.draggable = !1), this.flkty.updateDraggable(), t.closest(lv).classList.add(Av);
                                }),
                                    t.addEventListener("theme:media:pause", () => {
                                        (this.flkty.options.draggable = !0), this.flkty.updateDraggable(), t.closest(lv).classList.remove(Av);
                                    });
                            }),
                        vi(t),
                        null !== i)
                    ) {
                        (this.flktyNav = new e(i, {
                            asNavFor: t,
                            contain: !0,
                            pageDots: !1,
                            prevNextButtons: !1,
                            resize: !0,
                            on: {
                                ready: () => {
                                    i.setAttribute(Dv, "-1");
                                },
                            },
                        })),
                            null !== this.flktyNav && document.addEventListener("theme:resize:width", this.flktyNavOnResize),
                            vi(i);
                        const s = this.container.querySelectorAll(pv);
                        s.length &&
                            s.forEach((t) => {
                                t.addEventListener("click", (t) => {
                                    t.preventDefault();
                                });
                            });
                    }
                }
                destroyProductSlider() {
                    null !== this.flkty && (this.flkty.destroy(), this.flktyNav.destroy(), (this.flkty = null), (this.flktyNav = null));
                }
                initUpsellSlider() {
                    const t = this.container.querySelector(wv);
                    if (this.container.querySelectorAll(bv).length > 1) {
                        const i = new e(t, { wrapAround: !0, pageDots: !0, adaptiveHeight: !0, prevNextButtons: !1 });
                        i.on("change", (t) => {
                            i.cells.forEach((e, i) => {
                                const s = e.element.querySelectorAll(vv);
                                s.length &&
                                    s.forEach((e) => {
                                        e.setAttribute(Dv, i === t ? "0" : "-1");
                                    });
                            });
                        });
                    }
                }
                initFeatureSlider() {
                    this.featureSliders.forEach((t) => {
                        Array.from(t.children).length > 1 && (this.flktyFeature = new e(t, { wrapAround: !0, pageDots: !0, adaptiveHeight: !0, prevNextButtons: !1 }));
                    });
                }
                handleMediaFocus(t) {
                    if (t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.TAB) return;
                    const i = t.currentTarget.getAttribute(Hv),
                        s = this.container.querySelector(`[${xv}="${i}"]`),
                        o = parseInt([...s.parentNode.children].indexOf(s)),
                        n = this.container.querySelector(lv),
                        r = this.container.querySelector(hv),
                        a = e.data(n) || null,
                        l = e.data(r) || null;
                    a && a.isActive && o > -1 && (t.code === theme.keyboardKeys.ENTER || t.code === theme.keyboardKeys.NUMPADENTER) && a.select(o), l && l.isActive && o > -1 && l.select(o);
                }
                switchMedia(t) {
                    const e = document.querySelectorAll(`${dv}`),
                        i = this.container.querySelector(`${dv}[${xv}="${t}"]`),
                        s = !document.body.classList.contains(Tv);
                    e.length &&
                        e.forEach((t) => {
                            t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(qv);
                        }),
                        s && i.focus(),
                        i.closest(lv).classList.remove(Av),
                        i.classList.remove(qv),
                        i.dispatchEvent(new CustomEvent("theme:media:visible"), { bubbles: !0 });
                    const o = i.querySelector(mv);
                    o && "true" !== o.getAttribute(Mv) && i.querySelector(gv).dispatchEvent(new Event("click"));
                }
                initMediaSwitch() {
                    const t = this.container.querySelectorAll(cv);
                    t.length &&
                        t.forEach((t) => {
                            t.addEventListener("keyup", this.handleMediaFocus.bind(this)),
                                t.addEventListener("click", (t) => {
                                    t.preventDefault();
                                });
                        });
                }
                initProductVideo() {
                    this.videos = new Hi(this.container);
                }
                initProductModel() {
                    const t = this.container.querySelectorAll(uv);
                    t.length &&
                        t.forEach((t) => {
                            theme.ProductModel.init(t, this.sectionId);
                        });
                }
                initShopifyXrLaunch() {
                    document.addEventListener("shopify_xr_launch", () => {
                        this.container.querySelector(`${uv}:not(.${qv})`).dispatchEvent(new CustomEvent("xrLaunch"));
                    });
                }
                onUnload() {
                    null !== this.flktyNav && document.removeEventListener("theme:resize:width", this.flktyNavOnResize), document.removeEventListener("theme:resize:width", this.checkSliderOnResize);
                }
                scrollToReviews() {
                    const t = this.container.querySelector(fv);
                    t &&
                        ["click", "keydown"].forEach((e) => {
                            t.addEventListener(e, (t) => {
                                if ((t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER) || "click" != t.type) {
                                    const t = document.querySelector(yv);
                                    if (!t) return;
                                    t.scrollIntoView({ behavior: "smooth" });
                                }
                            });
                        });
                }
                onBlockSelect(t) {
                    const i = e.data(t.target.closest(Sv)),
                        s = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    i && i.select(s);
                }
                constructor(t) {
                    if (
                        ((this.container = t.container),
                        (this.sectionId = this.container.getAttribute(Iv)),
                        (this.tallLayout = "true" === this.container.getAttribute(Fv)),
                        (this.featureSliders = this.container.querySelectorAll(Sv)),
                        (this.flkty = null),
                        (this.flktyNav = null),
                        (this.isFlickityDragging = !1),
                        (this.enableHistoryState = !this.container.classList.contains(Lv)),
                        (this.checkSliderOnResize = () => this.checkSlider()),
                        (this.flktyNavOnResize = () => this.resizeFlickityNav()),
                        this.scrollToReviews(),
                        this.initUpsellSlider(),
                        this.initFeatureSlider(),
                        new eh(this.container),
                        this.container.classList.contains(kv))
                    )
                        return;
                    const e = this.container.querySelector(Ev);
                    if (e && e.innerHTML) {
                        const t = JSON.parse(e.innerHTML).handle;
                        let i = {};
                        t && (i = { handle: t }), Shopify.Products.recordRecentlyViewed(i);
                    } else Shopify.Products.recordRecentlyViewed();
                    new (class {
                        init() {
                            this.zoomWrappers.length &&
                                this.zoomWrappers.forEach((t, e) => {
                                    t.addEventListener("click", (i) => {
                                        i.preventDefault(), (this.slider && this.slider.classList.contains(Wy)) || ((this.a11y.state.trigger = t), this.createZoom(e));
                                    });
                                });
                        }
                        createZoom(t) {
                            const e = this;
                            let i = [],
                                s = 0;
                            this.zoomWrappers.forEach((o) => {
                                const n = o.getAttribute("href"),
                                    r = parseInt(o.getAttribute(Uy)),
                                    a = parseInt(o.getAttribute(jy));
                                if ((i.push({ src: n, w: r, h: a, msrc: n }), (s += 1), e.zoomWrappers.length === s)) {
                                    let e = `${Vy}`;
                                    1 === s && (e = `${Vy} ${Ny}`),
                                        new Oc(i, {
                                            barsSize: { top: 60, bottom: 60 },
                                            history: !1,
                                            focus: !1,
                                            index: t,
                                            mainClass: e,
                                            showHideOpacity: !0,
                                            showAnimationDuration: 250,
                                            hideAnimationDuration: 250,
                                            closeOnScroll: !1,
                                            closeOnVerticalDrag: !1,
                                            captionEl: !1,
                                            closeEl: !0,
                                            closeElClasses: ["caption-close"],
                                            tapToClose: !1,
                                            clickToCloseNonZoomable: !1,
                                            maxSpreadZoom: 2,
                                            loop: !0,
                                            spacing: 0,
                                            allowPanToNext: !0,
                                            pinchToClose: !1,
                                        });
                                }
                            });
                        }
                        constructor(t) {
                            (this.container = t),
                                (this.mediaContainer = this.container.querySelector(_y)),
                                (this.slider = this.container.querySelector($y)),
                                (this.zoomWrappers = this.container.querySelectorAll(Ry)),
                                (this.zoomEnable = "true" === this.mediaContainer.dataset.gallery),
                                (this.a11y = Ke),
                                this.zoomEnable && this.init();
                        }
                    })(this.container),
                        this.productSlider(),
                        this.initMediaSwitch(),
                        this.initProductVideo(),
                        this.initProductModel(),
                        this.initShopifyXrLaunch();
                }
            })(this);
        },
        onUnload: function () {
            Ov[this.id].onUnload();
        },
        onBlockSelect(t) {
            Ov[this.id].onBlockSelect(t);
        },
    };
    I("product-template", [nl, Bv, io, so, Hp, _e, Zi, Pl, Ir, zy]),
        I("featured-product", [nl, Bv, io, so, Hp, _e, Zi, Pl, Ir, zy]),
        customElements.get("complementary-products") || customElements.define("complementary-products", Xy),
        customElements.get("recipient-form") || customElements.define("recipient-form", av);
    const zv = "href",
        _v = "data-media-id",
        $v = "data-deferred-media-loaded",
        Rv = "[data-product-content-wrapper]",
        Vv = "[data-product-single-media-wrapper]",
        Nv = "[data-model]",
        Wv = "[data-product-link]",
        Uv = "[data-product-single-media-image]",
        jv = "[data-slider-contents]",
        Gv = "[data-slider-images]",
        Kv = "[data-tab-button]",
        Qv = "[data-tab-item]",
        Xv = "[data-circle-text]",
        Yv = { aosAnimate: "aos-animate", tabButtonActive: "products-list__nav__button--active", tabItemActive: "products-list__item--active", mediaHidden: "media--hidden", isDisabled: "is-disabled" },
        Jv = {};
    I("products-list", [
        {
            onLoad() {
                Jv[this.id] = new (class {
                    listen() {
                        (this.slidersImages.length > 0 || this.slidersContents.length > 0) && document.addEventListener("theme:resize", this.sliderResizeEvent);
                    }
                    resizeSlider() {
                        this.flktyImages.length > 0 &&
                            requestAnimationFrame(() => {
                                this.flktyImages.forEach((t) => t.resize());
                            }),
                            this.flktyContent.length > 0 &&
                                requestAnimationFrame(() => {
                                    this.flktyContent.forEach((t) => t.resize());
                                });
                    }
                    initButtons() {
                        this.tabButtons.length &&
                            this.tabButtons.forEach((t) => {
                                t.addEventListener("click", (e) => {
                                    if (t.classList.contains(Yv.tabButtonActive)) return;
                                    const i = t.getAttribute(zv),
                                        s = this.container.querySelector(i),
                                        o = s.querySelector(Vv),
                                        n = o ? o.dataset.mediaId : null,
                                        r = s.querySelector(Xv);
                                    this.tabButtons.forEach((t) => {
                                        t.classList.remove(Yv.tabButtonActive);
                                    }),
                                        this.tabItems.forEach((t) => {
                                            const e = t.querySelector(Xv);
                                            t.classList.remove(Yv.tabItemActive),
                                                null == e || e.classList.add(Yv.isDisabled),
                                                theme.settings.animationsEnabled &&
                                                    t.querySelectorAll(`.${Yv.aosAnimate}`).forEach((t) => {
                                                        t.classList.remove(Yv.aosAnimate),
                                                            setTimeout(() => {
                                                                t.classList.add(Yv.aosAnimate);
                                                            });
                                                    });
                                        }),
                                        t.classList.add(Yv.tabButtonActive),
                                        s.classList.add(Yv.tabItemActive),
                                        document.dispatchEvent(new CustomEvent("theme:resize")),
                                        r && (r.classList.remove(Yv.isDisabled), document.dispatchEvent(new CustomEvent("theme:scroll"))),
                                        this.handleProductVideos(s, n),
                                        e.preventDefault();
                                });
                            });
                    }
                    initSliders() {
                        this.slidersImages.forEach((t, i) => {
                            const s = t.closest(Qv).querySelector(jv),
                                o = new e(t, {
                                    fade: !0,
                                    pageDots: !1,
                                    prevNextButtons: !0,
                                    wrapAround: !0,
                                    adaptiveHeight: !0,
                                    asNavFor: s,
                                    on: {
                                        change: (t) => {
                                            this.flktyContent.length > 0 && this.flktyContent[i].select(t);
                                        },
                                    },
                                });
                            o.on("settle", (e) => {
                                const i = t.querySelectorAll(Vv);
                                for (let t = 0; t < i.length; t++) t === e ? i[t].querySelector(Uv).removeAttribute("tabindex") : i[t].querySelector(Uv).setAttribute("tabindex", "-1");
                            }),
                                this.flktyImages.push(o);
                        }),
                            this.slidersContents.forEach((t) => {
                                const i = new e(t, { fade: !0, pageDots: !1, prevNextButtons: !1, wrapAround: !0, adaptiveHeight: !0 });
                                i.on("settle", (e) => {
                                    const i = t.querySelectorAll(Rv);
                                    for (let t = 0; t < i.length; t++)
                                        t === e
                                            ? i[t].querySelectorAll(Wv).forEach((t) => {
                                                  t.removeAttribute("tabindex");
                                              })
                                            : i[t].querySelectorAll(Wv).forEach((t) => {
                                                  t.setAttribute("tabindex", "-1");
                                              });
                                }),
                                    this.flktyContent.push(i);
                            });
                    }
                    initProductVideos() {
                        this.tabItems.forEach((t) => {
                            t.classList.contains(Yv.tabItemActive) && this.handleProductVideos(t);
                        });
                    }
                    loadVideos(t, e = null) {
                        new IntersectionObserver(
                            (i, s) => {
                                i.forEach((i) => {
                                    if (i.isIntersecting) {
                                        const o = new Hi(t);
                                        this.videos.push(o), t.setAttribute($v, ""), this.playToggle(e), s.unobserve(i.target);
                                    }
                                });
                            },
                            { root: null, rootMargin: "300px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
                        ).observe(t);
                    }
                    handleProductVideos(t, e = null) {
                        t.hasAttribute($v) ? this.playToggle(e) : this.loadVideos(t, e);
                    }
                    playToggle(t) {
                        this.videos.forEach((e) => {
                            "function" == typeof e.pauseContainerMedia && t && (e.pauseContainerMedia(t, this.container), this.switchMedia(t)), t || 0 !== Object.keys(e.players).length || this.pauseContainerMedia(this.container);
                        });
                    }
                    switchMedia(t) {
                        const e = this.container.querySelector(`${Vv}[${_v}="${t}"]`);
                        !document.body.classList.contains(Yv.noOutline) && e.focus(), e.classList.remove(Yv.mediaHidden), e.dispatchEvent(new CustomEvent("theme:media:visible"), { bubbles: !0 });
                    }
                    pauseContainerMedia(t) {
                        const e = t.querySelectorAll(Vv);
                        0 !== e.length &&
                            e.forEach((t) => {
                                t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(Yv.mediaHidden);
                            });
                    }
                    initProductModel() {
                        const t = this.container.querySelectorAll(Nv);
                        t.length &&
                            t.forEach((t) => {
                                theme.ProductModel.init(t, this.sectionId);
                            });
                    }
                    initShopifyXrLaunch() {
                        document.addEventListener("shopify_xr_launch", () => {
                            this.container.querySelector(`${Nv}:not(.${Yv.mediaHidden})`).dispatchEvent(new CustomEvent("xrLaunch"));
                        });
                    }
                    onBlockSelect(t) {
                        t.target.dispatchEvent(new Event("click"));
                    }
                    onUnload() {
                        (this.slidersImages.length > 0 || this.slidersContents.length > 0) && document.removeEventListener("theme:resize", this.sliderResizeEvent);
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.sectionId = this.container.dataset.sectionId),
                            (this.tabButtons = this.container.querySelectorAll(Kv)),
                            (this.tabItems = this.container.querySelectorAll(Qv)),
                            (this.slidersImages = this.container.querySelectorAll(Gv)),
                            (this.slidersContents = this.container.querySelectorAll(jv)),
                            (this.videos = []),
                            (this.flktyImages = []),
                            (this.flktyContent = []),
                            (this.sliderResizeEvent = () => this.resizeSlider()),
                            this.initButtons(),
                            this.initSliders(),
                            this.initProductVideos(),
                            this.initProductModel(),
                            this.initShopifyXrLaunch(),
                            this.listen();
                    }
                })(this);
            },
            onUnload() {
                Jv[this.id].onUnload();
            },
            onBlockSelect(t) {
                Jv[this.id].onBlockSelect(t);
            },
        },
        uu,
    ]);
    const Zv = "[data-product-block]",
        tb = "[data-related-products]",
        eb = "[data-recent-wrapper]",
        ib = "[data-recently-viewed-wrapper]",
        sb = "[data-slider]",
        ob = "[data-slide]",
        nb = "[data-aos]",
        rb = "[data-tabs-holder]",
        ab = "[data-tabs-link]",
        lb = "[data-tab]",
        cb = "[data-tooltip]",
        hb = "data-section-id",
        db = "data-product-id",
        ub = "data-limit",
        pb = "data-minimum",
        mb = "data-tabs-link",
        gb = "data-column-mobile",
        fb = "hidden",
        yb = "aos-animate",
        vb = "mobile--one-whole",
        bb = "mobile--one-half",
        wb = {};
    const Sb = {
        onLoad() {
            wb[this.id] = new (class {
                related() {
                    if (((this.relatedProducts = this.container.querySelector(tb)), !this.relatedProducts)) return;
                    const t = this.container.getAttribute(hb),
                        e = this.container.getAttribute(db),
                        i = this.container.getAttribute(ub),
                        s = `${theme.routes.product_recommendations_url}?section_id=${t}&limit=${i}&product_id=${e}`;
                    fetch(s)
                        .then((t) => {
                            if (!t.ok) {
                                const e = new Error(t.status);
                                throw (this.hideRelated(), e);
                            }
                            return t.text();
                        })
                        .then((t) => {
                            const e = document.createElement("div");
                            e.innerHTML = t;
                            const i = e.querySelector(tb);
                            i &&
                                i.querySelectorAll(Zv).length &&
                                ((this.relatedProducts.innerHTML = i.innerHTML), (this.relatedProductGrid = new fo(this.relatedProducts)), (this.relatedGridSlider = new Hg(this.container)), this.initTooltips(this.relatedProducts));
                        });
                }
                recent() {
                    const t = this.container.querySelector(eb),
                        e = t ? parseInt(t.getAttribute(ub)) : 4;
                    Shopify.Products.showRecentlyViewed({
                        howManyToShow: e,
                        wrapperId: `recently-viewed-products-${this.sectionId}`,
                        section: this.section,
                        onComplete: (t, e) => {
                            const i = e.container,
                                s = i.querySelector(eb),
                                o = i.querySelector(ib),
                                n = t.querySelectorAll(Zv),
                                r = s.querySelectorAll(nb),
                                a = s.querySelector(sb),
                                l = s.hasAttribute(pb) ? parseInt(s.getAttribute(pb)) : 1,
                                c = !o && n.length > 0,
                                h = o && n.length >= l,
                                d = a.getAttribute(gb);
                            if (c || h) {
                                (this.recentProductGrid = new fo(s)),
                                    this.initTooltips(s),
                                    h && i.classList.remove(fb),
                                    a &&
                                        ((this.recentGridSlider = new Hg(i)),
                                        requestAnimationFrame(() => {
                                            this.recentGridSlider.sliders.forEach((t) => {
                                                t.dispatchEvent(new CustomEvent("theme:slider:resize", { bubbles: !0 })), this.recentGridSlider.setSliderArrowsPosition(t);
                                            });
                                        }),
                                        a.querySelectorAll(ob).forEach((t) => {
                                            2 == d ? (t.classList.add(bb), t.classList.remove(vb)) : (t.classList.add(vb), t.classList.remove(bb));
                                        }));
                                let t = [];
                                s.addEventListener("theme:target:animate", (e) => {
                                    t.push(e.detail), t.length === r.length && requestAnimationFrame(() => r.forEach((t) => t.classList.add(yb)));
                                });
                            }
                        },
                    });
                }
                hideRelated() {
                    const t = this.relatedProducts.closest(lb),
                        e = this.relatedProducts.closest(rb),
                        i = e.querySelector(`[${mb}="${t.dataset.tab}"]`);
                    t.remove(),
                        i &&
                            (i.remove(),
                            e.querySelector(ab).dispatchEvent(new Event("click")),
                            this.tabs.customScrollbar.unload(),
                            requestAnimationFrame(() => {
                                this.tabs.customScrollbar = new zi(this.tabs.container);
                            }));
                }
                initTooltips(t) {
                    (this.tooltips = t.querySelectorAll(cb)),
                        this.tooltips.forEach((t) => {
                            new Ji(t);
                        });
                }
                onDeselect() {
                    this.relatedProductGrid && this.relatedProductGrid.onDeselect(), this.recentProductGrid && this.recentProductGrid.onDeselect();
                }
                onBlockSelect(t) {
                    const e = t.target,
                        i = this.container.querySelectorAll(lb);
                    !e || i.length < 2 || (e.dispatchEvent(new Event("click")), e.parentNode.scrollTo({ top: 0, left: e.offsetLeft - e.clientWidth, behavior: "smooth" }));
                }
                onUnload() {
                    this.relatedProductGrid && this.relatedProductGrid.onUnload(),
                        this.relatedGridSlider && this.relatedGridSlider.onUnload(),
                        this.recentProductGrid && this.recentProductGrid.onUnload(),
                        this.recentGridSlider && this.recentGridSlider.onUnload();
                }
                constructor(t) {
                    (this.section = t), (this.sectionId = t.id), (this.container = t.container), this.related(), this.recent(), (this.tabs = new gr(this.container));
                }
            })(this);
        },
        onDeselect() {
            wb[this.id].onDeselect();
        },
        onBlockSelect(t) {
            wb[this.id].onBlockSelect(t);
        },
        onUnload() {
            wb[this.id].onUnload();
        },
    };
    I("related-products", Sb), I("recent-products", Sb);
    const Eb = {},
        Lb = "[data-slider]",
        kb = "[data-item]",
        Ab = "[data-button-show]",
        Cb = "[data-button-hide]",
        qb = "[data-item-products]",
        Tb = "[data-item-products-slider]",
        Pb = "[data-item-product]",
        xb = "a, button",
        Ib = "blog-item--active",
        Hb = "blog-item__products--visible",
        Fb = "flickity-enabled",
        Mb = "is-selected",
        Db = { slider: "data-slider", slidePosition: "data-slide-position", sectionId: "data-section-id", tabIndex: "tabindex" };
    const Ob = {
        onLoad() {
            Eb[this.id] = new (class {
                initSlider() {
                    (this.flkty = new e(this.slider, {
                        prevNextButtons: !0,
                        pageDots: !1,
                        cellAlign: "left",
                        wrapAround: !1,
                        groupCells: !0,
                        contain: !0,
                        on: {
                            ready: () => {
                                this.handleFocus();
                            },
                        },
                    })),
                        this.flkty.on("change", () => {
                            const t = this.container.querySelectorAll(kb);
                            this.handleFocus(),
                                t.length &&
                                    t.forEach((t) => {
                                        const e = t.querySelector(qb);
                                        t.classList.remove(Ib), e && t.querySelector(qb).classList.remove(Hb);
                                    }),
                                this.flkty && !this.flkty.options.draggable && ((this.flkty.options.draggable = !0), this.flkty.updateDraggable());
                        });
                }
                destroySlider() {
                    null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
                }
                checkSlidesSize() {
                    const t = this.container.querySelector(kb).currentStyle || window.getComputedStyle(this.container.querySelector(kb));
                    this.gutter = parseInt(t.marginRight);
                    const e = this.slider.offsetWidth + this.gutter < this.getItemsWidth();
                    window.innerWidth >= theme.sizes.small && e ? this.initSlider() : this.destroySlider();
                }
                getItemsWidth() {
                    let t = 0;
                    const e = this.slider.querySelectorAll(kb);
                    return (
                        e.length &&
                            e.forEach((e) => {
                                t += e.offsetWidth + this.gutter;
                            }),
                        t
                    );
                }
                bindButtons() {
                    const t = this.container.querySelectorAll(Tb),
                        i = this.container.querySelectorAll(Ab),
                        s = this.container.querySelectorAll(Cb);
                    i.length &&
                        i.forEach((t) => {
                            t.addEventListener("click", (e) => {
                                e.preventDefault(),
                                    this.container.querySelectorAll(kb).forEach((t) => {
                                        const e = t.querySelector(qb);
                                        t.classList.remove(Ib), e && (e.classList.remove(Hb), this.changeTabIndex(e));
                                    });
                                const i = t.closest(kb),
                                    s = i.querySelector(qb);
                                if ((i.classList.add(Ib), s)) {
                                    s.classList.add(Hb), this.changeTabIndex(s, "enable");
                                    const t = s.querySelector(Tb),
                                        e = t.querySelectorAll(Pb);
                                    if (t.classList.contains(Fb)) {
                                        const i = t.querySelector(`.${Mb}`).getAttribute(Db.slidePosition);
                                        e.forEach((t, e) => {
                                            t.setAttribute(Db.tabIndex, e === i ? "0" : "-1");
                                        });
                                    }
                                }
                                null !== this.flkty && ((this.flkty.options.draggable = !1), this.flkty.updateDraggable()), (this.a11y.state.trigger = t);
                            });
                        }),
                        s.length &&
                            s.forEach((t) => {
                                t.addEventListener("click", (e) => {
                                    e.preventDefault();
                                    const i = t.closest(kb),
                                        s = i.querySelector(qb);
                                    i.classList.remove(Ib), s && (s.classList.remove(Hb), this.changeTabIndex(s)), null !== this.flkty && ((this.flkty.options.draggable = !0), this.flkty.updateDraggable()), this.a11y.state.trigger.focus();
                                });
                            }),
                        t.length &&
                            t.forEach((t) => {
                                if (t.querySelectorAll(Pb).length > 1) {
                                    const i = new e(t, {
                                        prevNextButtons: !0,
                                        contain: !0,
                                        pageDots: !1,
                                        wrapAround: !0,
                                        on: {
                                            change: (t) => {
                                                i.cells.forEach((e, i) => {
                                                    e.element.querySelectorAll(xb).forEach((e) => {
                                                        e.setAttribute(Db.tabIndex, i === t ? "0" : "-1");
                                                    });
                                                });
                                            },
                                        },
                                    });
                                }
                            }),
                        this.slider.addEventListener("keyup", (t) => {
                            if (t.code === theme.keyboardKeys.ESCAPE) {
                                const e = t.target.hasAttribute(Db.slider) ? t.target.querySelectorAll(kb) : t.target.closest(Lb).querySelectorAll(kb);
                                e.length &&
                                    (e.forEach((t) => {
                                        const e = t.querySelector(qb);
                                        t.classList.remove(Ib), e && (e.classList.remove(Hb), this.changeTabIndex(e));
                                    }),
                                    this.flkty && ((this.flkty.options.draggable = !0), this.flkty.updateDraggable())),
                                    this.a11y.state.trigger.focus();
                            }
                        });
                }
                handleFocus() {
                    const t = this.container.querySelectorAll(kb);
                    t.length &&
                        t.forEach((t) => {
                            const e = t.classList.contains(Mb),
                                i = t.querySelector(qb);
                            e ? (this.changeTabIndex(t, "enable"), i && this.changeTabIndex(i)) : (this.changeTabIndex(t), i && i.classList.remove(Hb));
                        });
                }
                listen() {
                    this.slider && (this.checkSlidesSize(), document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize)), document.addEventListener("mousedown", this.clickOutsideItemEvent);
                }
                changeTabIndex(t, e = "") {
                    const i = "enable" === e ? "0" : "-1";
                    t.querySelectorAll(xb).forEach((t) => {
                        t.setAttribute(Db.tabIndex, i);
                    });
                }
                onBlockSelect(t) {
                    if (null !== this.flkty) {
                        const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
                            i = parseInt(this.flkty.slides[0].cells.length),
                            s = Math.floor(e / i);
                        this.flkty.select(s);
                    } else {
                        const e = this.slider.currentStyle || window.getComputedStyle(this.slider),
                            i = parseInt(e.paddingLeft),
                            s = t.target.offsetLeft - i;
                        this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
                    }
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize), document.removeEventListener("mousedown", this.clickOutsideItemEvent);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.flkty = null),
                        (this.slider = this.container.querySelector(Lb)),
                        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
                        (this.isFullWidth = this.container.hasAttribute(Db.fullWidth)),
                        (this.gutter = 0),
                        (this.a11y = Ke),
                        (this.clickOutsideItemEvent = (t) => {
                            if (!t.target.matches(kb) && !t.target.closest(kb)) {
                                const t = this.container.querySelectorAll(kb);
                                t.length &&
                                    t.forEach((t) => {
                                        const e = t.querySelector(qb);
                                        e && (e.classList.remove(Hb), this.changeTabIndex(e)), t.classList.remove(Ib);
                                    });
                            }
                        }),
                        this.bindButtons(),
                        this.listen();
                }
            })(this);
        },
        onUnload(t) {
            Eb[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            Eb[this.id].onBlockSelect(t);
        },
    };
    I("shoppable-blog", Ob);
    const Bb = "[data-scroll-down]",
        zb = "[data-site-header]",
        _b = "[data-slide]",
        $b = "a, button",
        Rb = "[data-slider]",
        Vb = ".lazy-image",
        Nb = "text-highlight",
        Wb = '[data-parallax="zoom-on-scroll"],[data-parallax="card-scrolling"],[data-parallax="zoom-on-scroll,card-scrolling"]',
        Ub = "data-style",
        jb = "data-current-style",
        Gb = "tabindex",
        Kb = "data-slide-position",
        Qb = "site-header--fixed",
        Xb = "slider--no-cached-images",
        Yb = "slider--img-loaded",
        Jb = "img-in",
        Zb = {};
    I("slider", [
        {
            onLoad() {
                Zb[this.id] = new (class {
                    initSlider() {
                        const t = this.container.querySelectorAll(_b).length,
                            i = parseInt(this.container.dataset.duration),
                            s = "true" === this.container.dataset.pageDots && t > 1,
                            o = "true" === this.container.dataset.navArrows && t > 1;
                        let n = "true" === this.container.dataset.autoplay;
                        if ((n && (n = i), t > 1))
                            (this.flkty = new e(this.container, {
                                fade: !0,
                                cellSelector: _b,
                                autoPlay: n,
                                wrapAround: !0,
                                adaptiveHeight: !0,
                                setGallerySize: !0,
                                imagesLoaded: !0,
                                pageDots: s,
                                prevNextButtons: o,
                                dragThreshold: 25,
                                on: {
                                    ready: () => {
                                        const t = this.container.querySelector(`${_b}[${Kb}="1"]`).getAttribute(Ub);
                                        this.container.setAttribute(jb, t), requestAnimationFrame(this.resizeEvent), document.addEventListener("theme:vars", this.resizeEvent), this.handleFirstSlideAnimation(!0);
                                    },
                                    change: (t) => {
                                        const e = this.flkty.selectedElement.getAttribute(Ub);
                                        this.container.setAttribute(jb, e),
                                            this.handleFirstSlideAnimation(!1),
                                            this.flkty.cells.forEach((e, i) => {
                                                e.element.querySelectorAll($b).forEach((e) => {
                                                    e.setAttribute(Gb, i === t ? "0" : "-1");
                                                }),
                                                    e.element.querySelectorAll(Nb).forEach((e) => {
                                                        e.setTriggerAttribute(Boolean(i === t));
                                                    });
                                            });
                                    },
                                },
                            })),
                                vi(this.container);
                        else if (1 === t) {
                            const t = this.container.querySelector(_b).getAttribute(Ub);
                            this.container.setAttribute(jb, t);
                        }
                    }
                    handleFirstSlideAnimation(t = !1) {
                        if (!t) return this.container.classList.remove(Xb), void this.container.classList.remove(Yb);
                        const e = this.container.querySelectorAll(_b)[0].querySelectorAll(Vb),
                            i = this.container.classList.contains(Jb);
                        if (e.length && !i) {
                            this.container.classList.add(Xb);
                            const t = (i) => {
                                requestAnimationFrame(() => this.container.classList.add(Yb)), e[0].removeEventListener("transitionend", t);
                            };
                            e[0].addEventListener("transitionend", t);
                        }
                    }
                    bindScrollButton() {
                        const t = this.container.querySelector(Bb);
                        t &&
                            t.addEventListener("click", (t) => {
                                t.preventDefault();
                                const e = this.header.classList.contains(Qb) ? 60 : 0,
                                    i = parseInt(Math.ceil(this.container.offsetTop + this.container.offsetHeight - e));
                                window.scrollTo({ top: i, left: 0, behavior: "smooth" });
                            });
                    }
                    onBlockSelect(t) {
                        const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
                        null !== this.flkty && (this.flkty.select(e), this.flkty.pausePlayer());
                    }
                    onBlockDeselect(t) {
                        "true" === t.target.closest(Rb).dataset.autoplay && null !== this.flkty && this.flkty.playPlayer();
                    }
                    onReorder() {
                        this.handleFirstSlideAnimation(!1), null !== this.flkty && this.flkty.resize();
                    }
                    onUnload() {
                        this.handleFirstSlideAnimation(!1),
                            null !== this.flkty && (document.removeEventListener("theme:vars", this.resizeEvent), this.flkty.destroy(), (this.flkty = null)),
                            this.parallax && (this.parallax.unload(), (this.parallax = null));
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.header = document.querySelector(zb)),
                            (this.flkty = null),
                            (this.parallax = null),
                            (this.resizeEvent = () => {
                                this.flkty.resize();
                            }),
                            this.initSlider(),
                            this.bindScrollButton(),
                            this.container.matches(Wb) && (this.parallax = new du(this.container));
                    }
                })(this);
            },
            onReorder(t) {
                Zb[this.id].onReorder(t);
            },
            onUnload(t) {
                Zb[this.id].onUnload(t);
            },
            onBlockSelect(t) {
                Zb[this.id].onBlockSelect(t);
            },
            onBlockDeselect(t) {
                Zb[this.id].onBlockDeselect(t);
            },
        },
        Dp,
    ]);
    const tw = "[data-sticky-card-body]",
        ew = "[data-sticky-card-wrapper]",
        iw = "[data-sticky-card-content]",
        sw = "[data-sticky-card-aside]",
        ow = "[data-sticky-card-text]",
        nw = "[data-sticky-card-image]",
        rw = "[data-sticky-vh]",
        aw = "is-stuck-up",
        lw = "has-passed-sticky",
        cw = "spillover",
        hw = "data-sticky-card-layout-mobile",
        dw = {};
    I("sticky-image-cards", {
        onLoad() {
            dw[this.id] = new (class {
                init() {
                    requestAnimationFrame(() => {
                        this.calculateHeights(), this.onScroll();
                    }),
                        document.addEventListener("theme:scroll", this.onScrollCallback),
                        document.addEventListener("theme:resize", this.onResizeCallback);
                }
                onScroll() {
                    this.isEligible() && this.detectStickyPositions();
                }
                isEligible() {
                    const t = Math.round(this.container.getBoundingClientRect().top + window.scrollY),
                        e = t + this.container.offsetHeight < Math.round(window.scrollY);
                    return t < Math.round(window.scrollY + window.innerHeight) && !e;
                }
                detectStickyPositions() {
                    const t = Math.round(this.body.getBoundingClientRect().top - this.headerHeight - this.wrapperTop);
                    [...this.wrapper].forEach((e, i) => {
                        const s = Math.floor(e.getBoundingClientRect().top - this.headerHeight);
                        if (this.isMobile) {
                            if (i !== this.lastIndex) {
                                const t = Math.floor(this.wrapper[i + 1].getBoundingClientRect().top - this.headerHeight);
                                e.classList.toggle(lw, t <= this.stickyTop);
                            }
                            this.container.classList.toggle(`checkpoint-${i + 1}`, t <= -1 * this.cumulativeHeights[i]);
                        }
                        e.classList.toggle(aw, s <= this.stickyTop);
                    });
                }
                calculateHeights() {
                    let { stickyHeaderHeight: t } = N();
                    (this.headerHeight = t || 0),
                        (this.spacingTop = parseInt(window.getComputedStyle(this.container).getPropertyValue("--padding")) || 20),
                        (this.wrapperTop = parseInt(window.getComputedStyle(this.wrapper[0]).getPropertyValue("top")) || 0),
                        (this.stickyTop = Math.floor(this.wrapperTop - this.headerHeight)),
                        (this.gap = parseInt(window.getComputedStyle(this.aside).getPropertyValue("gap")) || 0),
                        (this.viewportHeight = this.vh.offsetHeight),
                        (this.lastIndex = [...this.wrapper].length - 1),
                        (this.cumulativeHeights = []),
                        this.isMobile && ((this.wrapperTop = this.spacingTop), (this.stickyTop = this.spacingTop)),
                        this.textInContent &&
                            (this.isDesktop &&
                                this.textInContent.length > 0 &&
                                this.textInContent.forEach((t, e) => {
                                    t.style.setProperty("--row-height", "auto"), this.wrapper[e].style.setProperty("--row-height", "auto");
                                    const i = t.offsetHeight,
                                        s = this.image[e].offsetHeight,
                                        o = Math.max(i, s);
                                    t.style.setProperty("--row-height", `${o}px`), this.wrapper[e].style.setProperty("--row-height", `${o}px`);
                                }),
                            [...this.wrapper].forEach((t, e) => {
                                t.style.setProperty("--item-height", "auto"),
                                    t.style.setProperty("--item-double-height", "auto"),
                                    requestAnimationFrame(() => {
                                        const i = t.offsetHeight,
                                            s = i + this.wrapperTop + this.headerHeight > this.viewportHeight,
                                            o = [...this.wrapper].map((t) => (Number(t.dataset.index) >= e ? 0 : t.offsetHeight));
                                        this.cumulativeHeights.push(o.reduce((t, e) => t + e, 0)),
                                            t.classList.toggle(cw, s),
                                            s && this.isMobile && (t.style.setProperty("--item-height", `${i}px`), t.style.setProperty("--item-double-height", 2 * i + "px"));
                                    });
                            }));
                }
                onResize() {
                    requestAnimationFrame(() => {
                        (this.isDesktop = Boolean(re() >= window.theme.sizes.large)), (this.isMobile = le());
                        const t = /iPhone|iPad|iPod/i.test(navigator.userAgent);
                        let e = this.isDesktop || (!t && this.isMobile);
                        this.orientation !== X() && t && ((e = !0), (this.orientation = X())), e && this.calculateHeights();
                    });
                }
                onUnload() {
                    document.removeEventListener("theme:scroll", this.onScrollCallback), document.removeEventListener("theme:resize", this.onResizeCallback);
                }
                onBlockSelect(t) {
                    requestAnimationFrame(() => {
                        const e = Number(t.target.dataset.index),
                            i =
                                Math.round(this.body.getBoundingClientRect().top + window.scrollY) +
                                [...this.wrapper].map((t) => (Number(t.dataset.index) >= e ? 0 : t.offsetHeight)).reduce((t, e) => t + e, 0) -
                                (() => (this.isMobile && "stacked" === this.layoutMobile ? this.gap * e * -1 + this.gap / 2 : this.stickyTop))() -
                                this.headerHeight;
                        setTimeout(() => {
                            window.scrollTo({ top: i, left: 0, behavior: "smooth" });
                        }, 400);
                    });
                }
                constructor(t) {
                    var e;
                    (this.container = t.container),
                        (this.body = this.container.querySelector(tw)),
                        (this.wrapper = this.container.querySelectorAll(ew)),
                        (this.content = this.container.querySelector(iw)),
                        (this.aside = this.container.querySelector(sw)),
                        (this.text = this.container.querySelectorAll(ow)),
                        (this.image = this.container.querySelectorAll(nw)),
                        (this.textInContent = null === (e = this.content) || void 0 === e ? void 0 : e.querySelectorAll(ow)),
                        (this.vh = this.container.querySelector(rw)),
                        (this.layoutMobile = this.container.getAttribute(hw)),
                        (this.isDesktop = Boolean(re() >= window.theme.sizes.large)),
                        (this.isMobile = le()),
                        (this.orientation = X()),
                        0 !== this.image.length && ((this.onScrollCallback = () => this.onScroll()), (this.onResizeCallback = () => this.onResize()), this.init());
                }
            })(this);
        },
        onUnload() {
            dw[this.id].onUnload();
        },
        onBlockSelect(t) {
            dw[this.id].onBlockSelect(t);
        },
    });
    const uw = "[data-sticky-wrapper]",
        pw = "[data-sticky-aside]",
        mw = "[data-sticky-inner]",
        gw = "[data-sticky-content]",
        fw = ".js-only [data-sticky-text]",
        yw = ".js-only [data-sticky-text-inner]",
        vw = ".js-only [data-sticky-image]",
        bw = "[data-sticky-images]",
        ww = ".image-wrapper",
        Sw = "[data-sticky-dot]",
        Ew = "text-highlight",
        Lw = "data-sticky-with-gaps",
        kw = "data-sticky-single-text",
        Aw = "data-index",
        Cw = 0.5,
        qw = { horizontal: "horizontal", horizontalReversed: "horizontal-reversed", vertical: "vertical", verticalReversed: "vertical-reversed" },
        Tw = { maxVisibility: "maximum-visibility-of-each-image-in-viewport", middleOfViewport: "image-in-the-middle-of-viewport" },
        Pw = "is-active",
        xw = {};
    I("sticky-images-and-text", [
        {
            onLoad() {
                xw[this.id] = new (class {
                    init() {
                        this.getTypeOfIntersecting(),
                            this.observeImagesIntersecting(),
                            this.calculateHeights(),
                            (this.performAnimation = requestAnimationFrame(this.calculateImagesOffsetCallback)),
                            requestAnimationFrame(() => {
                                requestAnimationFrame(() => this.calculateHeights());
                            }),
                            document.addEventListener("theme:scroll", this.onScrollCallback),
                            document.addEventListener("theme:resize:width", this.onResizeCallback),
                            this.syncDots();
                    }
                    getTypeOfIntersecting() {
                        (this.typeOfIntersecting = Tw.maxVisibility),
                            (this.fractionOfViewport = this.image[0].offsetHeight / window.innerHeight),
                            this.verticalScroll && !le() && this.fractionOfViewport < 0.6 && (this.typeOfIntersecting = Tw.middleOfViewport);
                    }
                    observeImagesIntersecting() {
                        (this.observersCollection = new Set()),
                            (this.compareIntersectionRatio = []),
                            (this.maxVisibility = 0),
                            (this.observer = new IntersectionObserver(
                                (t, e) => {
                                    t.forEach((t) => {
                                        const e = t.target.offsetHeight,
                                            i = t.intersectionRatio,
                                            s = t.isIntersecting,
                                            o = { target: t.target, intersectionRatio: t.intersectionRatio },
                                            n = this.typeOfIntersecting === Tw.maxVisibility;
                                        let r = Cw;
                                        this.windowHeight <= e && (r = 0),
                                            n &&
                                                s &&
                                                (this.observersCollection.forEach((e) => {
                                                    e.target === t.target && this.observersCollection.delete(e);
                                                }),
                                                this.observersCollection.add(o),
                                                (this.compareIntersectionRatio = [...this.observersCollection].map((t) => t.intersectionRatio)),
                                                (this.maxVisibility = Math.max(...this.compareIntersectionRatio))),
                                            s &&
                                                i > r &&
                                                n &&
                                                this.maxVisibility === i &&
                                                ((this.maxVisibilityItem = [...this.observersCollection].find((t) => t.intersectionRatio === this.maxVisibility)),
                                                (this.activeIndex = Number(this.maxVisibilityItem.target.dataset.index)),
                                                this.lastActiveIndex !== this.activeIndex && (this.sync(), (this.lastActiveIndex = this.activeIndex)));
                                    });
                                },
                                { root: null, rootMargin: "0px", threshold: [0, 0.15, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.85, 1] }
                            )),
                            this.image.forEach((t) => this.observer.observe(t));
                    }
                    onScroll() {
                        this.performAnimation || (this.performAnimation = requestAnimationFrame(this.calculateImagesOffsetCallback)),
                            this.typeOfIntersecting === Tw.middleOfViewport && this.image.forEach((t) => this.checkImagePositionInViewport(t));
                    }
                    removeAnimationFrame() {
                        this.performAnimation && (cancelAnimationFrame(this.performAnimation), (this.performAnimation = null));
                    }
                    checkImagePositionInViewport(t) {
                        if (!t) return;
                        const e = window.innerHeight,
                            i = window.scrollY,
                            s = i + e / 2,
                            o = i + e,
                            n = Math.round(t.getBoundingClientRect().top + i),
                            r = n + t.offsetHeight;
                        n < o && !(r < i) && s > n && r > s && ((this.activeIndex = Number(t.dataset.index)), this.lastActiveIndex !== this.activeIndex && (this.sync(), (this.lastActiveIndex = this.activeIndex)));
                    }
                    calculateImagesOffset() {
                        const t = this.aside.getBoundingClientRect().top - this.headerHeight,
                            e = t - this.innerStickyTop;
                        let i = 0,
                            s = 0;
                        const o = this.hasShortImages ? e : t;
                        (i = o < 0 ? (o / this.bottomEndingPoint) * -1 * 100 : o >= 0 ? 0 : 100),
                            (s = i > 100 ? 100 : i),
                            (s *= this.image.length - 1),
                            (le() || this.horizontalScroll) && this.aside.style.setProperty("--translateX", `${Number(s * this.direction).toFixed(2)}%`),
                            this.lastOffset !== s ? (this.performAnimation = requestAnimationFrame(this.calculateImagesOffsetCallback)) : this.performAnimation && this.removeAnimationFrame(),
                            (this.lastOffset = s);
                    }
                    calculateHeights() {
                        let { stickyHeaderHeight: t, windowHeight: e } = N();
                        if (((this.headerHeight = t || 0), (this.windowHeight = e || window.innerHeight), this.text.length > 0)) {
                            const t = this.content ? parseInt(window.getComputedStyle(this.content).getPropertyValue("padding-top")) : 0,
                                e = this.content ? parseInt(window.getComputedStyle(this.content).getPropertyValue("padding-bottom")) : 0,
                                i = [...this.text].map((i) => i.offsetHeight + t + e),
                                s = [...this.textInner].map((t) => t.offsetHeight),
                                o = Math.max(...i),
                                n = Math.max(...s),
                                r = le() ? n : o,
                                a = i.reduce((t, e) => t + e, 0),
                                l = Math.floor(a / i.length) || this.text[0].offsetHeight;
                            this.container.style.removeProperty("--average-text-height"),
                                this.container.style.setProperty("--average-text-height", `${l}px`),
                                this.container.style.removeProperty("--highest-text"),
                                this.container.style.setProperty("--highest-text", `${r}px`);
                        }
                        (this.imagesHeight = this.images.offsetHeight),
                            (this.hasShortImages = !1),
                            this.image.length > 0 &&
                                ((this.imgHeight = this.image[0].querySelector(ww).offsetHeight),
                                (this.imgPadding = parseInt(window.getComputedStyle(this.image[0]).getPropertyValue("padding-top"))),
                                this.container.style.removeProperty("--images-height"),
                                this.container.style.setProperty("--images-height", `${this.imagesHeight}px`),
                                this.container.style.removeProperty("--img-height"),
                                this.container.style.setProperty("--img-height", `${this.imgHeight + 2 * this.imgPadding}px`)),
                            (this.asideHeight = this.aside.offsetHeight),
                            (this.asidePadding = parseInt(window.getComputedStyle(this.aside).getPropertyValue("padding-top"))),
                            (this.breathingSpace = (this.windowHeight - this.imagesHeight) / 2 / 2),
                            (this.innerStickyTop = parseInt(window.getComputedStyle(this.inner).getPropertyValue("top")) - this.headerHeight - this.breathingSpace),
                            (this.gutters = this.withGaps ? 2 * this.asidePadding : 0),
                            (this.additionalSpace = le() ? (this.withGaps ? this.asidePadding + 10 : 10) : this.gutters),
                            (this.minHeightForEndingPoing = this.imagesHeight + this.additionalSpace),
                            !le() &&
                                this.horizontalScroll &&
                                ((this.minHeightForEndingPoing = this.windowHeight - this.headerHeight),
                                (this.hasShortImages = this.fractionOfViewport <= 0.6),
                                this.hasShortImages && (this.minHeightForEndingPoing = this.imagesHeight - this.innerStickyTop + 3 * this.breathingSpace)),
                            (this.bottomEndingPoint = this.asideHeight - this.minHeightForEndingPoing);
                    }
                    refreshImagesOffsetValues() {
                        requestAnimationFrame(() => {
                            requestAnimationFrame(() => {
                                document.dispatchEvent(new CustomEvent("theme:scroll"));
                            });
                        });
                    }
                    onResize() {
                        this.calculateHeights(), requestAnimationFrame(() => this.calculateHeights()), this.getTypeOfIntersecting(), this.refreshImagesOffsetValues();
                    }
                    sync() {
                        const t = this.singleText ? [] : this.text;
                        [...this.image, ...t, ...this.dot].forEach((t) => {
                            const e = Number(t.getAttribute(Aw));
                            t.classList.toggle(Pw, e === Number(this.activeIndex));
                        }),
                            this.textHighlight.forEach((t) => t.shouldAnimate());
                    }
                    syncDots() {
                        this.dot.forEach((t) => {
                            t.addEventListener("click", (t) => {
                                t.preventDefault();
                                const e = Number(t.target.dataset.index),
                                    i = this.image[e],
                                    s = Math.round(i.getBoundingClientRect().top + window.scrollY),
                                    o = i.offsetHeight;
                                let n = this.wrapper.offsetTop + this.images.offsetHeight * e - this.headerHeight;
                                this.verticalScroll && ae() && ((n = s - this.headerHeight), this.typeOfIntersecting === Tw.middleOfViewport && (n = s - window.innerHeight / 2 + o / 2 - this.headerHeight)),
                                    window.scrollTo({ top: n, left: 0, behavior: "smooth" });
                            });
                        });
                    }
                    onUnload() {
                        this.image.forEach((t) => this.observer.unobserve(t)), document.removeEventListener("theme:scroll", this.onScrollCallback), document.removeEventListener("theme:resize:width", this.onResizeCallback);
                    }
                    onBlockSelect(t) {
                        const e = Number(t.target.dataset.index),
                            i = Math.round(t.target.getBoundingClientRect().top + window.scrollY),
                            s = t.target.offsetHeight,
                            o = this.wrapper.offsetTop + this.images.offsetHeight * e,
                            n = le() ? Math.round(10 / (this.image.length - 1)) * e : 0;
                        let r = o - this.headerHeight - n;
                        this.verticalScroll && ae() && ((r = i - this.headerHeight), this.typeOfIntersecting === Tw.middleOfViewport && (r = i - window.innerHeight / 2 + s / 2 - this.headerHeight)),
                            setTimeout(() => {
                                window.scrollTo({ top: r, left: 0, behavior: "smooth" });
                            }, 500);
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.scrollDirection = this.container.dataset.scrollDirection),
                            (this.horizontalScroll = this.scrollDirection === qw.horizontal || this.scrollDirection === qw.horizontalReversed),
                            (this.verticalScroll = this.scrollDirection === qw.vertical || this.scrollDirection === qw.verticalReversed),
                            (this.reverseDirection = this.scrollDirection === qw.horizontalReversed || this.scrollDirection === qw.verticalReversed),
                            (this.direction = this.reverseDirection ? 1 : -1),
                            (this.withGaps = this.container.hasAttribute(Lw)),
                            (this.singleText = this.container.hasAttribute(kw)),
                            (this.image = this.container.querySelectorAll(vw)),
                            (this.text = this.container.querySelectorAll(fw)),
                            (this.textInner = this.container.querySelectorAll(yw)),
                            (this.images = this.container.querySelector(bw)),
                            (this.dot = this.container.querySelectorAll(Sw)),
                            (this.aside = this.container.querySelector(pw)),
                            (this.inner = this.container.querySelector(mw)),
                            (this.content = this.container.querySelector(gw)),
                            (this.wrapper = this.container.querySelector(uw)),
                            (this.textHighlight = this.container.querySelectorAll(Ew)),
                            (this.performAnimation = null),
                            (this.lastOffset = 0),
                            (this.activeIndex = 0),
                            (this.lastActiveIndex = this.activeIndex),
                            this.wrapper && ((this.onScrollCallback = () => this.onScroll()), (this.onResizeCallback = () => this.onResize()), (this.calculateImagesOffsetCallback = () => this.calculateImagesOffset()), this.init());
                    }
                })(this);
            },
            onUnload() {
                xw[this.id].onUnload();
            },
            onBlockSelect(t) {
                xw[this.id].onBlockSelect(t);
            },
        },
        Dp,
    ]),
        I("subcollections", Fg),
        I("tab-collections", [yo, Fg, fr]);
    const Iw = {},
        Hw = "[data-slider]",
        Fw = "[data-item]",
        Mw = ".flickity-button",
        Dw = "flickity-enabled",
        Ow = "has-arrows",
        Bw = "carousel--resize",
        zw = "flickity-button-holder",
        _w = "data-section-id";
    const $w = {
        onLoad() {
            Iw[this.id] = new (class {
                init() {
                    this.checkSlideCount(), this.listen();
                }
                onResize() {
                    this.checkSlideCount(), null !== this.flkty && this.flkty.resize();
                }
                checkSlideCount() {
                    const t = Boolean(2 == this.slidesCount && window.innerWidth >= theme.sizes.small),
                        e = Boolean(1 == this.slidesCount),
                        i = window.innerWidth < theme.sizes.small;
                    if (!(t || e || i))
                        return this.flkty
                            ? void (this.flkty && (this.flkty.isActive || this.initSlider(), this.flkty.slideableWidth > this.flkty.size.width ? this.initSlider() : this.destroySlider()))
                            : (this.initSlider(), void this.onResize());
                    this.destroySlider();
                }
                initSlider() {
                    (this.flkty = new e(this.slider, {
                        cellSelector: Fw,
                        prevNextButtons: !0,
                        pageDots: !1,
                        groupCells: !0,
                        cellAlign: "left",
                        contain: !0,
                        adaptiveHeight: !1,
                        on: {
                            ready: () => {
                                requestAnimationFrame(() => {
                                    this.slider.querySelectorAll(Mw).forEach((t) => {
                                        ut(t, zw);
                                    });
                                });
                            },
                        },
                    })),
                        this.container.classList.add(Ow),
                        this.createResizeClass();
                }
                createResizeClass() {
                    if ("function" == typeof e.prototype._createResizeClass) return;
                    (e.prototype._createResizeClass = function () {
                        this.element.classList.add(Bw);
                    }),
                        e.createMethods.push("_createResizeClass");
                    const t = e.prototype.resize;
                    e.prototype.resize = function () {
                        this.element.classList.remove(Bw), t.call(this), this.element.classList.add(Bw);
                    };
                }
                destroySlider() {
                    var t;
                    this.slider.classList.contains(Dw) &&
                        (null !== this.flkty &&
                            (null === (t = this.slider.querySelectorAll(Mw)) ||
                                void 0 === t ||
                                t.forEach((t) => {
                                    const e = t.parentNode;
                                    e && e.classList.contains(zw) && (e.parentNode.insertBefore(t, e), e.parentNode.removeChild(e));
                                }),
                            this.flkty.destroy()),
                        this.container.classList.remove(Ow));
                }
                listen() {
                    document.addEventListener("theme:resize:width", this.onResizeCallback);
                }
                onBlockSelect(t) {
                    if (null !== this.flkty && this.flkty.isActive) {
                        const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
                            i = parseInt(this.flkty.slides[0].cells.length),
                            s = Math.floor(e / i);
                        this.flkty.select(s);
                    } else {
                        const e = this.slider.currentStyle || window.getComputedStyle(this.slider),
                            i = parseInt(e.paddingLeft),
                            s = t.target.offsetLeft - i;
                        this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
                    }
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.onResizeCallback);
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.sectionId = this.container.getAttribute(_w)),
                        (this.slider = this.container.querySelector(Hw)),
                        this.slider && ((this.slidesCount = this.slider.querySelectorAll(Fw).length), (this.flkty = null), (this.onResizeCallback = () => this.onResize()), this.init());
                }
            })(this);
        },
        onUnload(t) {
            Iw[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            Iw[this.id].onBlockSelect(t);
        },
    };
    I("testimonials", $w);
    const Rw = "no-outline",
        Vw = "[data-skip-content]",
        Nw = 'a[href="#"]';
    document.documentElement.style.setProperty(
        "--scrollbar-width",
        `${(() => {
            const t = document.createElement("div");
            (t.style.visibility = "hidden"), (t.style.overflow = "scroll"), (t.style.msOverflowStyle = "scrollbar"), document.body.appendChild(t);
            const e = document.createElement("div");
            t.appendChild(e);
            const i = t.offsetWidth - e.offsetWidth;
            return t.parentNode.removeChild(t), i;
        })()}px`
    ),
        document.addEventListener("DOMContentLoaded", function () {
            H("*"),
                new (class {
                    init() {
                        (this.body = document.body),
                            (this.inPageLink = document.querySelector(Vw)),
                            (this.linkesWithOnlyHash = document.querySelectorAll(Nw)),
                            (this.isFocused = !1),
                            this.focusHash(),
                            this.bindInPageLinks(),
                            this.clickEvents(),
                            this.focusEvents(),
                            this.focusEventsOff();
                    }
                    clickEvents() {
                        this.inPageLink &&
                            this.inPageLink.addEventListener("click", (t) => {
                                t.preventDefault();
                            }),
                            this.linkesWithOnlyHash &&
                                this.linkesWithOnlyHash.forEach((t) => {
                                    t.addEventListener("click", (t) => {
                                        t.preventDefault();
                                    });
                                });
                    }
                    focusEvents() {
                        document.addEventListener("keyup", (t) => {
                            t.code === theme.keyboardKeys.TAB && (this.body.classList.remove(Rw), (this.isFocused = !0));
                        });
                    }
                    focusEventsOff() {
                        document.addEventListener("mousedown", () => {
                            this.body.classList.add(Rw), (this.isFocused = !1);
                        });
                    }
                    forceFocus(t, e) {
                        e = e || {};
                        var i = t.tabIndex;
                        (t.tabIndex = -1),
                            (t.dataset.tabIndex = i),
                            t.focus(),
                            void 0 !== e.className && t.classList.add(e.className),
                            t.addEventListener("blur", function s(o) {
                                o.target.removeEventListener(o.type, s), (t.tabIndex = i), delete t.dataset.tabIndex, void 0 !== e.className && t.classList.remove(e.className);
                            });
                    }
                    focusHash(t) {
                        t = t || {};
                        let e = window.location.hash;
                        void 0 !== theme.settings.newHash && ((e = theme.settings.newHash), (window.location.hash = `#${e}`));
                        const i = document.getElementById(e.slice(1));
                        if (i && t.ignore && i.matches(t.ignore)) return !1;
                        e && i && this.forceFocus(i, t);
                    }
                    bindInPageLinks(t) {
                        return (
                            (t = t || {}),
                            Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter((e) => {
                                if ("#" === e.hash || "" === e.hash) return !1;
                                if (t.ignore && e.matches(t.ignore)) return !1;
                                if (((i = e.hash.substr(1)), null === document.getElementById(i))) return !1;
                                var i,
                                    s = document.querySelector(e.hash);
                                return (
                                    !!s &&
                                    (e.addEventListener("click", () => {
                                        this.forceFocus(s, t);
                                    }),
                                    !0)
                                );
                            })
                        );
                    }
                    constructor() {
                        this.init();
                    }
                })(),
                customElements.get("product-grid-item-swatch") || "disabled" == window.theme.settings.colorSwatchesType || customElements.define("product-grid-item-swatch", Zs);
            "scrollBehavior" in document.documentElement.style || Xe({ url: theme.assets.smoothscroll });
        });
})(themeVendor.ScrollLock, themeVendor.Flickity, themeVendor.themeCurrency, themeVendor.ajaxinate);
document.addEventListener("DOMContentLoaded", function () {
    var stickyAddToCart = document.querySelector(".sticky-add-to-cart");
    var mainAddToCartButton = document.querySelector('[name="add"]');

    if (!stickyAddToCart || !mainAddToCartButton) return;

    window.addEventListener("scroll", function () {
        var rect = mainAddToCartButton.getBoundingClientRect();

        if (rect.bottom < 0) {
            stickyAddToCart.style.display = "flex";
        } else {
            stickyAddToCart.style.display = "none";
        }
    });

    document.getElementById("stickyAddToCartButton").addEventListener("click", function () {
        mainAddToCartButton.click();
    });
});

// Swiper Mobile exclusive offer
var swiper = new Swiper(".exclusive-offer", {
    slidesPerView: 1.3,
    spaceBetween: 10,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});

var swiper = new Swiper(".exclusive-offer-desktop", {
    slidesPerView: 2,
    spaceBetween: 20,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});

var swiper = new Swiper(".exclusive-offer-desktop", {
    slidesPerView: 3,
    spaceBetween: 30,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});

// nav-category-wrapper — CSS scroll-snap (no Swiper needed)

function bindVariantChange() {
    const variantSelector = document.querySelector('[name="id"]');
    const sectionIdInput = document.querySelector('[name="sid"]');

    if (!variantSelector || !sectionIdInput) return;

    variantSelector.removeEventListener("change", onVariantChange);
    variantSelector.addEventListener("change", onVariantChange);
}

function onVariantChange(event) {

    const variantId = event.target.value;
    const sectionId = document.querySelector('[name="sid"]').value;

    const subElementId = `ProductPhoto--${sectionId}`;
    const subElementEl = document.getElementById(subElementId);

    if (!subElementEl) return;

    fetch(`${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`)
        .then((res) => res.text())
        .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newSubElement = doc.getElementById(subElementId);

            if (newSubElement) {
                subElementEl.innerHTML = newSubElement.innerHTML;

                // Re-bind change listener
                bindVariantChange();

                // ✅ Wait a bit, then initialize Flickity
                setTimeout(() => {
                    if (typeof Flickity !== "undefined") {
                        // Find the correct container class
                        const slider = document.querySelector(".product-single__media-slider"); // Update this class if needed
                        if (slider) {
                            new Flickity(slider, {
                                cellAlign: "left",
                                contain: true,
                                wrapAround: true,
                                imagesLoaded: true,
                            });
                        } else {
                            console.warn("Slider container not found.");
                        }
                    } else {
                        console.error("Flickity is still undefined. Make sure it's loaded.");
                    }
                }, 50);
                let betterAltCoinsNum = document.querySelector(".betteralt-coins-pdp");
                let productPrice = document.querySelector(".product__price--regular").textContent;
                let numCoins=0;
                productPrice = productPrice.replace(/[^0-9.]/g, "");
                // 2️⃣ Convert to number
                productPrice = parseFloat(productPrice);
                // 3️⃣ Remove decimals
                productPrice = Math.floor(productPrice);
                if(productPrice){
                    numCoins = Math.ceil(productPrice/20);
                }
                if(betterAltCoinsNum){
                    betterAltCoinsNum.textContent = numCoins;
                }
                    }
                
                let productHandle = document.querySelector(".productHandle").textContent;
                console.log(productHandle);
                const judgemeUrlToFetch = `https://api.judge.me/api/v1/widgets/preview_badge?shop_domain=betteralt-india.myshopify.com&api_token=TKZdE_bFKUQWVI0zmynJW7WfgNk&handle=${productHandle}`;
                const productInfo2 = document.querySelectorAll(".custom-pdp-info--2");
                const averageRating1 = document.querySelectorAll(".averageRating");
                const numberOfReviews1 = document.querySelectorAll(".numberOfReviews");

                fetch(judgemeUrlToFetch)
                    .then(response => response.json())
                    .then(data => {
                    // data.badge contains the HTML string
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data.badge;

                    const badgeDiv = tempDiv.querySelector('.jdgm-prev-badge');
                    if (badgeDiv) {
                        const averageRating = badgeDiv.getAttribute('data-average-rating');
                        const numberOfReviews = badgeDiv.getAttribute('data-number-of-reviews');
                        for(let i=0; i<averageRating1.length; i++){
                        averageRating1[i].textContent=averageRating;
                        }
                        for(let i=0; i<numberOfReviews1.length; i++){
                        numberOfReviews1[i].textContent=`(${numberOfReviews} reviews)`;
                        }
                        for(let i=0; i<productInfo2.length; i++){
                            // productInfo2[i].style.display="flex";
                        }
                    } else {
                        console.log("Badge not found in response.");
                    }
                    })
                    .catch(error => console.error("Error fetching Judge.me data:", error));
                });

}

document.addEventListener("DOMContentLoaded", () => {
    bindVariantChange();
});

 // product slider progressbar js code  

(function() {
  'use strict';

  let progressTimeout;

  function initProgressBar() {
    const slider = document.querySelector('.flickity-slider');
    const slides = slider?.querySelectorAll('.product-single__media-slide') || [];
    const progressBar = document.querySelector('.slider-progress-bar');

    if (!slider || !slides.length || !progressBar || progressBar.dataset.init === 'true') return;

    progressBar.dataset.init = 'true';

    function getActiveSlide() {
      const selectedSlide = slider.querySelector('.product-single__media-slide.is-selected');
      const slidesArr = [...slides];
      const index = selectedSlide ? slidesArr.indexOf(selectedSlide) : 0;
      return index >= 0 ? index : 0;
    }

    function updateProgress() {
      clearTimeout(progressTimeout);
      progressTimeout = setTimeout(() => {
        const idx = getActiveSlide();
        const widthPct = ((idx + 1) / slides.length) * 100;
        progressBar.style.setProperty('width', `${widthPct}%`, 'important');
      }, 50);
    }

    // Touch and mouse interaction support
    slides.forEach(slide => {
      let startX;
      slide.addEventListener('touchstart', e => startX = e.touches[0].clientX, { passive: true });
      slide.addEventListener('touchmove', updateProgress, { passive: true });
      slide.addEventListener('touchend', e => {
        if (Math.abs(e.changedTouches[0].clientX - startX) > 30) {
          setTimeout(updateProgress, 100);
        }
      }, { passive: true });
    });

    let dragging = false;
    slider.addEventListener('mousedown', () => dragging = true);
    slider.addEventListener('mousemove', () => dragging && updateProgress());
    slider.addEventListener('mouseup', () => {
      dragging = false;
      setTimeout(updateProgress, 100);
    });
    slider.addEventListener('mouseleave', () => dragging = false);

    // Flickity integration
    setTimeout(() => {
      const flkty = Flickity?.data(slider.closest('.flickity-enabled'));
      if (flkty) {
        ['select', 'change', 'settle'].forEach(event => {
          flkty.on(event, index => {
            const idx = index ?? 0;
            const pct = ((idx + 1) / slides.length) * 100;
            progressBar.style.setProperty('width', `${pct}%`, 'important');
          });
        });
        flkty.on('dragMove', updateProgress);
      }
    }, 200);

    setTimeout(updateProgress, 100);
    window.addEventListener('resize', updateProgress);
  }

  function reinitialize() {
    const progressBar = document.querySelector('.slider-progress-bar');
    if (progressBar) delete progressBar.dataset.init;
    setTimeout(initProgressBar, 300);
  }

  document.addEventListener('DOMContentLoaded', initProgressBar);
  ['shopify:section:load', 'shopify:section:reorder'].forEach(evt =>
    document.addEventListener(evt, () => setTimeout(reinitialize, 500))
  );

  document.addEventListener('change', e => {
    if (e.target.matches('input[name*="option"], select[name*="option"], [name="id"], .product-form select')) {
      reinitialize();
    }
  });

  document.addEventListener('click', e => {
    if (e.target.closest('.radio__label, .variant-button, [data-variant-id], .product-form__buttons button')) {
      setTimeout(reinitialize, 100);
    }
  });

  const originalFetch = window.fetch;
  window.fetch = function() {
    return originalFetch.apply(this, arguments).then(response => {
      const url = arguments[0];
      if (typeof url === 'string' && (url.includes('variants') || url.includes('products'))) {
        setTimeout(reinitialize, 200);
      }
      return response;
    }).catch(err => {
      throw err;
    });
  };

  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1 &&
          (node.classList?.contains('product-single__media-slide') ||
           node.querySelector?.('.product-single__media-slide'))) {
          setTimeout(reinitialize, 100);
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('beforeunload', () => {
    observer.disconnect();
    clearTimeout(progressTimeout);
  });

})();




 // product slider progressbar js code ends  



/*

document.querySelector('form[action*="/cart/add"]').addEventListener('change', function(e) {
  const selectedVariantId = document.querySelector('[name="id"]').value;
  const selectedSectionId = document.querySelector('[name="sid"]').value;
  console.log("selectedVariantId",selectedVariantId,selectedSectionId);
  fetch(window.location.pathname + `?variant=${selectedVariantId}&section_id=${selectedSectionId}`)
    .then((response) => response.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newHtml = doc.getElementById('shopify-section-'+selectedSectionId).innerHTML;

      document.getElementById('shopify-section-'+selectedSectionId).innerHTML = newHtml;
    });
});*/


// code for cart  delete js 


function transformRemoveLinks() {
  const removeLinks = document.querySelectorAll('.cart__item__remove');

  removeLinks.forEach(link => {
    if (link.getAttribute('href')?.includes('/cart/change')) {
      link.setAttribute('href', 'javascript:void(0)');
      link.setAttribute('onclick', 'return false;');
      // Optionally add data-line attribute if you can parse line number from href
      if (!link.hasAttribute('data-line')) {
        const url = new URL(link.href, window.location.origin);
        const line = url.searchParams.get('line');
        if (line) link.setAttribute('data-line', line);
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  transformRemoveLinks();
});


// Intercept all cart change events

document.addEventListener('DOMContentLoaded', () => {

  function checkIfBundleIsAddedToCart(){

    const cartDrawer = document.querySelector("#cart-drawer");
    const textToBeChanged = cartDrawer.querySelector(".success-message");

    let cartItemTitles = document.querySelectorAll(".cart__item__title");
    let cartItemTitleTexts = [];

    for(let i=0; i<cartItemTitles.length; i++){
        let cartItemTitleText = cartItemTitles[i].querySelector("a").textContent;
        console.log("Product in cart: ", cartItemTitleText);
        cartItemTitleTexts.push(cartItemTitleText);
    }

    // if(cartItemTitleTexts.includes("Buy 3 @1499") && textToBeChanged){
    //     if(textToBeChanged){
    //         textToBeChanged.textContent="Free tumbler added at checkout 🔥";
    //     }
    // }else{
    //     if(textToBeChanged){
    //         textToBeChanged.textContent="Gift added at checkout 🥳";
    //     }
    // }
    //textToBeChanged.textContent="Gift added at checkout 🥳";
  }

  checkIfBundleIsAddedToCart();

  const originalFetch = window.fetch;

  window.fetch = async function(input, init) {
    let url = typeof input === 'string' ? input : input.url;
    let options = init || (typeof input === 'object' ? input : {});

    if (url.includes('/cart')) {
      //console.log('Cart request detected:', url, options);

        //console.log('Cart is being modified!');

        const response = await originalFetch.apply(this, arguments);
        const clone = response.clone();

        // checkIfBundleIsAddedToCart();

        return response;
    }

    return originalFetch.apply(this, arguments);
  };

  // Reposition whatsapp button on all pages
  let counter1 = 0;

  function repositionWhatsappBtn(){
    let whatsappBtn1 = document.querySelector(".WhatsAppButton__root");
    if(whatsappBtn1){
      whatsappBtn1.style.bottom="57px";
    }
    setTimeout(() => {
      if(counter1 <= 7){
        repositionWhatsappBtn();
      }
      counter1++;
    }, 2000)
  }

  repositionWhatsappBtn();

    let counter2 = 0;

    function hideWhatsappBtn() {
    const whatsappBtn1 = document.querySelector(".WhatsAppButton__root");

    if (
        whatsappBtn1 &&
        window.innerWidth <= 766 &&
        window.getComputedStyle(whatsappBtn1).display !== "none"
    ) {
        whatsappBtn1.style.display = "none";
    }

    setTimeout(() => {
        counter2++;
        if (counter2 <= 7) {
        hideWhatsappBtn();
        }
    }, 2000);
    }

    hideWhatsappBtn();

//   let bottomNavigationBarTexts = document.querySelectorAll(".col-wrap");

//   for(let i=0; i<bottomNavigationBarTexts.length; i++){
//     let colWrap1 = bottomNavigationBarTexts[i];
//     if(colWrap1.querySelector("p").textContent === "Money Back"){
//         colWrap1.querySelector("p").style.color="#1aa343";
//     }
//   }

  // Custom redirect from app bundle page to 1499 bundle

  if(window.location.href.includes("/apps/gbb/easybundle/1?currentFlow=byob&page=addProductsPage1")){
    window.location.href="https://betteralt.in/products/betteralt-get-3-for-1499";
  }
});

